export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateString: { input: string; output: string; }
  DateTime: { input: number; output: number; }
  JSONObject: { input: any; output: any; }
};

export type GQLAccommodation = {
  __typename?: 'Accommodation';
  accommodationFor: GQLAccommodationFor;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  request: Scalars['String']['output'];
  studentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum GQLAccommodationFor {
  Classroom = 'Classroom'
}

export type GQLAccountTag = {
  __typename?: 'AccountTag';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GQLAcquisition = {
  __typename?: 'Acquisition';
  apaDeferredRevenueAmount?: Maybe<Scalars['Float']['output']>;
  apaScalingRatio?: Maybe<Scalars['Float']['output']>;
  firstCloseDate?: Maybe<Scalars['DateString']['output']>;
  id: Scalars['ID']['output'];
  integrationDate?: Maybe<Scalars['DateString']['output']>;
  name: Scalars['String']['output'];
  secondCloseDate?: Maybe<Scalars['DateString']['output']>;
};

export type GQLAcquisitionEdge = {
  __typename?: 'AcquisitionEdge';
  cursor: Scalars['ID']['output'];
  node: GQLAcquisition;
};

export type GQLAcquisitionInput = {
  apaDeferredRevenueAmount?: InputMaybe<Scalars['Float']['input']>;
  apaScalingRatio?: InputMaybe<Scalars['Float']['input']>;
  firstCloseDate?: InputMaybe<Scalars['DateString']['input']>;
  integrationDate?: InputMaybe<Scalars['DateString']['input']>;
  name: Scalars['String']['input'];
  secondCloseDate?: InputMaybe<Scalars['DateString']['input']>;
};

export type GQLAcquisitionPaginatedList = {
  __typename?: 'AcquisitionPaginatedList';
  edges: Array<GQLAcquisitionEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLAddMakeUpSessionInformationInput = {
  cohortSessionId: Scalars['ID']['input'];
  makeUpCohortId: Scalars['ID']['input'];
  makeUpSessionId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLAddress = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GQLAddressCoordinates>;
  id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GQLAddressCoordinates = {
  __typename?: 'AddressCoordinates';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GQLAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secondaryPhone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAdminHelpDocContent = {
  __typename?: 'AdminHelpDocContent';
  docPath: Scalars['String']['output'];
  markdown: Scalars['String']['output'];
  routePatterns: Array<Scalars['String']['output']>;
  section: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLAdminHelpDocIndexEntry = {
  __typename?: 'AdminHelpDocIndexEntry';
  docPath: Scalars['String']['output'];
  routePatterns: Array<Scalars['String']['output']>;
  section: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLAdminInstructorTableQuery = {
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
  regionalManagerId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<GQLUsStateId>;
  status: GQLInstructorStatus;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAdminLessonsInstructor = {
  __typename?: 'AdminLessonsInstructor';
  about?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isRetired?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationLandingPageId?: Maybe<Scalars['ID']['output']>;
  locationLandingPageName?: Maybe<Scalars['String']['output']>;
  portraitImage?: Maybe<Scalars['String']['output']>;
  slackUsername?: Maybe<Scalars['String']['output']>;
  spokenLanguageCodes?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  usStateId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['String']['output'];
  wallpaperImage?: Maybe<Scalars['String']['output']>;
};

export enum GQLAdminPrivateAvailFilter {
  INCLUDE_PRIVATE = 'INCLUDE_PRIVATE',
  NONE = 'NONE',
  ONLY_PRIVATE = 'ONLY_PRIVATE'
}

export type GQLAdminRecentHistoryItem = {
  __typename?: 'AdminRecentHistoryItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GQLAdminSlotSearchInput = {
  address: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  isFixedLocation: Scalars['Boolean']['input'];
  lessonTypeNames: Array<Scalars['String']['input']>;
  meetingPointId?: InputMaybe<Scalars['String']['input']>;
  preferredProviderId?: InputMaybe<Scalars['ID']['input']>;
  privateAvailFilter: GQLAdminPrivateAvailFilter;
  searchState: Scalars['String']['input'];
  skipMinLeadTime?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
};

export type GQLAnvilPdfIds = {
  __typename?: 'AnvilPdfIds';
  admin?: Maybe<Scalars['ID']['output']>;
  insurance?: Maybe<Scalars['ID']['output']>;
  student?: Maybe<Scalars['ID']['output']>;
};

export type GQLApiCallCount = {
  __typename?: 'ApiCallCount';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type GQLApiCallCountByDateQuery = {
  date: Scalars['String']['input'];
};

export type GQLApiCallCountEdge = {
  __typename?: 'ApiCallCountEdge';
  cursor: Scalars['ID']['output'];
  node: GQLApiCallCount;
};

export type GQLApiCallCountPaginatedList = {
  __typename?: 'ApiCallCountPaginatedList';
  edges: Array<GQLApiCallCountEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLApprovedInstructorSchedule = {
  __typename?: 'ApprovedInstructorSchedule';
  createdAt: Scalars['DateTime']['output'];
  dayTimesAvailable: Array<GQLScheduleDayTimes>;
  daysPerWeek: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endDateUpdatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  instructorName?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  lastAvailabilityDate?: Maybe<Scalars['String']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  mostRecentRequest?: Maybe<GQLInstructorSchedule>;
  rollingWeekLength: Scalars['Int']['output'];
  scheduleRequestId: Scalars['ID']['output'];
  startDate: Scalars['String']['output'];
  status: GQLScheduleStatus;
  timesOff?: Maybe<Array<GQLInstructorTimeOff>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GQLApprovedInstructorScheduleInput = {
  dayTimesAvailable: Array<GQLScheduleDayTimesInput>;
  daysPerWeek: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorId: Scalars['ID']['input'];
  rollingWeekLength: Scalars['Int']['input'];
  scheduleRequestId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};

export type GQLApprovedInstructorScheduleQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorId: Scalars['ID']['input'];
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLApprovedInstructorScheduleUpdateInput = {
  dayTimesAvailable?: InputMaybe<Array<GQLScheduleDayTimesInput>>;
  daysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  rollingWeekLength?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLApprovedInstructorsSchedulesQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLArchiveStudentCertificateInput = {
  certificateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLArchiveStudentNoteInput = {
  noteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum GQLAttendance {
  Absent = 'Absent',
  Made_Up = 'Made_Up',
  Makeup_Scheduled = 'Makeup_Scheduled',
  Not_Set = 'Not_Set',
  Present = 'Present'
}

export type GQLAuditLog = {
  __typename?: 'AuditLog';
  action: GQLAuditLogActions;
  changes: Array<GQLLogChange>;
  collection: GQLAuditLogCollection;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  updatedBy: GQLUpdatedBy;
};

export enum GQLAuditLogActions {
  Create = 'Create',
  Delete = 'Delete',
  Unknown = 'Unknown',
  Update = 'Update'
}

export type GQLAuditLogCollection = {
  __typename?: 'AuditLogCollection';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type GQLAuditLogEdge = {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['ID']['output'];
  node: GQLAuditLog;
};

export enum GQLAuditLogUserRoles {
  Admin = 'Admin',
  Instructor = 'Instructor',
  System = 'System',
  User = 'User'
}

export type GQLAuditLogsPaginatedList = {
  __typename?: 'AuditLogsPaginatedList';
  edges: Array<GQLAuditLogEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLAuditLogsQuery = {
  action?: InputMaybe<GQLAuditLogActions>;
  collection?: InputMaybe<GQLCollections>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLAuthRules = {
  __typename?: 'AuthRules';
  parkingHub: GQLParkingHubObjectAuthRules;
  userId: Scalars['ID']['output'];
};


export type GQLAuthRulesParkingHubArgs = {
  id: Scalars['ID']['input'];
};

export type GQLAvailFormContext = {
  __typename?: 'AvailFormContext';
  instructor: GQLAvailFormInstructor;
  vehicles: Array<GQLAvailFormVehicle>;
};

export type GQLAvailFormContextInput = {
  date: Scalars['String']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLAvailFormInstructor = {
  __typename?: 'AvailFormInstructor';
  availsFixedByDefault?: Maybe<Scalars['Boolean']['output']>;
  baseAddress?: Maybe<Scalars['String']['output']>;
  canManageMeetingLocations?: Maybe<Scalars['Boolean']['output']>;
  canManageOwnSchedule?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxBaseTravelMinutes?: Maybe<Scalars['Int']['output']>;
  maxBetweenTravelMinutes?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type GQLAvailFormVehicle = {
  __typename?: 'AvailFormVehicle';
  dailyAvailabilities: Array<GQLAvailFormVehicleDailyAvailability>;
  id: Scalars['ID']['output'];
  instructorIds: Array<Scalars['ID']['output']>;
  instructorNames: Array<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

export type GQLAvailFormVehicleDailyAvailability = {
  __typename?: 'AvailFormVehicleDailyAvailability';
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  instructorName: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type GQLAvailabilitiesForVehiclesQuery = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime: Scalars['DateTime']['input'];
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type GQLAvailabilitiesQuery = {
  endTime: Scalars['DateTime']['input'];
  instructorIds: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type GQLAvailability = {
  __typename?: 'Availability';
  center: GQLCenter;
  date: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  fixedLocationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  instructor: GQLInstructor;
  instructorId: Scalars['ID']['output'];
  isFixedLocation: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  lessonCount?: Maybe<Scalars['Int']['output']>;
  lessonTypes?: Maybe<Array<Scalars['String']['output']>>;
  locationAllowed: GQLLocationAllowed;
  maxBaseTravelMinutes?: Maybe<Scalars['Int']['output']>;
  maxBetweenTravelMinutes?: Maybe<Scalars['Int']['output']>;
  maxDurationMinutes?: Maybe<Scalars['Int']['output']>;
  maxLessons?: Maybe<Scalars['Int']['output']>;
  minLeadHours: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  vehicle?: Maybe<GQLVehicle>;
};

export type GQLAvailabilityAddFailure = {
  __typename?: 'AvailabilityAddFailure';
  date?: Maybe<Scalars['DateString']['output']>;
  error: Scalars['String']['output'];
};

export type GQLAvailabilityCreateInput = {
  /** @deprecated Use centerAddress */
  center?: InputMaybe<GQLCenterInput>;
  centerAddress?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  fixedLocationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use instructorId */
  instructor?: InputMaybe<GQLAvailabilityInstructorInput>;
  instructorId: Scalars['ID']['input'];
  isPrivate: Scalars['Boolean']['input'];
  lessonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAllowed?: InputMaybe<GQLLocationAllowed>;
  maxBaseTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxLessons?: InputMaybe<Scalars['Int']['input']>;
  minLeadHours?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  /** @deprecated Use vehicleId */
  vehicle?: InputMaybe<GQLAvailabilityVehicleInput>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLAvailabilityInstructorInput = {
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
};

export type GQLAvailabilityQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLAvailabilityUpdateFailure = {
  __typename?: 'AvailabilityUpdateFailure';
  availabilityId: Scalars['ID']['output'];
  error: Scalars['String']['output'];
};

export type GQLAvailabilityUpdateInput = {
  /** @deprecated Use centerAddress */
  center?: InputMaybe<GQLCenterInput>;
  centerAddress?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedLocationId?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAllowed?: InputMaybe<GQLLocationAllowed>;
  maxBaseTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxLessons?: InputMaybe<Scalars['Int']['input']>;
  minLeadHours?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use vehicleId */
  vehicle?: InputMaybe<GQLAvailabilityVehicleInput>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLAvailabilityVehicleInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAvailabilityVehicleRef = {
  __typename?: 'AvailabilityVehicleRef';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type GQLBalancedQuantity = {
  __typename?: 'BalancedQuantity';
  availableQuantity: Scalars['Int']['output'];
  expiredQuantity: Scalars['Int']['output'];
  purchasedQuantity: Scalars['Int']['output'];
  receivedQuantity: Scalars['Int']['output'];
  refundedQuantity: Scalars['Int']['output'];
  sentQuantity: Scalars['Int']['output'];
  usedQuantity: Scalars['Int']['output'];
  voidedQuantity: Scalars['Int']['output'];
};

export type GQLBaseLedgerLog = {
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLBaseLedgerLogSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLBatchAddAvailsResult = {
  __typename?: 'BatchAddAvailsResult';
  added: Array<GQLAvailability>;
  failed: Array<GQLAvailabilityAddFailure>;
};

export type GQLBatchDeleteAvailsQuery = {
  availabilityIds: Array<Scalars['ID']['input']>;
  instructorId: Scalars['ID']['input'];
};

export type GQLBatchDeleteAvailsResult = {
  __typename?: 'BatchDeleteAvailsResult';
  deleted: Array<Scalars['ID']['output']>;
  failed: Array<GQLAvailabilityUpdateFailure>;
};

export type GQLBatchEditAvailsQuery = {
  availabilityIds: Array<Scalars['ID']['input']>;
  instructorId: Scalars['ID']['input'];
};

export type GQLBatchEditAvailsResult = {
  __typename?: 'BatchEditAvailsResult';
  failed: Array<GQLAvailabilityUpdateFailure>;
  updated: Array<GQLAvailability>;
};

export type GQLBatchEditAvailsUpdate = {
  centerAddress?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fixedLocationId?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAllowed?: InputMaybe<GQLLocationAllowed>;
  maxBaseTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxLessons?: InputMaybe<Scalars['Int']['input']>;
  minLeadHours?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLBookingAlert = {
  __typename?: 'BookingAlert';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: GQLPerson;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type GQLBookingAlertEdge = {
  __typename?: 'BookingAlertEdge';
  cursor: Scalars['ID']['output'];
  node: GQLBookingAlert;
};

export type GQLBookingAlertInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type GQLBookingAlertsPaginatedList = {
  __typename?: 'BookingAlertsPaginatedList';
  edges: Array<GQLBookingAlertEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLBookingAlertsQuery = {
  studentId: Scalars['ID']['input'];
};

export type GQLBulkAvailabilityCreateInput = {
  avails: Array<GQLAvailabilityCreateInput>;
};

export type GQLCalendarHoliday = {
  __typename?: 'CalendarHoliday';
  date: Scalars['String']['output'];
  disallowAvails: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type GQLCancelLogEntry = {
  __typename?: 'CancelLogEntry';
  changedBy?: Maybe<GQLPerson>;
  changedById?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<GQLInitiatedBy>;
  instructor?: Maybe<GQLInstructor>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  lessonStartTime: Scalars['DateTime']['output'];
  note?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<GQLPerson>;
  userId: Scalars['ID']['output'];
};

export type GQLCancelLogsQuery = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type GQLCancelPolicy = {
  changeFee: Scalars['Float']['input'];
  informativeMessage?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

export type GQLCart = {
  __typename?: 'Cart';
  bookedSlotIds?: Maybe<Array<Scalars['ID']['output']>>;
  coupon?: Maybe<GQLCoupon>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isFirstPurchase?: Maybe<Scalars['Boolean']['output']>;
  isOrderComplete: Scalars['Boolean']['output'];
  items: Array<GQLProductPackageWithPrice>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  purchaseId?: Maybe<Scalars['ID']['output']>;
  student?: Maybe<GQLStudent>;
  studentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usState?: Maybe<GQLUsStateId>;
};

export type GQLCartCreateInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<GQLProductPackageWithPriceInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLCartEdge = {
  __typename?: 'CartEdge';
  cursor: Scalars['ID']['output'];
  node: GQLCart;
};

export type GQLCartFilterInput = {
  cohortId?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationLandingPageId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  purchaseTitle?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLCartInput = {
  id: Scalars['ID']['input'];
};

export type GQLCartsPaginatedList = {
  __typename?: 'CartsPaginatedList';
  edges: Array<GQLCartEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLCast = {
  __typename?: 'Cast';
  exampleData?: Maybe<Scalars['JSONObject']['output']>;
  fieldInfo: Array<GQLFieldInfo>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GQLCastList = {
  __typename?: 'CastList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GQLCenter = {
  __typename?: 'Center';
  location: Scalars['String']['output'];
  locationCoords?: Maybe<GQLLatLng>;
};

export type GQLCenterGeocode = {
  __typename?: 'CenterGeocode';
  city: Scalars['String']['output'];
  formattedAddress: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type GQLCenterInput = {
  location: Scalars['String']['input'];
  locationCoords?: InputMaybe<GQLLocationCoordsInput>;
};

export type GQLCertificate = {
  __typename?: 'Certificate';
  certNumber: Scalars['Int']['output'];
  certType: GQLCertificateType;
  certTypeId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: GQLPerson;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedTo?: Maybe<GQLPerson>;
  issuedToId?: Maybe<Scalars['ID']['output']>;
  usState?: Maybe<GQLUsState>;
  usStateId?: Maybe<Scalars['ID']['output']>;
};

export type GQLCertificateEdge = {
  __typename?: 'CertificateEdge';
  cursor: Scalars['ID']['output'];
  node: GQLCertificate;
};

export type GQLCertificateInput = {
  certNumber: Scalars['Int']['input'];
  certTypeId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  issuedAt: Scalars['DateTime']['input'];
  issuedToId?: InputMaybe<Scalars['ID']['input']>;
  usStateId: Scalars['ID']['input'];
};

export type GQLCertificateType = {
  __typename?: 'CertificateType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  usStateId: Scalars['ID']['output'];
  valMax?: Maybe<Scalars['Int']['output']>;
  valMin?: Maybe<Scalars['Int']['output']>;
};

export type GQLCertificatesPaginatedList = {
  __typename?: 'CertificatesPaginatedList';
  edges: Array<GQLCertificateEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLCertificatesQuery = {
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLChangeLessonInstructorInput = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  newInstructorId: Scalars['ID']['input'];
};

export type GQLChargeLedgerLogQueryInput = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCheckSlotAvailabilityInput = {
  endTime: Scalars['DateTime']['input'];
  instructorId: Scalars['ID']['input'];
  skipLessonSlotConflictCheck?: InputMaybe<Scalars['Boolean']['input']>;
  skipTransientSlotConflictCheck?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type GQLCheckoutAdvanceInput = {
  cartId: Scalars['ID']['input'];
  event: GQLCheckoutEventInput;
};

export type GQLCheckoutAdvancePayload = {
  __typename?: 'CheckoutAdvancePayload';
  status: GQLCheckoutAdvanceStatus;
  view: GQLCheckoutView;
};

export enum GQLCheckoutAdvanceStatus {
  APPLIED = 'APPLIED',
  CONFLICT = 'CONFLICT',
  DEDUPED = 'DEDUPED'
}

export type GQLCheckoutEventInput = {
  clientEventId: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['JSONObject']['input']>;
  protocolVersion: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type GQLCheckoutInitInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  initMode?: InputMaybe<GQLCheckoutInitMode>;
  initRequestId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  packageId: Scalars['ID']['input'];
  priceSchemeId: Scalars['ID']['input'];
  protocolVersion: Scalars['Int']['input'];
  ref?: InputMaybe<Scalars['String']['input']>;
  skipPackages?: InputMaybe<Scalars['Boolean']['input']>;
  state: GQLUsStateId;
};

export enum GQLCheckoutInitMode {
  RESUME_OR_CREATE = 'RESUME_OR_CREATE',
  START_NEW = 'START_NEW'
}

export type GQLCheckoutInitPayload = {
  __typename?: 'CheckoutInitPayload';
  cartId: Scalars['ID']['output'];
  view: GQLCheckoutView;
};

export type GQLCheckoutSyncInput = {
  cartId: Scalars['ID']['input'];
  protocolVersion: Scalars['Int']['input'];
};

export type GQLCheckoutView = {
  __typename?: 'CheckoutView';
  cartId: Scalars['ID']['output'];
  step: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  warnings: Array<GQLCheckoutWarning>;
};

export type GQLCheckoutViewInput = {
  cartId: Scalars['ID']['input'];
  protocolVersion: Scalars['Int']['input'];
};

export type GQLCheckoutWarning = {
  __typename?: 'CheckoutWarning';
  blocking: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GQLClaimInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type GQLClientCourseTimerEventInput = {
  courseId: Scalars['ID']['input'];
  lectureId: Scalars['ID']['input'];
  originId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type GQLCohort = {
  __typename?: 'Cohort';
  allowMakeupRequests: Scalars['Boolean']['output'];
  courseId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  enrolledUserIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated using instructorName instead */
  instructor?: Maybe<Scalars['String']['output']>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  instructorName?: Maybe<Scalars['String']['output']>;
  isEnrollmentOpen: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  maxEnrollees: Scalars['Int']['output'];
  meetingPoint?: Maybe<GQLStateMeetingPoint>;
  name: Scalars['String']['output'];
  numEnrolled: Scalars['Int']['output'];
  sessions?: Maybe<Array<GQLCohortSession>>;
  startDate: Scalars['String']['output'];
  state: GQLUsStateId;
  stateId: Scalars['String']['output'];
  students?: Maybe<Array<GQLStudentObject>>;
  timeZone: Scalars['String']['output'];
  videoConferenceUrl?: Maybe<Scalars['String']['output']>;
};

/** Fields that are automatically filled from cohort/student data */
export enum GQLCohortAutoFillField {
  CohortName = 'cohortName',
  InstructorName = 'instructorName',
  StartDate = 'startDate',
  StudentName = 'studentName'
}

export type GQLCohortEdge = {
  __typename?: 'CohortEdge';
  cursor: Scalars['ID']['output'];
  node: GQLCohort;
};

export type GQLCohortEmailSendLog = {
  __typename?: 'CohortEmailSendLog';
  cohortId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  failedToQueueCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  queuedCount: Scalars['Int']['output'];
  recipientCount: Scalars['Int']['output'];
  sentById: Scalars['String']['output'];
  sentByName?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type GQLCohortEmailTemplate = {
  __typename?: 'CohortEmailTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLCohortEmailTemplatePreview = {
  __typename?: 'CohortEmailTemplatePreview';
  /** Fields that will be auto-filled from cohort/student data */
  autoFilledFields: Array<GQLCohortAutoFillField>;
  body: Scalars['String']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Fields that require manual input from the sender */
  liquidFields: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type GQLCohortInput = {
  allowMakeupRequests?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  enrolledUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated using instructorId instead */
  instructor?: InputMaybe<Scalars['String']['input']>;
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  isEnrollmentOpen: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  maxEnrollees: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  state: GQLUsStateId;
  stateId: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  updateSessionsInstructor?: InputMaybe<Scalars['Boolean']['input']>;
  videoConferenceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCohortSession = {
  __typename?: 'CohortSession';
  attendance?: Maybe<Array<GQLStudentSessionAttendance>>;
  attendanceForStudent: Array<GQLStudentSessionAttendance>;
  cohort?: Maybe<GQLCohort>;
  cohortId: Scalars['ID']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructorId?: Maybe<Scalars['ID']['output']>;
  instructorName?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  makeupRequestForStudent?: Maybe<GQLMakeupRequest>;
  name: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};


export type GQLCohortSessionAttendanceForStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLCohortSessionMakeupRequestForStudentArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLCohortSessionInput = {
  cohortId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type GQLCohortSessionsQueryByInstructorId = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  instructorId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLCohortSessionsQueryByInstructorIds = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  instructorIds: Array<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum GQLCollections {
  Certificates = 'Certificates',
  CourseOrders = 'CourseOrders',
  ExpiredCredit = 'ExpiredCredit',
  InstructorAvailsV2 = 'InstructorAvailsV2',
  InstructorReviewsV3 = 'InstructorReviewsV3',
  Instructors = 'Instructors',
  InstructorsPrivate = 'InstructorsPrivate',
  LegalAndPermissions = 'LegalAndPermissions',
  LessonReports = 'LessonReports',
  LessonSlotsV2 = 'LessonSlotsV2',
  PurchaseLog = 'PurchaseLog',
  StudentLessonSlotsV2 = 'StudentLessonSlotsV2',
  TimeLog = 'TimeLog',
  UserNotesV2 = 'UserNotesV2',
  Users = 'Users',
  Vehicles = 'Vehicles',
  Vouchers = 'Vouchers'
}

export type GQLColoradoRequiredContractPurchaseDetails = {
  __typename?: 'ColoradoRequiredContractPurchaseDetails';
  hasClassroomCourse: Scalars['Boolean']['output'];
  hasLessons: Scalars['Boolean']['output'];
  hasOnlineCourse: Scalars['Boolean']['output'];
};

export type GQLCompleteOrderInput = {
  bookedSlotIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};

export type GQLCoupon = GQLCourseCoupon | GQLLessonCoupon | GQLRoadTestCoupon;

export type GQLCouponEdge = {
  __typename?: 'CouponEdge';
  cursor: Scalars['ID']['output'];
  node: GQLCoupon;
};

export enum GQLCouponType {
  Course = 'course',
  Lesson = 'lesson',
  RoadTest = 'roadTest'
}

export type GQLCouponsFilterQuery = {
  type: GQLCouponType;
};

export type GQLCouponsPaginatedList = {
  __typename?: 'CouponsPaginatedList';
  edges: Array<GQLCouponEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLCourseConfig = {
  __typename?: 'CourseConfig';
  checkoutUrl: Scalars['String']['output'];
  faqContent?: Maybe<Array<GQLFaqItem>>;
  featuresSection: GQLFeaturesSection;
  helpfulLinks?: Maybe<Array<GQLHelpfulLink>>;
  heroContent: GQLCourseContent;
  id: Scalars['ID']['output'];
  listing?: Maybe<GQLListing>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageType?: Maybe<Scalars['String']['output']>;
  pageMeta: GQLPageMeta;
  priceCard: GQLPriceCard;
  state: GQLUsStateId;
  syllabus?: Maybe<GQLSyllabus>;
  thingsToKnow?: Maybe<Array<Scalars['String']['output']>>;
};

export type GQLCourseContent = {
  __typename?: 'CourseContent';
  highlights: Array<GQLHighlight>;
  infoCardTitle?: Maybe<Scalars['String']['output']>;
  msrp?: Maybe<Scalars['Int']['output']>;
  pricePromo?: Maybe<Scalars['String']['output']>;
  subtitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GQLCourseCoupon = {
  __typename?: 'CourseCoupon';
  code: Scalars['String']['output'];
  courseId?: Maybe<Scalars['String']['output']>;
  courseSlug?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDailyCoupon: Scalars['Boolean']['output'];
  state: GQLUsStateId;
  title: Scalars['String']['output'];
  type: GQLCouponType;
};

export type GQLCourseCouponInput = {
  code: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  discount: Scalars['Float']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  isDailyCoupon: Scalars['Boolean']['input'];
  state: GQLUsStateId;
  title: Scalars['String']['input'];
};

export type GQLCourseLecture = {
  __typename?: 'CourseLecture';
  content: GQLCourseLectureContent;
  id: Scalars['ID']['output'];
  includesAQuiz: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  /** Time the student spent on the lecture in milliseconds. */
  timeSpentByStudent: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};


export type GQLCourseLectureContentArgs = {
  courseId: Scalars['ID']['input'];
  seed?: InputMaybe<Scalars['String']['input']>;
};


export type GQLCourseLectureTimeSpentByStudentArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCourseLectureContent = {
  __typename?: 'CourseLectureContent';
  minimumDuration: Scalars['Int']['output'];
  parts: Array<GQLLecturePart>;
};

export type GQLCourseNotaryStatusInput = {
  courseId: Scalars['ID']['input'];
  hasCompletedNotary: Scalars['Boolean']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCourseOrder = {
  __typename?: 'CourseOrder';
  address?: Maybe<GQLCourseOrderAddress>;
  confirmInfo?: Maybe<GQLCourseOrderConfirmInfo>;
  courseId: Scalars['ID']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated use shippingOrders collection instead */
  shipping?: Maybe<GQLCourseOrderShipping>;
};

export type GQLCourseOrderAddress = {
  __typename?: 'CourseOrderAddress';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  dlNumber?: Maybe<Scalars['String']['output']>;
  dob: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated use middleName instead */
  middleInit?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  /** @deprecated use firstName, middleName, lastName instead */
  userName?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type GQLCourseOrderAddressInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type GQLCourseOrderConfirmInfo = {
  __typename?: 'CourseOrderConfirmInfo';
  branchLicenseNumber?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  dob: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleInit?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use middleName instead */
  noMiddleName?: Maybe<Scalars['Boolean']['output']>;
  roadAndVisionExams?: Maybe<Scalars['String']['output']>;
  sex: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GQLCourseOrderConfirmInfoInput = {
  branchLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  roadAndVisionExams?: InputMaybe<Scalars['String']['input']>;
  sex: Scalars['String']['input'];
};

export type GQLCourseOrderInput = {
  address?: InputMaybe<GQLCourseOrderAddressInput>;
  confirmInfo?: InputMaybe<GQLCourseOrderConfirmInfoInput>;
  shipping?: InputMaybe<GQLCourseOrderShippingInput>;
};

export type GQLCourseOrderQuery = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCourseOrderShipping = {
  __typename?: 'CourseOrderShipping';
  isComplete: Scalars['Boolean']['output'];
  shippingDetails?: Maybe<GQLCourseOrderShippingDetails>;
  shippingMethod: Scalars['String']['output'];
};

export type GQLCourseOrderShippingDetails = {
  __typename?: 'CourseOrderShippingDetails';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type GQLCourseOrderShippingDetailsInput = {
  amount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type GQLCourseOrderShippingInput = {
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  shippingDetails?: InputMaybe<GQLCourseOrderShippingDetailsInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCoursePrepQuizQuestion = GQLQuizQuestion & {
  __typename?: 'CoursePrepQuizQuestion';
  answer: Scalars['String']['output'];
  choices?: Maybe<Array<GQLLectureQuestionChoice>>;
  doShuffle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<GQLLectureContentImage>;
  question: Scalars['String']['output'];
  type: GQLQuizQuestionType;
};

export type GQLCoursePrepTest = {
  __typename?: 'CoursePrepTest';
  chapters: Array<GQLCoursePrepTestChapter>;
  title: Scalars['String']['output'];
};

export type GQLCoursePrepTestChapter = {
  __typename?: 'CoursePrepTestChapter';
  id: Scalars['ID']['output'];
  questions: Array<GQLCoursePrepQuizQuestion>;
  title: Scalars['String']['output'];
};

export type GQLCoursePrepTestChapterScores = {
  __typename?: 'CoursePrepTestChapterScores';
  chapterId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  questionScores: Array<GQLLectureQuizQuestionPrepTestScore>;
};

export type GQLCourseProgressArchive = {
  __typename?: 'CourseProgressArchive';
  authorId: Scalars['ID']['output'];
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
};

export type GQLCourseSurvey = {
  __typename?: 'CourseSurvey';
  best?: Maybe<Scalars['String']['output']>;
  courseId: Scalars['ID']['output'];
  courseScore?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  worst?: Maybe<Scalars['String']['output']>;
};

export type GQLCourseSurveyInput = {
  best?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['ID']['input'];
  courseScore?: InputMaybe<Scalars['String']['input']>;
  worst?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCourseTest = {
  __typename?: 'CourseTest';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLCourseTestLecture = {
  __typename?: 'CourseTestLecture';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type GQLCourseTimerClientEvent = GQLCourseTimerEventBase & {
  __typename?: 'CourseTimerClientEvent';
  courseId: Scalars['ID']['output'];
  lectureId: Scalars['ID']['output'];
  localId: Scalars['ID']['output'];
  originId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GQLCourseTimerEvent = GQLCourseTimerClientEvent | GQLCourseTimerPatchEvent;

export type GQLCourseTimerEventBase = {
  localId: Scalars['ID']['output'];
  originId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GQLCourseTimerPatchEvent = GQLCourseTimerEventBase & {
  __typename?: 'CourseTimerPatchEvent';
  localId: Scalars['ID']['output'];
  originId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  updates: Array<GQLCourseTimerPatchUpdate>;
};

export type GQLCourseTimerPatchUpdate = {
  __typename?: 'CourseTimerPatchUpdate';
  courseId: Scalars['ID']['output'];
  from: Scalars['DateTime']['output'];
  lectureId: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
};

export type GQLCourseTimerReportTimeSlot = {
  __typename?: 'CourseTimerReportTimeSlot';
  courseId: Scalars['ID']['output'];
  from: Scalars['DateTime']['output'];
  lecture: GQLCourseLecture;
  lectureId: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
};

export type GQLCourseTimerReportTimeSlotEdge = {
  __typename?: 'CourseTimerReportTimeSlotEdge';
  cursor: Scalars['ID']['output'];
  node: GQLCourseTimerReportTimeSlot;
};

export type GQLCourseTimerReportTimeSlotPaginatedList = {
  __typename?: 'CourseTimerReportTimeSlotPaginatedList';
  edges: Array<GQLCourseTimerReportTimeSlotEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLCourseTimerSecondsSpent = {
  __typename?: 'CourseTimerSecondsSpent';
  byCourse: Array<GQLCourseTimerSecondsSpentByCourse>;
  studentId: Scalars['ID']['output'];
};

export type GQLCourseTimerSecondsSpentByCourse = {
  __typename?: 'CourseTimerSecondsSpentByCourse';
  byLecture: Array<GQLCourseTimerSecondsSpentByLecture>;
  courseId: Scalars['ID']['output'];
  secondsSpent: Scalars['Int']['output'];
  secondsSpentCapped: Scalars['Int']['output'];
};

export type GQLCourseTimerSecondsSpentByLecture = {
  __typename?: 'CourseTimerSecondsSpentByLecture';
  courseId: Scalars['ID']['output'];
  lectureId: Scalars['ID']['output'];
  secondsSpent: Scalars['Int']['output'];
  secondsSpentCapped: Scalars['Int']['output'];
};

export type GQLCourseTimerSecondsSpentQuery = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
};

export type GQLCourseTopic = {
  __typename?: 'CourseTopic';
  id: Scalars['ID']['output'];
  lectures: Array<GQLCourseLecture>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLCoursesForStateFilters = {
  isClassroomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isKnowledgeTest?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSessionCohort?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLCoursesQuery = {
  isClassroomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentOpen?: InputMaybe<Scalars['Boolean']['input']>;
  limitToInstructorState?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLCreateCheckoutPaymentIntentInput = {
  amountCents: Scalars['Int']['input'];
  cartId?: InputMaybe<Scalars['ID']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  state: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateCheckoutPaymentIntentPayload = {
  __typename?: 'CreateCheckoutPaymentIntentPayload';
  amountSubtotalCents?: Maybe<Scalars['Int']['output']>;
  amountTotalCents?: Maybe<Scalars['Int']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  taxAmountCents?: Maybe<Scalars['Int']['output']>;
};

export type GQLCreateDirectChargeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  amountCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId: Scalars['String']['input'];
  source?: InputMaybe<GQLDirectChargeSource>;
  state: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLCreateDirectChargePayload = {
  __typename?: 'CreateDirectChargePayload';
  amountCents: Scalars['Int']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  latestCharge: Scalars['ID']['output'];
  paymentIntentId: Scalars['ID']['output'];
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GQLCreateDriveLogInput = {
  dayOrNight?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  duration: Scalars['Int']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime: Scalars['DateTime']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCreateFleetNoteInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
  text: Scalars['String']['input'];
};

export type GQLCreateInstructorTimeOffInput = {
  endDate: Scalars['String']['input'];
  instructorId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};

export type GQLCreateMakeupRequestInput = {
  makeupSessionId: Scalars['ID']['input'];
  originalSessionId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLCreateParkingHubInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type GQLCreatePayrollRunInput = {
  endDate: Scalars['DateString']['input'];
  entities: Array<Scalars['String']['input']>;
  excludedInstructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedInstructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateString']['input'];
};

export type GQLCreatePayrollRunResult = {
  __typename?: 'CreatePayrollRunResult';
  didCreate: Scalars['Boolean']['output'];
  payrollRun: GQLPayrollRun;
};

export type GQLCreateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSharedLessons?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  numLessons?: InputMaybe<Scalars['Int']['input']>;
  numRoadTests?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<GQLProductLinkInput>>;
  type: GQLCreateProductTypeInput;
};

export enum GQLCreateProductTypeInput {
  Course = 'course',
  Fee = 'fee',
  Package = 'package'
}

export type GQLCreatePurchaseInput = {
  acquisitionId?: InputMaybe<Scalars['ID']['input']>;
  amountDollars: Scalars['Float']['input'];
  categoryId: GQLPaymentCategories;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  items: Array<GQLPurchaseItemInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationPartnerExpiresAt?: InputMaybe<Scalars['String']['input']>;
  organizationPartnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentCaptureDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseSessionId?: InputMaybe<Scalars['ID']['input']>;
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodType?: InputMaybe<Scalars['String']['input']>;
  studentAddress?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  usStateId: GQLUsStateId;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateSessionCookieInput = {
  idToken: Scalars['String']['input'];
};

export type GQLCreateShippingOrderInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isReOrder: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  shippingDetails: GQLShippingOrderShippingDetailsInput;
  state: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
  zipcode: Scalars['String']['input'];
};

export type GQLCreateTimeOffResult = {
  __typename?: 'CreateTimeOffResult';
  removedAvailabilityIds: Array<Scalars['ID']['output']>;
  timeOffId: Scalars['ID']['output'];
};

export type GQLCreateTraineeInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  paylocityId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
};

export type GQLCreateVendorInput = {
  categories: Array<GQLVendorCategoryKey>;
  name: Scalars['String']['input'];
};

export type GQLCreateVoucherBySourceIdInput = {
  billingAmount: Scalars['Float']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numToCreate: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
  usStateId: GQLUsStateId;
  zipcode: Scalars['String']['input'];
};

export type GQLCreateVoucherV2Input = {
  billingAmount: Scalars['Float']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numToCreate: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  source: Scalars['ID']['input'];
  usStateId: GQLUsStateId;
  zipcode: Scalars['String']['input'];
};

export type GQLCreateVoucherV2SourceInput = {
  name: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  usStateId: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type GQLDateRange = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GQLDatoCourseFilterInput = {
  isClassroomCourse: Scalars['Boolean']['input'];
  isKnowledgeTest: Scalars['Boolean']['input'];
  isSingleSessionCohort: Scalars['Boolean']['input'];
};

export type GQLDayEvents = {
  __typename?: 'DayEvents';
  auditIssues: Array<GQLInstructorEventAuditIssue>;
  dateStr: Scalars['String']['output'];
  events: Array<GQLInstructorEvent>;
  hasAvail: Scalars['Boolean']['output'];
  hasOverlappingEvents: Scalars['Boolean']['output'];
  isMissingRequiredMealBreak: Scalars['Boolean']['output'];
  locationString?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<GQLVehicle>;
};

export type GQLDeleteBookingAlertInput = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLDeleteDriveLogInput = {
  driveId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLDeleteFleetAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
};

export type GQLDeleteFleetNoteInput = {
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
  noteId: Scalars['ID']['input'];
};

export type GQLDeleteMakeupRequestInput = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLDeleteStudentContractInput = {
  contractId: Scalars['ID']['input'];
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  userFileId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLDeleteStudentContractResult = {
  __typename?: 'DeleteStudentContractResult';
  contractId: Scalars['ID']['output'];
  deletedUserFileId?: Maybe<Scalars['ID']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export type GQLDeleteUserFileInput = {
  fileId: Scalars['ID']['input'];
  fileLabel: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLDigitalCertificateResult = {
  __typename?: 'DigitalCertificateResult';
  filename: Scalars['String']['output'];
  pdfData: Scalars['String']['output'];
};

export enum GQLDirectChargeSource {
  ADMIN_PURCHASE = 'ADMIN_PURCHASE',
  CERTIFICATE_SHIPPING = 'CERTIFICATE_SHIPPING'
}

export type GQLDistanceFromInput = {
  instructorId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLDriveLog = {
  __typename?: 'DriveLog';
  dayOrNight?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type GQLDrivingSkill = {
  __typename?: 'DrivingSkill';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export enum GQLDrivingSkillRating {
  Capable = 'Capable',
  Consistent = 'Consistent',
  NeedsAdditionalDevelopment = 'NeedsAdditionalDevelopment',
  NeedsImprovement = 'NeedsImprovement',
  Proficient = 'Proficient',
  Todo = 'Todo'
}

export type GQLEditPurchaseInput = {
  acquisitionId?: InputMaybe<Scalars['ID']['input']>;
  amountDollars?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<GQLPaymentCategories>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<GQLPurchaseItemInput>>;
  organizationPartnerExpiresAt?: InputMaybe<Scalars['String']['input']>;
  organizationPartnerId?: InputMaybe<Scalars['ID']['input']>;
  paymentCaptureDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseId: Scalars['ID']['input'];
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  studentAddress?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  usStateId?: InputMaybe<GQLUsStateId>;
  versionId: Scalars['ID']['input'];
};

export type GQLEligibleMakeupSessionsInput = {
  lookaheadDays: Scalars['Int']['input'];
  originalSessionId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLEligibleStudent = {
  __typename?: 'EligibleStudent';
  displayName: Scalars['String']['output'];
  distanceMeters: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Float']['output']>;
  drivingMinutesRemaining: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  licenseExpirationDate?: Maybe<Scalars['Float']['output']>;
  licenseIssueDate?: Maybe<Scalars['Float']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  observationMinutesRemaining: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['ID']['output'];
};

export type GQLEmailStudentReportInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  lessonId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLEnqueueDataSyncJobInput = {
  collection: Scalars['String']['input'];
  params: Scalars['JSONObject']['input'];
};

export type GQLEnqueueDataSyncJobResult = {
  __typename?: 'EnqueueDataSyncJobResult';
  collection: Scalars['String']['output'];
  jobId: Scalars['ID']['output'];
};

export type GQLEnqueueRestoreArchivedStudentCourseInput = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLEnrollStudentToCohortInput = {
  cohortId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLExamAttempt = {
  __typename?: 'ExamAttempt';
  courseId: Scalars['ID']['output'];
  examId: Scalars['ID']['output'];
  examSlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxTime: Scalars['DateTime']['output'];
  result: GQLExamSessionResult;
  startTime: Scalars['DateTime']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type GQLExamQuestion = {
  __typename?: 'ExamQuestion';
  choices: Array<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type GQLExamResponseInput = {
  choice: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  question: Scalars['String']['input'];
};

export type GQLExamSession = {
  __typename?: 'ExamSession';
  courseId: Scalars['ID']['output'];
  examId: Scalars['ID']['output'];
  examSlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxTime: Scalars['DateTime']['output'];
  questions: Array<GQLExamQuestion>;
  responses: Array<GQLExamSessionResponse>;
  startTime: Scalars['DateTime']['output'];
};

export type GQLExamSessionResponse = {
  __typename?: 'ExamSessionResponse';
  choice: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GQLExamSessionResult = {
  __typename?: 'ExamSessionResult';
  didPass: Scalars['Boolean']['output'];
};

export type GQLExamTypeInfo = {
  __typename?: 'ExamTypeInfo';
  description: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLExistingPurchaseItemUpdate = {
  __typename?: 'ExistingPurchaseItemUpdate';
  itemId: Scalars['ID']['output'];
  priceUpdate: Scalars['Float']['output'];
  quantityUpdate: Scalars['Float']['output'];
};

export type GQLExpenditure = {
  __typename?: 'Expenditure';
  itemId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  purchaseId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type GQLExpiration = {
  __typename?: 'Expiration';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  expirationType: GQLExpireProductsTypes;
  id: Scalars['ID']['output'];
  isVoid: Scalars['Boolean']['output'];
  itemsToExpireByPurchase: Array<GQLItemsToExpireByPurchase>;
  purchaseIds: Array<Scalars['ID']['output']>;
  studentId: Scalars['ID']['output'];
  versionId: Scalars['ID']['output'];
};

export type GQLExpirationQuery = {
  expirationId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLExpireProductsInput = {
  description: Scalars['String']['input'];
  itemsToExpire: Array<GQLItemToExpireInput>;
  purchaseId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  studentId: Scalars['ID']['input'];
  type: GQLExpireProductsTypes;
};

export enum GQLExpireProductsTypes {
  EXPIRED = 'EXPIRED',
  NO_SHOW = 'NO_SHOW',
  OTHER = 'OTHER'
}

export type GQLFaqItem = {
  __typename?: 'FAQItem';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type GQLFeature = {
  __typename?: 'Feature';
  icon: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLFeatureFlag = GQLFeatureFlagBool | GQLFeatureFlagInt | GQLFeatureFlagString;

export type GQLFeatureFlagBase = {
  key: Scalars['ID']['output'];
};

export type GQLFeatureFlagBool = GQLFeatureFlagBase & {
  __typename?: 'FeatureFlagBool';
  key: Scalars['ID']['output'];
  value: Scalars['Boolean']['output'];
};

export type GQLFeatureFlagInt = GQLFeatureFlagBase & {
  __typename?: 'FeatureFlagInt';
  key: Scalars['ID']['output'];
  value: Scalars['Int']['output'];
};

export type GQLFeatureFlagString = GQLFeatureFlagBase & {
  __typename?: 'FeatureFlagString';
  key: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type GQLFeaturesSection = {
  __typename?: 'FeaturesSection';
  description: Scalars['String']['output'];
  features: Array<GQLFeature>;
  title: Scalars['String']['output'];
};

export type GQLFieldInfo = {
  __typename?: 'FieldInfo';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<GQLOption>>;
  styles?: Maybe<GQLFieldStyles>;
  type: Scalars['String']['output'];
};

export type GQLFieldStyles = {
  __typename?: 'FieldStyles';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  helperText?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type GQLFirebaseCourseSessionTime = {
  __typename?: 'FirebaseCourseSessionTime';
  sessionEnd?: Maybe<Scalars['DateTime']['output']>;
  sessionStart?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLFleetAttachment = {
  __typename?: 'FleetAttachment';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  entityId: Scalars['ID']['output'];
  entityType: GQLFleetEntityType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GQLFleetAttachmentsQuery = {
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
};

export enum GQLFleetEntityType {
  Hub = 'Hub',
  Vehicle = 'Vehicle'
}

export type GQLFleetNote = {
  __typename?: 'FleetNote';
  attachmentIds: Array<Scalars['ID']['output']>;
  attachments: Array<GQLFleetAttachment>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<GQLPerson>;
  createdById: Scalars['ID']['output'];
  entityId: Scalars['ID']['output'];
  entityType: GQLFleetEntityType;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<GQLPerson>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type GQLFleetNoteEdge = {
  __typename?: 'FleetNoteEdge';
  cursor: Scalars['ID']['output'];
  node: GQLFleetNote;
};

export type GQLFleetNotesPaginatedList = {
  __typename?: 'FleetNotesPaginatedList';
  edges: Array<GQLFleetNoteEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLFleetNotesQuery = {
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
};

export type GQLFulfillFreeCheckoutOrderInput = {
  cartId: Scalars['ID']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLFulfillFreeCheckoutOrderPayload = {
  __typename?: 'FulfillFreeCheckoutOrderPayload';
  purchaseId: Scalars['ID']['output'];
};

export type GQLFundsBalance = {
  __typename?: 'FundsBalance';
  availableCents: Scalars['Int']['output'];
  paidCents: Scalars['Int']['output'];
  receivedCents: Scalars['Int']['output'];
  refundedCents: Scalars['Int']['output'];
  sentCents: Scalars['Int']['output'];
  voidedCents: Scalars['Int']['output'];
};

export type GQLGenerateDigitalCertificateInput = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLGenerateStudentDetailedCourseReportPdfInput = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLGeoJsonFeature = {
  __typename?: 'GeoJsonFeature';
  geometry: GQLGeoJsonGeometry;
  id: Scalars['ID']['output'];
  properties: GQLGeoJsonProperties;
  type: Scalars['String']['output'];
};

export type GQLGeoJsonFeatureCollection = {
  __typename?: 'GeoJsonFeatureCollection';
  features: Array<GQLGeoJsonFeatureCollectionFeature>;
  type: Scalars['String']['output'];
};

export type GQLGeoJsonFeatureCollectionFeature = {
  __typename?: 'GeoJsonFeatureCollectionFeature';
  geometry: GQLGeoJsonGeometry;
  id: Scalars['ID']['output'];
  properties: Scalars['JSONObject']['output'];
  type: Scalars['String']['output'];
};

export type GQLGeoJsonGeometry = {
  __typename?: 'GeoJsonGeometry';
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>;
  type: Scalars['String']['output'];
};

export type GQLGeoJsonProperties = {
  __typename?: 'GeoJsonProperties';
  label?: Maybe<Scalars['String']['output']>;
  pricePerMinute?: Maybe<Scalars['Float']['output']>;
};

export type GQLGetLessonReviewInput = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLHelpfulLink = {
  __typename?: 'HelpfulLink';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GQLHighlight = {
  __typename?: 'Highlight';
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GQLHubCalendar = {
  __typename?: 'HubCalendar';
  approvedInstructorsSchedules: Array<GQLApprovedInstructorSchedule>;
  calendarEvents: Array<GQLHubCalendarEvent>;
  hub: GQLParkingHub;
  instructorsSchedules: Array<GQLInstructorSchedule>;
  isVehiclePageTruncated: Scalars['Boolean']['output'];
  timeZone: Scalars['String']['output'];
  vehicles: GQLVehiclesPaginatedList;
};

export type GQLHubCalendarEvent = {
  __typename?: 'HubCalendarEvent';
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Present for avail/approvedSchedule/timeOff events.
   * noAvail events are vehicle-level placeholders and do not have an instructor.
   */
  instructor?: Maybe<GQLInstructor>;
  isAllDay: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: GQLHubCalendarEventType;
  vehicle?: Maybe<GQLAvailabilityVehicleRef>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export enum GQLHubCalendarEventType {
  ApprovedSchedule = 'approvedSchedule',
  Avail = 'avail',
  NoAvail = 'noAvail',
  TimeOff = 'timeOff'
}

export type GQLHubCalendarQuery = {
  endDate: Scalars['DateString']['input'];
  hubId: Scalars['ID']['input'];
  startDate: Scalars['DateString']['input'];
};

export type GQLIdLessonPackageInput = {
  id: Scalars['ID']['input'];
  item: GQLProductPackageWithPriceInput;
};

export type GQLIdToken = {
  __typename?: 'IdToken';
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type GQLIllinoisCompletionForm = {
  __typename?: 'IllinoisCompletionForm';
  firstName: Scalars['String']['output'];
  isClassroomCreditTransferred: Scalars['Boolean']['output'];
  isLaboratoryCreditTransferred: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  middleInit: Scalars['String']['output'];
  noMiddleName: Scalars['Boolean']['output'];
  sex: Scalars['String']['output'];
};

export type GQLImpersonateUserResponse = {
  __typename?: 'ImpersonateUserResponse';
  token: Scalars['String']['output'];
};

export enum GQLInitiatedBy {
  Coastline = 'Coastline',
  Immediate_Reschedule = 'Immediate_Reschedule',
  Instructor = 'Instructor',
  Student = 'Student'
}

export type GQLInstructor = {
  __typename?: 'Instructor';
  about?: Maybe<Scalars['String']['output']>;
  adminInfo: GQLInstructorAdminInfo;
  badges?: Maybe<Array<GQLInstructorBadge>>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Scalars['String']['output']>;
  locationLandingPage?: Maybe<GQLLocationLandingPage>;
  locationLandingPageId?: Maybe<Scalars['ID']['output']>;
  locationLandingPageName?: Maybe<Scalars['String']['output']>;
  meetingPoints: Array<GQLStateMeetingPoint>;
  metro?: Maybe<GQLMetro>;
  name: Scalars['String']['output'];
  portraitImage?: Maybe<Scalars['String']['output']>;
  privateInfo: GQLInstructorPrivateInfo;
  signInEmail?: Maybe<Scalars['String']['output']>;
  spokenLanguageCodes?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  usState?: Maybe<GQLUsState>;
  usStateId: Scalars['ID']['output'];
  wallpaperImage?: Maybe<Scalars['String']['output']>;
};

export type GQLInstructorAddStudentInput = {
  productQuantityList: Array<GQLProductQuantityInput>;
  studentId: Scalars['ID']['input'];
};

export type GQLInstructorAdminInfo = {
  __typename?: 'InstructorAdminInfo';
  badges?: Maybe<Array<GQLInstructorBadge>>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isRetired?: Maybe<Scalars['Boolean']['output']>;
  isTrainee: Scalars['Boolean']['output'];
  payrollFirstName?: Maybe<Scalars['String']['output']>;
  payrollLastName?: Maybe<Scalars['String']['output']>;
  payrollTitle?: Maybe<Scalars['String']['output']>;
  regionalManager?: Maybe<GQLPerson>;
  regionalManagerId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['ID']['output'];
};

export type GQLInstructorAlert = {
  __typename?: 'InstructorAlert';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  readMoreLink?: Maybe<Scalars['String']['output']>;
  severity: GQLInstructorAlertSeverity;
  timestamp: Scalars['DateTime']['output'];
};

export type GQLInstructorAlertCreateInput = {
  message: Scalars['String']['input'];
  readMoreLink?: InputMaybe<Scalars['String']['input']>;
  severity: GQLInstructorAlertSeverity;
};

export type GQLInstructorAlertDeleteInput = {
  id: Scalars['ID']['input'];
};

export type GQLInstructorAlertEdge = {
  __typename?: 'InstructorAlertEdge';
  cursor: Scalars['ID']['output'];
  node: GQLInstructorAlert;
};

export type GQLInstructorAlertPaginatedList = {
  __typename?: 'InstructorAlertPaginatedList';
  edges: Array<GQLInstructorAlertEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum GQLInstructorAlertSeverity {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export type GQLInstructorAlertUpdateInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  readMoreLink?: InputMaybe<Scalars['String']['input']>;
  severity: GQLInstructorAlertSeverity;
};

export type GQLInstructorBadge = {
  __typename?: 'InstructorBadge';
  icon: GQLInstructorBadgeIcon;
  title: Scalars['String']['output'];
};

export enum GQLInstructorBadgeIcon {
  Lessons100 = 'lessons100',
  Lessons200 = 'lessons200',
  Lessons500 = 'lessons500',
  Lessons800 = 'lessons800',
  Lessons1000 = 'lessons1000',
  Lessons1500 = 'lessons1500',
  Lessons2000 = 'lessons2000',
  Manager = 'manager',
  Operator = 'operator',
  OtherLanguage = 'otherLanguage',
  TrainingSpecialist = 'trainingSpecialist'
}

export type GQLInstructorBadgeInput = {
  icon: GQLInstructorBadgeIcon;
  title: Scalars['String']['input'];
};

export type GQLInstructorBadgeQuery = {
  instructorId: Scalars['ID']['input'];
};

export type GQLInstructorDailyAvailabilitiesQuery = {
  date: Scalars['String']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLInstructorEdge = {
  __typename?: 'InstructorEdge';
  cursor: Scalars['ID']['output'];
  node: GQLInstructor;
};

export type GQLInstructorEvent = {
  __typename?: 'InstructorEvent';
  activity: Scalars['String']['output'];
  breakEndTime?: Maybe<Scalars['DateTime']['output']>;
  breakStartTime?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use cohortIds */
  cohortId?: Maybe<Scalars['ID']['output']>;
  cohortIds?: Maybe<Array<Scalars['ID']['output']>>;
  cohortName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cohortSessionIds */
  cohortSessionId?: Maybe<Scalars['ID']['output']>;
  cohortSessionIds?: Maybe<Array<Scalars['ID']['output']>>;
  cohortSessionName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  estTravelDistance?: Maybe<Scalars['Float']['output']>;
  estTravelTime?: Maybe<Scalars['Float']['output']>;
  eventSourceType: GQLInstructorEventSourceType;
  lessonId?: Maybe<Scalars['ID']['output']>;
  lessonTypeDurationMinutes?: Maybe<Scalars['Float']['output']>;
  lessonTypeName?: Maybe<Scalars['String']['output']>;
  nonTeachingRateTime?: Maybe<Scalars['Float']['output']>;
  otherRateTime?: Maybe<Scalars['Float']['output']>;
  otherTime?: Maybe<Scalars['Float']['output']>;
  sourceRateType?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  teachingRateTime?: Maybe<Scalars['Float']['output']>;
  teachingTime?: Maybe<Scalars['Float']['output']>;
  timeLogId?: Maybe<Scalars['ID']['output']>;
  travelDistance?: Maybe<Scalars['Float']['output']>;
  travelSegmentPosition?: Maybe<GQLInstructorEventTravelSegmentPosition>;
  travelTime?: Maybe<Scalars['Float']['output']>;
  type: GQLInstructorEventType;
};

export type GQLInstructorEventAuditIssue = {
  __typename?: 'InstructorEventAuditIssue';
  code: GQLInstructorEventAuditIssueCode;
  lessonId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export enum GQLInstructorEventAuditIssueCode {
  MISSING_AVAIL_COORDS = 'MISSING_AVAIL_COORDS',
  MISSING_AVAIL_FOR_LESSON_DAY = 'MISSING_AVAIL_FOR_LESSON_DAY',
  MISSING_LESSON_PICKUP_COORDS = 'MISSING_LESSON_PICKUP_COORDS',
  TRAVEL_STATS_UNAVAILABLE = 'TRAVEL_STATS_UNAVAILABLE'
}

export enum GQLInstructorEventSourceType {
  CLASSROOM_SESSION = 'CLASSROOM_SESSION',
  LESSON = 'LESSON',
  MANUAL_TIME_LOG = 'MANUAL_TIME_LOG',
  MEAL_BREAK = 'MEAL_BREAK',
  PAID_BREAK = 'PAID_BREAK',
  SYSTEM_TRAVEL = 'SYSTEM_TRAVEL'
}

export enum GQLInstructorEventTravelSegmentPosition {
  BETWEEN_LESSONS = 'BETWEEN_LESSONS',
  FROM_LAST_LESSON = 'FROM_LAST_LESSON',
  TO_FIRST_LESSON = 'TO_FIRST_LESSON'
}

export enum GQLInstructorEventType {
  BREAK = 'BREAK',
  CLASSROOM_SESSION = 'CLASSROOM_SESSION',
  DRIVE = 'DRIVE',
  ESTIMATED = 'ESTIMATED',
  FILLER = 'FILLER',
  LESSON = 'LESSON',
  MEAL_BREAK = 'MEAL_BREAK',
  TIME_LOG = 'TIME_LOG'
}

export type GQLInstructorEventsInput = {
  endDate: Scalars['DateTime']['input'];
  instructorId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type GQLInstructorEventsResponse = {
  __typename?: 'InstructorEventsResponse';
  eventsByDay: Array<GQLDayEvents>;
};

export type GQLInstructorIsochrone = {
  __typename?: 'InstructorIsochrone';
  geoJson: Scalars['JSONObject']['output'];
  instructor: GQLInstructorIsochroneInstructor;
  isCustom: Scalars['Boolean']['output'];
};

export type GQLInstructorIsochroneInstructor = {
  __typename?: 'InstructorIsochroneInstructor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: GQLUsStateId;
};

export type GQLInstructorLessonNotificationRegistrationsQuery = {
  instructorId: Scalars['ID']['input'];
  maxMilesDistance?: InputMaybe<Scalars['Float']['input']>;
  onlyHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLInstructorLessonNotificationRegistrationsResponse = {
  __typename?: 'InstructorLessonNotificationRegistrationsResponse';
  from: Scalars['DateTime']['output'];
  registrations: Array<GQLLessonNotificationRegistrationForInstructor>;
  to: Scalars['DateTime']['output'];
};

export type GQLInstructorLessonUpdateInput = {
  actualDurationMinutes: Scalars['Int']['input'];
  actualDurationNote: Scalars['String']['input'];
};

export type GQLInstructorMetricsPeriodRange = {
  __typename?: 'InstructorMetricsPeriodRange';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type GQLInstructorMetricsReport = {
  __typename?: 'InstructorMetricsReport';
  periodRanges: Array<GQLInstructorMetricsPeriodRange>;
  summaries: Array<GQLInstructorMetricsSummary>;
  timeseries: Array<GQLInstructorMetricsTimeSeriesPoint>;
};

export type GQLInstructorMetricsSummary = {
  __typename?: 'InstructorMetricsSummary';
  cancelPerc?: Maybe<Scalars['Float']['output']>;
  certPerc?: Maybe<Scalars['Float']['output']>;
  leftOnTimePerc?: Maybe<Scalars['Float']['output']>;
  lessonHours?: Maybe<Scalars['Float']['output']>;
  numCancels?: Maybe<Scalars['Int']['output']>;
  numLessons?: Maybe<Scalars['Int']['output']>;
  periodId: Scalars['ID']['output'];
  reportPerc?: Maybe<Scalars['Float']['output']>;
  reportSentPerc?: Maybe<Scalars['Float']['output']>;
  reviewAvg?: Maybe<Scalars['Float']['output']>;
  reviewPerc?: Maybe<Scalars['Float']['output']>;
};

export type GQLInstructorMetricsTimeSeriesPoint = {
  __typename?: 'InstructorMetricsTimeSeriesPoint';
  cancelPerc?: Maybe<Scalars['Float']['output']>;
  certPerc?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  leftOnTimePerc?: Maybe<Scalars['Float']['output']>;
  lessonHours?: Maybe<Scalars['Float']['output']>;
  numCancels?: Maybe<Scalars['Int']['output']>;
  numLessons?: Maybe<Scalars['Int']['output']>;
  reportPerc?: Maybe<Scalars['Float']['output']>;
  reportSentPerc?: Maybe<Scalars['Float']['output']>;
  reviewAvg?: Maybe<Scalars['Float']['output']>;
  reviewPerc?: Maybe<Scalars['Float']['output']>;
};

export type GQLInstructorMutationTimeOffQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLInstructorOnAvail = {
  __typename?: 'InstructorOnAvail';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
};

export type GQLInstructorPrivateInfo = {
  __typename?: 'InstructorPrivateInfo';
  availsFixedByDefault?: Maybe<Scalars['Boolean']['output']>;
  baseAddress?: Maybe<Scalars['String']['output']>;
  breakTimes: Array<Scalars['Int']['output']>;
  canManageMeetingLocations?: Maybe<Scalars['Boolean']['output']>;
  canManageOwnSchedule?: Maybe<Scalars['Boolean']['output']>;
  doNotSyncHoursWithPayroll?: Maybe<Scalars['Boolean']['output']>;
  doNotSyncRoadTestHoursWithPayroll?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  employmentType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasRoadTestStipend?: Maybe<Scalars['Boolean']['output']>;
  hasSignedBreakTimeWaiver?: Maybe<Scalars['Boolean']['output']>;
  jobCodes?: Maybe<Array<Scalars['String']['output']>>;
  lastName: Scalars['String']['output'];
  licenseExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  managerId?: Maybe<Scalars['ID']['output']>;
  managerName?: Maybe<Scalars['String']['output']>;
  maxBaseTravelMinutes?: Maybe<Scalars['Int']['output']>;
  maxBaseTravelMinutesOverride?: Maybe<Scalars['Int']['output']>;
  maxBetweenTravelMinutes?: Maybe<Scalars['Int']['output']>;
  maxBetweenTravelMinutesOverride?: Maybe<Scalars['Int']['output']>;
  nonTeachingPay?: Maybe<Scalars['Int']['output']>;
  optOutLessonEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  paylocityId?: Maybe<Scalars['ID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  servicesProvided?: Maybe<Scalars['JSONObject']['output']>;
  slackUsername?: Maybe<Scalars['String']['output']>;
  status: GQLInstructorStatus;
  teachingPay?: Maybe<Scalars['Int']['output']>;
};

export type GQLInstructorSchedule = {
  __typename?: 'InstructorSchedule';
  createdAt: Scalars['DateTime']['output'];
  dayTimesAvailable: Array<GQLScheduleDayTimes>;
  daysPerWeek: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  instructorName?: Maybe<Scalars['String']['output']>;
  isApproved: Scalars['Boolean']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  rollingWeekLength?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  timesOff?: Maybe<Array<GQLInstructorTimeOff>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GQLInstructorScheduleInput = {
  dayTimesAvailable: Array<GQLScheduleDayTimesInput>;
  daysPerWeek: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorId: Scalars['ID']['input'];
  rollingWeekLength: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GQLInstructorScheduleQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorId: Scalars['ID']['input'];
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLInstructorScheduleUpdateInput = {
  dayTimesAvailable?: InputMaybe<Array<GQLScheduleDayTimesInput>>;
  daysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  rollingWeekLength?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum GQLInstructorStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Retired = 'Retired',
  Trainee = 'Trainee'
}

export type GQLInstructorTeachingZonePreview = {
  __typename?: 'InstructorTeachingZonePreview';
  geoJson: Scalars['JSONObject']['output'];
  isStatic: Scalars['Boolean']['output'];
};

export type GQLInstructorTeachingZonePreviewQuery = {
  address: Scalars['String']['input'];
  instructorId: Scalars['ID']['input'];
  maxTravelMinutes: Scalars['Int']['input'];
};

export type GQLInstructorTimeLog = {
  __typename?: 'InstructorTimeLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  logType: GQLInstructorTimeLogType;
  rateType: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type GQLInstructorTimeLogCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  instructorId: Scalars['ID']['input'];
  isOverlapAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  logType?: InputMaybe<GQLInstructorTimeLogType>;
  rateType: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  travelDistance?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLInstructorTimeLogEdge = {
  __typename?: 'InstructorTimeLogEdge';
  cursor: Scalars['ID']['output'];
  node: GQLInstructorTimeLog;
};

export type GQLInstructorTimeLogListQuery = {
  instructorId: Scalars['ID']['input'];
};

export type GQLInstructorTimeLogPaginatedList = {
  __typename?: 'InstructorTimeLogPaginatedList';
  edges: Array<GQLInstructorTimeLogEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLInstructorTimeLogQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
};

export enum GQLInstructorTimeLogType {
  Drive = 'Drive',
  Other = 'Other'
}

export type GQLInstructorTimeLogUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  isOverlapAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  rateType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLInstructorTimeOff = {
  __typename?: 'InstructorTimeOff';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GQLInstructorTimeOffInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GQLInstructorTimeOffQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructorId: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLInstructorZone = {
  __typename?: 'InstructorZone';
  center: GQLLatLng;
  features: Array<GQLGeoJsonFeature>;
  instructorId: Scalars['ID']['output'];
  instructorName: Scalars['String']['output'];
  isStatic: Scalars['Boolean']['output'];
};

export type GQLInstructorsCoverage = {
  __typename?: 'InstructorsCoverage';
  center: GQLLatLng;
  instructorZones: Array<GQLInstructorZone>;
};

export type GQLInstructorsPaginatedList = {
  __typename?: 'InstructorsPaginatedList';
  edges: Array<GQLInstructorEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLInstructorsQuery = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
  regionalManagerId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<GQLUsStateId>;
  statuses?: InputMaybe<Array<GQLInstructorStatus>>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type GQLInstructorsSchedulesQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLInstructorsTimeOffQuery = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  instructorIds: Array<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLItemBalancedQuantity = {
  __typename?: 'ItemBalancedQuantity';
  balancedQuantity: GQLBalancedQuantity;
  itemId: Scalars['ID']['output'];
};

export type GQLItemInput = {
  customAmount?: InputMaybe<Scalars['Float']['input']>;
  itemId: Scalars['ID']['input'];
  products?: InputMaybe<Array<GQLSubItemInput>>;
  quantity: Scalars['Int']['input'];
};

export type GQLItemToExpire = {
  __typename?: 'ItemToExpire';
  expiredQuantity: Scalars['Int']['output'];
  itemId: Scalars['ID']['output'];
  product: GQLProductInfo;
  productId: Scalars['ID']['output'];
};

export type GQLItemToExpireInput = {
  expiredQuantity: Scalars['Int']['input'];
  itemId: Scalars['ID']['input'];
};

export type GQLItemToRefund = {
  __typename?: 'ItemToRefund';
  itemId: Scalars['ID']['output'];
  product: GQLProductInfo;
  productId: Scalars['ID']['output'];
  refundedQuantity: Scalars['Int']['output'];
};

export type GQLItemToRefundInput = {
  itemId: Scalars['ID']['input'];
  refundedQuantity: Scalars['Int']['input'];
};

export type GQLItemToTransfer = {
  __typename?: 'ItemToTransfer';
  itemId: Scalars['ID']['output'];
  product: GQLProduct;
  productId: Scalars['ID']['output'];
  transferredQuantity: Scalars['Int']['output'];
};

export type GQLItemToTransferAndExpire = {
  __typename?: 'ItemToTransferAndExpire';
  itemId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  purchaseId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type GQLItemToTransferInput = {
  itemId: Scalars['ID']['input'];
  transferredQuantity: Scalars['Int']['input'];
};

export type GQLItemsToExpireByPurchase = {
  __typename?: 'ItemsToExpireByPurchase';
  itemsToExpire: Array<GQLItemToExpire>;
  purchaseId: Scalars['ID']['output'];
};

export type GQLLanguageOption = {
  __typename?: 'LanguageOption';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GQLLastBookedInstructor = {
  __typename?: 'LastBookedInstructor';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GQLLatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GQLLectureBlockColumn = GQLLectureSingleImageBlock | GQLLectureTitleBlock;

export type GQLLectureBlockTextColumn = {
  __typename?: 'LectureBlockTextColumn';
  structuredText: Scalars['JSONObject']['output'];
};

export type GQLLectureColumnImage = {
  __typename?: 'LectureColumnImage';
  image: GQLLectureContentImage;
};

export type GQLLectureContentBlock = GQLLectureSingleImageBlock | GQLLectureSingleVideoBlock | GQLLectureTitleBlock | GQLLectureTwoColumnBlock;

export enum GQLLectureContentBlockType {
  SingleImage = 'singleImage',
  SingleVideo = 'singleVideo',
  Title = 'title',
  TwoColumn = 'twoColumn'
}

export type GQLLectureContentImage = {
  __typename?: 'LectureContentImage';
  alt?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  base64?: Maybe<Scalars['String']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
  srcSet?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  webpSrcSet?: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};

export type GQLLectureContentPart = {
  __typename?: 'LectureContentPart';
  blocks: Array<GQLLectureContentBlock>;
  id: Scalars['ID']['output'];
  structuredText?: Maybe<Scalars['JSONObject']['output']>;
  type: GQLLecturePartType;
  video?: Maybe<GQLLectureContentVideo>;
};

export type GQLLectureContentVideo = {
  __typename?: 'LectureContentVideo';
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GQLLecturePart = GQLLectureContentPart | GQLLectureQuizPart;

export enum GQLLecturePartType {
  Content = 'content',
  Quiz = 'quiz'
}

export type GQLLectureQuestionChoice = {
  __typename?: 'LectureQuestionChoice';
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
};

export type GQLLectureQuizPart = {
  __typename?: 'LectureQuizPart';
  id: Scalars['ID']['output'];
  questions: Array<GQLLectureQuizQuestion>;
  type: GQLLecturePartType;
};

export type GQLLectureQuizQuestion = GQLQuizQuestion & {
  __typename?: 'LectureQuizQuestion';
  /** @deprecated This field has to be inaccessible by students */
  answer: Scalars['String']['output'];
  choices?: Maybe<Array<GQLLectureQuestionChoice>>;
  doShuffle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<GQLLectureContentImage>;
  question: Scalars['String']['output'];
  type: GQLQuizQuestionType;
};

export type GQLLectureQuizQuestionPrepTestScore = {
  __typename?: 'LectureQuizQuestionPrepTestScore';
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
};

export type GQLLectureQuizQuestionPrepTestScoreInput = {
  id: Scalars['ID']['input'];
  isCorrect: Scalars['Boolean']['input'];
};

export type GQLLectureReport = {
  __typename?: 'LectureReport';
  id: Scalars['ID']['output'];
  testScore?: Maybe<Scalars['Float']['output']>;
  totalTimeSeconds?: Maybe<Scalars['Int']['output']>;
};

export type GQLLectureSessionTime = {
  __typename?: 'LectureSessionTime';
  lectureId?: Maybe<Scalars['ID']['output']>;
  session?: Maybe<GQLFirebaseCourseSessionTime>;
};

export type GQLLectureSingleImageBlock = {
  __typename?: 'LectureSingleImageBlock';
  id: Scalars['ID']['output'];
  image: GQLLectureContentImage;
  type: GQLLectureContentBlockType;
};

export type GQLLectureSingleVideoBlock = {
  __typename?: 'LectureSingleVideoBlock';
  id: Scalars['ID']['output'];
  type: GQLLectureContentBlockType;
  video?: Maybe<GQLLectureContentVideo>;
};

export type GQLLectureTimeDaily = {
  __typename?: 'LectureTimeDaily';
  date: Scalars['String']['output'];
  totalTimeSeconds: Scalars['Int']['output'];
};

export type GQLLectureTitleBlock = {
  __typename?: 'LectureTitleBlock';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: GQLLectureContentBlockType;
};

export type GQLLectureTwoColumnBlock = {
  __typename?: 'LectureTwoColumnBlock';
  column1: Array<GQLLectureBlockColumn>;
  column2: GQLLectureBlockTextColumn;
  id: Scalars['ID']['output'];
  type: GQLLectureContentBlockType;
};

export type GQLLedgerEntity = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  versionId: Scalars['ID']['output'];
};

export type GQLLedgerLog = GQLLedgerLogCancelLesson | GQLLedgerLogCharge | GQLLedgerLogEditPurchase | GQLLedgerLogExpireProducts | GQLLedgerLogRefund | GQLLedgerLogRemoveStudentFromLesson | GQLLedgerLogScheduleLesson | GQLLedgerLogScheduleMultipleLessons | GQLLedgerLogTransferAccount | GQLLedgerLogTransferExpiration | GQLLedgerLogTransferLesson | GQLLedgerLogTransferPurchase | GQLLedgerLogUpdateLesson | GQLLedgerLogVoidExpiration | GQLLedgerLogVoidPurchase | GQLLedgerLogVoidRefund;

export type GQLLedgerLogCancelLesson = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogCancelLesson';
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  purchaseIds: Array<Scalars['ID']['output']>;
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogCancelLessonSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogCharge = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogCharge';
  amountDollars: Scalars['Float']['output'];
  categoryId: GQLPaymentCategories;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscount?: Maybe<Scalars['Float']['output']>;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<GQLPurchaseItem>;
  paymentCaptureDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
  usStateId: GQLUsStateId;
  voucherCode?: Maybe<Scalars['String']['output']>;
};


export type GQLLedgerLogChargeSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogEditPurchase = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogEditPurchase';
  categoryId?: Maybe<GQLPaymentCategories>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscount?: Maybe<Scalars['Float']['output']>;
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemsUpdates?: Maybe<Array<GQLPurchaseItemUpdate>>;
  paymentCaptureDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseId: Scalars['ID']['output'];
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
  usStateId?: Maybe<GQLUsStateId>;
  voucherCode?: Maybe<Scalars['String']['output']>;
};


export type GQLLedgerLogEditPurchaseSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogExpireProducts = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogExpireProducts';
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  expirationType: GQLExpireProductsTypes;
  id: Scalars['ID']['output'];
  isVoid: Scalars['Boolean']['output'];
  itemsToExpire: Array<GQLItemToExpire>;
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogExpireProductsSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogRefund = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogRefund';
  amountToRefund: Scalars['Float']['output'];
  categoryId: GQLPaymentCategories;
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemsToRefund?: Maybe<Array<GQLItemToRefund>>;
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogRefundSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogRemoveStudentFromLesson = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogRemoveStudentFromLesson';
  createdById: Scalars['ID']['output'];
  expenditures: Array<GQLExpenditure>;
  id: Scalars['ID']['output'];
  initiatedBy: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogRemoveStudentFromLessonSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogScheduleLesson = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogScheduleLesson';
  createdById: Scalars['ID']['output'];
  expenditures: Array<GQLExpenditure>;
  id: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogScheduleLessonSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogScheduleMultipleLessons = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogScheduleMultipleLessons';
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogScheduleMultipleLessonsSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogTransferAccount = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogTransferAccount';
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStudentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  purchaseIds: Array<Scalars['ID']['output']>;
  sourceStudentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogTransferAccountSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogTransferExpiration = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogTransferExpiration';
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStudentId: Scalars['ID']['output'];
  expirationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isVoid: Scalars['Boolean']['output'];
  itemsToTransferAndExpire: Array<GQLItemToTransferAndExpire>;
  purchaseIds: Array<Scalars['ID']['output']>;
  sourceStudentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogTransferExpirationSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogTransferLesson = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogTransferLesson';
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStudentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  purchaseIds: Array<Scalars['ID']['output']>;
  sourceStudentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogTransferLessonSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogTransferPurchase = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogTransferPurchase';
  amountToTransfer: Scalars['Float']['output'];
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStudentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  itemsToTransfer: Array<GQLItemToTransfer>;
  purchaseId: Scalars['ID']['output'];
  sourceStudentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogTransferPurchaseSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export enum GQLLedgerLogTypes {
  CancelLesson = 'cancelLesson',
  Charge = 'charge',
  EditPurchase = 'editPurchase',
  ExpireProducts = 'expireProducts',
  Refund = 'refund',
  RemoveStudentFromLesson = 'removeStudentFromLesson',
  ScheduleLesson = 'scheduleLesson',
  ScheduleMultipleLessons = 'scheduleMultipleLessons',
  TransferAccount = 'transferAccount',
  TransferExpiration = 'transferExpiration',
  TransferLesson = 'transferLesson',
  TransferPurchase = 'transferPurchase',
  UpdateLesson = 'updateLesson',
  VoidExpiration = 'voidExpiration',
  VoidPurchase = 'voidPurchase',
  VoidRefund = 'voidRefund'
}

export type GQLLedgerLogUpdateLesson = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogUpdateLesson';
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lessonId: Scalars['ID']['output'];
  studentIds: Array<Scalars['ID']['output']>;
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogUpdateLessonSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogVoidExpiration = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogVoidExpiration';
  createdById: Scalars['ID']['output'];
  expirationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogVoidExpirationSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogVoidPurchase = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogVoidPurchase';
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogVoidPurchaseSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogVoidRefund = GQLBaseLedgerLog & {
  __typename?: 'LedgerLogVoidRefund';
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  purchaseId: Scalars['ID']['output'];
  refundId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: GQLLedgerLogTypes;
};


export type GQLLedgerLogVoidRefundSummaryArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLedgerLogsEdge = {
  __typename?: 'LedgerLogsEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLedgerLog;
};

export type GQLLedgerLogsPaginatedList = {
  __typename?: 'LedgerLogsPaginatedList';
  edges: Array<GQLLedgerLogsEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLedgerLogsQuery = {
  studentId: Scalars['ID']['input'];
  types?: InputMaybe<Array<GQLLedgerLogTypes>>;
};

export type GQLLegacyLogSummary = {
  __typename?: 'LegacyLogSummary';
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type GQLLesson = {
  __typename?: 'Lesson';
  actualDurationMinutes?: Maybe<Scalars['Int']['output']>;
  actualDurationNote?: Maybe<Scalars['String']['output']>;
  bookedAt: Scalars['DateTime']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  durationMinutes: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  hasHomePickup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instructor: GQLInstructor;
  instructorId: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isFromCustomSlot: Scalars['Boolean']['output'];
  isFromReservationLink: Scalars['Boolean']['output'];
  isObserverAllowed: Scalars['Boolean']['output'];
  isShareable: Scalars['Boolean']['output'];
  lessonType?: Maybe<GQLLessonType>;
  locationId?: Maybe<Scalars['ID']['output']>;
  meetingPoint?: Maybe<GQLStateMeetingPoint>;
  meetingPointId?: Maybe<Scalars['ID']['output']>;
  observerInstructor?: Maybe<GQLInstructor>;
  observerInstructorId?: Maybe<Scalars['ID']['output']>;
  pickupLocation: Scalars['String']['output'];
  pickupLocationCoords?: Maybe<GQLLatLng>;
  price: Scalars['Float']['output'];
  searchState?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  studentDetails: GQLLessonStudentDetails;
  studentDetailsList: Array<GQLLessonStudentDetails>;
  studentIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type GQLLessonCurrentValueArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLLessonStudentDetailsArgs = {
  studentId: Scalars['ID']['input'];
};

export type GQLLessonAlertDeliveryResult = {
  __typename?: 'LessonAlertDeliveryResult';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLLessonCancelQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLLessonCancellationInfo = {
  cancelPolicy?: InputMaybe<GQLCancelPolicy>;
  cancellationReason?: InputMaybe<GQLLessonCancellationReason>;
  description: Scalars['String']['input'];
  initiatedBy: GQLInitiatedBy;
};

export enum GQLLessonCancellationReason {
  Other = 'other',
  Weather = 'weather'
}

export type GQLLessonCategoryRating = {
  __typename?: 'LessonCategoryRating';
  categoryId: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
};

export type GQLLessonCoupon = {
  __typename?: 'LessonCoupon';
  code: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  displayInLandingPages?: Maybe<Scalars['Boolean']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locations: Array<GQLLocationLandingPage>;
  onlyFirstPurchase: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: GQLCouponType;
};

export type GQLLessonCouponInput = {
  code: Scalars['String']['input'];
  discount: Scalars['Float']['input'];
  displayInLandingPages?: InputMaybe<Scalars['Boolean']['input']>;
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  onlyFirstPurchase: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type GQLLessonDrivingRatingChange = {
  drivingSkillId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};

export type GQLLessonDrivingSkillRating = {
  __typename?: 'LessonDrivingSkillRating';
  drivingSkill: GQLDrivingSkill;
  drivingSkillId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lesson: GQLLesson;
  lessonId: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  student: GQLStudent;
  studentId: Scalars['ID']['output'];
};

export type GQLLessonDrivingSkillRatingInput = {
  lessonDrivingRatingChange: Array<GQLLessonDrivingRatingChange>;
  lessonId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLLessonDrivingSkillsReport = {
  __typename?: 'LessonDrivingSkillsReport';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  drivingSkillsRatings: Array<GQLLessonDrivingSkillRating>;
  id: Scalars['ID']['output'];
  /** @deprecated Deprecated: always returns false and will be removed */
  isOnLastLesson?: Maybe<Scalars['Boolean']['output']>;
  lastEmailSent?: Maybe<Scalars['DateTime']['output']>;
  lesson: GQLLesson;
  lessonId: Scalars['ID']['output'];
  lessonStartTime: Scalars['DateTime']['output'];
  needsAdditionalLesson?: Maybe<Scalars['Boolean']['output']>;
  ratings?: Maybe<Array<GQLLessonCategoryRating>>;
  sends?: Maybe<Array<GQLLessonReportSend>>;
  student: GQLStudent;
  studentId: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLLessonDrivingSkillsReportEdge = {
  __typename?: 'LessonDrivingSkillsReportEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLessonDrivingSkillsReport;
};

export type GQLLessonDrivingSkillsReportPaginatedList = {
  __typename?: 'LessonDrivingSkillsReportPaginatedList';
  drivingSkills: Array<GQLDrivingSkill>;
  edges: Array<GQLLessonDrivingSkillsReportEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLessonEdge = {
  __typename?: 'LessonEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLesson;
};

export type GQLLessonNotificationRegistration = {
  __typename?: 'LessonNotificationRegistration';
  address: Scalars['String']['output'];
  coords: GQLLatLng;
  id: Scalars['ID']['output'];
  lessonType: Scalars['String']['output'];
  notificationInterval: Scalars['Float']['output'];
  ranges: Array<GQLLessonNotificationRegistrationRange>;
  studentId: Scalars['ID']['output'];
};

export type GQLLessonNotificationRegistrationEdge = {
  __typename?: 'LessonNotificationRegistrationEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLessonNotificationRegistration;
};

export type GQLLessonNotificationRegistrationForInstructor = {
  __typename?: 'LessonNotificationRegistrationForInstructor';
  address: Scalars['String']['output'];
  coords: GQLLatLng;
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  lessonType: Scalars['String']['output'];
  meetingPoint?: Maybe<Scalars['String']['output']>;
  milesDistanceFrom?: Maybe<Scalars['Float']['output']>;
  openings: Array<GQLLessonNotificationRegistrationOpening>;
  ranges: Array<GQLLessonNotificationRegistrationRange>;
  timeZone: Scalars['String']['output'];
};

export type GQLLessonNotificationRegistrationInput = {
  notificationInterval: Scalars['Float']['input'];
  ranges: Array<GQLLessonNotificationRegistrationRangeInput>;
};

export type GQLLessonNotificationRegistrationOpening = {
  __typename?: 'LessonNotificationRegistrationOpening';
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type GQLLessonNotificationRegistrationPaginatedList = {
  __typename?: 'LessonNotificationRegistrationPaginatedList';
  edges: Array<GQLLessonNotificationRegistrationEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLessonNotificationRegistrationRange = {
  __typename?: 'LessonNotificationRegistrationRange';
  day: GQLWeekDays;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type GQLLessonNotificationRegistrationRangeInput = {
  day: GQLWeekDays;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type GQLLessonNotificationRegistrationsQuery = {
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLLessonPackage = {
  __typename?: 'LessonPackage';
  drivingMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isSharedLessons?: Maybe<Scalars['Boolean']['output']>;
  numLessons: Scalars['Int']['output'];
  numRoadTests: Scalars['Int']['output'];
  observationMinutes: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type GQLLessonPackageInput = {
  drivingMinutes: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  isSharedLessons?: InputMaybe<Scalars['Boolean']['input']>;
  numLessons: Scalars['Int']['input'];
  numRoadTests: Scalars['Int']['input'];
  observationMinutes: Scalars['Int']['input'];
  totalMinutes: Scalars['Int']['input'];
};

export type GQLLessonQuery = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLLessonRemoveStudentQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLLessonReportSend = {
  __typename?: 'LessonReportSend';
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sentAt: Scalars['DateTime']['output'];
  sentById: Scalars['ID']['output'];
  sentTo: Array<Scalars['String']['output']>;
};

export type GQLLessonReview = {
  __typename?: 'LessonReview';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructor: GQLInstructor;
  instructorId: Scalars['ID']['output'];
  lesson: GQLLesson;
  lessonId: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  student: GQLStudent;
  studentId: Scalars['ID']['output'];
  studentName: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GQLLessonReviewEdge = {
  __typename?: 'LessonReviewEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLessonReview;
};

export type GQLLessonStudentDetails = {
  __typename?: 'LessonStudentDetails';
  dmvConfirmationCode?: Maybe<Scalars['String']['output']>;
  dmvLocation?: Maybe<Scalars['String']['output']>;
  drivingHistory?: Maybe<Scalars['String']['output']>;
  hasReview: Scalars['Boolean']['output'];
  hasSentReportToStudent: Scalars['Boolean']['output'];
  isObserverAllowed: Scalars['Boolean']['output'];
  lessonId: Scalars['ID']['output'];
  pickupDetails?: Maybe<Scalars['String']['output']>;
  productQuantity: Scalars['Int']['output'];
  productQuantityList: Array<GQLProductQuantity>;
  student: GQLStudent;
  studentId: Scalars['ID']['output'];
};


export type GQLLessonStudentDetailsProductQuantityArgs = {
  productId: Scalars['ID']['input'];
};

export type GQLLessonStudentDetailsInput = {
  allowObserver?: InputMaybe<Scalars['String']['input']>;
  dmvConfirmationCode?: InputMaybe<Scalars['String']['input']>;
  dmvLocation?: InputMaybe<Scalars['String']['input']>;
  drivingHistory?: InputMaybe<Scalars['String']['input']>;
  pickupDetails?: InputMaybe<Scalars['String']['input']>;
  previousSchoolLessons?: InputMaybe<Scalars['String']['input']>;
};

export type GQLLessonStudentDetailsUpdateInput = {
  dmvLocation?: InputMaybe<Scalars['String']['input']>;
  drivingMinutes: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  observationMinutes: Scalars['Float']['input'];
  pickupDetails?: InputMaybe<Scalars['String']['input']>;
};

export type GQLLessonType = {
  __typename?: 'LessonType';
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Float']['output'];
  features: Array<GQLLessonTypeFeature>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GQLLessonTypeCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes: Scalars['Float']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GQLLessonTypeEdge = {
  __typename?: 'LessonTypeEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLessonType;
};

export type GQLLessonTypeFeature = {
  __typename?: 'LessonTypeFeature';
  content: Array<Scalars['String']['output']>;
  state: GQLUsState;
};

export type GQLLessonTypeFeaturesInput = {
  content: Array<Scalars['String']['input']>;
  usState: Scalars['ID']['input'];
};

export type GQLLessonTypeForMeetingPoint = {
  __typename?: 'LessonTypeForMeetingPoint';
  name: Scalars['String']['output'];
  nameId: GQLLessonTypeName;
};

export type GQLLessonTypeInput = {
  durationMinutes: Scalars['Int']['input'];
  filterLabel?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum GQLLessonTypeName {
  DmvTest = 'DmvTest',
  OneHour = 'OneHour',
  OneHourShared = 'OneHourShared',
  PrepTest60 = 'PrepTest60',
  RoadTest = 'RoadTest',
  RoadTest15 = 'RoadTest15',
  RoadTest15WithCar = 'RoadTest15WithCar',
  RoadTestWithCar = 'RoadTestWithCar',
  Shared = 'Shared',
  Standard = 'Standard'
}

export type GQLLessonTypeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GQLLessonTypesPaginatedList = {
  __typename?: 'LessonTypesPaginatedList';
  edges: Array<GQLLessonTypeEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLessonUpdateAddStudent = {
  dmvConfirmationCode?: InputMaybe<Scalars['String']['input']>;
  dmvLocation?: InputMaybe<Scalars['String']['input']>;
  drivingHistory?: InputMaybe<Scalars['String']['input']>;
  isObserverAllowed: Scalars['Boolean']['input'];
  pickupDetails?: InputMaybe<Scalars['String']['input']>;
  previousSchoolLessons?: InputMaybe<Scalars['String']['input']>;
  productQuantityList: Array<GQLProductQuantityInput>;
  studentId: Scalars['ID']['input'];
};

export type GQLLessonUpdateChangeLessonDetails = {
  actualDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  actualDurationNote?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  lessonType?: InputMaybe<GQLLessonTypeInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  meetingPointId?: InputMaybe<Scalars['ID']['input']>;
  observerInstructorId?: InputMaybe<Scalars['ID']['input']>;
  pickupLocation?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLLessonUpdateChangeStudentDetails = {
  dmvConfirmationCode?: InputMaybe<Scalars['String']['input']>;
  dmvLocation?: InputMaybe<Scalars['String']['input']>;
  drivingHistory?: InputMaybe<Scalars['String']['input']>;
  isObserverAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  pickupDetails?: InputMaybe<Scalars['String']['input']>;
  previousSchoolLessons?: InputMaybe<Scalars['String']['input']>;
  productQuantityList?: InputMaybe<Array<GQLProductQuantityInput>>;
  studentId: Scalars['ID']['input'];
};

export type GQLLessonUpdateInput = {
  addStudent?: InputMaybe<Array<GQLLessonUpdateAddStudent>>;
  changeLessonDetails?: InputMaybe<GQLLessonUpdateChangeLessonDetails>;
  changeStudentDetails?: InputMaybe<Array<GQLLessonUpdateChangeStudentDetails>>;
};

export type GQLLessonUpdateQuery = {
  id: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
};

export type GQLLessonsDrivingSkillsReportsQuery = {
  studentId: Scalars['ID']['input'];
};

export type GQLLessonsPaginatedList = {
  __typename?: 'LessonsPaginatedList';
  edges: Array<GQLLessonEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLessonsQuery = {
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  studentId: Scalars['ID']['input'];
};

export type GQLLessonsQueryByInstructorIds = {
  endTime: Scalars['DateTime']['input'];
  instructorIds: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type GQLLessonsQueryByObserverInstructorIds = {
  endTime: Scalars['DateTime']['input'];
  observerInstructorIds: Array<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type GQLLessonsReviewsByInstructorQuery = {
  instructorId: Scalars['ID']['input'];
};

export type GQLLessonsReviewsPaginatedList = {
  __typename?: 'LessonsReviewsPaginatedList';
  edges: Array<GQLLessonReviewEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum GQLLicensingCourseStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_REQUIRED = 'NOT_REQUIRED',
  NOT_STARTED = 'NOT_STARTED'
}

export type GQLLicensingProgress = {
  __typename?: 'LicensingProgress';
  canBookRoadTest: Scalars['Boolean']['output'];
  courseStatus: GQLLicensingCourseStatus;
  documents: Array<GQLLicensingRequiredDocument>;
  eligibilityDate?: Maybe<Scalars['DateTime']['output']>;
  hasRequirementsConfig: Scalars['Boolean']['output'];
  isEligibilityDateReached: Scalars['Boolean']['output'];
  isReadyForAdminReview: Scalars['Boolean']['output'];
  requiredDocumentsComplete: Scalars['Boolean']['output'];
  requirements?: Maybe<GQLProgramDeadlineRequirements>;
  roadTestApprovedById?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<GQLUsStateId>;
};

export type GQLLicensingRequiredDocument = {
  __typename?: 'LicensingRequiredDocument';
  documentId: Scalars['ID']['output'];
  isUploaded: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLListing = {
  __typename?: 'Listing';
  details: Array<Scalars['String']['output']>;
  isMostPopular?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: GQLListingTitle;
  url: Scalars['String']['output'];
};

export type GQLListingTitle = {
  __typename?: 'ListingTitle';
  course: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GQLLivestreamGroup = {
  __typename?: 'LivestreamGroup';
  cohortAssignments: Array<GQLLivestreamGroupCohortAssignment>;
  id: Scalars['ID']['output'];
  locationLandingPages: Array<GQLLocationLandingPage>;
  name: Scalars['String']['output'];
  state: GQLUsStateId;
};


export type GQLLivestreamGroupCohortAssignmentsArgs = {
  dateRange?: InputMaybe<GQLDateRange>;
};

export type GQLLivestreamGroupCohortAssignment = {
  __typename?: 'LivestreamGroupCohortAssignment';
  cohort: GQLCohort;
  locationLandingPage: GQLLocationLandingPage;
};

export type GQLLivestreamGroupInput = {
  name: Scalars['String']['input'];
  state: GQLUsStateId;
};

export enum GQLLocationAllowed {
  Both = 'both',
  Home = 'home',
  MeetingPoint = 'meetingPoint'
}

export type GQLLocationCenter = {
  __typename?: 'LocationCenter';
  address: Scalars['String']['output'];
  geocode?: Maybe<GQLCenterGeocode>;
};

export type GQLLocationCoordsInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GQLLocationCourse = {
  __typename?: 'LocationCourse';
  courseType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GQLLocationLandingPage = {
  __typename?: 'LocationLandingPage';
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  center: GQLLocationCenter;
  cmsId?: Maybe<Scalars['String']['output']>;
  courses: Array<GQLLocationCourse>;
  externalId?: Maybe<Scalars['String']['output']>;
  googleMyBusinessUrl?: Maybe<Scalars['String']['output']>;
  hasPackageConfigurations: Scalars['Boolean']['output'];
  /** @deprecated Use hubIds instead. Locations can now be associated with multiple hubs. */
  hubId?: Maybe<Scalars['ID']['output']>;
  hubIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  instructorIds: Array<Scalars['ID']['output']>;
  isPhysicalLocation?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  livestreamCourseId?: Maybe<Scalars['ID']['output']>;
  livestreamGroup?: Maybe<GQLLivestreamGroup>;
  livestreamGroupId?: Maybe<Scalars['ID']['output']>;
  maxBaseTravelMinutesOverride?: Maybe<Scalars['Int']['output']>;
  maxBetweenTravelMinutesOverride?: Maybe<Scalars['Int']['output']>;
  meetingPointIds?: Maybe<Array<Scalars['String']['output']>>;
  metro?: Maybe<GQLMetro>;
  metroId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  packageConfigurations: Array<GQLLocationPackageConfig>;
  packages: Array<GQLProductPackageWithPrice>;
  packagesForConfig: Array<GQLProductPackageWithPrice>;
  priceScheme?: Maybe<GQLPriceScheme>;
  priceSchemeId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  state: GQLUsStateId;
  stateCmsId?: Maybe<Scalars['String']['output']>;
};

export type GQLLocationLandingPageEdge = {
  __typename?: 'LocationLandingPageEdge';
  cursor: Scalars['ID']['output'];
  node: GQLLocationLandingPage;
};

export type GQLLocationLandingPageInput = {
  address: Scalars['String']['input'];
  birdeyeBusinessId?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  googleMyBusinessUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use hubIds instead. Locations can now be associated with multiple hubs. */
  hubId?: InputMaybe<Scalars['ID']['input']>;
  hubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPhysicalLocation?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  livestreamCourseId?: InputMaybe<Scalars['ID']['input']>;
  livestreamGroupId?: InputMaybe<Scalars['ID']['input']>;
  maxBaseTravelMinutesOverride?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutesOverride?: InputMaybe<Scalars['Int']['input']>;
  meetingPointIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metroId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  packageConfigurations?: InputMaybe<Array<GQLLocationPackageConfigInput>>;
  priceSchemeId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateCmsId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLLocationLandingPagePaginatedList = {
  __typename?: 'LocationLandingPagePaginatedList';
  edges: Array<GQLLocationLandingPageEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLLocationLandingPagesFilter = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<GQLUsStateId>;
};

export type GQLLocationPackageConfig = {
  __typename?: 'LocationPackageConfig';
  bannerOverride?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['ID']['output']>;
  ctaLabelOverride?: Maybe<Scalars['String']['output']>;
  descriptionOverride?: Maybe<Scalars['String']['output']>;
  displayStyle: GQLPackageDisplayStyle;
  packageId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  titleOverride?: Maybe<Scalars['String']['output']>;
};

export type GQLLocationPackageConfigInput = {
  bannerOverride?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  ctaLabelOverride?: InputMaybe<Scalars['String']['input']>;
  descriptionOverride?: InputMaybe<Scalars['String']['input']>;
  displayStyle: GQLPackageDisplayStyle;
  packageId: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
  titleOverride?: InputMaybe<Scalars['String']['input']>;
};

export type GQLLocationPackagesForConfigInput = {
  courseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priceSchemeId: Scalars['ID']['input'];
  state: GQLUsStateId;
};

export type GQLLocationPin = {
  __typename?: 'LocationPin';
  center: GQLLocationCenter;
  googleMyBusinessUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use hubIds instead. Locations can now be associated with multiple hubs. */
  hubId?: Maybe<Scalars['ID']['output']>;
  hubIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  isPhysicalLocation?: Maybe<Scalars['Boolean']['output']>;
  isochrone?: Maybe<Scalars['JSONObject']['output']>;
  metro?: Maybe<GQLMetro>;
  metroId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  state: GQLUsStateId;
};

export type GQLLogChange = GQLLogDateTimeChange | GQLLogFloatChange | GQLLogIntChange | GQLLogStringChange;

export type GQLLogChangeBase = {
  path: Scalars['String']['output'];
  valueType: GQLLogChangeValueType;
};

export enum GQLLogChangeValueType {
  DateTime = 'DateTime',
  Float = 'Float',
  Int = 'Int',
  String = 'String'
}

export type GQLLogDateTimeChange = GQLLogChangeBase & {
  __typename?: 'LogDateTimeChange';
  newDateTime?: Maybe<Scalars['DateTime']['output']>;
  oldDateTime?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  valueType: GQLLogChangeValueType;
};

export type GQLLogFloatChange = GQLLogChangeBase & {
  __typename?: 'LogFloatChange';
  newFloat?: Maybe<Scalars['Float']['output']>;
  oldFloat?: Maybe<Scalars['Float']['output']>;
  path: Scalars['String']['output'];
  valueType: GQLLogChangeValueType;
};

export type GQLLogIntChange = GQLLogChangeBase & {
  __typename?: 'LogIntChange';
  newInt?: Maybe<Scalars['Int']['output']>;
  oldInt?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
  valueType: GQLLogChangeValueType;
};

export type GQLLogStringChange = GQLLogChangeBase & {
  __typename?: 'LogStringChange';
  newString?: Maybe<Scalars['String']['output']>;
  oldString?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  valueType: GQLLogChangeValueType;
};

export enum GQLLogTypes {
  All = 'All',
  Auto = 'Auto',
  Cancels = 'Cancels',
  Manual = 'Manual'
}

export type GQLMakeupRequest = {
  __typename?: 'MakeupRequest';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  makeupSession: GQLCohortSession;
  originalSession: GQLCohortSession;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GQLMakeupRequestStatus;
  studentId: Scalars['ID']['output'];
  studentName: Scalars['String']['output'];
};

export type GQLMakeupRequestEdge = {
  __typename?: 'MakeupRequestEdge';
  cursor: Scalars['ID']['output'];
  node: GQLMakeupRequest;
};

export enum GQLMakeupRequestStatus {
  Approved = 'Approved',
  Open = 'Open',
  Rejected = 'Rejected'
}

export type GQLMakeupRequestsInput = {
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  courseId: Scalars['ID']['input'];
  makeupCohortId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<GQLMakeupRequestStatus>>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLMarketingAssessmentInput = {
  courseId: Scalars['ID']['input'];
  question1: Scalars['String']['input'];
  question2: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLMaskedCommunicationInput = {
  lessonId: Scalars['ID']['input'];
  studentId?: InputMaybe<Scalars['ID']['input']>;
  type: GQLMaskedCommunicationType;
};

export enum GQLMaskedCommunicationType {
  Text = 'text',
  Voice = 'voice'
}

export type GQLMeetInstructorsQuery = {
  location?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLMeetingPointsQuery = {
  lat: Scalars['Float']['input'];
  lessonType?: InputMaybe<Scalars['String']['input']>;
  lng: Scalars['Float']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
};

export type GQLMetro = {
  __typename?: 'Metro';
  cmsId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  locationLandingPageIds: Array<Scalars['ID']['output']>;
  locationLandingPages?: Maybe<Array<GQLLocationLandingPage>>;
  name: Scalars['String']['output'];
  slackChannel?: Maybe<Scalars['String']['output']>;
  state: GQLUsStateId;
  stateCmsId: Scalars['String']['output'];
};

export type GQLMetroEdge = {
  __typename?: 'MetroEdge';
  cursor: Scalars['ID']['output'];
  node: GQLMetro;
};

export type GQLMetroInput = {
  cmsId: Scalars['String']['input'];
  isPublished: Scalars['Boolean']['input'];
  locationLandingPageIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slackChannel?: InputMaybe<Scalars['String']['input']>;
  state: GQLUsStateId;
  stateCmsId: Scalars['String']['input'];
};

export type GQLMetroPaginatedList = {
  __typename?: 'MetroPaginatedList';
  edges: Array<GQLMetroEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLMigrateOnlineCourseInput = {
  destinationStudentId: Scalars['ID']['input'];
  onlineCourseId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  sourceStudentId: Scalars['ID']['input'];
};

export type GQLMilesChatConversation = {
  __typename?: 'MilesChatConversation';
  closed: Scalars['Boolean']['output'];
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kustomerStatus?: Maybe<Scalars['String']['output']>;
  lastActivityAt: Scalars['DateTime']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GQLMilesChatConversationDetail = {
  __typename?: 'MilesChatConversationDetail';
  conversation?: Maybe<GQLMilesChatConversation>;
  found: Scalars['Boolean']['output'];
  transcript: Array<GQLMilesChatMessage>;
};

export type GQLMilesChatConversationStatus = {
  __typename?: 'MilesChatConversationStatus';
  closed: Scalars['Boolean']['output'];
  found: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type GQLMilesChatMessage = {
  __typename?: 'MilesChatMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  role: GQLMilesChatRole;
};

export enum GQLMilesChatRole {
  Assistant = 'assistant',
  User = 'user'
}

export type GQLMilesChatSendMessageResponse = {
  __typename?: 'MilesChatSendMessageResponse';
  conversationId: Scalars['ID']['output'];
  reply: Scalars['String']['output'];
};

export type GQLMoveStudentCertificateInput = {
  certificateId: Scalars['ID']['input'];
  fromUserId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};

export type GQLMoveStudentNoteInput = {
  fromUserId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
  toUserId: Scalars['ID']['input'];
};

export type GQLMutation = {
  __typename?: 'Mutation';
  activateInstructor: GQLInstructor;
  addInstructor: GQLInstructor;
  addMakeUpSessionInformation: Scalars['Boolean']['output'];
  addStudent: GQLStudent;
  addToCart: GQLCart;
  applyForScholarship: GQLScholarshipApplicationResponse;
  archiveCohort: Scalars['Boolean']['output'];
  archiveCohortSession: Scalars['Boolean']['output'];
  archiveStudentCertificate: Scalars['ID']['output'];
  archiveStudentNote: Scalars['ID']['output'];
  batchDeleteAvails: GQLBatchDeleteAvailsResult;
  batchEditAvails: GQLBatchEditAvailsResult;
  cancelLesson: GQLLesson;
  changeLessonInstructor: GQLLesson;
  checkoutAdvance: GQLCheckoutAdvancePayload;
  checkoutInit: GQLCheckoutInitPayload;
  clearCoupon: GQLCart;
  clearPackages: GQLCart;
  completeOrder: GQLCart;
  completeOrderWithSlots: GQLCart;
  confirmAdminMfaReset: Scalars['Boolean']['output'];
  createAcquisition: GQLAcquisition;
  createApprovedInstructorSchedule: Scalars['ID']['output'];
  createAvailability: GQLAvailability;
  createBulkAvailabilities: GQLBatchAddAvailsResult;
  createCart: GQLCart;
  createCheckoutPaymentIntent: GQLCreateCheckoutPaymentIntentPayload;
  createCoupon: GQLCoupon;
  createCourseOrder: GQLCourseOrder;
  createDirectCharge: GQLCreateDirectChargePayload;
  createDriveLog: GQLDriveLog;
  createFleetNote: GQLFleetNote;
  createInstructorAlert: GQLInstructorAlert;
  createInstructorSchedule?: Maybe<Scalars['ID']['output']>;
  createInstructorTimeLog: GQLInstructorTimeLog;
  createLessonNotificationRegistration: GQLLessonNotificationRegistration;
  createLessonType: GQLLessonType;
  createLivestreamGroup: GQLLivestreamGroup;
  createLocationLandingPage: GQLLocationLandingPage;
  createMakeupRequest: GQLMakeupRequest;
  createMetro: GQLMetro;
  createMilesChatConversation: GQLMilesChatConversationDetail;
  createOrganizationPartner: GQLOrganizationPartner;
  createParkingHub: GQLParkingHub;
  createPayrollRun: GQLCreatePayrollRunResult;
  createPriceScheme: GQLPriceScheme;
  createProduct: GQLProduct;
  createProductCatalog: GQLProductCatalog;
  createPurchase: GQLPurchase;
  createRecurringAvailabilities: GQLBatchAddAvailsResult;
  createReview: GQLLessonReview;
  createSessionCookie: Scalars['Boolean']['output'];
  createSharedLessonReservation: GQLTransientSlot;
  createShippingOrder: GQLShippingOrder;
  createSingleSessionCohort: GQLSingleSessionCohortResult;
  createStateConfig: GQLStateConfig;
  createStateMeetingPoint: GQLStateMeetingPoint;
  /** @deprecated Use createTimeOffAndRemoveAvailability instead. This mutation does not remove overlapping availabilities. */
  createTimeOff?: Maybe<Scalars['ID']['output']>;
  createTimeOffAndRemoveAvailability: GQLCreateTimeOffResult;
  createTrainee: GQLInstructor;
  createTransientSlot: GQLTransientSlot;
  createUserReferral: Scalars['Boolean']['output'];
  createVehicle: GQLVehicle;
  createVendor: GQLVendor;
  createVoucherBySourceId: Array<GQLVoucherV2>;
  createVoucherV2: Array<GQLVoucherV2>;
  createVoucherV2Source: Array<GQLVoucherV2Source>;
  deactivateInstructor: GQLInstructor;
  deleteAcquisition: Scalars['ID']['output'];
  deleteApprovedInstructorSchedule: Scalars['ID']['output'];
  deleteCoupon: Scalars['ID']['output'];
  deleteDriveLog: Scalars['Boolean']['output'];
  deleteFleetAttachment: Scalars['Boolean']['output'];
  deleteFleetNote: Scalars['ID']['output'];
  deleteInstructorAlert: Scalars['ID']['output'];
  deleteInstructorCustomIsochrone: Scalars['Boolean']['output'];
  deleteInstructorSchedule?: Maybe<Scalars['ID']['output']>;
  deleteInstructorTimeLog: Scalars['ID']['output'];
  deleteLessonNotificationRegistration: Scalars['Boolean']['output'];
  deleteLessonType: Scalars['Boolean']['output'];
  deleteLivestreamGroup: Scalars['ID']['output'];
  deleteLocationLandingPage: Scalars['ID']['output'];
  deleteMakeupRequest: Scalars['Boolean']['output'];
  deleteMetro: Scalars['ID']['output'];
  deleteNote: Scalars['ID']['output'];
  deleteOrganizationPartner: Scalars['ID']['output'];
  deleteParkingHub: Scalars['ID']['output'];
  deletePriceScheme: Scalars['ID']['output'];
  deleteProduct: Scalars['ID']['output'];
  deleteProductCatalog: Scalars['ID']['output'];
  deleteReview: Scalars['Boolean']['output'];
  deleteStateMeetingPoint: Scalars['ID']['output'];
  deleteStudentContract: GQLDeleteStudentContractResult;
  deleteTestFirebaseUser: Scalars['Boolean']['output'];
  deleteTimeOff?: Maybe<Scalars['ID']['output']>;
  deleteTransientSlot: Scalars['ID']['output'];
  deleteTransientSlotIfNotReserved?: Maybe<Scalars['ID']['output']>;
  deleteUserFile: Scalars['Boolean']['output'];
  deleteVehicle: Scalars['ID']['output'];
  deleteVendor: Scalars['ID']['output'];
  deleteVoucherV2: Scalars['Boolean']['output'];
  deleteVoucherV2Source: Scalars['Boolean']['output'];
  disableStudentAccount: Scalars['Boolean']['output'];
  dismissInstructorAlert: Scalars['Boolean']['output'];
  editPurchase: GQLPurchase;
  emailStudentReport: Scalars['Boolean']['output'];
  endMilesChatConversation: Scalars['Boolean']['output'];
  enqueueDataSyncJob: GQLEnqueueDataSyncJobResult;
  enqueueRestoreArchivedStudentCourse: Scalars['Boolean']['output'];
  enrollStudentToCohort: Scalars['Boolean']['output'];
  enrollStudentToOnlineCourse: GQLStudentOnlineCourse;
  expireProducts: GQLExpiration;
  fulfillFreeCheckoutOrder: GQLFulfillFreeCheckoutOrderPayload;
  generateCourseProgressArchivePdf: GQLPrintablePdfDocument;
  generateDigitalCertificate: Array<GQLDigitalCertificateResult>;
  generateStudentDetailedCourseReportPdf: GQLPrintablePdfDocument;
  impersonateUser: GQLImpersonateUserResponse;
  instructorAddStudentToLesson: GQLLesson;
  instructorUpdateLesson: GQLLesson;
  markLectureCompleted: GQLStudentOnlineCourse;
  migrateStudentOnlineCourse: GQLStudentCourseMigration;
  moveStudentCertificate: Scalars['ID']['output'];
  moveStudentNote: Scalars['ID']['output'];
  promoteTraineeToInstructor: GQLInstructor;
  putBookingAlert: GQLBookingAlert;
  putCertificate: GQLCertificate;
  putNote: GQLNote;
  putStudentCertificate: GQLStudentCertificateNote;
  putTestChargeLedgerLog: GQLLedgerLog;
  putTestLesson: GQLLesson;
  putTestProduct: GQLProduct;
  putTestUser: GQLStudent;
  putVehicle: GQLVehicle;
  reactivateStudentAccount: Scalars['Boolean']['output'];
  recordAdminVisitedInstructor: Scalars['Boolean']['output'];
  recordAdminVisitedStudent: Scalars['Boolean']['output'];
  recordAutoCreatedAccount: Scalars['Boolean']['output'];
  recordLastActive: Scalars['Boolean']['output'];
  redeemReferralCode: GQLRedeemReferralCodeResult;
  redeemVoucherV2: GQLRedeemVoucherV2Result;
  refreshTransientSlot: Scalars['ID']['output'];
  refundPurchase: GQLRefund;
  removeAutoCreatedAccount: Scalars['Boolean']['output'];
  removeBookingAlert: Scalars['ID']['output'];
  removeCourseOrderShipping: Scalars['Boolean']['output'];
  removeElevatedAccess: Scalars['Boolean']['output'];
  removeFromCart: GQLCart;
  removeStudentFromLesson: GQLLesson;
  removeUserAlsoViewing: Scalars['Boolean']['output'];
  resetTestDb: Scalars['Boolean']['output'];
  resetTestLedgerLogs: Scalars['Boolean']['output'];
  resetUserMFA: Scalars['Boolean']['output'];
  retireInstructor: GQLInstructor;
  retryPayrollRunCollection: GQLPayrollRun;
  reuploadPaylocityInstructors: GQLPayrollRun;
  revalidateLocationLandingPage?: Maybe<Scalars['Boolean']['output']>;
  saveAccommodation: Scalars['Boolean']['output'];
  saveCohort: GQLCohort;
  saveCohortSession: GQLCohortSession;
  saveStudentContractDetails: Scalars['ID']['output'];
  scheduleLesson: GQLLesson;
  scheduleMultipleLessons: Array<GQLLesson>;
  scoreQuiz: GQLScoreQuizResult;
  selfBookSharedLesson: GQLLesson;
  sendBookLessonsReservationEmails: Scalars['Int']['output'];
  sendCohortTemplateEmail: GQLSendCohortEmailResult;
  sendInstructorArrivedLessonAlert: Array<GQLLessonAlertDeliveryResult>;
  sendMilesChatMessage: GQLMilesChatSendMessageResponse;
  sendPayrollRunToPaylocity: GQLPayrollRun;
  sendRunningLateLessonAlert: Array<GQLLessonAlertDeliveryResult>;
  setCoupon: GQLCart;
  setCourseNotaryStatus: Scalars['Boolean']['output'];
  setInstructorCustomIsochrone: Scalars['Boolean']['output'];
  setInstructorLessonNotificationVisibility: Scalars['Boolean']['output'];
  setPaymentStatus: GQLCart;
  setPurchaseId: GQLCart;
  setStudentId: GQLCart;
  signOut: Scalars['Boolean']['output'];
  startExam: GQLExamSession;
  startMaskedLessonCommunication: Scalars['Boolean']['output'];
  submitCoursePrepTestChapterScores: Scalars['Boolean']['output'];
  submitCourseSurvey: Scalars['Boolean']['output'];
  submitExam: GQLExamAttempt;
  submitExamResponse: Scalars['Boolean']['output'];
  submitMarketingAssessment: Scalars['Boolean']['output'];
  syncCourseTimers: GQLSyncCourseTimersResult;
  transferAccount: Scalars['Boolean']['output'];
  transferExpiration: GQLExpiration;
  transferLesson: GQLLesson;
  transferPurchase: GQLPurchase;
  unenrollStudentFromCohort: Scalars['Boolean']['output'];
  unenrollStudentFromOnlineCourse: Scalars['Boolean']['output'];
  updateAcquisition: GQLAcquisition;
  updateApprovedInstructorSchedule: Scalars['ID']['output'];
  updateAvailability: GQLAvailability;
  updateCancelLog: GQLCancelLogEntry;
  updateCoupon: GQLCoupon;
  updateCourseOrder: GQLCourseOrder;
  updateDriveLog: GQLDriveLog;
  updateFleetNote: GQLFleetNote;
  updateIllinoisCompletionForm: Scalars['Boolean']['output'];
  updateInstructor: GQLInstructor;
  updateInstructorAlert: GQLInstructorAlert;
  updateInstructorSchedule?: Maybe<Scalars['ID']['output']>;
  updateInstructorTimeLog: GQLInstructorTimeLog;
  updateLesson: GQLLesson;
  updateLessonNotificationRegistration: GQLLessonNotificationRegistration;
  updateLessonReportForStudent: Scalars['Boolean']['output'];
  updateLessonType: GQLLessonType;
  updateLivestreamGroup: GQLLivestreamGroup;
  updateLocationLandingPage: GQLLocationLandingPage;
  updateMakeupRequestStatus: GQLMakeupRequest;
  updateMetro: GQLMetro;
  updateMyUserSettings: GQLUserSettings;
  updateOrganizationPartner: GQLOrganizationPartner;
  updateParkingHub: GQLParkingHub;
  updatePriceScheme: GQLPriceScheme;
  updateProduct: GQLProduct;
  updateProductCatalog: GQLProductCatalog;
  updateReview: GQLLessonReview;
  updateStateConfig: GQLStateConfig;
  updateStateMeetingPoint: GQLStateMeetingPoint;
  updateStudent: GQLStudent;
  updateStudentCourseLectureSession: Scalars['Boolean']['output'];
  updateStudentCourseMeta: Scalars['Boolean']['output'];
  updateStudentCourseSecurityAnswers: Scalars['Boolean']['output'];
  updateStudentEmail: Scalars['Boolean']['output'];
  updateStudentLegalAndPermissions: GQLStudentLegalAndPermissionsRecord;
  updateStudentSessionAttendance: Scalars['Boolean']['output'];
  updateStudentsSessionAttendance: Scalars['Boolean']['output'];
  /** @deprecated Editing time off is no longer supported. Delete and recreate instead. */
  updateTimeOff?: Maybe<Scalars['ID']['output']>;
  updateTransientSlot: Scalars['ID']['output'];
  updateTransientSlotTime?: Maybe<Scalars['ID']['output']>;
  updateUserAlsoViewing: Scalars['Boolean']['output'];
  updateUserFile: GQLUserFile;
  updateUserRoles: Array<GQLUserRole>;
  updateVehicle: GQLVehicle;
  updateVehicleAssignments: GQLVehicle;
  updateVendor: GQLVendor;
  updateVoucherV2: GQLVoucherV2;
  updateVoucherV2Source: GQLVoucherV2Source;
  uploadFleetAttachment: GQLFleetAttachment;
  uploadUserFile: GQLUserFile;
  voidExpiration: GQLExpiration;
  voidPurchase: GQLPurchase;
  voidRefund: GQLRefund;
};


export type GQLMutationActivateInstructorArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationAddInstructorArgs = {
  instructor: GQLNewInstructorInput;
};


export type GQLMutationAddMakeUpSessionInformationArgs = {
  input: GQLAddMakeUpSessionInformationInput;
};


export type GQLMutationAddStudentArgs = {
  student: GQLNewStudentInput;
};


export type GQLMutationAddToCartArgs = {
  input: GQLIdLessonPackageInput;
};


export type GQLMutationApplyForScholarshipArgs = {
  courseId: Scalars['String']['input'];
  dob: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  scholarshipAnswer: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};


export type GQLMutationArchiveCohortArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationArchiveCohortSessionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationArchiveStudentCertificateArgs = {
  input: GQLArchiveStudentCertificateInput;
};


export type GQLMutationArchiveStudentNoteArgs = {
  input: GQLArchiveStudentNoteInput;
};


export type GQLMutationBatchDeleteAvailsArgs = {
  query: GQLBatchDeleteAvailsQuery;
};


export type GQLMutationBatchEditAvailsArgs = {
  query: GQLBatchEditAvailsQuery;
  update: GQLBatchEditAvailsUpdate;
};


export type GQLMutationCancelLessonArgs = {
  input: GQLLessonCancellationInfo;
  query: GQLLessonCancelQuery;
};


export type GQLMutationChangeLessonInstructorArgs = {
  input: GQLChangeLessonInstructorInput;
};


export type GQLMutationCheckoutAdvanceArgs = {
  input: GQLCheckoutAdvanceInput;
};


export type GQLMutationCheckoutInitArgs = {
  input: GQLCheckoutInitInput;
};


export type GQLMutationClearCouponArgs = {
  input: GQLCartInput;
};


export type GQLMutationClearPackagesArgs = {
  input: GQLCartInput;
};


export type GQLMutationCompleteOrderArgs = {
  input: GQLCartInput;
};


export type GQLMutationCompleteOrderWithSlotsArgs = {
  input: GQLCompleteOrderInput;
};


export type GQLMutationConfirmAdminMfaResetArgs = {
  verificationId: Scalars['ID']['input'];
};


export type GQLMutationCreateAcquisitionArgs = {
  input: GQLAcquisitionInput;
};


export type GQLMutationCreateApprovedInstructorScheduleArgs = {
  input: GQLApprovedInstructorScheduleInput;
};


export type GQLMutationCreateAvailabilityArgs = {
  input: GQLAvailabilityCreateInput;
};


export type GQLMutationCreateBulkAvailabilitiesArgs = {
  input: GQLBulkAvailabilityCreateInput;
};


export type GQLMutationCreateCartArgs = {
  input: GQLCartCreateInput;
};


export type GQLMutationCreateCheckoutPaymentIntentArgs = {
  input: GQLCreateCheckoutPaymentIntentInput;
};


export type GQLMutationCreateCouponArgs = {
  input: GQLUpsertCouponInput;
};


export type GQLMutationCreateCourseOrderArgs = {
  input: GQLCourseOrderInput;
  query: GQLCourseOrderQuery;
};


export type GQLMutationCreateDirectChargeArgs = {
  input: GQLCreateDirectChargeInput;
};


export type GQLMutationCreateDriveLogArgs = {
  input: GQLCreateDriveLogInput;
};


export type GQLMutationCreateFleetNoteArgs = {
  input: GQLCreateFleetNoteInput;
};


export type GQLMutationCreateInstructorAlertArgs = {
  input: GQLInstructorAlertCreateInput;
};


export type GQLMutationCreateInstructorScheduleArgs = {
  input: GQLInstructorScheduleInput;
};


export type GQLMutationCreateInstructorTimeLogArgs = {
  input: GQLInstructorTimeLogCreateInput;
};


export type GQLMutationCreateLessonNotificationRegistrationArgs = {
  input: GQLLessonNotificationRegistrationInput;
  payload: Scalars['JSONObject']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLMutationCreateLessonTypeArgs = {
  input: GQLLessonTypeCreateInput;
};


export type GQLMutationCreateLivestreamGroupArgs = {
  input: GQLLivestreamGroupInput;
};


export type GQLMutationCreateLocationLandingPageArgs = {
  input: GQLLocationLandingPageInput;
};


export type GQLMutationCreateMakeupRequestArgs = {
  input: GQLCreateMakeupRequestInput;
};


export type GQLMutationCreateMetroArgs = {
  input: GQLMetroInput;
};


export type GQLMutationCreateMilesChatConversationArgs = {
  browserId: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
};


export type GQLMutationCreateOrganizationPartnerArgs = {
  input: GQLOrganizationPartnerInput;
};


export type GQLMutationCreateParkingHubArgs = {
  input: GQLCreateParkingHubInput;
};


export type GQLMutationCreatePayrollRunArgs = {
  input: GQLCreatePayrollRunInput;
};


export type GQLMutationCreatePriceSchemeArgs = {
  input: GQLPriceSchemeCreateInput;
};


export type GQLMutationCreateProductArgs = {
  product: GQLCreateProductInput;
};


export type GQLMutationCreateProductCatalogArgs = {
  input: GQLProductCatalogCreateInput;
};


export type GQLMutationCreatePurchaseArgs = {
  input: GQLCreatePurchaseInput;
};


export type GQLMutationCreateRecurringAvailabilitiesArgs = {
  input: GQLRecurringAvailabilityCreateInput;
};


export type GQLMutationCreateReviewArgs = {
  input: GQLPutLessonReviewInput;
};


export type GQLMutationCreateSessionCookieArgs = {
  session: GQLCreateSessionCookieInput;
};


export type GQLMutationCreateSharedLessonReservationArgs = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
};


export type GQLMutationCreateShippingOrderArgs = {
  input: GQLCreateShippingOrderInput;
};


export type GQLMutationCreateSingleSessionCohortArgs = {
  input: GQLSingleSessionCohortInput;
};


export type GQLMutationCreateStateConfigArgs = {
  input: GQLStateConfigCreateInput;
};


export type GQLMutationCreateStateMeetingPointArgs = {
  input: GQLStateMeetingPointCreateInput;
};


export type GQLMutationCreateTimeOffArgs = {
  input: GQLCreateInstructorTimeOffInput;
};


export type GQLMutationCreateTimeOffAndRemoveAvailabilityArgs = {
  input: GQLCreateInstructorTimeOffInput;
};


export type GQLMutationCreateTraineeArgs = {
  input: GQLCreateTraineeInput;
};


export type GQLMutationCreateTransientSlotArgs = {
  input: GQLTransientSlotInput;
};


export type GQLMutationCreateUserReferralArgs = {
  input: GQLUserReferralInput;
};


export type GQLMutationCreateVehicleArgs = {
  vehicle: GQLVehicleInput;
};


export type GQLMutationCreateVendorArgs = {
  input: GQLCreateVendorInput;
};


export type GQLMutationCreateVoucherBySourceIdArgs = {
  input: GQLCreateVoucherBySourceIdInput;
};


export type GQLMutationCreateVoucherV2Args = {
  input: GQLCreateVoucherV2Input;
};


export type GQLMutationCreateVoucherV2SourceArgs = {
  input: GQLCreateVoucherV2SourceInput;
};


export type GQLMutationDeactivateInstructorArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationDeleteAcquisitionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteApprovedInstructorScheduleArgs = {
  query: GQLScheduleMutateQuery;
};


export type GQLMutationDeleteCouponArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteDriveLogArgs = {
  input: GQLDeleteDriveLogInput;
};


export type GQLMutationDeleteFleetAttachmentArgs = {
  input: GQLDeleteFleetAttachmentInput;
};


export type GQLMutationDeleteFleetNoteArgs = {
  input: GQLDeleteFleetNoteInput;
};


export type GQLMutationDeleteInstructorAlertArgs = {
  input: GQLInstructorAlertDeleteInput;
};


export type GQLMutationDeleteInstructorCustomIsochroneArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationDeleteInstructorScheduleArgs = {
  query: GQLScheduleMutateQuery;
};


export type GQLMutationDeleteInstructorTimeLogArgs = {
  query: GQLInstructorTimeLogQuery;
};


export type GQLMutationDeleteLessonNotificationRegistrationArgs = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLMutationDeleteLessonTypeArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteLivestreamGroupArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteLocationLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteMakeupRequestArgs = {
  input: GQLDeleteMakeupRequestInput;
};


export type GQLMutationDeleteMetroArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteNoteArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type GQLMutationDeleteOrganizationPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteParkingHubArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeletePriceSchemeArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteProductCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteReviewArgs = {
  query: GQLGetLessonReviewInput;
};


export type GQLMutationDeleteStateMeetingPointArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['ID']['input'];
};


export type GQLMutationDeleteStudentContractArgs = {
  input: GQLDeleteStudentContractInput;
};


export type GQLMutationDeleteTestFirebaseUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteTimeOffArgs = {
  query: GQLInstructorMutationTimeOffQuery;
};


export type GQLMutationDeleteTransientSlotArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLMutationDeleteTransientSlotIfNotReservedArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLMutationDeleteUserFileArgs = {
  input: GQLDeleteUserFileInput;
};


export type GQLMutationDeleteVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteVendorArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteVoucherV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDeleteVoucherV2SourceArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationDisableStudentAccountArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLMutationDismissInstructorAlertArgs = {
  alertId: Scalars['ID']['input'];
};


export type GQLMutationEditPurchaseArgs = {
  input: GQLEditPurchaseInput;
};


export type GQLMutationEmailStudentReportArgs = {
  input: GQLEmailStudentReportInput;
};


export type GQLMutationEndMilesChatConversationArgs = {
  browserId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};


export type GQLMutationEnqueueDataSyncJobArgs = {
  input: GQLEnqueueDataSyncJobInput;
};


export type GQLMutationEnqueueRestoreArchivedStudentCourseArgs = {
  input: GQLEnqueueRestoreArchivedStudentCourseInput;
};


export type GQLMutationEnrollStudentToCohortArgs = {
  input: GQLEnrollStudentToCohortInput;
};


export type GQLMutationEnrollStudentToOnlineCourseArgs = {
  input: GQLStudentOnlineCourseInput;
};


export type GQLMutationExpireProductsArgs = {
  input: GQLExpireProductsInput;
};


export type GQLMutationFulfillFreeCheckoutOrderArgs = {
  input: GQLFulfillFreeCheckoutOrderInput;
};


export type GQLMutationGenerateCourseProgressArchivePdfArgs = {
  archiveId: Scalars['ID']['input'];
};


export type GQLMutationGenerateDigitalCertificateArgs = {
  input: GQLGenerateDigitalCertificateInput;
};


export type GQLMutationGenerateStudentDetailedCourseReportPdfArgs = {
  input: GQLGenerateStudentDetailedCourseReportPdfInput;
};


export type GQLMutationImpersonateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLMutationInstructorAddStudentToLessonArgs = {
  input: GQLInstructorAddStudentInput;
  query: GQLLessonUpdateQuery;
};


export type GQLMutationInstructorUpdateLessonArgs = {
  query: GQLLessonUpdateQuery;
  update: GQLInstructorLessonUpdateInput;
};


export type GQLMutationMarkLectureCompletedArgs = {
  input: GQLStudentCourseLectureInput;
};


export type GQLMutationMigrateStudentOnlineCourseArgs = {
  input: GQLMigrateOnlineCourseInput;
};


export type GQLMutationMoveStudentCertificateArgs = {
  input: GQLMoveStudentCertificateInput;
};


export type GQLMutationMoveStudentNoteArgs = {
  input: GQLMoveStudentNoteInput;
};


export type GQLMutationPromoteTraineeToInstructorArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationPutBookingAlertArgs = {
  bookingAlert: GQLBookingAlertInput;
};


export type GQLMutationPutCertificateArgs = {
  certificate: GQLCertificateInput;
};


export type GQLMutationPutNoteArgs = {
  note: GQLNoteInput;
};


export type GQLMutationPutStudentCertificateArgs = {
  input: GQLStudentCertificateInput;
};


export type GQLMutationPutTestChargeLedgerLogArgs = {
  input: GQLTestChargeLedgerLogInput;
};


export type GQLMutationPutTestLessonArgs = {
  input: GQLPutTestLessonInput;
};


export type GQLMutationPutTestProductArgs = {
  product: GQLPutTestProductInput;
};


export type GQLMutationPutTestUserArgs = {
  input: GQLTestUserInput;
};


export type GQLMutationPutVehicleArgs = {
  vehicle: GQLVehicleInput;
};


export type GQLMutationReactivateStudentAccountArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLMutationRecordAdminVisitedInstructorArgs = {
  instructorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type GQLMutationRecordAdminVisitedStudentArgs = {
  name: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLMutationRedeemReferralCodeArgs = {
  input: GQLRedeemReferralCodeInput;
};


export type GQLMutationRedeemVoucherV2Args = {
  input: GQLRedeemVoucherV2Input;
};


export type GQLMutationRefreshTransientSlotArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLMutationRefundPurchaseArgs = {
  input: GQLRefundPurchaseInput;
};


export type GQLMutationRemoveAutoCreatedAccountArgs = {
  email: Scalars['String']['input'];
};


export type GQLMutationRemoveBookingAlertArgs = {
  bookingAlert: GQLDeleteBookingAlertInput;
};


export type GQLMutationRemoveCourseOrderShippingArgs = {
  query: GQLCourseOrderQuery;
};


export type GQLMutationRemoveElevatedAccessArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLMutationRemoveFromCartArgs = {
  input: GQLIdLessonPackageInput;
};


export type GQLMutationRemoveStudentFromLessonArgs = {
  input: GQLLessonCancellationInfo;
  query: GQLLessonRemoveStudentQuery;
};


export type GQLMutationRemoveUserAlsoViewingArgs = {
  input: GQLRemoveUserAlsoViewingInput;
};


export type GQLMutationResetUserMfaArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLMutationRetireInstructorArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationRetryPayrollRunCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationReuploadPaylocityInstructorsArgs = {
  input: GQLReuploadPaylocityInstructorsInput;
};


export type GQLMutationRevalidateLocationLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationSaveAccommodationArgs = {
  input: GQLSaveAccommodationInput;
};


export type GQLMutationSaveCohortArgs = {
  input: GQLCohortInput;
};


export type GQLMutationSaveCohortSessionArgs = {
  input: GQLCohortSessionInput;
};


export type GQLMutationSaveStudentContractDetailsArgs = {
  input: GQLSaveStudentContractDetailsInput;
};


export type GQLMutationScheduleLessonArgs = {
  input: GQLScheduleLessonInput;
};


export type GQLMutationScheduleMultipleLessonsArgs = {
  input: Array<GQLScheduleLessonInput>;
};


export type GQLMutationScoreQuizArgs = {
  input: GQLScoreQuizInput;
  query: GQLScoreQuizQuery;
};


export type GQLMutationSelfBookSharedLessonArgs = {
  input: GQLSelfBookSharedLessonInput;
};


export type GQLMutationSendBookLessonsReservationEmailsArgs = {
  studentId: Scalars['ID']['input'];
  transientSlotIds: Array<Scalars['ID']['input']>;
};


export type GQLMutationSendCohortTemplateEmailArgs = {
  input: GQLSendCohortTemplateEmailInput;
};


export type GQLMutationSendInstructorArrivedLessonAlertArgs = {
  input: GQLSendInstructorArrivedLessonAlertInput;
};


export type GQLMutationSendMilesChatMessageArgs = {
  browserId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type GQLMutationSendPayrollRunToPaylocityArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationSendRunningLateLessonAlertArgs = {
  input: GQLSendRunningLateLessonAlertInput;
};


export type GQLMutationSetCouponArgs = {
  input: GQLSetCouponInput;
};


export type GQLMutationSetCourseNotaryStatusArgs = {
  input: GQLCourseNotaryStatusInput;
};


export type GQLMutationSetInstructorCustomIsochroneArgs = {
  geoJson: Scalars['JSONObject']['input'];
  instructorId: Scalars['ID']['input'];
};


export type GQLMutationSetInstructorLessonNotificationVisibilityArgs = {
  query: GQLSetInstructorLessonNotificationVisibilityInput;
};


export type GQLMutationSetPaymentStatusArgs = {
  input: GQLPaymentStatusInput;
};


export type GQLMutationSetPurchaseIdArgs = {
  input: GQLSetPurchaseIdInput;
};


export type GQLMutationSetStudentIdArgs = {
  input: GQLSetStudentInput;
};


export type GQLMutationStartExamArgs = {
  input: GQLStartExamInput;
};


export type GQLMutationStartMaskedLessonCommunicationArgs = {
  input: GQLMaskedCommunicationInput;
};


export type GQLMutationSubmitCoursePrepTestChapterScoresArgs = {
  input: GQLSubmitCoursePrepTestChapterScoresInput;
};


export type GQLMutationSubmitCourseSurveyArgs = {
  input: GQLCourseSurveyInput;
};


export type GQLMutationSubmitExamArgs = {
  input: GQLSubmitExamInput;
};


export type GQLMutationSubmitExamResponseArgs = {
  input: GQLSubmitExamResponseInput;
};


export type GQLMutationSubmitMarketingAssessmentArgs = {
  input: GQLMarketingAssessmentInput;
};


export type GQLMutationSyncCourseTimersArgs = {
  input: GQLSyncCourseTimersInput;
  query: GQLSyncCourseTimersQuery;
};


export type GQLMutationTransferAccountArgs = {
  input: GQLTransferAccountInput;
};


export type GQLMutationTransferExpirationArgs = {
  input: GQLTransferExpirationInput;
};


export type GQLMutationTransferLessonArgs = {
  input: GQLTransferLessonInput;
};


export type GQLMutationTransferPurchaseArgs = {
  input: GQLTransferPurchaseInput;
};


export type GQLMutationUnenrollStudentFromCohortArgs = {
  input: GQLUnenrollStudentFromCohortInput;
};


export type GQLMutationUnenrollStudentFromOnlineCourseArgs = {
  input: GQLStudentOnlineCourseInput;
};


export type GQLMutationUpdateAcquisitionArgs = {
  id: Scalars['ID']['input'];
  input: GQLAcquisitionInput;
};


export type GQLMutationUpdateApprovedInstructorScheduleArgs = {
  input: GQLApprovedInstructorScheduleUpdateInput;
  query: GQLScheduleMutateQuery;
};


export type GQLMutationUpdateAvailabilityArgs = {
  input: GQLAvailabilityUpdateInput;
  query: GQLAvailabilityQuery;
};


export type GQLMutationUpdateCancelLogArgs = {
  input: GQLUpdateCancelLogInput;
};


export type GQLMutationUpdateCouponArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpsertCouponInput;
};


export type GQLMutationUpdateCourseOrderArgs = {
  input: GQLCourseOrderInput;
  query: GQLCourseOrderQuery;
};


export type GQLMutationUpdateDriveLogArgs = {
  input: GQLUpdateDriveLogInput;
};


export type GQLMutationUpdateFleetNoteArgs = {
  input: GQLUpdateFleetNoteInput;
};


export type GQLMutationUpdateIllinoisCompletionFormArgs = {
  input: GQLUpdateIllinoisCompletionFormInput;
};


export type GQLMutationUpdateInstructorArgs = {
  query: GQLUpdateInstructorQuery;
  update: GQLUpdateInstructorInput;
};


export type GQLMutationUpdateInstructorAlertArgs = {
  input: GQLInstructorAlertUpdateInput;
};


export type GQLMutationUpdateInstructorScheduleArgs = {
  input: GQLInstructorScheduleUpdateInput;
  query: GQLScheduleMutateQuery;
};


export type GQLMutationUpdateInstructorTimeLogArgs = {
  input: GQLInstructorTimeLogUpdateInput;
  query: GQLInstructorTimeLogQuery;
};


export type GQLMutationUpdateLessonArgs = {
  query: GQLLessonUpdateQuery;
  update: GQLLessonUpdateInput;
};


export type GQLMutationUpdateLessonNotificationRegistrationArgs = {
  id: Scalars['ID']['input'];
  input: GQLLessonNotificationRegistrationInput;
  studentId: Scalars['ID']['input'];
};


export type GQLMutationUpdateLessonReportForStudentArgs = {
  input: GQLLessonDrivingSkillRatingInput;
};


export type GQLMutationUpdateLessonTypeArgs = {
  input: GQLLessonTypeUpdateInput;
};


export type GQLMutationUpdateLivestreamGroupArgs = {
  id: Scalars['ID']['input'];
  input: GQLLivestreamGroupInput;
};


export type GQLMutationUpdateLocationLandingPageArgs = {
  id: Scalars['ID']['input'];
  input: GQLLocationLandingPageInput;
};


export type GQLMutationUpdateMakeupRequestStatusArgs = {
  input: GQLUpdateMakeupRequestStatusInput;
};


export type GQLMutationUpdateMetroArgs = {
  id: Scalars['ID']['input'];
  input: GQLMetroInput;
};


export type GQLMutationUpdateMyUserSettingsArgs = {
  input: GQLUpdateMyUserSettingsInput;
};


export type GQLMutationUpdateOrganizationPartnerArgs = {
  id: Scalars['ID']['input'];
  input: GQLOrganizationPartnerInput;
};


export type GQLMutationUpdateParkingHubArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateParkingHubInput;
};


export type GQLMutationUpdatePriceSchemeArgs = {
  input: GQLPriceSchemeUpdateInput;
};


export type GQLMutationUpdateProductArgs = {
  product: GQLUpdateProductInput;
};


export type GQLMutationUpdateProductCatalogArgs = {
  input: GQLProductCatalogUpdateInput;
};


export type GQLMutationUpdateReviewArgs = {
  input: GQLUpdateLessonReviewInput;
  query: GQLGetLessonReviewInput;
};


export type GQLMutationUpdateStateConfigArgs = {
  input: GQLStateConfigUpdateInput;
};


export type GQLMutationUpdateStateMeetingPointArgs = {
  input: GQLStateMeetingPointUpdateInput;
};


export type GQLMutationUpdateStudentArgs = {
  student: GQLStudentInput;
};


export type GQLMutationUpdateStudentCourseLectureSessionArgs = {
  input: GQLUpdateCourseSessionInput;
};


export type GQLMutationUpdateStudentCourseMetaArgs = {
  input: GQLUpdateStudentCourseMetaInput;
};


export type GQLMutationUpdateStudentCourseSecurityAnswersArgs = {
  input: GQLUpdateStudentCourseSecurityAnswersInput;
};


export type GQLMutationUpdateStudentEmailArgs = {
  newEmail: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLMutationUpdateStudentLegalAndPermissionsArgs = {
  input: GQLUpdateStudentLegalAndPermissionsInput;
};


export type GQLMutationUpdateStudentSessionAttendanceArgs = {
  input: GQLUpdateStudentSessionAttendanceInput;
};


export type GQLMutationUpdateStudentsSessionAttendanceArgs = {
  input: GQLUpdateStudentsSessionAttendanceInput;
};


export type GQLMutationUpdateTimeOffArgs = {
  input: GQLInstructorTimeOffInput;
  query: GQLInstructorMutationTimeOffQuery;
};


export type GQLMutationUpdateTransientSlotArgs = {
  input: GQLUpdateTransientSlotInput;
};


export type GQLMutationUpdateTransientSlotTimeArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLMutationUpdateUserAlsoViewingArgs = {
  input: GQLUpdateUserAlsoViewingInput;
};


export type GQLMutationUpdateUserFileArgs = {
  input: GQLUpdateUserFileInput;
};


export type GQLMutationUpdateUserRolesArgs = {
  userId: Scalars['ID']['input'];
  userRoles: Array<GQLUserRole>;
};


export type GQLMutationUpdateVehicleArgs = {
  vehicle: GQLVehicleInput;
};


export type GQLMutationUpdateVehicleAssignmentsArgs = {
  input: GQLUpdateVehicleAssignmentsInput;
};


export type GQLMutationUpdateVendorArgs = {
  input: GQLUpdateVendorInput;
};


export type GQLMutationUpdateVoucherV2Args = {
  input: GQLUpdateVoucherV2Input;
};


export type GQLMutationUpdateVoucherV2SourceArgs = {
  input: GQLUpdateVoucherV2SourceInput;
};


export type GQLMutationUploadFleetAttachmentArgs = {
  input: GQLUploadFleetAttachmentInput;
};


export type GQLMutationUploadUserFileArgs = {
  input: GQLUploadUserFileInput;
};


export type GQLMutationVoidExpirationArgs = {
  input: GQLVoidExpirationInput;
};


export type GQLMutationVoidPurchaseArgs = {
  input: GQLVoidPurchaseInput;
};


export type GQLMutationVoidRefundArgs = {
  input: GQLVoidRefundInput;
};

export type GQLMyself = {
  __typename?: 'Myself';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  profile?: Maybe<GQLStudent>;
  roles: Array<Scalars['String']['output']>;
  signInEmail?: Maybe<Scalars['String']['output']>;
};

export type GQLNearbyLocationResult = {
  __typename?: 'NearbyLocationResult';
  distanceMiles: Scalars['Float']['output'];
  location: GQLLocationPin;
};

export type GQLNearbyLocationsInput = {
  courseType?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
  maxDistanceMiles?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<GQLUsStateId>;
};

export type GQLNewInstructorInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  availsFixedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<GQLInstructorBadgeInput>>;
  baseAddress?: InputMaybe<Scalars['String']['input']>;
  canManageMeetingLocations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOwnSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSyncHoursWithPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSyncRoadTestHoursWithPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  employmentType?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  hasRoadTestStipend?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignedBreakTimeWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  jobCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
  longBreakMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBaseTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  optOutLessonEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  paylocityId?: InputMaybe<Scalars['ID']['input']>;
  payrollFirstName?: InputMaybe<Scalars['String']['input']>;
  payrollLastName?: InputMaybe<Scalars['String']['input']>;
  payrollTitle?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  portraitImage?: InputMaybe<Scalars['String']['input']>;
  regionalManagerId?: InputMaybe<Scalars['ID']['input']>;
  servicesProvided?: InputMaybe<Array<Scalars['String']['input']>>;
  shortBreakMinutes?: InputMaybe<Scalars['Int']['input']>;
  slackUsername?: InputMaybe<Scalars['String']['input']>;
  spokenLanguageCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  usStateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLNewStudentInput = {
  acceptTOS: Scalars['Boolean']['input'];
  address?: InputMaybe<GQLAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  dmvPreRegNumber?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  drivingHistory?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facilityNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasNoMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseEligibilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguageCode?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  previousSchoolLessons?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  signupSource?: InputMaybe<Scalars['String']['input']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use licenseNumber instead */
  wdlNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GQLNote = {
  __typename?: 'Note';
  createdAt: Scalars['DateTime']['output'];
  createdBy: GQLPerson;
  createdById: Scalars['ID']['output'];
  format: GQLNoteFormat;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isHiddenFromInstructorView: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type GQLNoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['ID']['output'];
  node: GQLNote;
};

export enum GQLNoteFormat {
  Legacy = 'Legacy',
  Markdown = 'Markdown'
}

export type GQLNoteInput = {
  format?: InputMaybe<GQLNoteFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHiddenFromInstructorView?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLNotesPaginatedList = {
  __typename?: 'NotesPaginatedList';
  edges: Array<GQLNoteEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLNotesQuery = {
  userId: Scalars['ID']['input'];
};

export type GQLObservationAvailabilityRangeInput = {
  day: GQLWeekDays;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type GQLObservationLessonCandidate = {
  __typename?: 'ObservationLessonCandidate';
  dashUrl: Scalars['String']['output'];
  distanceMiles: Scalars['Float']['output'];
  endTime: Scalars['DateTime']['output'];
  instructorId: Scalars['ID']['output'];
  instructorLessonCount: Scalars['Int']['output'];
  instructorName: Scalars['String']['output'];
  lessonId: Scalars['ID']['output'];
  pickupLocation: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type GQLObservationLessonCandidateEdge = {
  __typename?: 'ObservationLessonCandidateEdge';
  cursor: Scalars['ID']['output'];
  node: GQLObservationLessonCandidate;
};

export type GQLObservationLessonCandidatePaginatedList = {
  __typename?: 'ObservationLessonCandidatePaginatedList';
  edges: Array<GQLObservationLessonCandidateEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLObservationLessonCandidatesInput = {
  availabilityRanges: Array<GQLObservationAvailabilityRangeInput>;
  endDate: Scalars['DateString']['input'];
  maxDistanceMiles?: InputMaybe<Scalars['Float']['input']>;
  minInstructorLessonCount?: InputMaybe<Scalars['Int']['input']>;
  originAddress: Scalars['String']['input'];
  originCoords: GQLLocationCoordsInput;
  startDate: Scalars['DateString']['input'];
  timeZone: Scalars['String']['input'];
};

export type GQLOnlineCourseContent = {
  __typename?: 'OnlineCourseContent';
  anvilPdfIds: GQLAnvilPdfIds;
  anvilPdfTemplateId?: Maybe<Scalars['String']['output']>;
  attendancePercentRequired?: Maybe<Scalars['Int']['output']>;
  branchLicenseNumber?: Maybe<Scalars['String']['output']>;
  certificateCourseName?: Maybe<Scalars['String']['output']>;
  certificateIncludeMeetsRequirements?: Maybe<Scalars['Boolean']['output']>;
  certificateInstructor?: Maybe<Scalars['String']['output']>;
  challengeRequired?: Maybe<Scalars['Boolean']['output']>;
  chapterTimeLimitHours?: Maybe<Scalars['Int']['output']>;
  completionFlow: Array<Scalars['String']['output']>;
  courseAgeMinimum?: Maybe<Scalars['Float']['output']>;
  courseTypeId?: Maybe<Scalars['ID']['output']>;
  dailyTimeLimit?: Maybe<Scalars['Int']['output']>;
  datoStateId: Scalars['ID']['output'];
  dmvPreRegistrationLink?: Maybe<Scalars['String']['output']>;
  examCourseCompletionRequired?: Maybe<Scalars['Boolean']['output']>;
  examCourseCompletionTopicsIds?: Maybe<Array<Scalars['ID']['output']>>;
  examCourseProgressTimerMinutes?: Maybe<Scalars['Int']['output']>;
  examSlug?: Maybe<Scalars['String']['output']>;
  externalCourseId?: Maybe<Scalars['String']['output']>;
  failTwiceReview: Scalars['Boolean']['output'];
  hasCertificate: Scalars['Boolean']['output'];
  hasControlNumber: Scalars['Boolean']['output'];
  hasDrivingLessons: Scalars['Boolean']['output'];
  hasShipping: Scalars['Boolean']['output'];
  hasTimer: Scalars['Boolean']['output'];
  hasWeakSecurityMeasures: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  idleTimeoutSec: Scalars['Int']['output'];
  inactivityCheck: Scalars['Boolean']['output'];
  instructionsText?: Maybe<Scalars['String']['output']>;
  isClassroomCourse: Scalars['Boolean']['output'];
  isEnrollmentOpen: Scalars['Boolean']['output'];
  isExamEligible?: Maybe<Scalars['Boolean']['output']>;
  isExternalCourse: Scalars['Boolean']['output'];
  isGuideRequired: Scalars['Boolean']['output'];
  isKnowledgeTest: Scalars['Boolean']['output'];
  isSingleSessionCohort: Scalars['Boolean']['output'];
  lectureIds: Array<Scalars['ID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  maxEnrollees?: Maybe<Scalars['Int']['output']>;
  meetingPointId?: Maybe<Scalars['ID']['output']>;
  minPercentCorrect: Scalars['Int']['output'];
  notarizedFormLink?: Maybe<Scalars['String']['output']>;
  numLectures: Scalars['Int']['output'];
  numTests: Scalars['Int']['output'];
  requireOrder?: Maybe<Scalars['Boolean']['output']>;
  requiredHours: Scalars['Int']['output'];
  requiresDmvPreRegistration?: Maybe<Scalars['Boolean']['output']>;
  requiresNotarizedForm?: Maybe<Scalars['Boolean']['output']>;
  requiresSampleCertificateCheck?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  stateLongName: Scalars['String']['output'];
  stateShortName: Scalars['String']['output'];
  testLectures: Array<GQLCourseTestLecture>;
  timerLockedLectureId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topics: Array<GQLCourseTopic>;
  verifyAddressText?: Maybe<Scalars['String']['output']>;
};

export type GQLOption = {
  __typename?: 'Option';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLOrganizationPartner = {
  __typename?: 'OrganizationPartner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentType: GQLOrganizationPartnerPaymentType;
};

export type GQLOrganizationPartnerEdge = {
  __typename?: 'OrganizationPartnerEdge';
  cursor: Scalars['ID']['output'];
  node: GQLOrganizationPartner;
};

export type GQLOrganizationPartnerInput = {
  name: Scalars['String']['input'];
  paymentType: GQLOrganizationPartnerPaymentType;
};

export type GQLOrganizationPartnerPaginatedList = {
  __typename?: 'OrganizationPartnerPaginatedList';
  edges: Array<GQLOrganizationPartnerEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum GQLOrganizationPartnerPaymentType {
  Postpaid = 'Postpaid',
  Prepaid = 'Prepaid'
}

export type GQLOrganizationPartnerStudentPurchase = {
  __typename?: 'OrganizationPartnerStudentPurchase';
  id: Scalars['ID']['output'];
  organizationPartnerExpiresAt?: Maybe<Scalars['String']['output']>;
  purchaseAmountDollars: Scalars['Float']['output'];
  purchaseCreatedAt: Scalars['DateTime']['output'];
  purchaseDescription: Scalars['String']['output'];
  purchaseId: Scalars['ID']['output'];
  studentEmail: Scalars['String']['output'];
  studentId: Scalars['ID']['output'];
  studentName: Scalars['String']['output'];
};

export type GQLOrganizationPartnerStudentPurchaseEdge = {
  __typename?: 'OrganizationPartnerStudentPurchaseEdge';
  cursor: Scalars['ID']['output'];
  node: GQLOrganizationPartnerStudentPurchase;
};

export type GQLOrganizationPartnerStudentPurchasePaginatedList = {
  __typename?: 'OrganizationPartnerStudentPurchasePaginatedList';
  edges: Array<GQLOrganizationPartnerStudentPurchaseEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLOrganizationPartnerStudentsQuery = {
  organizationPartnerId: Scalars['ID']['input'];
};

export enum GQLPackageDisplayStyle {
  HIDDEN = 'HIDDEN',
  HIGHLIGHTED = 'HIGHLIGHTED',
  MINIMAL = 'MINIMAL',
  STANDARD = 'STANDARD'
}

export type GQLPackagesForCoordinatesQuery = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state: Scalars['String']['input'];
};

export type GQLPackagesForPriceSchemeQuery = {
  priceSchemeId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type GQLPackagesForZipcodeQuery = {
  zipcode: Scalars['String']['input'];
};

export type GQLPackagesQuery = {
  courseType?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type GQLPageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type GQLPageMeta = {
  __typename?: 'PageMeta';
  classroomAddress?: Maybe<Scalars['String']['output']>;
  hasScholarship: Scalars['Boolean']['output'];
  isClassroom: Scalars['Boolean']['output'];
  isKnowledgeTest: Scalars['Boolean']['output'];
  licensingStepPath: Scalars['String']['output'];
  locationSentence?: Maybe<Scalars['String']['output']>;
  showLicensingSteps: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLPageQuery = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<GQLSortKeyDirectionPair>>;
};

export type GQLPaginatedCartsResponse = {
  __typename?: 'PaginatedCartsResponse';
  carts: Array<GQLCart>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedCohortsResponse = {
  __typename?: 'PaginatedCohortsResponse';
  edges: Array<GQLCohortEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedMakeupRequestsResponse = {
  __typename?: 'PaginatedMakeupRequestsResponse';
  edges: Array<GQLMakeupRequestEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedVoucherV2Sources = {
  __typename?: 'PaginatedVoucherV2Sources';
  edges: Array<GQLVoucherV2SourceEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLPaginatedVouchersV2 = {
  __typename?: 'PaginatedVouchersV2';
  edges: Array<GQLVoucherV2Edge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLParkingHub = {
  __typename?: 'ParkingHub';
  center?: Maybe<GQLLocationCenter>;
  gateCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  opsManager?: Maybe<GQLPerson>;
  opsManagerUserId?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GQLParkingHubObjectAuthRules = {
  __typename?: 'ParkingHubObjectAuthRules';
  canEdit: Scalars['Boolean']['output'];
};

export enum GQLPaymentCategories {
  Acquisition = 'acquisition',
  Cash = 'cash',
  CashCheck = 'cashCheck',
  Charter = 'charter',
  Check = 'check',
  Complimentary = 'complimentary',
  Corporate = 'corporate',
  NotApplicable = 'notApplicable',
  Paypal = 'paypal',
  Stripe = 'stripe',
  Transfer = 'transfer',
  Voucher = 'voucher'
}

export type GQLPaymentStatusInput = {
  id: Scalars['ID']['input'];
  paymentStatus: Scalars['String']['input'];
};

export type GQLPayrollAuditIssue = {
  __typename?: 'PayrollAuditIssue';
  code: Scalars['String']['output'];
  date?: Maybe<Scalars['DateString']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  lessonId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLPayrollRun = {
  __typename?: 'PayrollRun';
  auditIssues: Array<GQLPayrollAuditIssue>;
  collectSummary?: Maybe<GQLPayrollRunCollectSummary>;
  collectionAttempt: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  endDate: Scalars['DateString']['output'];
  entities: Array<Scalars['String']['output']>;
  excludedInstructorIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  includedInstructorIds: Array<Scalars['ID']['output']>;
  parentRunId?: Maybe<Scalars['ID']['output']>;
  phase: GQLPayrollRunPhase;
  runConfigHash: Scalars['String']['output'];
  startDate: Scalars['DateString']['output'];
  status: GQLPayrollRunStatus;
  updatedAt: Scalars['DateTime']['output'];
  warnings?: Maybe<Array<GQLPayrollAuditIssue>>;
};

export type GQLPayrollRunCollectSummary = {
  __typename?: 'PayrollRunCollectSummary';
  blockingIssueCount: Scalars['Int']['output'];
  entitiesProcessed: Scalars['Int']['output'];
  eventsCollected: Scalars['Int']['output'];
  instructorDaysProcessed: Scalars['Int']['output'];
  instructorsProcessed: Scalars['Int']['output'];
  paylocityPayloadItems: Scalars['Int']['output'];
  skippedInstructorDays: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type GQLPayrollRunEdge = {
  __typename?: 'PayrollRunEdge';
  cursor: Scalars['ID']['output'];
  node: GQLPayrollRun;
};

export type GQLPayrollRunInstructorUpload = {
  __typename?: 'PayrollRunInstructorUpload';
  createdAt: Scalars['DateTime']['output'];
  entity: Scalars['String']['output'];
  error?: Maybe<GQLPayrollRunInstructorUploadError>;
  id: Scalars['ID']['output'];
  instructorId: Scalars['ID']['output'];
  payloadItemCount: Scalars['Int']['output'];
  paylocityCompanyId: Scalars['String']['output'];
  paylocityEmployeeId: Scalars['ID']['output'];
  responseBody?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['Int']['output']>;
  runId: Scalars['ID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadAttempt: Scalars['Int']['output'];
};

export type GQLPayrollRunInstructorUploadError = {
  __typename?: 'PayrollRunInstructorUploadError';
  message: Scalars['String']['output'];
};

export type GQLPayrollRunPaginatedList = {
  __typename?: 'PayrollRunPaginatedList';
  edges: Array<GQLPayrollRunEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum GQLPayrollRunPhase {
  Collection = 'collection',
  Normalization = 'normalization',
  PaylocityUpload = 'paylocityUpload'
}

export enum GQLPayrollRunStatus {
  Blocked = 'blocked',
  Collecting = 'collecting',
  NeedsCorrection = 'needsCorrection',
  Normalizing = 'normalizing',
  ReadyToSend = 'readyToSend',
  SendFailed = 'sendFailed',
  Sending = 'sending',
  Sent = 'sent'
}

export type GQLPendingRequiredContractSummary = {
  __typename?: 'PendingRequiredContractSummary';
  purchaseId: Scalars['ID']['output'];
  state: GQLUsStateId;
};

export type GQLPerson = {
  __typename?: 'Person';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLPriceCard = {
  __typename?: 'PriceCard';
  doShowOtherCoursesForState: Scalars['Boolean']['output'];
  msrp: Scalars['Int']['output'];
  pricePromo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GQLPriceScheme = {
  __typename?: 'PriceScheme';
  canonicalPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  locationLandingPages: Array<GQLLocationLandingPage>;
  name: Scalars['String']['output'];
  productCatalog?: Maybe<GQLProductCatalog>;
  productCatalogId: Scalars['ID']['output'];
  products: Array<GQLPriceSchemeProductLink>;
};

export type GQLPriceSchemeCreateInput = {
  baseProductOverrides: Array<GQLProductOverrideInput>;
  enabledProductIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  productCatalogId: Scalars['ID']['input'];
};

export type GQLPriceSchemeEdge = {
  __typename?: 'PriceSchemeEdge';
  cursor: Scalars['ID']['output'];
  node: GQLPriceScheme;
};

export type GQLPriceSchemeInfo = {
  __typename?: 'PriceSchemeInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLPriceSchemePaginatedList = {
  __typename?: 'PriceSchemePaginatedList';
  edges: Array<GQLPriceSchemeEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLPriceSchemeProductLink = {
  __typename?: 'PriceSchemeProductLink';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  productLinks: Array<GQLProductLink>;
  type: GQLProductType;
};

export type GQLPriceSchemeUpdateInput = {
  baseProductOverrides: Array<GQLProductOverrideInput>;
  enabledProductIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productCatalogId: Scalars['ID']['input'];
};

export type GQLPriceSchemesQuery = {
  productCatalogId?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type GQLPrintablePdfDocument = {
  __typename?: 'PrintablePdfDocument';
  filename: Scalars['String']['output'];
  pdfData: Scalars['String']['output'];
};

export type GQLProduct = GQLProductInfoBase & {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSharedLessons: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numLessons: Scalars['Int']['output'];
  numRoadTests: Scalars['Int']['output'];
  /** @deprecated Use PriceScheme. */
  price?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<GQLProductLink>>;
  type: GQLProductType;
};


export type GQLProductPriceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
};

export type GQLProductBalancedQuantity = {
  __typename?: 'ProductBalancedQuantity';
  balancedQuantity: GQLBalancedQuantity;
  productId: Scalars['ID']['output'];
};

export type GQLProductCatalog = {
  __typename?: 'ProductCatalog';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceSchemeIds: Array<Scalars['ID']['output']>;
  priceSchemes: Array<GQLPriceScheme>;
  productPrices: Array<GQLProductCatalogProductPrice>;
};

export type GQLProductCatalogCreateInput = {
  name: Scalars['String']['input'];
  productPrices: Array<GQLProductPriceInput>;
};

export type GQLProductCatalogEdge = {
  __typename?: 'ProductCatalogEdge';
  cursor: Scalars['ID']['output'];
  node: GQLProductCatalog;
};

export type GQLProductCatalogPackageCourseType = {
  __typename?: 'ProductCatalogPackageCourseType';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GQLProductCatalogPackageDefaults = {
  __typename?: 'ProductCatalogPackageDefaults';
  banner?: Maybe<Scalars['String']['output']>;
  courseType?: Maybe<Scalars['String']['output']>;
  defaultCtaLabel?: Maybe<Scalars['String']['output']>;
  defaultDisplayStyle: GQLPackageDisplayStyle;
  description: Scalars['String']['output'];
  hasCertificateShipping: Scalars['Boolean']['output'];
  isTaxable: Scalars['Boolean']['output'];
  roadTestCarType?: Maybe<GQLRoadTestCarType>;
  title: Scalars['String']['output'];
};

export type GQLProductCatalogPackageDefaultsInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  courseType?: InputMaybe<Scalars['String']['input']>;
  defaultCtaLabel?: InputMaybe<Scalars['String']['input']>;
  defaultDisplayStyle: GQLPackageDisplayStyle;
  description: Scalars['String']['input'];
  hasCertificateShipping: Scalars['Boolean']['input'];
  isTaxable: Scalars['Boolean']['input'];
  roadTestCarType?: InputMaybe<GQLRoadTestCarType>;
  title: Scalars['String']['input'];
};

export type GQLProductCatalogPaginatedList = {
  __typename?: 'ProductCatalogPaginatedList';
  edges: Array<GQLProductCatalogEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLProductCatalogProductPrice = {
  __typename?: 'ProductCatalogProductPrice';
  id: Scalars['ID']['output'];
  moreInfo?: Maybe<Scalars['String']['output']>;
  packageDefaults?: Maybe<GQLProductCatalogPackageDefaults>;
  priceAlgo: GQLProductPriceAlgo;
  product: GQLProduct;
  productCatalogId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
};

export type GQLProductCatalogUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  productPrices: Array<GQLProductPriceInput>;
};

export type GQLProductCatalogsQuery = {
  name?: InputMaybe<Scalars['String']['input']>;
  priceSchemeId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['ID']['output'];
  node: GQLProduct;
};

export type GQLProductInfo = GQLProductInfoBase & {
  __typename?: 'ProductInfo';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: GQLProductType;
};

export type GQLProductInfoBase = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: GQLProductType;
};

export type GQLProductLink = {
  __typename?: 'ProductLink';
  path: Array<Scalars['String']['output']>;
  product: GQLProductInfo;
  productId: Scalars['ID']['output'];
  /** @deprecated Use 'product.name' instead. */
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type GQLProductLinkInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type GQLProductOverrideInput = {
  overridePrice: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
};

export type GQLProductPackage = {
  __typename?: 'ProductPackage';
  banner?: Maybe<Scalars['String']['output']>;
  courseAgeMinimum?: Maybe<Scalars['Int']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  courseType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  doHighlight?: Maybe<Scalars['Boolean']['output']>;
  hasCertificateShipping?: Maybe<Scalars['Boolean']['output']>;
  hasCourse: Scalars['Boolean']['output'];
  hasLessons: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isHomePickup?: Maybe<Scalars['Boolean']['output']>;
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  lessonPackage?: Maybe<GQLLessonPackage>;
  roadTestCarType?: Maybe<GQLRoadTestCarType>;
  state: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
};

export type GQLProductPackageWithPrice = {
  __typename?: 'ProductPackageWithPrice';
  banner?: Maybe<Scalars['String']['output']>;
  bookUrl?: Maybe<Scalars['String']['output']>;
  couponDiscountAmount?: Maybe<Scalars['Float']['output']>;
  courseAgeMinimum?: Maybe<Scalars['Int']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  courseType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  didApplyCoupon?: Maybe<Scalars['Boolean']['output']>;
  discountAmount: Scalars['Float']['output'];
  doHighlight?: Maybe<Scalars['Boolean']['output']>;
  extras?: Maybe<Scalars['String']['output']>;
  hasCertificateShipping?: Maybe<Scalars['Boolean']['output']>;
  hasCourse: Scalars['Boolean']['output'];
  hasLessons: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCheckoutFlowPackage?: Maybe<Scalars['Boolean']['output']>;
  isHomePickup?: Maybe<Scalars['Boolean']['output']>;
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  lessonPackage?: Maybe<GQLLessonPackage>;
  moreInfo?: Maybe<Scalars['String']['output']>;
  msrp: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  priceCents?: Maybe<Scalars['Int']['output']>;
  roadTestCarType?: Maybe<GQLRoadTestCarType>;
  state: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
};

export type GQLProductPackageWithPriceInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  bookUrl?: InputMaybe<Scalars['String']['input']>;
  couponDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  courseAgeMinimum?: InputMaybe<Scalars['Int']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  courseType?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  didApplyCoupon?: InputMaybe<Scalars['Boolean']['input']>;
  discountAmount: Scalars['Float']['input'];
  doHighlight?: InputMaybe<Scalars['Boolean']['input']>;
  extras?: InputMaybe<Scalars['String']['input']>;
  hasCertificateShipping?: InputMaybe<Scalars['Boolean']['input']>;
  hasCourse: Scalars['Boolean']['input'];
  hasLessons: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  isCheckoutFlowPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isHomePickup?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  lessonPackage?: InputMaybe<GQLLessonPackageInput>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  msrp: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  priceCents?: InputMaybe<Scalars['Int']['input']>;
  roadTestCarType?: InputMaybe<GQLRoadTestCarType>;
  state: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

export type GQLProductPriceAlgo = GQLProductPriceAlgoDollarDiscount | GQLProductPriceAlgoDollarThenPercentDiscount | GQLProductPriceAlgoFixed | GQLProductPriceAlgoPercentDiscount | GQLProductPriceAlgoPercentThenDollarDiscount;

export type GQLProductPriceAlgoBase = {
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoDollarDiscount = GQLProductPriceAlgoBase & {
  __typename?: 'ProductPriceAlgoDollarDiscount';
  dollarDiscount: Scalars['Float']['output'];
  rounding: GQLProductPriceRounding;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoDollarDiscountInput = {
  dollarDiscount: Scalars['Float']['input'];
  rounding: GQLProductPriceRoundingInput;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoDollarThenPercentDiscount = GQLProductPriceAlgoBase & {
  __typename?: 'ProductPriceAlgoDollarThenPercentDiscount';
  dollarDiscount: Scalars['Float']['output'];
  percentDiscount: Scalars['Float']['output'];
  rounding: GQLProductPriceRounding;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoDollarThenPercentDiscountInput = {
  dollarDiscount: Scalars['Float']['input'];
  percentDiscount: Scalars['Float']['input'];
  rounding: GQLProductPriceRoundingInput;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoFixed = GQLProductPriceAlgoBase & {
  __typename?: 'ProductPriceAlgoFixed';
  fixedPrice: Scalars['Float']['output'];
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoFixedPriceInput = {
  fixedPrice: Scalars['Float']['input'];
  type: GQLProductPriceAlgoType;
};

/** Only one of the fields should be passed */
export type GQLProductPriceAlgoInput = {
  dollarDiscount?: InputMaybe<GQLProductPriceAlgoDollarDiscountInput>;
  dollarThenPercentDiscount?: InputMaybe<GQLProductPriceAlgoDollarThenPercentDiscountInput>;
  fixed?: InputMaybe<GQLProductPriceAlgoFixedPriceInput>;
  percentDiscount?: InputMaybe<GQLProductPriceAlgoPercentDiscountInput>;
  percentThenDollarDiscount?: InputMaybe<GQLProductPriceAlgoPercentThenDollarDiscountInput>;
};

export type GQLProductPriceAlgoPercentDiscount = GQLProductPriceAlgoBase & {
  __typename?: 'ProductPriceAlgoPercentDiscount';
  percentDiscount: Scalars['Float']['output'];
  rounding: GQLProductPriceRounding;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoPercentDiscountInput = {
  percentDiscount: Scalars['Float']['input'];
  rounding: GQLProductPriceRoundingInput;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoPercentThenDollarDiscount = GQLProductPriceAlgoBase & {
  __typename?: 'ProductPriceAlgoPercentThenDollarDiscount';
  dollarDiscount: Scalars['Float']['output'];
  percentDiscount: Scalars['Float']['output'];
  rounding: GQLProductPriceRounding;
  type: GQLProductPriceAlgoType;
};

export type GQLProductPriceAlgoPercentThenDollarDiscountInput = {
  dollarDiscount: Scalars['Float']['input'];
  percentDiscount: Scalars['Float']['input'];
  rounding: GQLProductPriceRoundingInput;
  type: GQLProductPriceAlgoType;
};

export enum GQLProductPriceAlgoType {
  DollarDiscount = 'dollarDiscount',
  DollarThenPercentDiscount = 'dollarThenPercentDiscount',
  Fixed = 'fixed',
  PercentDiscount = 'percentDiscount',
  PercentThenDollarDiscount = 'percentThenDollarDiscount'
}

export type GQLProductPriceInput = {
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  packageDefaults?: InputMaybe<GQLProductCatalogPackageDefaultsInput>;
  priceAlgo: GQLProductPriceAlgoInput;
  productId: Scalars['ID']['input'];
};

export type GQLProductPriceRounding = {
  __typename?: 'ProductPriceRounding';
  type: GQLProductPriceRoundingType;
  value: Scalars['Float']['output'];
};

export type GQLProductPriceRoundingInput = {
  type: GQLProductPriceRoundingType;
  value: Scalars['Float']['input'];
};

export enum GQLProductPriceRoundingType {
  Digit = 'digit',
  Down = 'down',
  Nearest = 'nearest',
  Up = 'up'
}

export type GQLProductQuantity = {
  __typename?: 'ProductQuantity';
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type GQLProductQuantityInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum GQLProductType {
  Course = 'course',
  DrivingMinute = 'drivingMinute',
  Fee = 'fee',
  HomePickup = 'homePickup',
  ObservationMinute = 'observationMinute',
  Package = 'package'
}

export type GQLProductsPaginatedList = {
  __typename?: 'ProductsPaginatedList';
  edges: Array<GQLProductEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLProductsQuery = {
  omitPackages?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPackages?: InputMaybe<Scalars['Boolean']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type GQLProfileCreditUsage = {
  __typename?: 'ProfileCreditUsage';
  date: Scalars['DateTime']['output'];
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  type: GQLProfileCreditUsageType;
};

export enum GQLProfileCreditUsageType {
  Expiration = 'Expiration',
  Lesson = 'Lesson'
}

export type GQLProfileTransactions = {
  __typename?: 'ProfileTransactions';
  creditUsage: Array<GQLProfileCreditUsage>;
  hasMadePurchase: Scalars['Boolean']['output'];
  hasPendingWaContract: Scalars['Boolean']['output'];
  hasSignedWaContract: Scalars['Boolean']['output'];
  pendingRequiredContract?: Maybe<GQLPendingRequiredContractSummary>;
  purchasesAndRefunds: Array<GQLStudentOperation>;
};

export type GQLProgramDeadline = {
  __typename?: 'ProgramDeadline';
  daysRemaining?: Maybe<Scalars['Int']['output']>;
  deadlineDate?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<GQLProgramDeadlineRequirements>;
  status: GQLProgramDeadlineStatus;
  type?: Maybe<Scalars['String']['output']>;
};

export type GQLProgramDeadlineRequirements = {
  __typename?: 'ProgramDeadlineRequirements';
  courseCompleted: Scalars['Boolean']['output'];
  drivingComplete: Scalars['Boolean']['output'];
  drivingMinutesCompleted: Scalars['Int']['output'];
  drivingMinutesRequired?: Maybe<Scalars['Int']['output']>;
  observationComplete: Scalars['Boolean']['output'];
  observationMinutesCompleted: Scalars['Int']['output'];
  observationMinutesRequired?: Maybe<Scalars['Int']['output']>;
  requiresCourseCompletion: Scalars['Boolean']['output'];
};

export enum GQLProgramDeadlineStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  ON_TRACK = 'ON_TRACK',
  WARNING = 'WARNING'
}

export type GQLPublishedLocationsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<GQLUsStateId>;
};

export type GQLPurchase = GQLLedgerEntity & {
  __typename?: 'Purchase';
  acquisitionId?: Maybe<Scalars['ID']['output']>;
  acquisitionName?: Maybe<Scalars['String']['output']>;
  amountDollars: Scalars['Float']['output'];
  categoryId: GQLPaymentCategories;
  contractId?: Maybe<Scalars['ID']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isVoid: Scalars['Boolean']['output'];
  items: Array<GQLPurchaseItem>;
  organizationPartnerExpiresAt?: Maybe<Scalars['String']['output']>;
  organizationPartnerId?: Maybe<Scalars['ID']['output']>;
  organizationPartnerName?: Maybe<Scalars['String']['output']>;
  paymentCaptureDate?: Maybe<Scalars['DateTime']['output']>;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodType?: Maybe<Scalars['String']['output']>;
  usStateId: GQLUsStateId;
  versionId: Scalars['ID']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
  voucherCode?: Maybe<Scalars['String']['output']>;
};

export type GQLPurchaseItem = GQLPurchasePackage | GQLPurchaseProduct;

export type GQLPurchaseItemInput = {
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  itemId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type GQLPurchaseItemUpdate = GQLExistingPurchaseItemUpdate | GQLPurchasePackage | GQLPurchaseProduct;

export type GQLPurchasePackage = {
  __typename?: 'PurchasePackage';
  itemId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Array<Scalars['ID']['output']>;
  priceDollars: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: GQLProductType;
};

export type GQLPurchasePackageItem = {
  __typename?: 'PurchasePackageItem';
  itemId: Scalars['ID']['output'];
  items?: Maybe<Array<GQLPurchaseProductItem>>;
  name: Scalars['String']['output'];
  priceDollars: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: GQLProductType;
};

export type GQLPurchasePricingPreview = {
  __typename?: 'PurchasePricingPreview';
  couponDiscountAmount?: Maybe<Scalars['Float']['output']>;
  totalDollars: Scalars['Float']['output'];
};

export type GQLPurchasePricingPreviewInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  items: Array<GQLPurchaseItemInput>;
  studentAddress?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  usStateId: GQLUsStateId;
};

export type GQLPurchaseProduct = {
  __typename?: 'PurchaseProduct';
  basePriceDollars: Scalars['Float']['output'];
  itemId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Array<Scalars['ID']['output']>;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: GQLProductType;
};

export type GQLPurchaseProductItem = {
  __typename?: 'PurchaseProductItem';
  basePriceDollars: Scalars['Float']['output'];
  itemId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: GQLProductType;
};

export type GQLPurchaseQuery = {
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLPurchaseTransfer = GQLLedgerEntity & {
  __typename?: 'PurchaseTransfer';
  amountToTransfer: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destinationStudentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  itemsToTransfer: Array<GQLItemToTransfer>;
  purchaseId: Scalars['ID']['output'];
  sourceStudentId: Scalars['ID']['output'];
  versionId: Scalars['ID']['output'];
};

export type GQLPutLessonReviewInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  studentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type GQLPutTestLessonInput = {
  bookedAt: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  instructorId: Scalars['ID']['input'];
  isObserverAllowed: Scalars['Boolean']['input'];
  isShareable: Scalars['Boolean']['input'];
  lessonId?: InputMaybe<Scalars['ID']['input']>;
  pickupLocation: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  startTime: Scalars['DateTime']['input'];
  students: Array<GQLLessonStudentDetailsUpdateInput>;
};

export type GQLPutTestProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSharedLessons?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  numLessons?: InputMaybe<Scalars['Int']['input']>;
  numRoadTests?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<GQLProductLinkInput>>;
  type: GQLProductType;
};

export type GQLQuantityByIndicator = {
  __typename?: 'QuantityByIndicator';
  quantity: Scalars['Int']['output'];
  syncIndicator: GQLSyncIndicator;
};

export type GQLQuery = {
  __typename?: 'Query';
  accommodation?: Maybe<GQLAccommodation>;
  acquisition: GQLAcquisition;
  acquisitions: GQLAcquisitionPaginatedList;
  activeInstructors: Array<GQLInstructor>;
  adminHelpDoc?: Maybe<GQLAdminHelpDocContent>;
  adminHelpDocs: Array<GQLAdminHelpDocIndexEntry>;
  adminInstructorHistory: Array<GQLAdminRecentHistoryItem>;
  adminLessonsInstructors: Array<GQLAdminLessonsInstructor>;
  adminSlotSearch: Array<GQLSlot>;
  adminStudentHistory: Array<GQLAdminRecentHistoryItem>;
  allVehicles: Array<GQLVehicle>;
  apiCallCountByDate: GQLApiCallCountPaginatedList;
  approvedInstructorSchedule: GQLApprovedInstructorSchedule;
  approvedInstructorsSchedules: Array<GQLApprovedInstructorSchedule>;
  auditLogs?: Maybe<GQLAuditLogsPaginatedList>;
  authRulesForUser: GQLAuthRules;
  autoCreatedAccountExists: Scalars['Boolean']['output'];
  availFormContext: GQLAvailFormContext;
  availabilities: Array<GQLAvailability>;
  availabilitiesForVehicles: Array<GQLAvailability>;
  availability: GQLAvailability;
  bookingAlerts: GQLBookingAlertsPaginatedList;
  calendarHolidays: Array<GQLCalendarHoliday>;
  cancelLogs: Array<GQLCancelLogEntry>;
  cart: GQLCart;
  cast: GQLCast;
  certificateTypes: Array<GQLCertificateType>;
  certificates: GQLCertificatesPaginatedList;
  checkSlotAvailability: GQLSlotAvailabilityResult;
  /** @deprecated Use checkoutView instead. Temporary compatibility alias for Legacy checkout migration. */
  checkoutSync: GQLCheckoutView;
  checkoutView: GQLCheckoutView;
  cohort: GQLCohort;
  cohortEmailSendLogs: Array<GQLCohortEmailSendLog>;
  cohortEmailTemplatePreview?: Maybe<GQLCohortEmailTemplatePreview>;
  cohortEmailTemplates: Array<GQLCohortEmailTemplate>;
  cohortSessionsByInstructorId: Array<GQLCohortSession>;
  cohortSessionsByInstructorIds: Array<GQLCohortSession>;
  cohorts: Array<GQLCohort>;
  cohortsByState: Array<GQLCohort>;
  cohortsForStudent: Array<GQLCohort>;
  cohortsPaginated: GQLPaginatedCohortsResponse;
  completedCarts: GQLCartsPaginatedList;
  coupons: GQLCouponsPaginatedList;
  courseById: GQLOnlineCourseContent;
  courseBySlug: GQLOnlineCourseContent;
  courseCoupons: Array<Maybe<GQLCourseCoupon>>;
  courseOrder?: Maybe<GQLCourseOrder>;
  courseOrders: Array<GQLCourseOrder>;
  coursePrepTest: GQLCoursePrepTest;
  coursePrepTestScores: Array<GQLCoursePrepTestChapterScores>;
  courseProgressArchives: Array<GQLCourseProgressArchive>;
  courseSurvey?: Maybe<GQLCourseSurvey>;
  courseTimerEvents: GQLSyncCourseTimersResult;
  courseTimerReport: GQLCourseTimerReportTimeSlotPaginatedList;
  courseTimerSecondsSpent: GQLCourseTimerSecondsSpent;
  courses: Array<GQLOnlineCourseContent>;
  coursesByState: Array<GQLCourseConfig>;
  coursesForState: Array<GQLOnlineCourseContent>;
  coursesWithIds: Array<GQLOnlineCourseContent>;
  driveLogs: Array<GQLDriveLog>;
  drivingSkills: Array<GQLDrivingSkill>;
  eligibleMakeupSessions: Array<GQLCohortSession>;
  examInfo: GQLExamTypeInfo;
  expiration: GQLExpiration;
  fleetAttachments: Array<GQLFleetAttachment>;
  fleetNotes: GQLFleetNotesPaginatedList;
  getInstructorReviewAggregations: GQLReviewAggregations;
  getLocationLandingPageBySlug?: Maybe<GQLLocationLandingPage>;
  /** @deprecated Use review query instead */
  getReview: GQLLessonReview;
  getTestStudent?: Maybe<GQLStudent>;
  hasOnlySharedLessonPackages: Scalars['Boolean']['output'];
  hubCalendar: GQLHubCalendar;
  illinoisCompletionForm?: Maybe<GQLIllinoisCompletionForm>;
  instructor: GQLInstructor;
  instructorAlerts: GQLInstructorAlertPaginatedList;
  instructorAlertsForUser: Array<GQLInstructorAlert>;
  instructorBadges: Array<GQLInstructorBadge>;
  instructorCustomIsochrone?: Maybe<GQLGeoJsonFeatureCollection>;
  instructorDailyAvailabilities: Array<GQLAvailability>;
  instructorEvents: GQLInstructorEventsResponse;
  instructorIsochrones: Array<GQLInstructorIsochrone>;
  instructorLessonNotificationRegistrations: GQLInstructorLessonNotificationRegistrationsResponse;
  instructorMetrics: GQLInstructorMetricsReport;
  instructorSchedule: GQLInstructorSchedule;
  instructorTeachingZonePreview: GQLInstructorTeachingZonePreview;
  instructorTimeLog: GQLInstructorTimeLog;
  instructorTimeLogs: GQLInstructorTimeLogPaginatedList;
  instructorTimeOff?: Maybe<Array<GQLInstructorTimeOff>>;
  instructors: GQLInstructorsPaginatedList;
  instructorsCoverageGeoJson: GQLInstructorsCoverage;
  instructorsForAdminTable: GQLInstructorsPaginatedList;
  instructorsSchedules: Array<GQLInstructorSchedule>;
  instructorsTimeOff?: Maybe<Array<GQLInstructorTimeOff>>;
  languageOptions: Array<GQLLanguageOption>;
  lastBookedInstructor?: Maybe<GQLLastBookedInstructor>;
  lastCompletedSyncCheck?: Maybe<GQLSyncCheck>;
  lectureById: GQLCourseLecture;
  ledgerLog: GQLLedgerLog;
  ledgerLogs: GQLLedgerLogsPaginatedList;
  lesson: GQLLesson;
  lessonByInstructorId: GQLLesson;
  lessonDrivingSkillsReportByStudentAndLesson?: Maybe<GQLLessonDrivingSkillsReport>;
  lessonNotificationRegistrations: GQLLessonNotificationRegistrationPaginatedList;
  lessonTypeById: GQLLessonType;
  lessonTypes: GQLLessonTypesPaginatedList;
  lessonTypesForAddress: Array<GQLLessonType>;
  lessons: GQLLessonsPaginatedList;
  lessonsByInstructorIds: Array<GQLLesson>;
  lessonsByObserverInstructorIds: Array<GQLLesson>;
  lessonsDrivingSkillsReportsByStudent: GQLLessonDrivingSkillsReportPaginatedList;
  lessonsReviewsByInstructor: GQLLessonsReviewsPaginatedList;
  livestreamGroup?: Maybe<GQLLivestreamGroup>;
  livestreamGroups: Array<GQLLivestreamGroup>;
  locationLandingPage?: Maybe<GQLLocationLandingPage>;
  locationLandingPages: GQLLocationLandingPagePaginatedList;
  locationPackagesForConfig: Array<GQLProductPackageWithPrice>;
  makeupRequests: GQLPaginatedMakeupRequestsResponse;
  me: GQLMyself;
  meetInstructors: GQLInstructorsPaginatedList;
  meetingPoint: GQLStateMeetingPoint;
  meetingPoints: Array<GQLStateMeetingPoint>;
  metro?: Maybe<GQLMetro>;
  metros: GQLMetroPaginatedList;
  milesChatConversation: GQLMilesChatConversationDetail;
  milesChatConversationStatus: GQLMilesChatConversationStatus;
  milesChatConversations: Array<GQLMilesChatConversation>;
  myActiveExamSession?: Maybe<GQLExamSession>;
  myExamAttempts: Array<GQLExamAttempt>;
  myExamEnabledCourses: Array<GQLOnlineCourseContent>;
  myMakeupRequests: Array<GQLMakeupRequest>;
  myTags: Array<Scalars['String']['output']>;
  myUserSettings: GQLUserSettings;
  nearbyLocations: Array<GQLNearbyLocationResult>;
  notes: GQLNotesPaginatedList;
  observationLessonCandidates: GQLObservationLessonCandidatePaginatedList;
  organizationCasts: Array<GQLCastList>;
  organizationPartner: GQLOrganizationPartner;
  organizationPartnerStudents: GQLOrganizationPartnerStudentPurchasePaginatedList;
  organizationPartners: GQLOrganizationPartnerPaginatedList;
  /** @deprecated Unused by current clients. Use the state-filtered /courses discovery flow instead. */
  otherStateCourses: Array<GQLCourseConfig>;
  packages: Array<Maybe<GQLProductPackage>>;
  packagesForCoordinates: Array<GQLProductPackageWithPrice>;
  packagesForPriceScheme: Array<GQLProductPackageWithPrice>;
  packagesForZipcode: Array<GQLProductPackageWithPrice>;
  parkingHub?: Maybe<GQLParkingHub>;
  parkingHubs: Array<GQLParkingHub>;
  payrollRun?: Maybe<GQLPayrollRun>;
  payrollRunInstructorUploads: Array<GQLPayrollRunInstructorUpload>;
  payrollRuns: GQLPayrollRunPaginatedList;
  /**
   * True when the user may use instructor–student phone masking.
   * June 8, 2026: this field is temporary rollout support and should be removed
   * after clients no longer need to check it.
   */
  phoneMaskingCommsEnabled: Scalars['Boolean']['output'];
  priceScheme: GQLPriceScheme;
  priceSchemeForAddress?: Maybe<GQLPriceScheme>;
  priceSchemes: GQLPriceSchemePaginatedList;
  product: GQLProduct;
  productCatalog: GQLProductCatalog;
  productCatalogPackageCourseTypes: Array<GQLProductCatalogPackageCourseType>;
  productCatalogs: GQLProductCatalogPaginatedList;
  products: GQLProductsPaginatedList;
  profileTransactions?: Maybe<GQLProfileTransactions>;
  programProgressForCohort: Array<GQLStudentProgramProgress>;
  publishedLocations: Array<GQLLocationPin>;
  purchase: GQLPurchase;
  purchasePricingPreview: GQLPurchasePricingPreview;
  reference: Array<GQLReferenceItem>;
  refund: GQLRefund;
  regionalManagers: Array<GQLPerson>;
  requiredContractPage: GQLRequiredContractPageData;
  review?: Maybe<GQLLessonReview>;
  searchAccountTags: Array<GQLAccountTag>;
  selfAuthMeta?: Maybe<GQLUserAuthMeta>;
  sharedLessonDrivingSkillsReport?: Maybe<GQLSharedLessonDrivingSkillsReport>;
  sharedLessons: Array<GQLSharedLesson>;
  shippingOrder?: Maybe<GQLShippingOrder>;
  shippingOrders: GQLShippingOrdersPaginatedList;
  stateConfig?: Maybe<GQLStateConfig>;
  stateConfigs: GQLStateConfigPaginatedList;
  stateMeetingPoints: GQLStateMeetingPointPaginatedList;
  student?: Maybe<GQLStudent>;
  studentBalance: GQLStudentBalance;
  /** @deprecated Use studentCourseEnrollmentInfo instead */
  studentClassroomCourseInfo: GQLStudentCourseEnrollmentInfo;
  studentContractDetails?: Maybe<GQLStudentContractDetails>;
  studentCourseEnrollmentInfo: GQLStudentCourseEnrollmentInfo;
  studentCourseGrades: Array<GQLStudentCourseGrades>;
  studentCourseMeta?: Maybe<GQLStudentOnlineCourse>;
  studentCourseSecurityAnswers?: Maybe<Scalars['JSONObject']['output']>;
  studentExamAttempts: Array<GQLExamAttempt>;
  studentLegalAndPermissions?: Maybe<GQLStudentLegalAndPermissionsRecord>;
  studentLegalAndPermissionsAggregated?: Maybe<GQLStudentLegalAndPermissionsSummary>;
  studentLocationReviewUrl?: Maybe<Scalars['String']['output']>;
  studentNotesAndCertificates: GQLStudentNotesAndCertificates;
  studentOnlineCourse: GQLStudentOnlineCoursesPaginatedList;
  studentOnlineCourseIsComplete: Scalars['Boolean']['output'];
  studentOnlineCourseReport: GQLStudentOnlineCourseReport;
  studentOnlineCourseTimeProgress: GQLStudentOnlineCourseTimeProgress;
  studentOnlineCourseTimerDebugInfo: GQLStudentOnlineCourseTimerDebugInfo;
  studentOperations: GQLStudentOperationsPaginatedResult;
  studentSearch: GQLStudentSearchResultPaginatedList;
  students: GQLStudentsPaginatedList;
  subLocations: Array<GQLSubLocation>;
  syncCheck: GQLSyncCheck;
  syncChecks: GQLSyncChecksPaginatedList;
  syncConflict: GQLSyncConflict;
  syncConflicts: GQLSyncConflictsPaginatedList;
  transferAccountCheck: GQLTransferAccountCheckResult;
  transientSlot: GQLTransientSlot;
  transientSlotIfExists?: Maybe<GQLTransientSlot>;
  transientSlots: Array<GQLTransientSlot>;
  transientSlotsForStudent: Array<GQLTransientSlot>;
  usStates: Array<GQLUsState>;
  userAlsoViewing: Array<GQLUserAlsoViewing>;
  userAuthInfo: GQLUserAuthInfo;
  userFiles: Array<GQLUserFile>;
  userLogs?: Maybe<GQLUserLogsPaginatedList>;
  userNotificationsLog: GQLUserNotificationsPaginatedList;
  userRoles: Array<GQLUserRole>;
  usersWithRoles: GQLUserManagementList;
  vehicle?: Maybe<GQLVehicle>;
  /** @deprecated Use availabilitiesForVehicles from availabilities instead */
  vehicleAvails: Array<GQLVehicleAvail>;
  vehicleParkingHub?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<GQLVehiclesPaginatedList>;
  vehiclesExpiredByDate: Array<GQLVehicle>;
  vendor?: Maybe<GQLVendor>;
  vendors: GQLVendorPaginatedList;
  voucherV2?: Maybe<GQLVoucherV2>;
  voucherV2ByRedemptionCode?: Maybe<GQLVoucherV2>;
  voucherV2Source?: Maybe<GQLVoucherV2Source>;
  voucherV2Sources?: Maybe<GQLPaginatedVoucherV2Sources>;
  vouchersV2: GQLPaginatedVouchersV2;
};


export type GQLQueryAccommodationArgs = {
  accommodationFor: GQLAccommodationFor;
  studentId: Scalars['ID']['input'];
};


export type GQLQueryAcquisitionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryAcquisitionsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryAdminHelpDocArgs = {
  docPath: Scalars['String']['input'];
};


export type GQLQueryAdminSlotSearchArgs = {
  input: GQLAdminSlotSearchInput;
};


export type GQLQueryApiCallCountByDateArgs = {
  pageQuery: GQLPageQuery;
  query: GQLApiCallCountByDateQuery;
};


export type GQLQueryApprovedInstructorScheduleArgs = {
  query: GQLApprovedInstructorScheduleQuery;
};


export type GQLQueryApprovedInstructorsSchedulesArgs = {
  query: GQLApprovedInstructorsSchedulesQuery;
};


export type GQLQueryAuditLogsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLAuditLogsQuery;
};


export type GQLQueryAuthRulesForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryAutoCreatedAccountExistsArgs = {
  email: Scalars['String']['input'];
};


export type GQLQueryAvailFormContextArgs = {
  query: GQLAvailFormContextInput;
};


export type GQLQueryAvailabilitiesArgs = {
  query: GQLAvailabilitiesQuery;
};


export type GQLQueryAvailabilitiesForVehiclesArgs = {
  query: GQLAvailabilitiesForVehiclesQuery;
};


export type GQLQueryAvailabilityArgs = {
  query: GQLAvailabilityQuery;
};


export type GQLQueryBookingAlertsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLBookingAlertsQuery;
};


export type GQLQueryCancelLogsArgs = {
  query: GQLCancelLogsQuery;
};


export type GQLQueryCartArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryCastArgs = {
  id: Scalars['String']['input'];
};


export type GQLQueryCertificatesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLCertificatesQuery>;
};


export type GQLQueryCheckSlotAvailabilityArgs = {
  input: GQLCheckSlotAvailabilityInput;
};


export type GQLQueryCheckoutSyncArgs = {
  input: GQLCheckoutSyncInput;
};


export type GQLQueryCheckoutViewArgs = {
  input: GQLCheckoutViewInput;
};


export type GQLQueryCohortArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryCohortEmailSendLogsArgs = {
  cohortId: Scalars['ID']['input'];
};


export type GQLQueryCohortEmailTemplatePreviewArgs = {
  templateId: Scalars['String']['input'];
};


export type GQLQueryCohortEmailTemplatesArgs = {
  courseId: Scalars['ID']['input'];
};


export type GQLQueryCohortSessionsByInstructorIdArgs = {
  query: GQLCohortSessionsQueryByInstructorId;
};


export type GQLQueryCohortSessionsByInstructorIdsArgs = {
  query: GQLCohortSessionsQueryByInstructorIds;
};


export type GQLQueryCohortsArgs = {
  courseId: Scalars['ID']['input'];
  doShowClosed?: InputMaybe<Scalars['Boolean']['input']>;
  minEndDate?: InputMaybe<Scalars['String']['input']>;
};


export type GQLQueryCohortsByStateArgs = {
  dateRange?: InputMaybe<GQLDateRange>;
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
  state: GQLUsStateId;
};


export type GQLQueryCohortsForStudentArgs = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
};


export type GQLQueryCohortsPaginatedArgs = {
  courseId: Scalars['ID']['input'];
  doShowClosed?: InputMaybe<Scalars['Boolean']['input']>;
  minEndDate?: InputMaybe<Scalars['String']['input']>;
  pageQuery: GQLPageQuery;
};


export type GQLQueryCompletedCartsArgs = {
  filter: GQLCartFilterInput;
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryCouponsArgs = {
  filterQuery?: InputMaybe<GQLCouponsFilterQuery>;
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryCourseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryCourseBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type GQLQueryCourseCouponsArgs = {
  courseId: Scalars['String']['input'];
};


export type GQLQueryCourseOrderArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryCourseOrdersArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryCoursePrepTestArgs = {
  courseId: Scalars['ID']['input'];
};


export type GQLQueryCoursePrepTestScoresArgs = {
  courseId: Scalars['ID']['input'];
};


export type GQLQueryCourseProgressArchivesArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryCourseSurveyArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryCourseTimerEventsArgs = {
  query: GQLSyncCourseTimersQuery;
};


export type GQLQueryCourseTimerReportArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLCourseTimerSecondsSpentQuery;
};


export type GQLQueryCourseTimerSecondsSpentArgs = {
  query: GQLCourseTimerSecondsSpentQuery;
};


export type GQLQueryCoursesArgs = {
  query?: InputMaybe<GQLCoursesQuery>;
};


export type GQLQueryCoursesByStateArgs = {
  state: GQLUsStateId;
};


export type GQLQueryCoursesForStateArgs = {
  filters?: InputMaybe<GQLCoursesForStateFilters>;
  state: GQLUsStateId;
};


export type GQLQueryCoursesWithIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type GQLQueryDriveLogsArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryEligibleMakeupSessionsArgs = {
  input: GQLEligibleMakeupSessionsInput;
};


export type GQLQueryExamInfoArgs = {
  examSlug: Scalars['String']['input'];
};


export type GQLQueryExpirationArgs = {
  query: GQLExpirationQuery;
};


export type GQLQueryFleetAttachmentsArgs = {
  query: GQLFleetAttachmentsQuery;
};


export type GQLQueryFleetNotesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLFleetNotesQuery;
};


export type GQLQueryGetInstructorReviewAggregationsArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLQueryGetLocationLandingPageBySlugArgs = {
  slug: Scalars['String']['input'];
  state: GQLUsStateId;
};


export type GQLQueryGetReviewArgs = {
  query: GQLGetLessonReviewInput;
};


export type GQLQueryGetTestStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryHasOnlySharedLessonPackagesArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryHubCalendarArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLHubCalendarQuery;
};


export type GQLQueryIllinoisCompletionFormArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryInstructorArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLQueryInstructorAlertsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryInstructorAlertsForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryInstructorBadgesArgs = {
  query: GQLInstructorBadgeQuery;
};


export type GQLQueryInstructorCustomIsochroneArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLQueryInstructorDailyAvailabilitiesArgs = {
  query: GQLInstructorDailyAvailabilitiesQuery;
};


export type GQLQueryInstructorEventsArgs = {
  input: GQLInstructorEventsInput;
};


export type GQLQueryInstructorIsochronesArgs = {
  state?: InputMaybe<GQLUsStateId>;
};


export type GQLQueryInstructorLessonNotificationRegistrationsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLInstructorLessonNotificationRegistrationsQuery;
};


export type GQLQueryInstructorMetricsArgs = {
  instructorId: Scalars['ID']['input'];
};


export type GQLQueryInstructorScheduleArgs = {
  query: GQLInstructorScheduleQuery;
};


export type GQLQueryInstructorTeachingZonePreviewArgs = {
  query: GQLInstructorTeachingZonePreviewQuery;
};


export type GQLQueryInstructorTimeLogArgs = {
  query: GQLInstructorTimeLogQuery;
};


export type GQLQueryInstructorTimeLogsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLInstructorTimeLogListQuery;
};


export type GQLQueryInstructorTimeOffArgs = {
  query: GQLInstructorTimeOffQuery;
};


export type GQLQueryInstructorsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLInstructorsQuery>;
};


export type GQLQueryInstructorsForAdminTableArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLAdminInstructorTableQuery;
};


export type GQLQueryInstructorsSchedulesArgs = {
  query: GQLInstructorsSchedulesQuery;
};


export type GQLQueryInstructorsTimeOffArgs = {
  query: GQLInstructorsTimeOffQuery;
};


export type GQLQueryLastBookedInstructorArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryLectureByIdArgs = {
  courseId: Scalars['ID']['input'];
  lectureId: Scalars['ID']['input'];
};


export type GQLQueryLedgerLogArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryLedgerLogsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLLedgerLogsQuery;
};


export type GQLQueryLessonArgs = {
  query: GQLLessonQuery;
};


export type GQLQueryLessonByInstructorIdArgs = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
};


export type GQLQueryLessonDrivingSkillsReportByStudentAndLessonArgs = {
  query: GQLLessonQuery;
};


export type GQLQueryLessonNotificationRegistrationsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLLessonNotificationRegistrationsQuery>;
};


export type GQLQueryLessonTypeByIdArgs = {
  lessonTypeId: Scalars['ID']['input'];
};


export type GQLQueryLessonTypesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryLessonTypesForAddressArgs = {
  address: Scalars['String']['input'];
};


export type GQLQueryLessonsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLLessonsQuery;
};


export type GQLQueryLessonsByInstructorIdsArgs = {
  query: GQLLessonsQueryByInstructorIds;
};


export type GQLQueryLessonsByObserverInstructorIdsArgs = {
  query: GQLLessonsQueryByObserverInstructorIds;
};


export type GQLQueryLessonsDrivingSkillsReportsByStudentArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLLessonsDrivingSkillsReportsQuery;
};


export type GQLQueryLessonsReviewsByInstructorArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLLessonsReviewsByInstructorQuery;
};


export type GQLQueryLivestreamGroupArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryLivestreamGroupsArgs = {
  state?: InputMaybe<GQLUsStateId>;
};


export type GQLQueryLocationLandingPageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryLocationLandingPagesArgs = {
  filter?: InputMaybe<GQLLocationLandingPagesFilter>;
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryLocationPackagesForConfigArgs = {
  query: GQLLocationPackagesForConfigInput;
};


export type GQLQueryMakeupRequestsArgs = {
  input: GQLMakeupRequestsInput;
  pageQuery: GQLPageQuery;
};


export type GQLQueryMeetInstructorsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLMeetInstructorsQuery>;
};


export type GQLQueryMeetingPointArgs = {
  query: GQLStateMeetingPointQuery;
};


export type GQLQueryMeetingPointsArgs = {
  query: GQLMeetingPointsQuery;
};


export type GQLQueryMetroArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryMetrosArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryMilesChatConversationArgs = {
  browserId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};


export type GQLQueryMilesChatConversationStatusArgs = {
  browserId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};


export type GQLQueryMilesChatConversationsArgs = {
  browserId: Scalars['ID']['input'];
};


export type GQLQueryMyExamAttemptsArgs = {
  courseId: Scalars['ID']['input'];
  examSlug: Scalars['String']['input'];
};


export type GQLQueryMyExamEnabledCoursesArgs = {
  examSlug: Scalars['String']['input'];
};


export type GQLQueryNearbyLocationsArgs = {
  input: GQLNearbyLocationsInput;
};


export type GQLQueryNotesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLNotesQuery;
};


export type GQLQueryObservationLessonCandidatesArgs = {
  input: GQLObservationLessonCandidatesInput;
  pageQuery: GQLPageQuery;
};


export type GQLQueryOrganizationPartnerArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryOrganizationPartnerStudentsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLOrganizationPartnerStudentsQuery;
};


export type GQLQueryOrganizationPartnersArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryOtherStateCoursesArgs = {
  courseId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type GQLQueryPackagesArgs = {
  query: GQLPackagesQuery;
};


export type GQLQueryPackagesForCoordinatesArgs = {
  query: GQLPackagesForCoordinatesQuery;
};


export type GQLQueryPackagesForPriceSchemeArgs = {
  query: GQLPackagesForPriceSchemeQuery;
};


export type GQLQueryPackagesForZipcodeArgs = {
  query: GQLPackagesForZipcodeQuery;
};


export type GQLQueryParkingHubArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPayrollRunArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPayrollRunInstructorUploadsArgs = {
  runId: Scalars['ID']['input'];
};


export type GQLQueryPayrollRunsArgs = {
  pageQuery: GQLPageQuery;
};


export type GQLQueryPriceSchemeArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPriceSchemeForAddressArgs = {
  address: Scalars['String']['input'];
};


export type GQLQueryPriceSchemesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLPriceSchemesQuery>;
};


export type GQLQueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type GQLQueryProductCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryProductCatalogsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLProductCatalogsQuery>;
};


export type GQLQueryProductsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLProductsQuery>;
};


export type GQLQueryProfileTransactionsArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryProgramProgressForCohortArgs = {
  cohortId: Scalars['ID']['input'];
  deadlineType: Scalars['String']['input'];
  state: GQLUsStateId;
  studentIds: Array<Scalars['ID']['input']>;
};


export type GQLQueryPublishedLocationsArgs = {
  filter?: InputMaybe<GQLPublishedLocationsFilter>;
};


export type GQLQueryPurchaseArgs = {
  query: GQLPurchaseQuery;
};


export type GQLQueryPurchasePricingPreviewArgs = {
  input: GQLPurchasePricingPreviewInput;
};


export type GQLQueryRefundArgs = {
  query: GQLRefundQuery;
};


export type GQLQueryRegionalManagersArgs = {
  query?: InputMaybe<GQLRegionalManagersQuery>;
};


export type GQLQueryRequiredContractPageArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryReviewArgs = {
  query: GQLGetLessonReviewInput;
};


export type GQLQuerySearchAccountTagsArgs = {
  query: Scalars['String']['input'];
};


export type GQLQuerySharedLessonDrivingSkillsReportArgs = {
  query: GQLLessonQuery;
};


export type GQLQuerySharedLessonsArgs = {
  query: GQLSharedLessonsQuery;
};


export type GQLQueryShippingOrderArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryShippingOrdersArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLShippingOrdersQuery>;
};


export type GQLQueryStateConfigArgs = {
  state: Scalars['ID']['input'];
};


export type GQLQueryStateConfigsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryStateMeetingPointsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLStateMeetingPointsQuery;
};


export type GQLQueryStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentBalanceArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentClassroomCourseInfoArgs = {
  state: GQLUsStateId;
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentContractDetailsArgs = {
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentCourseEnrollmentInfoArgs = {
  datoCourseFilter: GQLDatoCourseFilterInput;
  state: GQLUsStateId;
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentCourseGradesArgs = {
  courseId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};


export type GQLQueryStudentCourseMetaArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentCourseSecurityAnswersArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentExamAttemptsArgs = {
  courseId: Scalars['ID']['input'];
  examSlug: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentLegalAndPermissionsArgs = {
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentLegalAndPermissionsAggregatedArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentLocationReviewUrlArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentNotesAndCertificatesArgs = {
  query: GQLStudentNotesAndCertificatesQuery;
};


export type GQLQueryStudentOnlineCourseArgs = {
  pageQuery: GQLPageQuery;
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentOnlineCourseIsCompleteArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentOnlineCourseReportArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentOnlineCourseTimeProgressArgs = {
  onlineCourseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentOnlineCourseTimerDebugInfoArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type GQLQueryStudentOperationsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLStudentOperationsQuery;
};


export type GQLQueryStudentSearchArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: Scalars['String']['input'];
};


export type GQLQueryStudentsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLStudentsQuery>;
};


export type GQLQuerySubLocationsArgs = {
  filter?: InputMaybe<GQLSubLocationsFilter>;
};


export type GQLQuerySyncCheckArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerySyncChecksArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQuerySyncConflictArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerySyncConflictsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query?: InputMaybe<GQLSyncConflictsQuery>;
};


export type GQLQueryTransferAccountCheckArgs = {
  query: GQLTransferAccountInput;
};


export type GQLQueryTransientSlotArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLQueryTransientSlotIfExistsArgs = {
  transientSlotId: Scalars['ID']['input'];
};


export type GQLQueryTransientSlotsForStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryUserAlsoViewingArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryUserAuthInfoArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryUserFilesArgs = {
  studentId: Scalars['ID']['input'];
};


export type GQLQueryUserLogsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLUserLogsQuery;
};


export type GQLQueryUserNotificationsLogArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  query: GQLUserNotificationsLogQuery;
};


export type GQLQueryUserRolesArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryUsersWithRolesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  roleExcludeFilter?: InputMaybe<GQLUserRole>;
  roleIncludeFilter?: InputMaybe<GQLUserRole>;
};


export type GQLQueryVehicleArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type GQLQueryVehicleAvailsArgs = {
  startTime: Scalars['DateTime']['input'];
  vehicleId: Scalars['ID']['input'];
};


export type GQLQueryVehicleParkingHubArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type GQLQueryVehiclesArgs = {
  filter?: InputMaybe<GQLVehiclesFilter>;
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryVehiclesExpiredByDateArgs = {
  endDate: Scalars['DateString']['input'];
  startDate: Scalars['DateString']['input'];
};


export type GQLQueryVendorArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryVendorsArgs = {
  filter?: InputMaybe<GQLVendorsFilter>;
  pageQuery?: InputMaybe<GQLPageQuery>;
};


export type GQLQueryVoucherV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLQueryVoucherV2ByRedemptionCodeArgs = {
  code: Scalars['String']['input'];
};


export type GQLQueryVoucherV2SourceArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryVoucherV2SourcesArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
  search?: InputMaybe<GQLSearchVoucherV2SourcesInput>;
};


export type GQLQueryVouchersV2Args = {
  filter?: InputMaybe<GQLVoucherV2Filter>;
  pageQuery?: InputMaybe<GQLPageQuery>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLQuizAnswer = {
  __typename?: 'QuizAnswer';
  correctAnswer: Scalars['String']['output'];
  isCorrect: Scalars['Boolean']['output'];
  questionId: Scalars['ID']['output'];
  studentAnswer: Scalars['String']['output'];
};

export type GQLQuizAnswerInput = {
  questionId: Scalars['ID']['input'];
  studentAnswer: Scalars['String']['input'];
};

export type GQLQuizQuestion = {
  choices?: Maybe<Array<GQLLectureQuestionChoice>>;
  doShuffle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<GQLLectureContentImage>;
  question: Scalars['String']['output'];
};

export enum GQLQuizQuestionType {
  CoursePrepQuizQuestion = 'coursePrepQuizQuestion',
  LectureQuizQuestion = 'lectureQuizQuestion'
}

export type GQLQuizSubmission = {
  __typename?: 'QuizSubmission';
  courseId: Scalars['ID']['output'];
  didPass: Scalars['Boolean']['output'];
  lectureId: Scalars['ID']['output'];
  numCorrect: Scalars['Int']['output'];
  percentCorrect: Scalars['Float']['output'];
  quizAnswers: Array<GQLQuizAnswer>;
  quizId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type GQLRecurringAvailabilityCreateInput = {
  centerAddress?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  fixedLocationId?: InputMaybe<Scalars['String']['input']>;
  instructorId: Scalars['ID']['input'];
  lessonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAllowed?: InputMaybe<GQLLocationAllowed>;
  minLeadHours?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  weekDays?: InputMaybe<Array<GQLWeekDays>>;
};

export type GQLRedeemReferralCodeInput = {
  referralCode: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLRedeemReferralCodeResult = {
  __typename?: 'RedeemReferralCodeResult';
  codePrefix: Scalars['String']['output'];
  promoDescription: Scalars['String']['output'];
  promoTitle: Scalars['String']['output'];
};

export type GQLRedeemVoucherV2Input = {
  redemptionCode: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLRedeemVoucherV2Result = {
  __typename?: 'RedeemVoucherV2Result';
  status: Scalars['String']['output'];
  voucher?: Maybe<GQLVoucherV2>;
};

export type GQLReferenceItem = {
  __typename?: 'ReferenceItem';
  category: Scalars['String']['output'];
  label: Scalars['String']['output'];
  subLabel?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GQLRefund = GQLLedgerEntity & {
  __typename?: 'Refund';
  amountToRefund: Scalars['Float']['output'];
  categoryId: GQLPaymentCategories;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isVoid: Scalars['Boolean']['output'];
  itemsToRefund: Array<GQLItemToRefund>;
  purchaseId: Scalars['ID']['output'];
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  versionId: Scalars['ID']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Refund requests have to have at least one of
 * (amountToRefund, itemsToRefund) fields set.
 *
 * Here are all the valid options:
 *
 *   1. only amountToRefund field is set
 *   2. both amountToRefund & itemsToRefund are set
 *   3. only itemsToRefund field is set
 *
 * Having both amountToRefund & itemsToRefund not set is invalid.
 *
 * Case #1: amountToRefund was refunded, no items invalidated
 * Case #2: amountToRefund was refunded, itemsToRefund can't be used anymore
 * Case #3: amountToRefund is calculated from itemsToRefund,
 *         itemsToRefund can't be used anymore
 */
export type GQLRefundPurchaseInput = {
  amountToRefund?: InputMaybe<Scalars['Float']['input']>;
  categoryId: GQLPaymentCategories;
  description: Scalars['String']['input'];
  itemsToRefund?: InputMaybe<Array<GQLItemToRefundInput>>;
  purchaseId: Scalars['ID']['input'];
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};

export type GQLRefundQuery = {
  refundId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLRegionalManagersQuery = {
  id?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type GQLRemoveUserAlsoViewingInput = {
  studentId: Scalars['ID']['input'];
};

export type GQLRequiredContractPageData = {
  __typename?: 'RequiredContractPageData';
  pendingContract?: Maybe<GQLRequiredContractPagePendingContract>;
};

export type GQLRequiredContractPagePendingContract = {
  __typename?: 'RequiredContractPagePendingContract';
  coloradoPurchaseDetails?: Maybe<GQLColoradoRequiredContractPurchaseDetails>;
  purchaseId: Scalars['ID']['output'];
  purchaseTitle?: Maybe<Scalars['String']['output']>;
  state: GQLUsStateId;
  texasPurchaseDetails?: Maybe<GQLTexasRequiredContractPurchaseDetails>;
};

export type GQLReuploadPaylocityInstructorsInput = {
  instructorIds: Array<Scalars['ID']['input']>;
  runId: Scalars['ID']['input'];
};

export type GQLReviewAggregations = {
  __typename?: 'ReviewAggregations';
  averageRating: Scalars['Float']['output'];
  ratingCounts: Array<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum GQLRoadTestCarType {
  COASTLINE_CAR = 'COASTLINE_CAR',
  STUDENT_CAR = 'STUDENT_CAR'
}

export type GQLRoadTestCoupon = {
  __typename?: 'RoadTestCoupon';
  code: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  displayInLandingPages?: Maybe<Scalars['Boolean']['output']>;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locations: Array<GQLLocationLandingPage>;
  onlyFirstPurchase: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: GQLCouponType;
};

export type GQLRoadTestCouponInput = {
  code: Scalars['String']['input'];
  discount: Scalars['Float']['input'];
  displayInLandingPages?: InputMaybe<Scalars['Boolean']['input']>;
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  onlyFirstPurchase: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type GQLSaveAccommodationInput = {
  accommodationFor: GQLAccommodationFor;
  request: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLSaveStudentContractDetailsInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  details: GQLStudentContractDetailsInput;
  studentId: Scalars['ID']['input'];
};

export type GQLScheduleDayTimes = {
  __typename?: 'ScheduleDayTimes';
  dayOfTheWeek: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  lessonTypes?: Maybe<Array<Scalars['String']['output']>>;
  locationAllowed?: Maybe<GQLLocationAllowed>;
  startTime: Scalars['String']['output'];
};

export type GQLScheduleDayTimesInput = {
  dayOfTheWeek: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  lessonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationAllowed?: InputMaybe<GQLLocationAllowed>;
  startTime: Scalars['String']['input'];
};

export type GQLScheduleLessonInput = {
  skipBookingAlerts?: InputMaybe<Scalars['Boolean']['input']>;
  studentDetails?: InputMaybe<GQLLessonStudentDetailsInput>;
  studentId: Scalars['ID']['input'];
  transientSlotId: Scalars['ID']['input'];
};

export type GQLScheduleMutateQuery = {
  instructorId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export enum GQLScheduleStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING'
}

export type GQLScholarshipApplicationResponse = {
  __typename?: 'ScholarshipApplicationResponse';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type GQLScoreQuizInput = {
  studentAnswers: Array<GQLQuizAnswerInput>;
};

export type GQLScoreQuizQuery = {
  courseId: Scalars['ID']['input'];
  lectureId: Scalars['ID']['input'];
  quizId: Scalars['ID']['input'];
  seed: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLScoreQuizResult = {
  __typename?: 'ScoreQuizResult';
  quizSubmission: GQLQuizSubmission;
  studentOnlineCourse: GQLStudentOnlineCourse;
};

export type GQLSearchVoucherV2SourcesInput = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type GQLSelfBookSharedLessonInput = {
  addStudent: GQLLessonUpdateAddStudent;
  transientSlotId: Scalars['ID']['input'];
};

export type GQLSendCohortEmailResult = {
  __typename?: 'SendCohortEmailResult';
  failed: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  queued: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type GQLSendCohortTemplateEmailInput = {
  cohortId: Scalars['ID']['input'];
  customMessageData?: InputMaybe<Scalars['JSONObject']['input']>;
  studentIds: Array<Scalars['ID']['input']>;
  templateId: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
};

export type GQLSendInstructorArrivedLessonAlertInput = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type GQLSendRunningLateLessonAlertInput = {
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  minutesLate: Scalars['String']['input'];
};

export type GQLSessionTimePerDay = {
  __typename?: 'SessionTimePerDay';
  cappedTimeSeconds: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  totalTimeSeconds: Scalars['Int']['output'];
};

export type GQLSetCouponInput = {
  cartId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLSetInstructorLessonNotificationVisibilityInput = {
  instructorId: Scalars['ID']['input'];
  isHidden: Scalars['Boolean']['input'];
  lessonNotificationRegistrationId: Scalars['ID']['input'];
};

export type GQLSetPurchaseIdInput = {
  id: Scalars['ID']['input'];
  purchaseId: Scalars['ID']['input'];
};

export type GQLSetStudentInput = {
  id: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLSharedLesson = {
  __typename?: 'SharedLesson';
  eligibleStudents: Array<GQLEligibleStudent>;
  lesson: GQLLesson;
};

export type GQLSharedLessonDrivingSkillsReport = {
  __typename?: 'SharedLessonDrivingSkillsReport';
  comments?: Maybe<Scalars['String']['output']>;
  lessonEndTime: Scalars['DateTime']['output'];
  lessonId: Scalars['ID']['output'];
  lessonStartTime: Scalars['DateTime']['output'];
  lessonTypeName?: Maybe<Scalars['String']['output']>;
  needsAdditionalLesson?: Maybe<Scalars['Boolean']['output']>;
  ratings?: Maybe<Array<GQLLessonCategoryRating>>;
  timeZone: Scalars['String']['output'];
};

export type GQLSharedLessonsQuery = {
  excludePaired?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  includeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  maxMilesFromLesson: Scalars['Int']['input'];
  meetingPointId?: InputMaybe<Scalars['ID']['input']>;
  minDrivingMinutes: Scalars['Int']['input'];
  minObservationMinutes: Scalars['Int']['input'];
  withLicense?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLShippingOrder = {
  __typename?: 'ShippingOrder';
  address: GQLShippingOrderAddress;
  courseId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isReOrder: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  shippingDetails: GQLShippingOrderShippingDetails;
  student: GQLShippingOrderStudent;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLShippingOrderAddress = {
  __typename?: 'ShippingOrderAddress';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type GQLShippingOrderEdge = {
  __typename?: 'ShippingOrderEdge';
  cursor: Scalars['ID']['output'];
  node: GQLShippingOrder;
};

export type GQLShippingOrderShippingDetails = {
  __typename?: 'ShippingOrderShippingDetails';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type GQLShippingOrderShippingDetailsInput = {
  amount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
};

export type GQLShippingOrderStudent = {
  __typename?: 'ShippingOrderStudent';
  dlNumber?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type GQLShippingOrdersPaginatedList = {
  __typename?: 'ShippingOrdersPaginatedList';
  edges: Array<GQLShippingOrderEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLShippingOrdersQuery = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  studentId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLSignInWithEmailInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type GQLSingleSessionCohortInput = {
  allowMakeupRequests?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['ID']['input'];
  instructorId: Scalars['ID']['input'];
  isEnrollmentOpen: Scalars['Boolean']['input'];
  maxEnrollees: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  sessionDate: Scalars['String']['input'];
  sessionEndTime: Scalars['DateTime']['input'];
  sessionName: Scalars['String']['input'];
  sessionStartTime: Scalars['DateTime']['input'];
  state: GQLUsStateId;
  stateId: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type GQLSingleSessionCohortResult = {
  __typename?: 'SingleSessionCohortResult';
  cohort: GQLCohort;
  session: GQLCohortSession;
};

export type GQLSlot = {
  __typename?: 'Slot';
  endTime: Scalars['DateTime']['output'];
  instructorId: Scalars['ID']['output'];
  instructorName: Scalars['String']['output'];
  instructorTimezone: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isUnpaired: Scalars['Boolean']['output'];
  lessonId?: Maybe<Scalars['ID']['output']>;
  lessonTypeName: Scalars['String']['output'];
  location: GQLSlotLocation;
  startTime: Scalars['DateTime']['output'];
};

export type GQLSlotAvailabilityResult = {
  __typename?: 'SlotAvailabilityResult';
  isAvailable: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type GQLSlotLocation = {
  __typename?: 'SlotLocation';
  address: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export enum GQLSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type GQLSortKeyDirectionPair = {
  key: Scalars['String']['input'];
  sortDirection: GQLSortDirection;
};

export type GQLStartExamInput = {
  courseId: Scalars['ID']['input'];
  examSlug: Scalars['String']['input'];
};

export type GQLStateConfig = {
  __typename?: 'StateConfig';
  cmsId: Scalars['String']['output'];
  hasFixedLocations: Scalars['Boolean']['output'];
  hasHomePickup: Scalars['Boolean']['output'];
  hasMeetingPoints: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isShareableByDefault: Scalars['Boolean']['output'];
  longName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  state: Scalars['ID']['output'];
};

export type GQLStateConfigCreateInput = {
  cmsId: Scalars['String']['input'];
  hasFixedLocations: Scalars['Boolean']['input'];
  hasHomePickup: Scalars['Boolean']['input'];
  hasMeetingPoints: Scalars['Boolean']['input'];
  isShareableByDefault: Scalars['Boolean']['input'];
  longName: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type GQLStateConfigEdge = {
  __typename?: 'StateConfigEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStateConfig;
};

export type GQLStateConfigPaginatedList = {
  __typename?: 'StateConfigPaginatedList';
  edges: Array<GQLStateConfigEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStateConfigUpdateInput = {
  cmsId: Scalars['String']['input'];
  hasFixedLocations?: InputMaybe<Scalars['Boolean']['input']>;
  hasHomePickup?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeetingPoints?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isShareableByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GQLStateMeetingPoint = {
  __typename?: 'StateMeetingPoint';
  address: Scalars['String']['output'];
  coords?: Maybe<GQLLatLng>;
  description?: Maybe<Scalars['String']['output']>;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  restrictedLessonTypes?: Maybe<Array<GQLLessonTypeForMeetingPoint>>;
  state: Scalars['ID']['output'];
};

export type GQLStateMeetingPointCreateInput = {
  address: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  restrictedLessonTypes?: InputMaybe<Array<GQLLessonTypeName>>;
  state: Scalars['ID']['input'];
};

export type GQLStateMeetingPointEdge = {
  __typename?: 'StateMeetingPointEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStateMeetingPoint;
};

export type GQLStateMeetingPointPaginatedList = {
  __typename?: 'StateMeetingPointPaginatedList';
  edges: Array<GQLStateMeetingPointEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStateMeetingPointQuery = {
  meetingPointId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLStateMeetingPointUpdateInput = {
  address: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  restrictedLessonTypes?: InputMaybe<Array<GQLLessonTypeName>>;
  state: Scalars['ID']['input'];
};

export type GQLStateMeetingPointsQuery = {
  state?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLStudent = {
  __typename?: 'Student';
  acceptTOS?: Maybe<Scalars['Boolean']['output']>;
  address: GQLAddress;
  age?: Maybe<Scalars['Float']['output']>;
  balance: GQLStudentBalance;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  cohorts?: Maybe<Array<GQLCohort>>;
  completedDriversEd: Scalars['Boolean']['output'];
  controlNumber?: Maybe<Scalars['String']['output']>;
  dmvPreRegNumber?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  drivingHistory?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enrollmentFormsComplete?: Maybe<Scalars['Boolean']['output']>;
  facilityNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasConfirmedILInfo: Scalars['Boolean']['output'];
  hasFilledILEnrollmentForms: Scalars['Boolean']['output'];
  hasNoMiddleName?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instructorId?: Maybe<Scalars['ID']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFirstLessonPurchase?: Maybe<Scalars['Boolean']['output']>;
  isInstructor?: Maybe<Scalars['Boolean']['output']>;
  isRegionalManager?: Maybe<Scalars['Boolean']['output']>;
  lastActive?: Maybe<Scalars['Float']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseEligibilityDate?: Maybe<Scalars['DateTime']['output']>;
  licenseExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  licenseIssueDate?: Maybe<Scalars['DateTime']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licensingProgress?: Maybe<GQLLicensingProgress>;
  locationLandingPageIds?: Maybe<Array<Scalars['ID']['output']>>;
  marketingOptIn?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  migratedTo?: Maybe<GQLStudentMigrated>;
  name: Scalars['String']['output'];
  notes: Array<GQLNote>;
  parentEmail?: Maybe<Scalars['String']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  passedKnowledgeTest: Scalars['Boolean']['output'];
  preferredLanguageCode?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  preferredPronoun?: Maybe<Scalars['String']['output']>;
  previousDrivingHours?: Maybe<Scalars['Float']['output']>;
  previousHours?: Maybe<Scalars['Float']['output']>;
  previousObservationHours?: Maybe<Scalars['Float']['output']>;
  previousSchoolLessons?: Maybe<Scalars['String']['output']>;
  programDeadline?: Maybe<GQLProgramDeadline>;
  readBill?: Maybe<Scalars['Boolean']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  referralCode: Scalars['String']['output'];
  sex?: Maybe<Scalars['String']['output']>;
  signInEmail?: Maybe<Scalars['String']['output']>;
  signupSource?: Maybe<Scalars['String']['output']>;
  signupTimestamp?: Maybe<Scalars['DateTime']['output']>;
  smsOptIn?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  usStateId?: Maybe<Scalars['ID']['output']>;
  usedReferralCode?: Maybe<GQLUsedReferralCode>;
  /** @deprecated Use licenseNumber instead */
  wdlNumber?: Maybe<Scalars['String']['output']>;
};

export type GQLStudentBalance = {
  __typename?: 'StudentBalance';
  balancedQuantityByProductId: GQLBalancedQuantity;
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  drivingMinutesPurchased: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  drivingMinutesRemaining: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  drivingMinutesUsed: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  expirationDrivingMinutesUsed: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  expirationObservationMinutesUsed: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  homePickupsExpired: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  homePickupsPurchased: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  homePickupsRemaining: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  homePickupsUsed: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  observationMinutesPurchased: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  observationMinutesRemaining: Scalars['Float']['output'];
  /** @deprecated Use balancedQuantityByProductId or productBalancedQuantity instead */
  observationMinutesUsed: Scalars['Float']['output'];
  productBalancedQuantity: Array<GQLProductBalancedQuantity>;
  studentId: Scalars['ID']['output'];
  /** @deprecated Please use studentId instead */
  userId: Scalars['ID']['output'];
};


export type GQLStudentBalanceBalancedQuantityByProductIdArgs = {
  productId: Scalars['ID']['input'];
};

export type GQLStudentCertificateInput = {
  certIssuanceDate: Scalars['String']['input'];
  certNumber: Scalars['String']['input'];
  certType: Scalars['String']['input'];
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHiddenFromInstructorView?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLStudentCertificateNote = {
  __typename?: 'StudentCertificateNote';
  certIssuanceDate: Scalars['String']['output'];
  certNumber: Scalars['String']['output'];
  certType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: GQLPerson;
  createdById: Scalars['ID']['output'];
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isHiddenFromInstructorView: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type GQLStudentContract = {
  __typename?: 'StudentContract';
  dateOfSign?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  generatedFile?: Maybe<GQLUserFile>;
  id: Scalars['ID']['output'];
  paymentComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type GQLStudentContractDetails = {
  __typename?: 'StudentContractDetails';
  acknowledgment?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  dateOfSign?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  generatedUserFileId?: Maybe<Scalars['ID']['output']>;
  isMinor?: Maybe<Scalars['Boolean']['output']>;
  knowledgeExamPrice?: Maybe<Scalars['Float']['output']>;
  minutesPurchased?: Maybe<Scalars['Float']['output']>;
  packagePurchased?: Maybe<Scalars['String']['output']>;
  parentInitialSection1?: Maybe<Scalars['String']['output']>;
  parentInitialSection2?: Maybe<Scalars['String']['output']>;
  parentInitialSection3?: Maybe<Scalars['String']['output']>;
  parentInitialSection4?: Maybe<Scalars['String']['output']>;
  parentSignature?: Maybe<Scalars['String']['output']>;
  parentSignatureForm1?: Maybe<Scalars['String']['output']>;
  parentSignatureForm2?: Maybe<Scalars['String']['output']>;
  parentSignatureForm3?: Maybe<Scalars['String']['output']>;
  parentSignatureForm4?: Maybe<Scalars['String']['output']>;
  paymentComplete?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  privateRefusedInitials?: Maybe<Scalars['String']['output']>;
  skillsExamPrice?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  studentSignature?: Maybe<Scalars['String']['output']>;
  studentSignatureForm1?: Maybe<Scalars['String']['output']>;
  studentSignatureForm3?: Maybe<Scalars['String']['output']>;
  studentType?: Maybe<Scalars['String']['output']>;
  term1?: Maybe<Scalars['Boolean']['output']>;
  term2?: Maybe<Scalars['Boolean']['output']>;
  term3?: Maybe<Scalars['Boolean']['output']>;
  term4?: Maybe<Scalars['Boolean']['output']>;
  totalPayment?: Maybe<Scalars['Float']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type GQLStudentContractDetailsInput = {
  acknowledgment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  dateOfSign?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  isMinor?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeExamPrice?: InputMaybe<Scalars['Float']['input']>;
  minutesPurchased?: InputMaybe<Scalars['Float']['input']>;
  packagePurchased?: InputMaybe<Scalars['String']['input']>;
  parentInitialSection1?: InputMaybe<Scalars['String']['input']>;
  parentInitialSection2?: InputMaybe<Scalars['String']['input']>;
  parentInitialSection3?: InputMaybe<Scalars['String']['input']>;
  parentInitialSection4?: InputMaybe<Scalars['String']['input']>;
  parentSignature?: InputMaybe<Scalars['String']['input']>;
  parentSignatureForm1?: InputMaybe<Scalars['String']['input']>;
  parentSignatureForm2?: InputMaybe<Scalars['String']['input']>;
  parentSignatureForm3?: InputMaybe<Scalars['String']['input']>;
  parentSignatureForm4?: InputMaybe<Scalars['String']['input']>;
  paymentComplete?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privateRefusedInitials?: InputMaybe<Scalars['String']['input']>;
  skillsExamPrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  studentName?: InputMaybe<Scalars['String']['input']>;
  studentSignature?: InputMaybe<Scalars['String']['input']>;
  studentSignatureForm1?: InputMaybe<Scalars['String']['input']>;
  studentSignatureForm3?: InputMaybe<Scalars['String']['input']>;
  studentType?: InputMaybe<Scalars['String']['input']>;
  term1?: InputMaybe<Scalars['Boolean']['input']>;
  term2?: InputMaybe<Scalars['Boolean']['input']>;
  term3?: InputMaybe<Scalars['Boolean']['input']>;
  term4?: InputMaybe<Scalars['Boolean']['input']>;
  totalPayment?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export enum GQLStudentContractStatus {
  Incomplete = 'Incomplete',
  Issue = 'Issue',
  NotSent = 'NotSent',
  Sent = 'Sent',
  Signed = 'Signed'
}

export type GQLStudentCourseEnrollmentInfo = {
  __typename?: 'StudentCourseEnrollmentInfo';
  firstSessionStartTime?: Maybe<Scalars['DateTime']['output']>;
  hasCourseEnrollment: Scalars['Boolean']['output'];
};

export type GQLStudentCourseGrades = {
  __typename?: 'StudentCourseGrades';
  studentId: Scalars['ID']['output'];
  tests: Array<GQLStudentOnlineCourseTest>;
};

export type GQLStudentCourseLectureInput = {
  courseId: Scalars['ID']['input'];
  lectureId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLStudentCourseMigration = {
  __typename?: 'StudentCourseMigration';
  destinationStudentId: Scalars['ID']['output'];
  onlineCourseId: Scalars['ID']['output'];
  sourceStudentId: Scalars['ID']['output'];
};

export type GQLStudentEdge = {
  __typename?: 'StudentEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStudent;
};

export type GQLStudentExpirationOp = GQLStudentOperationBase & {
  __typename?: 'StudentExpirationOp';
  createdAt: Scalars['DateTime']['output'];
  expiration: GQLExpiration;
  id: Scalars['ID']['output'];
  operationType: GQLStudentOperationType;
  studentId: Scalars['ID']['output'];
};

export type GQLStudentId = {
  __typename?: 'StudentId';
  studentId: Scalars['ID']['output'];
};

export type GQLStudentIdProductId = {
  __typename?: 'StudentIdProductId';
  productId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
};

export type GQLStudentInput = {
  acceptTOS?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<GQLAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  canBookRoadTest?: InputMaybe<Scalars['Boolean']['input']>;
  changeNote?: InputMaybe<Scalars['String']['input']>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  dmvPreRegNumber?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  drivingHistory?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentFormsComplete?: InputMaybe<Scalars['Boolean']['input']>;
  facilityNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseEligibilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  preferredLanguageCode?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  previousDrivingHours?: InputMaybe<Scalars['Float']['input']>;
  previousHours?: InputMaybe<Scalars['Float']['input']>;
  previousObservationHours?: InputMaybe<Scalars['Float']['input']>;
  previousSchoolLessons?: InputMaybe<Scalars['String']['input']>;
  readBill?: InputMaybe<Scalars['Boolean']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  signupSource?: InputMaybe<Scalars['String']['input']>;
  signupTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use licenseNumber instead */
  wdlNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GQLStudentLegalAndPermissionsInput = {
  contractStatus: GQLStudentContractStatus;
  privateApproved: Scalars['Boolean']['input'];
  transferStatus: GQLStudentTransferStatus;
  transferType?: InputMaybe<GQLStudentTransferType>;
};

export type GQLStudentLegalAndPermissionsRecord = {
  __typename?: 'StudentLegalAndPermissionsRecord';
  autogenerated: Scalars['Boolean']['output'];
  contractStatus: GQLStudentContractStatus;
  isMigrated: Scalars['Boolean']['output'];
  observerApproved: Scalars['Boolean']['output'];
  privateApproved: Scalars['Boolean']['output'];
  purchaseId: Scalars['ID']['output'];
  studentId: Scalars['ID']['output'];
  transferStatus: GQLStudentTransferStatus;
  transferType?: Maybe<GQLStudentTransferType>;
};

export type GQLStudentLegalAndPermissionsSummary = {
  __typename?: 'StudentLegalAndPermissionsSummary';
  contractStatus: GQLStudentContractStatus;
  observerApproved: Scalars['Boolean']['output'];
  privateApproved: Scalars['Boolean']['output'];
  transferStatus: GQLStudentTransferStatus;
  transferType?: Maybe<GQLStudentTransferType>;
};

export type GQLStudentMigrated = {
  __typename?: 'StudentMigrated';
  email: Scalars['String']['output'];
};

export type GQLStudentNotesAndCertificates = {
  __typename?: 'StudentNotesAndCertificates';
  certificates: Array<GQLStudentCertificateNote>;
  notes: Array<GQLNote>;
};

export type GQLStudentNotesAndCertificatesQuery = {
  userId: Scalars['ID']['input'];
};

export type GQLStudentObject = {
  __typename?: 'StudentObject';
  accommodation?: Maybe<GQLAccommodation>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentEmail?: Maybe<Scalars['String']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use licenseNumber instead */
  wdlNumber?: Maybe<Scalars['String']['output']>;
};

export type GQLStudentOnlineCourse = {
  __typename?: 'StudentOnlineCourse';
  course: GQLOnlineCourseContent;
  courseCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  courseId: Scalars['ID']['output'];
  currentLecture?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use isEnrolled */
  enrolled: Scalars['Boolean']['output'];
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  featureFlags: Array<GQLFeatureFlag>;
  hasCompletedNotary?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isArchiveWarned?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isEnrolled: Scalars['Boolean']['output'];
  isMarketingAssessmentComplete?: Maybe<Scalars['Boolean']['output']>;
  isParentGuideOrdered?: Maybe<Scalars['Boolean']['output']>;
  isReviewCTAComplete?: Maybe<Scalars['Boolean']['output']>;
  lectures?: Maybe<Array<GQLStudentOnlineCourseLecture>>;
  name: Scalars['String']['output'];
  percentComplete?: Maybe<Scalars['Float']['output']>;
  percentTestsPassed?: Maybe<Scalars['Float']['output']>;
  studentId: Scalars['ID']['output'];
  tests?: Maybe<Array<GQLStudentOnlineCourseTest>>;
};

export type GQLStudentOnlineCourseEdge = {
  __typename?: 'StudentOnlineCourseEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStudentOnlineCourse;
};

export type GQLStudentOnlineCourseInput = {
  onlineCourseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLStudentOnlineCourseLecture = {
  __typename?: 'StudentOnlineCourseLecture';
  id: Scalars['ID']['output'];
};

export type GQLStudentOnlineCourseReport = {
  __typename?: 'StudentOnlineCourseReport';
  address: Scalars['String']['output'];
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  courseId: Scalars['ID']['output'];
  courseTotalTimeSeconds?: Maybe<Scalars['Int']['output']>;
  dmvPreRegNumber?: Maybe<Scalars['String']['output']>;
  dob: Scalars['String']['output'];
  lectureReports?: Maybe<Array<GQLLectureReport>>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sessionTimePerDay: Array<GQLSessionTimePerDay>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studentId: Scalars['ID']['output'];
  studentOnlineCourse: GQLStudentOnlineCourse;
  /** @deprecated Use licenseNumber instead */
  wdlNumber?: Maybe<Scalars['String']['output']>;
};

export type GQLStudentOnlineCourseTest = {
  __typename?: 'StudentOnlineCourseTest';
  id: Scalars['ID']['output'];
  numCorrect: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type GQLStudentOnlineCourseTimeProgress = {
  __typename?: 'StudentOnlineCourseTimeProgress';
  courseTotalTime: Scalars['Int']['output'];
  totalTimePerDay: Array<GQLLectureTimeDaily>;
};

export type GQLStudentOnlineCourseTimerDebugInfo = {
  __typename?: 'StudentOnlineCourseTimerDebugInfo';
  v1CappedTimeSec: Scalars['Int']['output'];
  v1TotalTimeSec: Scalars['Int']['output'];
  v2CappedTimeSec: Scalars['Int']['output'];
  v2TotalTimeSec: Scalars['Int']['output'];
};

export type GQLStudentOnlineCoursesPaginatedList = {
  __typename?: 'StudentOnlineCoursesPaginatedList';
  edges: Array<GQLStudentOnlineCourseEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStudentOperation = GQLStudentExpirationOp | GQLStudentPurchaseOp | GQLStudentPurchaseTransferOp | GQLStudentRefundOp;

export type GQLStudentOperationBase = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  operationType: GQLStudentOperationType;
  studentId: Scalars['ID']['output'];
};

export type GQLStudentOperationEdge = {
  __typename?: 'StudentOperationEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStudentOperation;
};

export enum GQLStudentOperationType {
  Expiration = 'Expiration',
  IncomingPurchaseTransfer = 'IncomingPurchaseTransfer',
  OutgoingPurchaseTransfer = 'OutgoingPurchaseTransfer',
  Purchase = 'Purchase',
  Refund = 'Refund'
}

export type GQLStudentOperationsPaginatedResult = {
  __typename?: 'StudentOperationsPaginatedResult';
  edges: Array<GQLStudentOperationEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStudentOperationsQuery = {
  studentId: Scalars['ID']['input'];
};

export type GQLStudentProgramProgress = {
  __typename?: 'StudentProgramProgress';
  daysRemaining?: Maybe<Scalars['Int']['output']>;
  deadlineDate?: Maybe<Scalars['String']['output']>;
  drivingMinutesScheduled: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastInstructorId?: Maybe<Scalars['String']['output']>;
  lastInstructorName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextScheduledDriveDate?: Maybe<Scalars['DateTime']['output']>;
  nextScheduledObservationDate?: Maybe<Scalars['DateTime']['output']>;
  observationMinutesScheduled: Scalars['Int']['output'];
  requirements: GQLProgramDeadlineRequirements;
  status: GQLProgramDeadlineStatus;
};

export type GQLStudentPurchaseOp = GQLStudentOperationBase & {
  __typename?: 'StudentPurchaseOp';
  createdAt: Scalars['DateTime']['output'];
  fundsBalance: GQLFundsBalance;
  id: Scalars['ID']['output'];
  itemBalancedQuantity: Array<GQLItemBalancedQuantity>;
  operationType: GQLStudentOperationType;
  productBalancedQuantity: Array<GQLProductBalancedQuantity>;
  purchase: GQLPurchase;
  studentContract?: Maybe<GQLStudentContract>;
  studentId: Scalars['ID']['output'];
};

export type GQLStudentPurchaseTransferOp = GQLStudentOperationBase & {
  __typename?: 'StudentPurchaseTransferOp';
  createdAt: Scalars['DateTime']['output'];
  fundsBalance: GQLFundsBalance;
  id: Scalars['ID']['output'];
  itemBalancedQuantity: Array<GQLItemBalancedQuantity>;
  operationType: GQLStudentOperationType;
  productBalancedQuantity: Array<GQLProductBalancedQuantity>;
  purchase: GQLPurchase;
  purchaseTransfer: GQLPurchaseTransfer;
  studentId: Scalars['ID']['output'];
};

export type GQLStudentRefundOp = GQLStudentOperationBase & {
  __typename?: 'StudentRefundOp';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  operationType: GQLStudentOperationType;
  refund: GQLRefund;
  studentId: Scalars['ID']['output'];
};

export type GQLStudentSearchResult = {
  __typename?: 'StudentSearchResult';
  altEmail?: Maybe<Scalars['String']['output']>;
  altName?: Maybe<Scalars['String']['output']>;
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isMigrated?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  signupTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLStudentSearchResultEdge = {
  __typename?: 'StudentSearchResultEdge';
  cursor: Scalars['ID']['output'];
  node: GQLStudentSearchResult;
};

export type GQLStudentSearchResultPaginatedList = {
  __typename?: 'StudentSearchResultPaginatedList';
  edges: Array<GQLStudentSearchResultEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStudentSessionAttendance = {
  __typename?: 'StudentSessionAttendance';
  attendance: GQLAttendance;
  cohortSessionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isMakeup?: Maybe<Scalars['Boolean']['output']>;
  makeUpCohortId?: Maybe<Scalars['ID']['output']>;
  makeUpSessionId?: Maybe<Scalars['ID']['output']>;
  studentId: Scalars['ID']['output'];
};

export enum GQLStudentTransferStatus {
  No = 'No',
  YesMissingPaperwork = 'YesMissingPaperwork',
  YesPaperWorkComplete = 'YesPaperWorkComplete'
}

export enum GQLStudentTransferType {
  Both = 'Both',
  CarOnly = 'CarOnly',
  CourseOnly = 'CourseOnly'
}

export type GQLStudentsPaginatedList = {
  __typename?: 'StudentsPaginatedList';
  edges: Array<GQLStudentEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLStudentsQuery = {
  /** @deprecated Use ids instead */
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GQLSubItemInput = {
  itemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type GQLSubLocation = {
  __typename?: 'SubLocation';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reviews?: Maybe<Array<GQLSubLocationReview>>;
  state: GQLUsStateId;
};

export type GQLSubLocationReview = {
  __typename?: 'SubLocationReview';
  author: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type GQLSubLocationsFilter = {
  state?: InputMaybe<GQLUsStateId>;
};

export type GQLSubmitCoursePrepTestChapterScoresInput = {
  chapterId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  questionScores: Array<GQLLectureQuizQuestionPrepTestScoreInput>;
};

export type GQLSubmitExamInput = {
  isAutoSubmit: Scalars['Boolean']['input'];
  sessionId: Scalars['ID']['input'];
};

export type GQLSubmitExamResponseInput = {
  examId: Scalars['ID']['input'];
  responses: Array<GQLExamResponseInput>;
};

export type GQLSyllabus = {
  __typename?: 'Syllabus';
  chapters?: Maybe<Array<Scalars['String']['output']>>;
  intro?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<GQLSyllabusQuestion>>;
};

export type GQLSyllabusQuestion = {
  __typename?: 'SyllabusQuestion';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type GQLSyncCheck = {
  __typename?: 'SyncCheck';
  checkedStudentsCount: Scalars['Int']['output'];
  conflicts: GQLSyncConflictsPaginatedList;
  conflictsByIndicator: Array<GQLQuantityByIndicator>;
  conflictsCount: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  errors: Array<GQLSyncCheckError>;
  errorsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ignoredStudentsCount: Scalars['Int']['output'];
  isCancelled: Scalars['Boolean']['output'];
  ledgerStudentsCount: Scalars['Int']['output'];
  outOfSyncStudentsCount: Scalars['Int']['output'];
  sampleRate: Scalars['Float']['output'];
  startTime: Scalars['DateTime']['output'];
  versionId: Scalars['ID']['output'];
};


export type GQLSyncCheckConflictsArgs = {
  pageQuery?: InputMaybe<GQLPageQuery>;
};

export type GQLSyncCheckEdge = {
  __typename?: 'SyncCheckEdge';
  cursor: Scalars['ID']['output'];
  node: GQLSyncCheck;
};

export type GQLSyncCheckError = {
  __typename?: 'SyncCheckError';
  message: Scalars['String']['output'];
  stack: Scalars['String']['output'];
};

export enum GQLSyncCheckLogTypes {
  Cancel = 'cancel',
  Conflict = 'conflict',
  End = 'end',
  Progress = 'progress',
  Start = 'start'
}

export type GQLSyncChecksPaginatedList = {
  __typename?: 'SyncChecksPaginatedList';
  edges: Array<GQLSyncCheckEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLSyncConflict = {
  details: GQLSyncConflictDetails;
  id: Scalars['ID']['output'];
  lastSyncCheckId: Scalars['ID']['output'];
  syncIndicator: GQLSyncIndicator;
};

export type GQLSyncConflictDayBreakdown = {
  __typename?: 'SyncConflictDayBreakdown';
  date: Scalars['DateTime']['output'];
  hasConflict: Scalars['Boolean']['output'];
  legacyLogs: Array<GQLLegacyLogSummary>;
  nextLogs: Array<GQLLedgerLog>;
};

export type GQLSyncConflictDetails = {
  __typename?: 'SyncConflictDetails';
  dayByDayBreakdown: Array<GQLSyncConflictDayBreakdown>;
  timeZone: Scalars['String']['output'];
};

export type GQLSyncConflictEdge = {
  __typename?: 'SyncConflictEdge';
  cursor: Scalars['ID']['output'];
  node: GQLSyncConflict;
};

export type GQLSyncConflictsPaginatedList = {
  __typename?: 'SyncConflictsPaginatedList';
  edges: Array<GQLSyncConflictEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLSyncConflictsQuery = {
  syncCheckId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLSyncCourseTimersInput = {
  events: Array<GQLClientCourseTimerEventInput>;
};

export type GQLSyncCourseTimersQuery = {
  fromEventId?: InputMaybe<Scalars['ID']['input']>;
  studentId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type GQLSyncCourseTimersResult = {
  __typename?: 'SyncCourseTimersResult';
  events: Array<GQLCourseTimerPatchEvent>;
};

export enum GQLSyncIndicator {
  StudentExpiredMinutes = 'studentExpiredMinutes',
  StudentFundsBalance = 'studentFundsBalance',
  StudentProductBalance = 'studentProductBalance'
}

export type GQLSyncStudentExpiredMinutesConflict = GQLSyncConflict & {
  __typename?: 'SyncStudentExpiredMinutesConflict';
  details: GQLSyncConflictDetails;
  id: Scalars['ID']['output'];
  lastSyncCheckId: Scalars['ID']['output'];
  legacyId: GQLStudentId;
  legacyValue: GQLSyncStudentExpiredMinutesEntityValue;
  nextId: GQLStudentId;
  nextValue: GQLSyncStudentExpiredMinutesEntityValue;
  syncIndicator: GQLSyncIndicator;
};

export type GQLSyncStudentExpiredMinutesEntityValue = {
  __typename?: 'SyncStudentExpiredMinutesEntityValue';
  expiredMinutesTotal: Scalars['Int']['output'];
};

export type GQLSyncStudentFundsBalanceConflict = GQLSyncConflict & {
  __typename?: 'SyncStudentFundsBalanceConflict';
  details: GQLSyncConflictDetails;
  id: Scalars['ID']['output'];
  lastSyncCheckId: Scalars['ID']['output'];
  legacyId: GQLStudentId;
  legacyValue: GQLSyncStudentFundsBalanceConflictEntityValue;
  nextId: GQLStudentId;
  nextValue: GQLSyncStudentFundsBalanceConflictEntityValue;
  syncIndicator: GQLSyncIndicator;
};

export type GQLSyncStudentFundsBalanceConflictEntityValue = {
  __typename?: 'SyncStudentFundsBalanceConflictEntityValue';
  paidCents: Scalars['Int']['output'];
  refundedCents: Scalars['Int']['output'];
  sentCents: Scalars['Int']['output'];
};

export type GQLSyncStudentProductBalanceConflict = GQLSyncConflict & {
  __typename?: 'SyncStudentProductBalanceConflict';
  details: GQLSyncConflictDetails;
  id: Scalars['ID']['output'];
  lastSyncCheckId: Scalars['ID']['output'];
  legacyId: GQLStudentIdProductId;
  legacyValue: GQLSyncStudentProductBalanceConflictEntityValue;
  nextId: GQLStudentIdProductId;
  nextValue: GQLSyncStudentProductBalanceConflictEntityValue;
  syncIndicator: GQLSyncIndicator;
};

export type GQLSyncStudentProductBalanceConflictEntityValue = {
  __typename?: 'SyncStudentProductBalanceConflictEntityValue';
  purchasedQuantity: Scalars['Int']['output'];
  refundedQuantity: Scalars['Int']['output'];
  sentQuantity: Scalars['Int']['output'];
  usedQuantity: Scalars['Int']['output'];
};

export type GQLTestChargeLedgerLogInput = {
  drivingMinutes: Scalars['Int']['input'];
  observationMinutes: Scalars['Int']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLTestUserInput = {
  acceptTOS?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<GQLAddressInput>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentEmail?: InputMaybe<Scalars['String']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  preferredPronoun?: InputMaybe<Scalars['String']['input']>;
  roles: Array<GQLUserRole>;
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  uid?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLTexasRequiredContractPurchaseDetails = {
  __typename?: 'TexasRequiredContractPurchaseDetails';
  hasCourse: Scalars['Boolean']['output'];
  hasLessons: Scalars['Boolean']['output'];
  studentTypeOptions: Array<GQLTexasStudentContractTypeOption>;
};

export type GQLTexasStudentContractTypeOption = {
  __typename?: 'TexasStudentContractTypeOption';
  description: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GQLTransferAccountCheckResult = {
  __typename?: 'TransferAccountCheckResult';
  canTransfer: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  fromId: Scalars['ID']['output'];
  toId: Scalars['ID']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type GQLTransferAccountInput = {
  fromId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toId: Scalars['ID']['input'];
};

export type GQLTransferExpirationInput = {
  description: Scalars['String']['input'];
  destinationStudentId: Scalars['ID']['input'];
  expirationId: Scalars['ID']['input'];
  sourceStudentId: Scalars['ID']['input'];
};

export type GQLTransferLessonInput = {
  description: Scalars['String']['input'];
  destinationStudentId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  shouldTransferPurchases: Scalars['Boolean']['input'];
  sourceStudentId: Scalars['ID']['input'];
};

export type GQLTransferPurchaseInput = {
  amountToTransfer?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  destinationStudentId: Scalars['ID']['input'];
  itemsToTransfer: Array<GQLItemToTransferInput>;
  purchaseId: Scalars['ID']['input'];
  sourceStudentId: Scalars['ID']['input'];
};

export type GQLTransientSlot = {
  __typename?: 'TransientSlot';
  endTime: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fullSharedReservation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instructor: GQLTransientSlotInstructor;
  instructorId: Scalars['ID']['output'];
  isBooked?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  isReserved?: Maybe<Scalars['Boolean']['output']>;
  isShareable: Scalars['Boolean']['output'];
  isShared?: Maybe<Scalars['Boolean']['output']>;
  lessonType: GQLTransientSlotLessonType;
  locationId?: Maybe<Scalars['String']['output']>;
  meetingPointId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pickupAddress: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  reservedBy?: Maybe<GQLPerson>;
  reservedFor?: Maybe<GQLPerson>;
  searchAddress?: Maybe<Scalars['String']['output']>;
  searchCity?: Maybe<Scalars['String']['output']>;
  searchState: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GQLTransientSlotInput = {
  endTime: Scalars['DateTime']['input'];
  fullSharedReservation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructorId: Scalars['ID']['input'];
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isShareable: Scalars['Boolean']['input'];
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  lessonTypeId: Scalars['ID']['input'];
  locationId: Scalars['String']['input'];
  meetingPointId?: InputMaybe<Scalars['String']['input']>;
  overrideDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  pickupAddress?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  searchAddress: Scalars['String']['input'];
  searchCity: Scalars['String']['input'];
  searchState: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type GQLTransientSlotInstructor = {
  __typename?: 'TransientSlotInstructor';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
};

export type GQLTransientSlotLessonType = {
  __typename?: 'TransientSlotLessonType';
  durationMinutes: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GQLTransientSlotUserInput = {
  userId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type GQLUsState = {
  __typename?: 'USState';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum GQLUsStateId {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY'
}

export type GQLUnenrollStudentFromCohortInput = {
  cohortId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateCancelLogInput = {
  id: Scalars['ID']['input'];
  initiatedBy?: InputMaybe<GQLInitiatedBy>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateCourseSessionInput = {
  lectureId: Scalars['ID']['input'];
  onlineCourseId: Scalars['ID']['input'];
  startNewSession?: InputMaybe<Scalars['Boolean']['input']>;
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateDriveLogInput = {
  dayOrNight?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  driveId: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime: Scalars['DateTime']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateFleetNoteInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type GQLUpdateIllinoisCompletionFormInput = {
  firstName: Scalars['String']['input'];
  isClassroomCreditTransferred: Scalars['Boolean']['input'];
  isLaboratoryCreditTransferred: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  middleInit: Scalars['String']['input'];
  noMiddleName: Scalars['Boolean']['input'];
  sex: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateInstructorInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  availsFixedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<GQLInstructorBadgeInput>>;
  baseAddress?: InputMaybe<Scalars['String']['input']>;
  canManageMeetingLocations?: InputMaybe<Scalars['Boolean']['input']>;
  canManageOwnSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSyncHoursWithPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  doNotSyncRoadTestHoursWithPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasRoadTestStipend?: InputMaybe<Scalars['Boolean']['input']>;
  hasSignedBreakTimeWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  jobCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
  longBreakMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBaseTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBaseTravelMinutesOverride?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutes?: InputMaybe<Scalars['Int']['input']>;
  maxBetweenTravelMinutesOverride?: InputMaybe<Scalars['Int']['input']>;
  optOutLessonEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  paylocityId?: InputMaybe<Scalars['ID']['input']>;
  payrollFirstName?: InputMaybe<Scalars['String']['input']>;
  payrollLastName?: InputMaybe<Scalars['String']['input']>;
  payrollTitle?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  portraitImage?: InputMaybe<Scalars['String']['input']>;
  regionalManagerId?: InputMaybe<Scalars['ID']['input']>;
  servicesProvided?: InputMaybe<Array<Scalars['String']['input']>>;
  shortBreakMinutes?: InputMaybe<Scalars['Int']['input']>;
  slackUsername?: InputMaybe<Scalars['String']['input']>;
  spokenLanguageCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLUpdateInstructorQuery = {
  instructorId: Scalars['ID']['input'];
};

export type GQLUpdateLessonReviewInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateMakeupRequestStatusInput = {
  requestId: Scalars['ID']['input'];
  status: GQLMakeupRequestStatus;
};

export type GQLUpdateMyUserSettingsInput = {
  referralProgramPromoDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  themePreference?: InputMaybe<GQLUserThemePreference>;
};

export type GQLUpdateParkingHubInput = {
  address: Scalars['String']['input'];
  gateCode?: InputMaybe<Scalars['String']['input']>;
  opsManagerUserId?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSharedLessons?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numLessons?: InputMaybe<Scalars['Int']['input']>;
  numRoadTests?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<GQLProductLinkInput>>;
};

export type GQLUpdateStudentCourseMetaInput = {
  allowLowerGrade?: InputMaybe<Scalars['Boolean']['input']>;
  courseCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  courseTimerVersion?: InputMaybe<Scalars['Int']['input']>;
  currentLecture?: InputMaybe<Scalars['ID']['input']>;
  isArchiveWarned?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isParentGuideOrdered?: InputMaybe<Scalars['Boolean']['input']>;
  isPassed?: InputMaybe<Scalars['Boolean']['input']>;
  isReviewCTAComplete?: InputMaybe<Scalars['Boolean']['input']>;
  lectureId?: InputMaybe<Scalars['ID']['input']>;
  numCorrect?: InputMaybe<Scalars['Int']['input']>;
  onlineCourseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  totalQuestions?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLUpdateStudentCourseSecurityAnswersInput = {
  answers: Scalars['JSONObject']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateStudentLegalAndPermissionsInput = {
  legalAndPermissions: GQLStudentLegalAndPermissionsInput;
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateStudentSessionAttendanceInput = {
  attendance: GQLAttendance;
  cohortSessionId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateStudentsSessionAttendanceInput = {
  attendance: GQLAttendance;
  cohortSessionId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type GQLUpdateTransientSlotInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullSharedReservation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isBooked?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  isReserved?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reservedBy?: InputMaybe<GQLTransientSlotUserInput>;
  reservedFor?: InputMaybe<GQLTransientSlotUserInput>;
  skipReservationNotificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLUpdateUserAlsoViewingInput = {
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateUserFileInput = {
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
};

export type GQLUpdateVehicleAssignmentsInput = {
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  opsManagerUserId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId: Scalars['ID']['input'];
};

export type GQLUpdateVendorInput = {
  categories: Array<GQLVendorCategoryKey>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type GQLUpdateVoucherV2Input = {
  billingAmount?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  usStateId: GQLUsStateId;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateVoucherV2SourceInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  usStateId?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdatedBy = {
  __typename?: 'UpdatedBy';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  role: GQLAuditLogUserRoles;
};

export type GQLUploadFleetAttachmentInput = {
  contentType: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  entityType: GQLFleetEntityType;
  fileData: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUploadUserFileInput = {
  contentType: Scalars['String']['input'];
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  fileData: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  isHiddenFromStudent?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
};

export type GQLUpsertCouponInput = {
  course?: InputMaybe<GQLCourseCouponInput>;
  lesson?: InputMaybe<GQLLessonCouponInput>;
  roadTest?: InputMaybe<GQLRoadTestCouponInput>;
  type: GQLCouponType;
};

export type GQLUsedReferralCode = {
  __typename?: 'UsedReferralCode';
  fulfillmentStatus: Scalars['String']['output'];
  fullReferralCode: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type GQLUserAlsoViewing = {
  __typename?: 'UserAlsoViewing';
  activeSince: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type GQLUserAuthInfo = {
  __typename?: 'UserAuthInfo';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  mfaFactors: Array<GQLUserMfaFactor>;
  providerId?: Maybe<Scalars['String']['output']>;
};

export type GQLUserAuthMeta = {
  __typename?: 'UserAuthMeta';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isTwoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  roles?: Maybe<Array<GQLUserRole>>;
};

export type GQLUserFile = {
  __typename?: 'UserFile';
  contractId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  documentTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHiddenFromStudent?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  /** @deprecated Use path to generate signed URLs on demand */
  url: Scalars['String']['output'];
};

export type GQLUserLog = {
  __typename?: 'UserLog';
  action: Scalars['String']['output'];
  changedBy?: Maybe<GQLPerson>;
  changedById?: Maybe<Scalars['ID']['output']>;
  changes: Array<GQLLogChange>;
  changesRaw?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<GQLInitiatedBy>;
  instructor?: Maybe<GQLInstructor>;
  instructorId?: Maybe<Scalars['ID']['output']>;
  lessonId?: Maybe<Scalars['ID']['output']>;
  lessonStartTime?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GQLPerson>;
  userId: Scalars['ID']['output'];
};

export type GQLUserLogEdge = {
  __typename?: 'UserLogEdge';
  cursor: Scalars['ID']['output'];
  node: GQLUserLog;
};

export type GQLUserLogsPaginatedList = {
  __typename?: 'UserLogsPaginatedList';
  edges: Array<GQLUserLogEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLUserLogsQuery = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLUserManagementEdge = {
  __typename?: 'UserManagementEdge';
  cursor: Scalars['ID']['output'];
  node: GQLUserAuthMeta;
};

export type GQLUserManagementList = {
  __typename?: 'UserManagementList';
  edges: Array<GQLUserManagementEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLUserMfaFactor = {
  __typename?: 'UserMfaFactor';
  displayName?: Maybe<Scalars['String']['output']>;
  enrollmentTime?: Maybe<Scalars['DateTime']['output']>;
  factorId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type GQLUserNotificationsEdge = {
  __typename?: 'UserNotificationsEdge';
  cursor: Scalars['ID']['output'];
  node: GQLUserNotificationsLog;
};

export type GQLUserNotificationsLog = {
  __typename?: 'UserNotificationsLog';
  errorMessage?: Maybe<Scalars['String']['output']>;
  humanReadableType?: Maybe<Scalars['String']['output']>;
  lessonId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  sendStatus: Scalars['String']['output'];
  sentTo?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type GQLUserNotificationsLogQuery = {
  studentId: Scalars['ID']['input'];
};

export type GQLUserNotificationsPaginatedList = {
  __typename?: 'UserNotificationsPaginatedList';
  edges: Array<GQLUserNotificationsEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLUserReferralInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
};

export enum GQLUserRole {
  Admin = 'Admin',
  ClassroomManager = 'ClassroomManager',
  Instructor = 'Instructor',
  RegionalManager = 'RegionalManager',
  SyncCheckAdmin = 'SyncCheckAdmin',
  Trainee = 'Trainee'
}

export type GQLUserSettings = {
  __typename?: 'UserSettings';
  /** @deprecated Dark mode preview is enabled for admins. This compatibility stub always returns true and will be removed. */
  adminDarkModePreviewEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  referralProgramPromoDismissed: Scalars['Boolean']['output'];
  themePreference: GQLUserThemePreference;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum GQLUserThemePreference {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM'
}

export type GQLVehicle = {
  __typename?: 'Vehicle';
  carKeyAccessCode?: Maybe<Scalars['String']['output']>;
  carKeyLocation?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  hubParkingSpot?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructorIds?: Maybe<Array<Scalars['ID']['output']>>;
  instructors?: Maybe<Array<GQLInstructor>>;
  insuranceStatus?: Maybe<Scalars['String']['output']>;
  inventoryStatus?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  opsManager?: Maybe<GQLPerson>;
  opsManagerUserId?: Maybe<Scalars['ID']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  parkingHub?: Maybe<Scalars['String']['output']>;
  parkingHubId?: Maybe<Scalars['ID']['output']>;
  plate?: Maybe<Scalars['String']['output']>;
  putIntoServiceDate?: Maybe<Scalars['DateString']['output']>;
  samsaraId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tagExpirationDate?: Maybe<Scalars['DateString']['output']>;
  trim?: Maybe<Scalars['String']['output']>;
  usStateId?: Maybe<GQLUsStateId>;
  vehicleAccessCode?: Maybe<Scalars['String']['output']>;
  vehicleAccessMethod?: Maybe<Scalars['String']['output']>;
  vendors?: Maybe<Array<GQLVendor>>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type GQLVehicleAvail = {
  __typename?: 'VehicleAvail';
  availId: Scalars['ID']['output'];
  date: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  instructor: GQLVehicleInstructorFields;
  startTime: Scalars['DateTime']['output'];
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

export type GQLVehicleAvailability = {
  __typename?: 'VehicleAvailability';
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructor: GQLInstructorOnAvail;
  startTime: Scalars['DateTime']['output'];
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

export type GQLVehicleAvailabilityQuery = {
  date: Scalars['String']['input'];
};

export type GQLVehicleEdge = {
  __typename?: 'VehicleEdge';
  cursor: Scalars['ID']['output'];
  node: GQLVehicle;
};

export type GQLVehicleInput = {
  carKeyAccessCode?: InputMaybe<Scalars['String']['input']>;
  carKeyLocation?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  hubParkingSpot?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  insuranceStatus?: InputMaybe<Scalars['String']['input']>;
  inventoryStatus?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  opsManagerUserId?: InputMaybe<Scalars['ID']['input']>;
  ownershipType?: InputMaybe<Scalars['String']['input']>;
  parkingHubId?: InputMaybe<Scalars['ID']['input']>;
  plate: Scalars['String']['input'];
  putIntoServiceDate?: InputMaybe<Scalars['DateString']['input']>;
  samsaraId?: InputMaybe<Scalars['String']['input']>;
  state: GQLUsStateId;
  status?: InputMaybe<Scalars['String']['input']>;
  tagExpirationDate?: InputMaybe<Scalars['DateString']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  vehicleAccessCode?: InputMaybe<Scalars['String']['input']>;
  vehicleAccessMethod?: InputMaybe<Scalars['String']['input']>;
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type GQLVehicleInstructorFields = {
  __typename?: 'VehicleInstructorFields';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
};

export type GQLVehicleMapAvailability = {
  __typename?: 'VehicleMapAvailability';
  availId: Scalars['ID']['output'];
  endTime: Scalars['DateTime']['output'];
  instructor: GQLInstructorOnAvail;
  startTime: Scalars['DateTime']['output'];
  vehicleId: Scalars['ID']['output'];
  vehicleName: Scalars['String']['output'];
};

export type GQLVehicleMapAvailabilityQuery = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type GQLVehiclesFilter = {
  instructorId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  opsManagerUserId?: InputMaybe<Scalars['ID']['input']>;
  parkingHubId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagExpirationEndDate?: InputMaybe<Scalars['DateString']['input']>;
  usStateId?: InputMaybe<GQLUsStateId>;
};

export type GQLVehiclesPaginatedList = {
  __typename?: 'VehiclesPaginatedList';
  edges: Array<GQLVehicleEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLVendor = {
  __typename?: 'Vendor';
  categories: Array<GQLVendorCategoryKey>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum GQLVendorCategoryKey {
  Carwash = 'carwash',
  Toll = 'toll'
}

export type GQLVendorEdge = {
  __typename?: 'VendorEdge';
  cursor: Scalars['ID']['output'];
  node: GQLVendor;
};

export type GQLVendorPaginatedList = {
  __typename?: 'VendorPaginatedList';
  edges: Array<GQLVendorEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLVendorsFilter = {
  category?: InputMaybe<GQLVendorCategoryKey>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type GQLVoidExpirationInput = {
  expirationId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLVoidPurchaseInput = {
  purchaseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLVoidRefundInput = {
  refundId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type GQLVoucherCounts = {
  __typename?: 'VoucherCounts';
  redeemed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unredeemed: Scalars['Int']['output'];
};

export type GQLVoucherStudent = {
  __typename?: 'VoucherStudent';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLVoucherV2 = {
  __typename?: 'VoucherV2';
  billingAmount: Scalars['Float']['output'];
  courseId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isRedeemed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  redeemedById?: Maybe<Scalars['ID']['output']>;
  redeemedToStudentId?: Maybe<Scalars['ID']['output']>;
  redemptionCode: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  student?: Maybe<GQLVoucherStudent>;
  usStateId: GQLUsStateId;
  zipcode: Scalars['String']['output'];
};

export type GQLVoucherV2Edge = {
  __typename?: 'VoucherV2Edge';
  cursor: Scalars['String']['output'];
  node: GQLVoucherV2;
};

export type GQLVoucherV2Filter = {
  isRedeemed?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  redemptionCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type GQLVoucherV2Source = {
  __typename?: 'VoucherV2Source';
  counts?: Maybe<GQLVoucherCounts>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usStateId: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type GQLVoucherV2SourceEdge = {
  __typename?: 'VoucherV2SourceEdge';
  cursor: Scalars['ID']['output'];
  node: GQLVoucherV2Source;
};

export enum GQLWeekDays {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type GQLSignOutNextMutationVariables = Exact<{ [key: string]: never; }>;


export type GQLSignOutNextMutation = { __typename?: 'Mutation', signOut: boolean };

export type GQLResetTestLedgerLogsMutationVariables = Exact<{ [key: string]: never; }>;


export type GQLResetTestLedgerLogsMutation = { __typename?: 'Mutation', resetTestLedgerLogs: boolean };

export type GQLCreateSessionCookieMutationVariables = Exact<{
  session: GQLCreateSessionCookieInput;
}>;


export type GQLCreateSessionCookieMutation = { __typename?: 'Mutation', createSessionCookie: boolean };

export type GQLExpireProductsMutationVariables = Exact<{
  input: GQLExpireProductsInput;
}>;


export type GQLExpireProductsMutation = { __typename?: 'Mutation', expireProducts: { __typename?: 'Expiration', id: string } };

export type GQLVoidExpirationMutationVariables = Exact<{
  input: GQLVoidExpirationInput;
}>;


export type GQLVoidExpirationMutation = { __typename?: 'Mutation', purchaseLog: { __typename?: 'Expiration', id: string } };

export type GQLTransferExpirationMutationVariables = Exact<{
  input: GQLTransferExpirationInput;
}>;


export type GQLTransferExpirationMutation = { __typename?: 'Mutation', transferExpiration: { __typename?: 'Expiration', id: string } };

export type GQLTransferPurchaseMutationVariables = Exact<{
  input: GQLTransferPurchaseInput;
}>;


export type GQLTransferPurchaseMutation = { __typename?: 'Mutation', transferPurchase: { __typename?: 'Purchase', id: string } };

export type GQLTransferLessonMutationVariables = Exact<{
  input: GQLTransferLessonInput;
}>;


export type GQLTransferLessonMutation = { __typename?: 'Mutation', transferLesson: { __typename?: 'Lesson', id: string } };

export type GQLLessonForBookingFragment = { __typename?: 'Lesson', id: string, bookedAt: number, startTime: number, endTime: number, actualDurationMinutes?: number | null, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } };

export type GQLScheduleLessonMutationVariables = Exact<{
  input: GQLScheduleLessonInput;
}>;


export type GQLScheduleLessonMutation = { __typename?: 'Mutation', scheduleLesson: { __typename?: 'Lesson', id: string, bookedAt: number, startTime: number, endTime: number, actualDurationMinutes?: number | null, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } } };

export type GQLSelfBookSharedLessonMutationVariables = Exact<{
  input: GQLSelfBookSharedLessonInput;
}>;


export type GQLSelfBookSharedLessonMutation = { __typename?: 'Mutation', selfBookSharedLesson: { __typename?: 'Lesson', id: string, bookedAt: number, startTime: number, endTime: number, actualDurationMinutes?: number | null, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } } };

export type GQLUpdateLessonMutationVariables = Exact<{
  query: GQLLessonUpdateQuery;
  update: GQLLessonUpdateInput;
}>;


export type GQLUpdateLessonMutation = { __typename?: 'Mutation', updateLesson: { __typename?: 'Lesson', id: string } };

export type GQLCancelLessonMutationVariables = Exact<{
  query: GQLLessonCancelQuery;
  input: GQLLessonCancellationInfo;
}>;


export type GQLCancelLessonMutation = { __typename?: 'Mutation', cancelLesson: { __typename?: 'Lesson', id: string } };

export type GQLRemoveStudentFromLessonMutationVariables = Exact<{
  query: GQLLessonRemoveStudentQuery;
  input: GQLLessonCancellationInfo;
}>;


export type GQLRemoveStudentFromLessonMutation = { __typename?: 'Mutation', removeStudentFromLesson: { __typename?: 'Lesson', id: string } };

export type GQLRefundPurchaseMutationVariables = Exact<{
  input: GQLRefundPurchaseInput;
}>;


export type GQLRefundPurchaseMutation = { __typename?: 'Mutation', refundPurchase: { __typename?: 'Refund', id: string, amountToRefund: number } };

export type GQLEditPurchaseMutationVariables = Exact<{
  input: GQLEditPurchaseInput;
}>;


export type GQLEditPurchaseMutation = { __typename?: 'Mutation', editPurchase: { __typename?: 'Purchase', id: string } };

export type GQLVoidPurchaseMutationVariables = Exact<{
  input: GQLVoidPurchaseInput;
}>;


export type GQLVoidPurchaseMutation = { __typename?: 'Mutation', purchaseLog: { __typename?: 'Purchase', id: string } };

export type GQLCreatePurchaseMutationVariables = Exact<{
  input: GQLCreatePurchaseInput;
}>;


export type GQLCreatePurchaseMutation = { __typename?: 'Mutation', createPurchase: { __typename?: 'Purchase', id: string } };

export type GQLInstructorUpdateLessonMutationVariables = Exact<{
  query: GQLLessonUpdateQuery;
  update: GQLInstructorLessonUpdateInput;
}>;


export type GQLInstructorUpdateLessonMutation = { __typename?: 'Mutation', instructorUpdateLesson: { __typename?: 'Lesson', id: string } };

export type GQLInstructorAddStudentToLessonMutationVariables = Exact<{
  query: GQLLessonUpdateQuery;
  input: GQLInstructorAddStudentInput;
}>;


export type GQLInstructorAddStudentToLessonMutation = { __typename?: 'Mutation', instructorAddStudentToLesson: { __typename?: 'Lesson', id: string } };

export type GQLChangeLessonInstructorMutationVariables = Exact<{
  input: GQLChangeLessonInstructorInput;
}>;


export type GQLChangeLessonInstructorMutation = { __typename?: 'Mutation', changeLessonInstructor: { __typename?: 'Lesson', id: string } };

export type GQLCourseTimerPatchEventFullFragment = { __typename: 'CourseTimerPatchEvent', localId: string, originId: string, studentId: string, type: string, updates: Array<{ __typename?: 'CourseTimerPatchUpdate', from: number, to: number, courseId: string, lectureId: string }> };

export type GQLSyncCourseTimersMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  fromEventId?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  events: Array<GQLClientCourseTimerEventInput> | GQLClientCourseTimerEventInput;
}>;


export type GQLSyncCourseTimersMutation = { __typename?: 'Mutation', syncCourseTimers: { __typename?: 'SyncCourseTimersResult', events: Array<{ __typename: 'CourseTimerPatchEvent', localId: string, originId: string, studentId: string, type: string, updates: Array<{ __typename?: 'CourseTimerPatchUpdate', from: number, to: number, courseId: string, lectureId: string }> }> } };

export type GQLEnrollStudentToOnlineCourseMutationVariables = Exact<{
  input: GQLStudentOnlineCourseInput;
}>;


export type GQLEnrollStudentToOnlineCourseMutation = { __typename?: 'Mutation', enrollStudentToOnlineCourse: { __typename?: 'StudentOnlineCourse', id: string, enrolled: boolean } };

export type GQLInstructorViewWithPrivateAndAdminFragment = { __typename?: 'Instructor', id: string, name: string, signInEmail?: string | null, languages?: string | null, spokenLanguageCodes?: Array<string> | null, about?: string | null, summary?: string | null, title?: string | null, portraitImage?: string | null, wallpaperImage?: string | null, usStateId: string, locationLandingPageId?: string | null, timeZone: string, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string, status: GQLInstructorStatus, slackUsername?: string | null, breakTimes: Array<number>, email: string, licenseNumber?: string | null, licenseExpirationDate?: number | null, baseAddress?: string | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, nonTeachingPay?: number | null, teachingPay?: number | null, phoneNumber?: string | null, managerName?: string | null, managerId?: string | null, doNotSyncRoadTestHoursWithPayroll?: boolean | null, canManageOwnSchedule?: boolean | null, jobCodes?: Array<string> | null, paylocityId?: string | null, doNotSyncHoursWithPayroll?: boolean | null, availsFixedByDefault?: boolean | null, canManageMeetingLocations?: boolean | null, employmentType?: string | null, hasRoadTestStipend?: boolean | null, hasSignedBreakTimeWaiver?: boolean | null, optOutLessonEmailNotifications?: boolean | null, maxBaseTravelMinutesOverride?: number | null, maxBetweenTravelMinutesOverride?: number | null, servicesProvided?: any | null }, adminInfo: { __typename?: 'InstructorAdminInfo', userId: string, payrollFirstName?: string | null, payrollLastName?: string | null, payrollTitle?: string | null, regionalManagerId?: string | null, isTrainee: boolean, isRetired?: boolean | null, isInactive?: boolean | null, regionalManager?: { __typename?: 'Person', name: string } | null } };

export type GQLGetInstructorWithPrivateAndAdminQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorWithPrivateAndAdminQuery = { __typename?: 'Query', instructor: { __typename?: 'Instructor', id: string, name: string, signInEmail?: string | null, languages?: string | null, spokenLanguageCodes?: Array<string> | null, about?: string | null, summary?: string | null, title?: string | null, portraitImage?: string | null, wallpaperImage?: string | null, usStateId: string, locationLandingPageId?: string | null, timeZone: string, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string, status: GQLInstructorStatus, slackUsername?: string | null, breakTimes: Array<number>, email: string, licenseNumber?: string | null, licenseExpirationDate?: number | null, baseAddress?: string | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, nonTeachingPay?: number | null, teachingPay?: number | null, phoneNumber?: string | null, managerName?: string | null, managerId?: string | null, doNotSyncRoadTestHoursWithPayroll?: boolean | null, canManageOwnSchedule?: boolean | null, jobCodes?: Array<string> | null, paylocityId?: string | null, doNotSyncHoursWithPayroll?: boolean | null, availsFixedByDefault?: boolean | null, canManageMeetingLocations?: boolean | null, employmentType?: string | null, hasRoadTestStipend?: boolean | null, hasSignedBreakTimeWaiver?: boolean | null, optOutLessonEmailNotifications?: boolean | null, maxBaseTravelMinutesOverride?: number | null, maxBetweenTravelMinutesOverride?: number | null, servicesProvided?: any | null }, adminInfo: { __typename?: 'InstructorAdminInfo', userId: string, payrollFirstName?: string | null, payrollLastName?: string | null, payrollTitle?: string | null, regionalManagerId?: string | null, isTrainee: boolean, isRetired?: boolean | null, isInactive?: boolean | null, regionalManager?: { __typename?: 'Person', name: string } | null } } };

export type GQLUpdateTransientSlotMutationVariables = Exact<{
  input: GQLUpdateTransientSlotInput;
}>;


export type GQLUpdateTransientSlotMutation = { __typename?: 'Mutation', updateTransientSlot: string };

export type GQLUpdateTransientSlotTimeMutationVariables = Exact<{
  transientSlotId: Scalars['ID']['input'];
}>;


export type GQLUpdateTransientSlotTimeMutation = { __typename?: 'Mutation', updateTransientSlotTime?: string | null };

export type GQLDeleteTransientSlotMutationVariables = Exact<{
  transientSlotId: Scalars['ID']['input'];
}>;


export type GQLDeleteTransientSlotMutation = { __typename?: 'Mutation', deleteTransientSlot: string };

export type GQLDeleteTransientSlotIfNotReservedMutationVariables = Exact<{
  transientSlotId: Scalars['ID']['input'];
}>;


export type GQLDeleteTransientSlotIfNotReservedMutation = { __typename?: 'Mutation', deleteTransientSlotIfNotReserved?: string | null };

export type GQLStateConfigForLocationFragment = { __typename?: 'StateConfig', id: string, shortName: string, longName: string, hasMeetingPoints: boolean, hasHomePickup: boolean, hasFixedLocations: boolean, isShareableByDefault: boolean };

export type GQLGetStateConfigForLocationQueryVariables = Exact<{
  state: Scalars['ID']['input'];
}>;


export type GQLGetStateConfigForLocationQuery = { __typename?: 'Query', stateConfig?: { __typename?: 'StateConfig', id: string, shortName: string, longName: string, hasMeetingPoints: boolean, hasHomePickup: boolean, hasFixedLocations: boolean, isShareableByDefault: boolean } | null };

export type GQLAddressPointFragment = { __typename?: 'StateMeetingPoint', id: string, address: string, label: string, distanceMiles?: number | null };

export type GQLSearchAvailabilityInstructorFragment = { __typename?: 'Instructor', id: string, name: string, timeZone: string, spokenLanguageCodes?: Array<string> | null };

export type GQLSearchAvailabilityInstructorQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLSearchAvailabilityInstructorQuery = { __typename?: 'Query', instructors: { __typename?: 'InstructorsPaginatedList', edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, timeZone: string, spokenLanguageCodes?: Array<string> | null } }> } };

export type GQLGetLastBookedInstructorQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetLastBookedInstructorQuery = { __typename?: 'Query', lastBookedInstructor?: { __typename?: 'LastBookedInstructor', id: string } | null };

export type GQLSignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type GQLSignOutMutation = { __typename?: 'Mutation', signOut: boolean };

export type GQLRecordLastActiveMutationVariables = Exact<{ [key: string]: never; }>;


export type GQLRecordLastActiveMutation = { __typename?: 'Mutation', recordLastActive: boolean };

export type GQLRecordAdminVisitedStudentMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type GQLRecordAdminVisitedStudentMutation = { __typename?: 'Mutation', recordAdminVisitedStudent: boolean };

export type GQLRecordAdminVisitedInstructorMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type GQLRecordAdminVisitedInstructorMutation = { __typename?: 'Mutation', recordAdminVisitedInstructor: boolean };

export type GQLLegacySelfAuthMetaViewFragment = { __typename?: 'UserAuthMeta', id: string, email: string, name: string, isTwoFactorEnabled?: boolean | null, isDisabled?: boolean | null, roles?: Array<GQLUserRole> | null, lastActive?: number | null };

export type GQLGetSelfAuthMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetSelfAuthMetaQuery = { __typename?: 'Query', selfAuthMeta?: { __typename?: 'UserAuthMeta', id: string, email: string, name: string, isTwoFactorEnabled?: boolean | null, isDisabled?: boolean | null, roles?: Array<GQLUserRole> | null, lastActive?: number | null } | null };

export type GQLAutoCreatedAccountExistsResultFragment = { __typename?: 'Query', autoCreatedAccountExists: boolean };

export type GQLAutoCreatedAccountExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GQLAutoCreatedAccountExistsQuery = { __typename?: 'Query', autoCreatedAccountExists: boolean };

export type GQLImpersonateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLImpersonateUserMutation = { __typename?: 'Mutation', impersonateUser: { __typename?: 'ImpersonateUserResponse', token: string } };

export type GQLRecordAutoCreatedAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type GQLRecordAutoCreatedAccountMutation = { __typename?: 'Mutation', recordAutoCreatedAccount: boolean };

export type GQLCreateAuthUserProfileMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLCreateAuthUserProfileMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string } };

type GQLCouponForView_CourseCoupon_Fragment = { __typename: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null };

type GQLCouponForView_LessonCoupon_Fragment = { __typename: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string, name: string }> };

type GQLCouponForView_RoadTestCoupon_Fragment = { __typename: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string, name: string }> };

export type GQLCouponForViewFragment =
  | GQLCouponForView_CourseCoupon_Fragment
  | GQLCouponForView_LessonCoupon_Fragment
  | GQLCouponForView_RoadTestCoupon_Fragment
;

export type GQLCouponsListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type GQLCouponsListQuery = { __typename?: 'Query', coupons: { __typename?: 'CouponsPaginatedList', edges: Array<{ __typename?: 'CouponEdge', cursor: string, node:
        | { __typename: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
        | { __typename: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string, name: string }> }
        | { __typename: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string, name: string }> }
       }> } };

export type GQLCheckoutPaymentIntentForStripeProviderFragment = { __typename?: 'CreateCheckoutPaymentIntentPayload', clientSecret?: string | null, taxAmountCents?: number | null, amountSubtotalCents?: number | null, amountTotalCents?: number | null };

export type GQLCreateCheckoutPaymentIntentMutationVariables = Exact<{
  input: GQLCreateCheckoutPaymentIntentInput;
}>;


export type GQLCreateCheckoutPaymentIntentMutation = { __typename?: 'Mutation', createCheckoutPaymentIntent: { __typename?: 'CreateCheckoutPaymentIntentPayload', clientSecret?: string | null, taxAmountCents?: number | null, amountSubtotalCents?: number | null, amountTotalCents?: number | null } };

export type GQLAccountCreditStudentFragment = { __typename?: 'Student', id: string, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousHours?: number | null };

export type GQLUpdateAccountCreditStudentMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateAccountCreditStudentMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousHours?: number | null } };

export type GQLAcquisitionSelectAcquisitionFragment = { __typename?: 'Acquisition', id: string, name: string };

export type GQLAcquisitionsForSelectQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLAcquisitionsForSelectQuery = { __typename?: 'Query', acquisitions: { __typename?: 'AcquisitionPaginatedList', edges: Array<{ __typename?: 'AcquisitionEdge', node: { __typename?: 'Acquisition', id: string, name: string } }> } };

export type GQLCourseBasicInfoFragment = { __typename?: 'OnlineCourseContent', id: string, title: string, stateShortName: string, isClassroomCourse: boolean, isKnowledgeTest: boolean };

export type GQLFetchCoursesForEnrollmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFetchCoursesForEnrollmentQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'OnlineCourseContent', id: string, title: string, stateShortName: string, isClassroomCourse: boolean, isKnowledgeTest: boolean }> };

export type GQLAdminHelpDocIndexEntryFieldsFragment = { __typename?: 'AdminHelpDocIndexEntry', docPath: string, routePatterns: Array<string>, section: string, status: string, title: string };

export type GQLAdminHelpDocContentFieldsFragment = { __typename?: 'AdminHelpDocContent', docPath: string, routePatterns: Array<string>, section: string, status: string, title: string, markdown: string };

export type GQLAdminHelpDocsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAdminHelpDocsQuery = { __typename?: 'Query', adminHelpDocs: Array<{ __typename?: 'AdminHelpDocIndexEntry', docPath: string, routePatterns: Array<string>, section: string, status: string, title: string }> };

export type GQLAdminHelpDocQueryVariables = Exact<{
  docPath: Scalars['String']['input'];
}>;


export type GQLAdminHelpDocQuery = { __typename?: 'Query', adminHelpDoc?: { __typename?: 'AdminHelpDocContent', docPath: string, routePatterns: Array<string>, section: string, status: string, title: string, markdown: string } | null };

export type GQLUserAlsoViewingFieldsFragment = { __typename?: 'UserAlsoViewing', userId: string, name: string, activeSince: number };

export type GQLGetUserAlsoViewingQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetUserAlsoViewingQuery = { __typename?: 'Query', userAlsoViewing: Array<{ __typename?: 'UserAlsoViewing', userId: string, name: string, activeSince: number }> };

export type GQLUpdateUserAlsoViewingMutationVariables = Exact<{
  input: GQLUpdateUserAlsoViewingInput;
}>;


export type GQLUpdateUserAlsoViewingMutation = { __typename?: 'Mutation', updateUserAlsoViewing: boolean };

export type GQLRemoveUserAlsoViewingMutationVariables = Exact<{
  input: GQLRemoveUserAlsoViewingInput;
}>;


export type GQLRemoveUserAlsoViewingMutation = { __typename?: 'Mutation', removeUserAlsoViewing: boolean };

export type GQLCreateAvailabilityMutationVariables = Exact<{
  input: GQLAvailabilityCreateInput;
}>;


export type GQLCreateAvailabilityMutation = { __typename?: 'Mutation', createAvailability: { __typename?: 'Availability', id: string } };

export type GQLUpdateAvailabilityMutationVariables = Exact<{
  query: GQLAvailabilityQuery;
  input: GQLAvailabilityUpdateInput;
}>;


export type GQLUpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability: { __typename?: 'Availability', id: string } };

export type GQLVehicleAvailabilityFieldsFragment = { __typename?: 'Availability', id: string, startTime: number, endTime: number, vehicle?: { __typename?: 'Vehicle', id: string, name?: string | null } | null, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } };

export type GQLAvailFormVehicleDailyAvailabilityFragment = { __typename?: 'AvailFormVehicleDailyAvailability', id: string, startTime: number, endTime: number, instructorId: string, instructorName: string };

export type GQLAvailFormVehicleFragment = { __typename?: 'AvailFormVehicle', id: string, number: string, instructorIds: Array<string>, instructorNames: Array<string>, dailyAvailabilities: Array<{ __typename?: 'AvailFormVehicleDailyAvailability', id: string, startTime: number, endTime: number, instructorId: string, instructorName: string }> };

export type GQLAvailFormInstructorFragment = { __typename?: 'AvailFormInstructor', id: string, displayName: string, timeZone: string, baseAddress?: string | null, state: string, availsFixedByDefault?: boolean | null, canManageOwnSchedule?: boolean | null, canManageMeetingLocations?: boolean | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null };

export type GQLAvailFormContextQueryVariables = Exact<{
  query: GQLAvailFormContextInput;
}>;


export type GQLAvailFormContextQuery = { __typename?: 'Query', availFormContext: { __typename?: 'AvailFormContext', instructor: { __typename?: 'AvailFormInstructor', id: string, displayName: string, timeZone: string, baseAddress?: string | null, state: string, availsFixedByDefault?: boolean | null, canManageOwnSchedule?: boolean | null, canManageMeetingLocations?: boolean | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null }, vehicles: Array<{ __typename?: 'AvailFormVehicle', id: string, number: string, instructorIds: Array<string>, instructorNames: Array<string>, dailyAvailabilities: Array<{ __typename?: 'AvailFormVehicleDailyAvailability', id: string, startTime: number, endTime: number, instructorId: string, instructorName: string }> }> } };

export type GQLAvailabilityFieldsFragment = { __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxLessons?: number | null, minLeadHours: number, maxDurationMinutes?: number | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, note?: string | null, instructorId: string, isFixedLocation: boolean, fixedLocationId?: string | null, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, lessonCount?: number | null, center: { __typename?: 'Center', location: string, locationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null }, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, vehicle?: { __typename?: 'Vehicle', id: string, name?: string | null, location?: string | null } | null };

export type GQLGetAvailabilityQueryVariables = Exact<{
  query: GQLAvailabilityQuery;
}>;


export type GQLGetAvailabilityQuery = { __typename?: 'Query', availability: { __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxLessons?: number | null, minLeadHours: number, maxDurationMinutes?: number | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, note?: string | null, instructorId: string, isFixedLocation: boolean, fixedLocationId?: string | null, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, lessonCount?: number | null, center: { __typename?: 'Center', location: string, locationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null }, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, vehicle?: { __typename?: 'Vehicle', id: string, name?: string | null, location?: string | null } | null } };

export type GQLGetLessonsByInstructorIdsQueryVariables = Exact<{
  query: GQLLessonsQueryByInstructorIds;
}>;


export type GQLGetLessonsByInstructorIdsQuery = { __typename?: 'Query', lessonsByInstructorIds: Array<{ __typename?: 'Lesson', id: string, startTime: number, endTime: number }> };

export type GQLBatchDeleteAvailsMutationVariables = Exact<{
  query: GQLBatchDeleteAvailsQuery;
}>;


export type GQLBatchDeleteAvailsMutation = { __typename?: 'Mutation', batchDeleteAvails: { __typename?: 'BatchDeleteAvailsResult', deleted: Array<string>, failed: Array<{ __typename?: 'AvailabilityUpdateFailure', availabilityId: string, error: string }> } };

export type GQLPutBookingAlertMutationVariables = Exact<{
  bookingAlert: GQLBookingAlertInput;
}>;


export type GQLPutBookingAlertMutation = { __typename?: 'Mutation', putBookingAlert: { __typename?: 'BookingAlert', id: string } };

export type GQLBookingAlertFieldsFragment = { __typename?: 'BookingAlert', id: string, text?: string | null, createdAt?: number | null, createdBy: { __typename?: 'Person', id: string, name: string } };

export type GQLBookingAlertsForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GQLBookingAlertsForStudentQuery = { __typename?: 'Query', bookingAlerts: { __typename?: 'BookingAlertsPaginatedList', edges: Array<{ __typename?: 'BookingAlertEdge', node: { __typename?: 'BookingAlert', id: string, text?: string | null, createdAt?: number | null, createdBy: { __typename?: 'Person', id: string, name: string } } }> } };

export type GQLRemoveBookingAlertMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GQLRemoveBookingAlertMutation = { __typename?: 'Mutation', removeBookingAlert: string };

export type GQLCreateBulkAvailabilitiesMutationVariables = Exact<{
  input: GQLBulkAvailabilityCreateInput;
}>;


export type GQLCreateBulkAvailabilitiesMutation = { __typename?: 'Mutation', createBulkAvailabilities: { __typename?: 'BatchAddAvailsResult', added: Array<{ __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number }>, failed: Array<{ __typename?: 'AvailabilityAddFailure', date?: string | null, error: string }> } };

export type GQLCourseForSelectFragment = { __typename?: 'OnlineCourseContent', id: string, title: string, stateShortName: string };

export type GQLAnvilFieldInfoFragment = { __typename?: 'FieldInfo', id: string, name: string, type: string, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null, styles?: { __typename?: 'FieldStyles', required?: boolean | null, disabled?: boolean | null, helperText?: string | null } | null };

export type GQLAnvilCastListFieldsFragment = { __typename?: 'CastList', id: string, name: string, title?: string | null };

export type GQLAnvilCastFieldsFragment = { __typename?: 'Cast', id: string, name: string, title?: string | null, exampleData?: any | null, fieldInfo: Array<{ __typename?: 'FieldInfo', id: string, name: string, type: string, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null, styles?: { __typename?: 'FieldStyles', required?: boolean | null, disabled?: boolean | null, helperText?: string | null } | null }> };

export type GQLGetAnvilOrgCastsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetAnvilOrgCastsQuery = { __typename?: 'Query', organizationCasts: Array<{ __typename?: 'CastList', id: string, name: string, title?: string | null }> };

export type GQLStartMaskedLessonCommunicationMutationVariables = Exact<{
  input: GQLMaskedCommunicationInput;
}>;


export type GQLStartMaskedLessonCommunicationMutation = { __typename?: 'Mutation', startMaskedLessonCommunication: boolean };

export type GQLSendInstructorArrivedLessonAlertMutationVariables = Exact<{
  input: GQLSendInstructorArrivedLessonAlertInput;
}>;


export type GQLSendInstructorArrivedLessonAlertMutation = { __typename?: 'Mutation', sendInstructorArrivedLessonAlert: Array<{ __typename?: 'LessonAlertDeliveryResult', status: number, message: string }> };

export type GQLInstructorMetricsPeriodRangeFieldsFragment = { __typename?: 'InstructorMetricsPeriodRange', id: string, startDate: number, endDate: number };

export type GQLInstructorMetricsSummaryFieldsFragment = { __typename?: 'InstructorMetricsSummary', periodId: string, numLessons?: number | null, lessonHours?: number | null, reviewAvg?: number | null, reviewPerc?: number | null, reportPerc?: number | null, reportSentPerc?: number | null, certPerc?: number | null, leftOnTimePerc?: number | null, numCancels?: number | null, cancelPerc?: number | null };

export type GQLInstructorMetricsTimeSeriesPointFieldsFragment = { __typename?: 'InstructorMetricsTimeSeriesPoint', date: string, numLessons?: number | null, lessonHours?: number | null, reviewAvg?: number | null, reviewPerc?: number | null, reportPerc?: number | null, reportSentPerc?: number | null, certPerc?: number | null, leftOnTimePerc?: number | null, numCancels?: number | null, cancelPerc?: number | null };

export type GQLGetInstructorMetricsQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorMetricsQuery = { __typename?: 'Query', instructorMetrics: { __typename?: 'InstructorMetricsReport', periodRanges: Array<{ __typename?: 'InstructorMetricsPeriodRange', id: string, startDate: number, endDate: number }>, summaries: Array<{ __typename?: 'InstructorMetricsSummary', periodId: string, numLessons?: number | null, lessonHours?: number | null, reviewAvg?: number | null, reviewPerc?: number | null, reportPerc?: number | null, reportSentPerc?: number | null, certPerc?: number | null, leftOnTimePerc?: number | null, numCancels?: number | null, cancelPerc?: number | null }>, timeseries: Array<{ __typename?: 'InstructorMetricsTimeSeriesPoint', date: string, numLessons?: number | null, lessonHours?: number | null, reviewAvg?: number | null, reviewPerc?: number | null, reportPerc?: number | null, reportSentPerc?: number | null, certPerc?: number | null, leftOnTimePerc?: number | null, numCancels?: number | null, cancelPerc?: number | null }> } };

export type GQLGetStudentLegalAndPermissionsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  purchaseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentLegalAndPermissionsQuery = { __typename?: 'Query', studentLegalAndPermissions?: { __typename?: 'StudentLegalAndPermissionsRecord', studentId: string, purchaseId: string, contractStatus: GQLStudentContractStatus, transferStatus: GQLStudentTransferStatus, transferType?: GQLStudentTransferType | null, privateApproved: boolean, autogenerated: boolean, isMigrated: boolean } | null };

export type GQLUpdateStudentLegalAndPermissionsMutationVariables = Exact<{
  input: GQLUpdateStudentLegalAndPermissionsInput;
}>;


export type GQLUpdateStudentLegalAndPermissionsMutation = { __typename?: 'Mutation', updateStudentLegalAndPermissions: { __typename?: 'StudentLegalAndPermissionsRecord', studentId: string, purchaseId: string, contractStatus: GQLStudentContractStatus, transferStatus: GQLStudentTransferStatus, transferType?: GQLStudentTransferType | null, privateApproved: boolean } };

export type GQLLessonCalendarHolidayFragmentFragment = { __typename?: 'CalendarHoliday', id: string, date: string, title: string };

export type GQLGetLessonCalendarHolidaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetLessonCalendarHolidaysQuery = { __typename?: 'Query', calendarHolidays: Array<{ __typename?: 'CalendarHoliday', id: string, date: string, title: string }> };

export type GQLGetLessonCurrentValueQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetLessonCurrentValueQuery = { __typename?: 'Query', lessonByInstructorId: { __typename?: 'Lesson', id: string, currentValue?: number | null } };

export type GQLLessonCardMeetingPointFragment = { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string };

export type GQLLessonCardObserverInstructorFragment = { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string };

export type GQLLessonCardStudentDetailsFragment = { __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, drivingHistory?: string | null, dmvLocation?: string | null, dmvConfirmationCode?: string | null, drivingMinutes: number, observationMinutes: number };

export type GQLLessonCardLessonFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, actualDurationMinutes?: number | null, actualDurationNote?: string | null, searchState?: string | null, pickupLocation: string, isShareable: boolean, lessonType?: { __typename?: 'LessonType', name: string } | null, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string } | null, observerInstructor?: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string } | null, instructor: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, drivingHistory?: string | null, dmvLocation?: string | null, dmvConfirmationCode?: string | null, drivingMinutes: number, observationMinutes: number }> };

export type GQLGetLessonCardDataQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  observationMinuteProductId: Scalars['ID']['input'];
}>;


export type GQLGetLessonCardDataQuery = { __typename?: 'Query', phoneMaskingCommsEnabled: boolean, lessonByInstructorId: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, actualDurationMinutes?: number | null, actualDurationNote?: string | null, searchState?: string | null, pickupLocation: string, isShareable: boolean, lessonType?: { __typename?: 'LessonType', name: string } | null, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string } | null, observerInstructor?: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string } | null, instructor: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, drivingHistory?: string | null, dmvLocation?: string | null, dmvConfirmationCode?: string | null, drivingMinutes: number, observationMinutes: number }> } };

export type GQLCreateSharedLessonReservationMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
}>;


export type GQLCreateSharedLessonReservationMutation = { __typename?: 'Mutation', createSharedLessonReservation: { __typename?: 'TransientSlot', id: string } };

export type GQLLessonForCardFragment = { __typename?: 'Lesson', id: string, startTime: number, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number } };

export type GQLListLessonsForCardQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
}>;


export type GQLListLessonsForCardQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, startTime: number, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number } } }> } };

export type GQLLessonFormStudentDetailsFragment = { __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, dmvLocation?: string | null, drivingMinutes: number, observationMinutes: number };

export type GQLLessonFormLessonFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, actualDurationMinutes?: number | null, actualDurationNote?: string | null, hasHomePickup: boolean, pickupLocation: string, isShareable: boolean, searchState?: string | null, locationId?: string | null, meetingPointId?: string | null, observerInstructorId?: string | null, pickupLocationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null, lessonType?: { __typename?: 'LessonType', name: string } | null, instructor: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, dmvLocation?: string | null, drivingMinutes: number, observationMinutes: number }> };

export type GQLGetLessonFormLessonQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  observationMinuteProductId: Scalars['ID']['input'];
}>;


export type GQLGetLessonFormLessonQuery = { __typename?: 'Query', lessonByInstructorId: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, actualDurationMinutes?: number | null, actualDurationNote?: string | null, hasHomePickup: boolean, pickupLocation: string, isShareable: boolean, searchState?: string | null, locationId?: string | null, meetingPointId?: string | null, observerInstructorId?: string | null, pickupLocationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null, lessonType?: { __typename?: 'LessonType', name: string } | null, instructor: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, pickupDetails?: string | null, dmvLocation?: string | null, drivingMinutes: number, observationMinutes: number }> } };

export type GQLLessonFormConflictingLessonsQueryVariables = Exact<{
  query: GQLLessonsQueryByInstructorIds;
}>;


export type GQLLessonFormConflictingLessonsQuery = { __typename?: 'Query', lessonsByInstructorIds: Array<{ __typename?: 'Lesson', id: string }> };

export type GQLLessonFormTransientSlotQueryVariables = Exact<{
  lessonId: Scalars['ID']['input'];
}>;


export type GQLLessonFormTransientSlotQuery = { __typename?: 'Query', transientSlotIfExists?: { __typename?: 'TransientSlot', id: string } | null };

export type GQLSendRunningLateLessonAlertMutationVariables = Exact<{
  input: GQLSendRunningLateLessonAlertInput;
}>;


export type GQLSendRunningLateLessonAlertMutation = { __typename?: 'Mutation', sendRunningLateLessonAlert: Array<{ __typename?: 'LessonAlertDeliveryResult', status: number, message: string }> };

export type GQLEmailStudentReportMutationVariables = Exact<{
  input: GQLEmailStudentReportInput;
}>;


export type GQLEmailStudentReportMutation = { __typename?: 'Mutation', emailStudentReport: boolean };

export type GQLAdminLessonsInstructorViewFragment = { __typename?: 'AdminLessonsInstructor', userId: string, displayName: string, usStateId?: string | null, timeZone: string, locationLandingPageId?: string | null, locationLandingPageName?: string | null, id: string };

export type GQLFetchAdminLessonsInstructorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFetchAdminLessonsInstructorsQuery = { __typename?: 'Query', adminLessonsInstructors: Array<{ __typename?: 'AdminLessonsInstructor', userId: string, displayName: string, usStateId?: string | null, timeZone: string, locationLandingPageId?: string | null, locationLandingPageName?: string | null, id: string }> };

export type GQLCalendarCohortSessionFragment = { __typename?: 'CohortSession', id: string, instructorId?: string | null, instructorName?: string | null, name: string, cohortId: string, startTime: number, endTime: number, cohort?: { __typename?: 'Cohort', name: string } | null };

export type GQLLessonsVehicleFragment = { __typename?: 'Vehicle', id: string, name?: string | null, parkingHub?: string | null, instructorIds?: Array<string> | null };

export type GQLGetVehiclesForInstructorQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filter?: InputMaybe<GQLVehiclesFilter>;
}>;


export type GQLGetVehiclesForInstructorQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesPaginatedList', edges: Array<{ __typename?: 'VehicleEdge', node: { __typename?: 'Vehicle', id: string, name?: string | null, parkingHub?: string | null, instructorIds?: Array<string> | null } }> } | null };

export type GQLLessonsCalendarLessonFragment = { __typename?: 'Lesson', id: string, instructorId: string, startTime: number, endTime: number, durationMinutes: number, pickupLocation: string, locationId?: string | null, isShareable: boolean, observerInstructorId?: string | null, instructor: { __typename?: 'Instructor', id: string, displayName: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, student: { __typename?: 'Student', name: string }, productQuantityList: Array<{ __typename?: 'ProductQuantity', productId: string, quantity: number }> }> };

export type GQLLessonsCalendarAvailabilityFragment = { __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, minLeadHours: number, maxDurationMinutes?: number | null, note?: string | null, isFixedLocation: boolean, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, instructor: { __typename?: 'Instructor', id: string, timeZone: string, displayName: string }, center: { __typename?: 'Center', location: string } };

export type GQLLessonsCalendarTimeOffFragment = { __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string };

export type GQLGetLessonsCalendarDataQueryVariables = Exact<{
  instructorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  includeSessions: Scalars['Boolean']['input'];
}>;


export type GQLGetLessonsCalendarDataQuery = { __typename?: 'Query', lessonsByInstructorIds: Array<{ __typename?: 'Lesson', id: string, instructorId: string, startTime: number, endTime: number, durationMinutes: number, pickupLocation: string, locationId?: string | null, isShareable: boolean, observerInstructorId?: string | null, instructor: { __typename?: 'Instructor', id: string, displayName: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, student: { __typename?: 'Student', name: string }, productQuantityList: Array<{ __typename?: 'ProductQuantity', productId: string, quantity: number }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, minLeadHours: number, maxDurationMinutes?: number | null, note?: string | null, isFixedLocation: boolean, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, instructor: { __typename?: 'Instructor', id: string, timeZone: string, displayName: string }, center: { __typename?: 'Center', location: string } }>, instructorsTimeOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null, cohortSessionsByInstructorIds?: Array<{ __typename?: 'CohortSession', id: string, instructorId?: string | null, instructorName?: string | null, name: string, cohortId: string, startTime: number, endTime: number, cohort?: { __typename?: 'Cohort', name: string } | null }>, lessonsByObserverInstructorIds: Array<{ __typename?: 'Lesson', id: string, instructorId: string, startTime: number, endTime: number, durationMinutes: number, pickupLocation: string, locationId?: string | null, isShareable: boolean, observerInstructorId?: string | null, instructor: { __typename?: 'Instructor', id: string, displayName: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, student: { __typename?: 'Student', name: string }, productQuantityList: Array<{ __typename?: 'ProductQuantity', productId: string, quantity: number }> }> }> };

export type GQLLessonsCalendarTransientSlotFragment = { __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, isBooked?: boolean | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string } };

export type GQLGetLessonsTransientSlotsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetLessonsTransientSlotsQuery = { __typename?: 'Query', transientSlots: Array<{ __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, isBooked?: boolean | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string } }> };

export type GQLMeetingPointFragment = { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string, state: string, restrictedLessonTypes?: Array<{ __typename?: 'LessonTypeForMeetingPoint', nameId: GQLLessonTypeName, name: string }> | null };

export type GQLGetStateMeetingPointsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['ID']['input']>;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetStateMeetingPointsQuery = { __typename?: 'Query', stateMeetingPoints: { __typename?: 'StateMeetingPointPaginatedList', edges: Array<{ __typename?: 'StateMeetingPointEdge', node: { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string, state: string, restrictedLessonTypes?: Array<{ __typename?: 'LessonTypeForMeetingPoint', nameId: GQLLessonTypeName, name: string }> | null } }> } };

export type GQLGetCompletedCartsQueryVariables = Exact<{
  filter: GQLCartFilterInput;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetCompletedCartsQuery = { __typename?: 'Query', completedCarts: { __typename?: 'CartsPaginatedList', totalCount: number, edges: Array<{ __typename?: 'CartEdge', node: { __typename?: 'Cart', id: string, updatedAt: number, isFirstPurchase?: boolean | null, student?: { __typename?: 'Student', id: string, name: string, email: string, dob?: number | null, address: { __typename?: 'Address', city?: string | null }, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string }> | null } | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, title: string, hasCourse: boolean }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GQLOrgPartnerSelectOrganizationPartnerFragment = { __typename?: 'OrganizationPartner', id: string, name: string };

export type GQLOrganizationPartnersForSelectQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLOrganizationPartnersForSelectQuery = { __typename?: 'Query', organizationPartners: { __typename?: 'OrganizationPartnerPaginatedList', edges: Array<{ __typename?: 'OrganizationPartnerEdge', node: { __typename?: 'OrganizationPartner', id: string, name: string } }> } };

export type GQLVoidRefundMutationVariables = Exact<{
  input: GQLVoidRefundInput;
}>;


export type GQLVoidRefundMutation = { __typename?: 'Mutation', purchaseLog: { __typename?: 'Refund', id: string } };

export type GQLDeleteStudentContractMutationVariables = Exact<{
  input: GQLDeleteStudentContractInput;
}>;


export type GQLDeleteStudentContractMutation = { __typename?: 'Mutation', deleteStudentContract: { __typename?: 'DeleteStudentContractResult', contractId: string, deletedUserFileId?: string | null, warning?: string | null } };

type GQLPurchaseItemForTable_PurchasePackage_Fragment = { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number };

type GQLPurchaseItemForTable_PurchaseProduct_Fragment = { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number };

export type GQLPurchaseItemForTableFragment =
  | GQLPurchaseItemForTable_PurchasePackage_Fragment
  | GQLPurchaseItemForTable_PurchaseProduct_Fragment
;

export type GQLPurchaseForTableFragment = { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
    | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
    | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
  > };

export type GQLStudentFundsBalanceForTableFragment = { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number };

export type GQLPurchaseOpForTableFragment = { __typename?: 'StudentPurchaseOp', id: string, operationType: GQLStudentOperationType, createdAt: number, studentContract?: { __typename?: 'StudentContract', id: string, dateOfSign?: string | null, filename?: string | null, paymentComplete?: boolean | null, generatedFile?: { __typename?: 'UserFile', id: string, label: string, url: string } | null } | null, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
      | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
      | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
    > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> };

export type GQLRefundOpForTableFragment = { __typename?: 'StudentRefundOp', id: string, operationType: GQLStudentOperationType, createdAt: number, refund: { __typename?: 'Refund', stripeChargeId?: string | null, stripeCustomerId?: string | null, categoryId: GQLPaymentCategories, amountToRefund: number, isVoid: boolean, voidedAt?: number | null, description: string, createdAt: number, itemsToRefund: Array<{ __typename?: 'ItemToRefund', itemId: string, productId: string, refundedQuantity: number, product: { __typename?: 'ProductInfo', name: string } }> } };

export type GQLPurchaseTransferOpForTableFragment = { __typename?: 'StudentPurchaseTransferOp', id: string, operationType: GQLStudentOperationType, createdAt: number, purchaseTransfer: { __typename?: 'PurchaseTransfer', description?: string | null, amountToTransfer: number, createdAt: number, itemsToTransfer: Array<{ __typename?: 'ItemToTransfer', itemId: string, productId: string, transferredQuantity: number, product: { __typename?: 'Product', name: string } }> }, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
      | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
      | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
    > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> };

export type GQLExpirationOpForTableFragment = { __typename?: 'StudentExpirationOp', id: string, operationType: GQLStudentOperationType, createdAt: number, expiration: { __typename?: 'Expiration', expirationType: GQLExpireProductsTypes, description: string, itemsToExpireByPurchase: Array<{ __typename?: 'ItemsToExpireByPurchase', purchaseId: string, itemsToExpire: Array<{ __typename?: 'ItemToExpire', itemId: string, productId: string, expiredQuantity: number, product: { __typename?: 'ProductInfo', id: string, name: string } }> }> } };

type GQLStudentOperationInfo_StudentExpirationOp_Fragment = { __typename?: 'StudentExpirationOp', id: string, operationType: GQLStudentOperationType, createdAt: number };

type GQLStudentOperationInfo_StudentPurchaseOp_Fragment = { __typename?: 'StudentPurchaseOp', id: string, operationType: GQLStudentOperationType, createdAt: number };

type GQLStudentOperationInfo_StudentPurchaseTransferOp_Fragment = { __typename?: 'StudentPurchaseTransferOp', id: string, operationType: GQLStudentOperationType, createdAt: number };

type GQLStudentOperationInfo_StudentRefundOp_Fragment = { __typename?: 'StudentRefundOp', id: string, operationType: GQLStudentOperationType, createdAt: number };

export type GQLStudentOperationInfoFragment =
  | GQLStudentOperationInfo_StudentExpirationOp_Fragment
  | GQLStudentOperationInfo_StudentPurchaseOp_Fragment
  | GQLStudentOperationInfo_StudentPurchaseTransferOp_Fragment
  | GQLStudentOperationInfo_StudentRefundOp_Fragment
;

type GQLPurchaseLogForTable_StudentExpirationOp_Fragment = { __typename?: 'StudentExpirationOp', id: string, operationType: GQLStudentOperationType, createdAt: number, expiration: { __typename?: 'Expiration', expirationType: GQLExpireProductsTypes, description: string, itemsToExpireByPurchase: Array<{ __typename?: 'ItemsToExpireByPurchase', purchaseId: string, itemsToExpire: Array<{ __typename?: 'ItemToExpire', itemId: string, productId: string, expiredQuantity: number, product: { __typename?: 'ProductInfo', id: string, name: string } }> }> } };

type GQLPurchaseLogForTable_StudentPurchaseOp_Fragment = { __typename?: 'StudentPurchaseOp', id: string, operationType: GQLStudentOperationType, createdAt: number, studentContract?: { __typename?: 'StudentContract', id: string, dateOfSign?: string | null, filename?: string | null, paymentComplete?: boolean | null, generatedFile?: { __typename?: 'UserFile', id: string, label: string, url: string } | null } | null, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
      | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
      | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
    > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> };

type GQLPurchaseLogForTable_StudentPurchaseTransferOp_Fragment = { __typename?: 'StudentPurchaseTransferOp', id: string, operationType: GQLStudentOperationType, createdAt: number, purchaseTransfer: { __typename?: 'PurchaseTransfer', description?: string | null, amountToTransfer: number, createdAt: number, itemsToTransfer: Array<{ __typename?: 'ItemToTransfer', itemId: string, productId: string, transferredQuantity: number, product: { __typename?: 'Product', name: string } }> }, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
      | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
      | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
    > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> };

type GQLPurchaseLogForTable_StudentRefundOp_Fragment = { __typename?: 'StudentRefundOp', id: string, operationType: GQLStudentOperationType, createdAt: number, refund: { __typename?: 'Refund', stripeChargeId?: string | null, stripeCustomerId?: string | null, categoryId: GQLPaymentCategories, amountToRefund: number, isVoid: boolean, voidedAt?: number | null, description: string, createdAt: number, itemsToRefund: Array<{ __typename?: 'ItemToRefund', itemId: string, productId: string, refundedQuantity: number, product: { __typename?: 'ProductInfo', name: string } }> } };

export type GQLPurchaseLogForTableFragment =
  | GQLPurchaseLogForTable_StudentExpirationOp_Fragment
  | GQLPurchaseLogForTable_StudentPurchaseOp_Fragment
  | GQLPurchaseLogForTable_StudentPurchaseTransferOp_Fragment
  | GQLPurchaseLogForTable_StudentRefundOp_Fragment
;

export type GQLGetPurchaseLogForTableQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetPurchaseLogForTableQuery = { __typename?: 'Query', studentOperations: { __typename?: 'StudentOperationsPaginatedResult', totalCount: number, edges: Array<{ __typename?: 'StudentOperationEdge', node:
        | { __typename?: 'StudentExpirationOp', id: string, operationType: GQLStudentOperationType, createdAt: number, expiration: { __typename?: 'Expiration', expirationType: GQLExpireProductsTypes, description: string, itemsToExpireByPurchase: Array<{ __typename?: 'ItemsToExpireByPurchase', purchaseId: string, itemsToExpire: Array<{ __typename?: 'ItemToExpire', itemId: string, productId: string, expiredQuantity: number, product: { __typename?: 'ProductInfo', id: string, name: string } }> }> } }
        | { __typename?: 'StudentPurchaseOp', id: string, operationType: GQLStudentOperationType, createdAt: number, studentContract?: { __typename?: 'StudentContract', id: string, dateOfSign?: string | null, filename?: string | null, paymentComplete?: boolean | null, generatedFile?: { __typename?: 'UserFile', id: string, label: string, url: string } | null } | null, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
              | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
              | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
            > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> }
        | { __typename?: 'StudentPurchaseTransferOp', id: string, operationType: GQLStudentOperationType, createdAt: number, purchaseTransfer: { __typename?: 'PurchaseTransfer', description?: string | null, amountToTransfer: number, createdAt: number, itemsToTransfer: Array<{ __typename?: 'ItemToTransfer', itemId: string, productId: string, transferredQuantity: number, product: { __typename?: 'Product', name: string } }> }, purchase: { __typename?: 'Purchase', id: string, categoryId: GQLPaymentCategories, usStateId: GQLUsStateId, stripeChargeId?: string | null, stripeCustomerId?: string | null, stripePaymentMethodType?: string | null, amountDollars: number, couponCode?: string | null, couponDiscount?: number | null, isVoid: boolean, voidedAt?: number | null, description: string, acquisitionId?: string | null, acquisitionName?: string | null, organizationPartnerId?: string | null, organizationPartnerName?: string | null, organizationPartnerExpiresAt?: string | null, createdAt: number, items: Array<
              | { __typename?: 'PurchasePackage', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, priceDollars: number }
              | { __typename?: 'PurchaseProduct', path: Array<string>, type: GQLProductType, itemId: string, productId: string, name: string, quantity: number, basePriceDollars: number }
            > }, fundsBalance: { __typename?: 'FundsBalance', availableCents: number, paidCents: number, receivedCents: number, refundedCents: number, sentCents: number }, productBalancedQuantity: Array<{ __typename?: 'ProductBalancedQuantity', productId: string, balancedQuantity: { __typename?: 'BalancedQuantity', purchasedQuantity: number, receivedQuantity: number, availableQuantity: number } }>, itemBalancedQuantity: Array<{ __typename?: 'ItemBalancedQuantity', itemId: string, balancedQuantity: { __typename?: 'BalancedQuantity', availableQuantity: number } }> }
        | { __typename?: 'StudentRefundOp', id: string, operationType: GQLStudentOperationType, createdAt: number, refund: { __typename?: 'Refund', stripeChargeId?: string | null, stripeCustomerId?: string | null, categoryId: GQLPaymentCategories, amountToRefund: number, isVoid: boolean, voidedAt?: number | null, description: string, createdAt: number, itemsToRefund: Array<{ __typename?: 'ItemToRefund', itemId: string, productId: string, refundedQuantity: number, product: { __typename?: 'ProductInfo', name: string } }> } }
       }> } };

export type GQLSharedLessonStudentDetailsFragment = { __typename?: 'LessonStudentDetails', studentId: string, drivingMinutes: number, observationMinutes: number };

export type GQLSharedLessonViewFragment = { __typename?: 'SharedLesson', lesson: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, durationMinutes: number, meetingPointId?: string | null, locationId?: string | null, isShareable: boolean, pickupLocation: string, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, drivingMinutes: number, observationMinutes: number }> }, eligibleStudents: Array<{ __typename?: 'EligibleStudent', userId: string, displayName: string, distanceMeters: number, dob?: number | null, email: string, phone?: string | null, drivingMinutesRemaining: number, observationMinutesRemaining: number, licenseExpirationDate?: number | null, licenseIssueDate?: number | null, licenseNumber?: string | null, tags?: Array<string> | null }> };

export type GQLGetSharedLessonsQueryVariables = Exact<{
  sharedLessonsQuery: GQLSharedLessonsQuery;
}>;


export type GQLGetSharedLessonsQuery = { __typename?: 'Query', sharedLessons: Array<{ __typename?: 'SharedLesson', lesson: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, durationMinutes: number, meetingPointId?: string | null, locationId?: string | null, isShareable: boolean, pickupLocation: string, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, drivingMinutes: number, observationMinutes: number }> }, eligibleStudents: Array<{ __typename?: 'EligibleStudent', userId: string, displayName: string, distanceMeters: number, dob?: number | null, email: string, phone?: string | null, drivingMinutesRemaining: number, observationMinutesRemaining: number, licenseExpirationDate?: number | null, licenseIssueDate?: number | null, licenseNumber?: string | null, tags?: Array<string> | null }> }> };

export type GQLProgressRequirementsFragment = { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean };

export type GQLLicensingProgressDocumentFragment = { __typename?: 'LicensingRequiredDocument', documentId: string, label: string, isUploaded: boolean, uploadedAt?: number | null };

export type GQLUsedReferralCodeForStudentAccountDetailsFragment = { __typename?: 'UsedReferralCode', referralCode: string, fullReferralCode: string, timestamp: number, fulfillmentStatus: string };

export type GQLLicensingProgressForStudentAccountDetailsFragment = { __typename?: 'LicensingProgress', state?: GQLUsStateId | null, hasRequirementsConfig: boolean, eligibilityDate?: number | null, isEligibilityDateReached: boolean, courseStatus: GQLLicensingCourseStatus, requiredDocumentsComplete: boolean, isReadyForAdminReview: boolean, canBookRoadTest: boolean, requirements?: { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean } | null, documents: Array<{ __typename?: 'LicensingRequiredDocument', documentId: string, label: string, isUploaded: boolean, uploadedAt?: number | null }> };

export type GQLStudentLicensingProgressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLStudentLicensingProgressQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, licensingProgress?: { __typename?: 'LicensingProgress', state?: GQLUsStateId | null, hasRequirementsConfig: boolean, eligibilityDate?: number | null, isEligibilityDateReached: boolean, courseStatus: GQLLicensingCourseStatus, requiredDocumentsComplete: boolean, isReadyForAdminReview: boolean, canBookRoadTest: boolean, requirements?: { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean } | null, documents: Array<{ __typename?: 'LicensingRequiredDocument', documentId: string, label: string, isUploaded: boolean, uploadedAt?: number | null }> } | null } | null };

export type GQLGetStudentReferralInfoQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentReferralInfoQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, usedReferralCode?: { __typename?: 'UsedReferralCode', referralCode: string, fullReferralCode: string, timestamp: number, fulfillmentStatus: string } | null } | null };

export type GQLUserAuthInfoForAccountDetailsFragment = { __typename?: 'UserAuthInfo', email?: string | null, createdAt: number, lastLoginAt?: number | null, providerId?: string | null, mfaFactors: Array<{ __typename?: 'UserMfaFactor', factorId?: string | null, displayName?: string | null, phoneNumber?: string | null }> };

export type GQLGetUserAuthInfoQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLGetUserAuthInfoQuery = { __typename?: 'Query', userAuthInfo: { __typename?: 'UserAuthInfo', email?: string | null, createdAt: number, lastLoginAt?: number | null, providerId?: string | null, mfaFactors: Array<{ __typename?: 'UserMfaFactor', factorId?: string | null, displayName?: string | null, phoneNumber?: string | null }> } };

export type GQLResetUserMfaMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLResetUserMfaMutation = { __typename?: 'Mutation', resetUserMFA: boolean };

export type GQLUpdateStudentRoadTestEligibilityMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentRoadTestEligibilityMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, licensingProgress?: { __typename?: 'LicensingProgress', canBookRoadTest: boolean, roadTestApprovedById?: string | null } | null } };

export type GQLStudentLegalAndPermissionsAggregatedForAccountFragment = { __typename?: 'StudentLegalAndPermissionsSummary', contractStatus: GQLStudentContractStatus, transferStatus: GQLStudentTransferStatus, transferType?: GQLStudentTransferType | null, privateApproved: boolean };

export type GQLGetStudentLegalAndPermissionsAggregatedQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentLegalAndPermissionsAggregatedQuery = { __typename?: 'Query', studentLegalAndPermissionsAggregated?: { __typename?: 'StudentLegalAndPermissionsSummary', contractStatus: GQLStudentContractStatus, transferStatus: GQLStudentTransferStatus, transferType?: GQLStudentTransferType | null, privateApproved: boolean } | null };

export type GQLProgressRequirementsFragmentFragment = { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean };

export type GQLProgramDeadlineFragmentFragment = { __typename?: 'ProgramDeadline', type?: string | null, status: GQLProgramDeadlineStatus, deadlineDate?: string | null, daysRemaining?: number | null, requirements?: { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean } | null };

export type GQLStudentProgramDeadlineQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLStudentProgramDeadlineQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, programDeadline?: { __typename?: 'ProgramDeadline', type?: string | null, status: GQLProgramDeadlineStatus, deadlineDate?: string | null, daysRemaining?: number | null, requirements?: { __typename?: 'ProgramDeadlineRequirements', drivingMinutesRequired?: number | null, drivingMinutesCompleted: number, drivingComplete: boolean, observationMinutesRequired?: number | null, observationMinutesCompleted: number, observationComplete: boolean, requiresCourseCompletion: boolean, courseCompleted: boolean } | null } | null } | null };

export type GQLStudentAutocompleteSearchResultFragment = { __typename?: 'StudentSearchResult', id: string, name: string, email?: string | null, altEmail?: string | null, altName?: string | null, phone?: string | null, altPhone?: string | null, signupTimestamp?: number | null, isMigrated?: boolean | null, isDeleted?: boolean | null };

export type GQLStudentAutocompleteSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type GQLStudentAutocompleteSearchQuery = { __typename?: 'Query', studentSearch: { __typename?: 'StudentSearchResultPaginatedList', edges: Array<{ __typename?: 'StudentSearchResultEdge', node: { __typename?: 'StudentSearchResult', id: string, name: string, email?: string | null, altEmail?: string | null, altName?: string | null, phone?: string | null, altPhone?: string | null, signupTimestamp?: number | null, isMigrated?: boolean | null, isDeleted?: boolean | null } }> } };

export type GQLPutStudentCertificateMutationVariables = Exact<{
  input: GQLStudentCertificateInput;
}>;


export type GQLPutStudentCertificateMutation = { __typename?: 'Mutation', putStudentCertificate: { __typename?: 'StudentCertificateNote', id: string } };

export type GQLCourseOrderShippingFragment = { __typename?: 'CourseOrder', id: string, courseId: string, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', timestamp: number } | null, address?: { __typename?: 'CourseOrderAddress', address: string, city: string, state: string, timestamp: number } | null, shipping?: { __typename?: 'CourseOrderShipping', isComplete: boolean, shippingDetails?: { __typename?: 'CourseOrderShippingDetails', amount: number, label: string } | null } | null };

export type GQLGetCourseOrdersQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetCourseOrdersQuery = { __typename?: 'Query', courseOrders: Array<{ __typename?: 'CourseOrder', id: string, courseId: string, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', timestamp: number } | null, address?: { __typename?: 'CourseOrderAddress', address: string, city: string, state: string, timestamp: number } | null, shipping?: { __typename?: 'CourseOrderShipping', isComplete: boolean, shippingDetails?: { __typename?: 'CourseOrderShippingDetails', amount: number, label: string } | null } | null }> };

export type GQLShippingOrderDataFragment = { __typename?: 'ShippingOrder', id: string, courseId?: string | null, isReOrder: boolean, createdAt?: number | null, shippingDetails: { __typename?: 'ShippingOrderShippingDetails', amount: number, label: string }, address: { __typename?: 'ShippingOrderAddress', address: string, city: string, state: string, zipcode: string } };

export type GQLGetShippingOrdersQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetShippingOrdersQuery = { __typename?: 'Query', shippingOrders: { __typename?: 'ShippingOrdersPaginatedList', edges: Array<{ __typename?: 'ShippingOrderEdge', node: { __typename?: 'ShippingOrder', id: string, courseId?: string | null, isReOrder: boolean, createdAt?: number | null, shippingDetails: { __typename?: 'ShippingOrderShippingDetails', amount: number, label: string }, address: { __typename?: 'ShippingOrderAddress', address: string, city: string, state: string, zipcode: string } } }> } };

export type GQLLessonForTableFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, isShareable: boolean, pickupLocation: string, meetingPointId?: string | null, hasHomePickup: boolean, durationMinutes: number, actualDurationMinutes?: number | null, isCancelled: boolean, instructor: { __typename?: 'Instructor', id: string, timeZone: string, name: string }, studentDetails: { __typename?: 'LessonStudentDetails', hasSentReportToStudent: boolean, drivingMinutes: number, observationMinutes: number } };

export type GQLListLessonsForTableQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  observationMinuteProductId: Scalars['ID']['input'];
}>;


export type GQLListLessonsForTableQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', totalCount: number, edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, isShareable: boolean, pickupLocation: string, meetingPointId?: string | null, hasHomePickup: boolean, durationMinutes: number, actualDurationMinutes?: number | null, isCancelled: boolean, instructor: { __typename?: 'Instructor', id: string, timeZone: string, name: string }, studentDetails: { __typename?: 'LessonStudentDetails', hasSentReportToStudent: boolean, drivingMinutes: number, observationMinutes: number } } }> } };

export type GQLPutStudentNoteMutationVariables = Exact<{
  input: GQLNoteInput;
}>;


export type GQLPutStudentNoteMutation = { __typename?: 'Mutation', putNote: { __typename?: 'Note', id: string } };

export type GQLStudentNoteTableFieldsFragment = { __typename?: 'Note', id: string, userId: string, text: string, format: GQLNoteFormat, createdById: string, createdAt: number, isHiddenFromInstructorView: boolean, isPinned: boolean, isArchived: boolean, createdBy: { __typename?: 'Person', id: string, name: string } };

export type GQLStudentCertificateTableFieldsFragment = { __typename?: 'StudentCertificateNote', id: string, userId: string, text: string, createdById: string, createdAt: number, isHiddenFromInstructorView: boolean, isPinned: boolean, isArchived: boolean, certType: string, certNumber: string, certIssuanceDate: string, deliveryMethod?: string | null, state?: string | null, createdBy: { __typename?: 'Person', id: string, name: string } };

export type GQLStudentNotesTableQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLStudentNotesTableQuery = { __typename?: 'Query', studentNotesAndCertificates: { __typename?: 'StudentNotesAndCertificates', notes: Array<{ __typename?: 'Note', id: string, userId: string, text: string, format: GQLNoteFormat, createdById: string, createdAt: number, isHiddenFromInstructorView: boolean, isPinned: boolean, isArchived: boolean, createdBy: { __typename?: 'Person', id: string, name: string } }>, certificates: Array<{ __typename?: 'StudentCertificateNote', id: string, userId: string, text: string, createdById: string, createdAt: number, isHiddenFromInstructorView: boolean, isPinned: boolean, isArchived: boolean, certType: string, certNumber: string, certIssuanceDate: string, deliveryMethod?: string | null, state?: string | null, createdBy: { __typename?: 'Person', id: string, name: string } }> } };

export type GQLMoveStudentNoteMutationVariables = Exact<{
  input: GQLMoveStudentNoteInput;
}>;


export type GQLMoveStudentNoteMutation = { __typename?: 'Mutation', moveStudentNote: string };

export type GQLMoveStudentCertificateMutationVariables = Exact<{
  input: GQLMoveStudentCertificateInput;
}>;


export type GQLMoveStudentCertificateMutation = { __typename?: 'Mutation', moveStudentCertificate: string };

export type GQLArchiveStudentNoteMutationVariables = Exact<{
  input: GQLArchiveStudentNoteInput;
}>;


export type GQLArchiveStudentNoteMutation = { __typename?: 'Mutation', archiveStudentNote: string };

export type GQLArchiveStudentCertificateMutationVariables = Exact<{
  input: GQLArchiveStudentCertificateInput;
}>;


export type GQLArchiveStudentCertificateMutation = { __typename?: 'Mutation', archiveStudentCertificate: string };

export type GQLStudentSummaryFragment = { __typename?: 'Student', id: string, name: string, email: string, tags?: Array<string> | null };

export type GQLSearchStudentsByTagsQueryVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLSearchStudentsByTagsQuery = { __typename?: 'Query', students: { __typename?: 'StudentsPaginatedList', totalCount: number, edges: Array<{ __typename?: 'StudentEdge', node: { __typename?: 'Student', id: string, name: string, email: string, tags?: Array<string> | null } }> } };

export type GQLTransientSlotDialogTransientSlotFragment = { __typename?: 'TransientSlot', id: string, updatedAt?: number | null, searchCity?: string | null, isReserved?: boolean | null, expiresAt?: number | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', displayName: string, timeZone: string }, reservedBy?: { __typename?: 'Person', name: string } | null, reservedFor?: { __typename?: 'Person', id: string, name: string } | null };

export type GQLTransientSlotDialogTransientSlotQueryQueryVariables = Exact<{
  slotId: Scalars['ID']['input'];
}>;


export type GQLTransientSlotDialogTransientSlotQueryQuery = { __typename?: 'Query', transientSlot: { __typename?: 'TransientSlot', id: string, updatedAt?: number | null, searchCity?: string | null, isReserved?: boolean | null, expiresAt?: number | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', displayName: string, timeZone: string }, reservedBy?: { __typename?: 'Person', name: string } | null, reservedFor?: { __typename?: 'Person', id: string, name: string } | null } };

export type GQLUserLogForTableFragment = { __typename?: 'UserLog', id: string, action: string, note?: string | null, timestamp?: number | null, type?: string | null, userId: string, lessonId?: string | null, lessonStartTime?: number | null, changesRaw?: any | null, changedBy?: { __typename?: 'Person', id: string, name: string } | null };

export type GQLUserLogTableQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GQLUserLogTableQuery = { __typename?: 'Query', userLogs?: { __typename?: 'UserLogsPaginatedList', edges: Array<{ __typename?: 'UserLogEdge', node: { __typename?: 'UserLog', id: string, action: string, note?: string | null, timestamp?: number | null, type?: string | null, userId: string, lessonId?: string | null, lessonStartTime?: number | null, changesRaw?: any | null, changedBy?: { __typename?: 'Person', id: string, name: string } | null } }> } | null };

export type GQLStudentCohortForExamFragment = { __typename?: 'Cohort', id: string, courseId: string, sessions?: Array<{ __typename?: 'CohortSession', id: string, startTime: number, endTime: number }> | null };

export type GQLCourseKnowledgeTestFlagFragment = { __typename?: 'OnlineCourseContent', id: string, isKnowledgeTest: boolean };

export type GQLFetchStudentCohortsForKnowledgeExamQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLFetchStudentCohortsForKnowledgeExamQuery = { __typename?: 'Query', cohortsForStudent: Array<{ __typename?: 'Cohort', id: string, courseId: string, sessions?: Array<{ __typename?: 'CohortSession', id: string, startTime: number, endTime: number }> | null }> };

export type GQLCheckIfKnowledgeTestCourseForDownloadQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLCheckIfKnowledgeTestCourseForDownloadQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', id: string, isKnowledgeTest: boolean } };

export type GQLAvailFieldsFragment = { __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxDurationMinutes?: number | null, locationAllowed: GQLLocationAllowed, fixedLocationId?: string | null, isFixedLocation: boolean, lessonTypes?: Array<string> | null, lessonCount?: number | null, center: { __typename?: 'Center', location: string }, vehicle?: { __typename?: 'Vehicle', id: string, number?: string | null } | null };

export type GQLGetAvailabilitiesQueryVariables = Exact<{
  query: GQLAvailabilitiesQuery;
}>;


export type GQLGetAvailabilitiesQuery = { __typename?: 'Query', availabilities: Array<{ __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxDurationMinutes?: number | null, locationAllowed: GQLLocationAllowed, fixedLocationId?: string | null, isFixedLocation: boolean, lessonTypes?: Array<string> | null, lessonCount?: number | null, center: { __typename?: 'Center', location: string }, vehicle?: { __typename?: 'Vehicle', id: string, number?: string | null } | null }> };

export type GQLBatchEditAvailsMutationVariables = Exact<{
  query: GQLBatchEditAvailsQuery;
  update: GQLBatchEditAvailsUpdate;
}>;


export type GQLBatchEditAvailsMutation = { __typename?: 'Mutation', batchEditAvails: { __typename?: 'BatchEditAvailsResult', updated: Array<{ __typename?: 'Availability', id: string }>, failed: Array<{ __typename?: 'AvailabilityUpdateFailure', availabilityId: string, error: string }> } };

export type GQLCreateRecurringAvailabilitiesMutationVariables = Exact<{
  input: GQLRecurringAvailabilityCreateInput;
}>;


export type GQLCreateRecurringAvailabilitiesMutation = { __typename?: 'Mutation', createRecurringAvailabilities: { __typename?: 'BatchAddAvailsResult', added: Array<{ __typename?: 'Availability', id: string }>, failed: Array<{ __typename?: 'AvailabilityAddFailure', date?: string | null, error: string }> } };

export type GQLInstructorCustomIsochroneFeatureFragment = { __typename?: 'GeoJsonFeatureCollectionFeature', id: string, type: string, properties: any, geometry: { __typename?: 'GeoJsonGeometry', type: string, coordinates: Array<Array<Array<number>>> } };

export type GQLInstructorCustomIsochroneFragment = { __typename?: 'GeoJsonFeatureCollection', type: string, features: Array<{ __typename?: 'GeoJsonFeatureCollectionFeature', id: string, type: string, properties: any, geometry: { __typename?: 'GeoJsonGeometry', type: string, coordinates: Array<Array<Array<number>>> } }> };

export type GQLInstructorCustomIsochroneQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLInstructorCustomIsochroneQuery = { __typename?: 'Query', instructorCustomIsochrone?: { __typename?: 'GeoJsonFeatureCollection', type: string, features: Array<{ __typename?: 'GeoJsonFeatureCollectionFeature', id: string, type: string, properties: any, geometry: { __typename?: 'GeoJsonGeometry', type: string, coordinates: Array<Array<Array<number>>> } }> } | null };

export type GQLSetInstructorCustomIsochroneMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  geoJson: Scalars['JSONObject']['input'];
}>;


export type GQLSetInstructorCustomIsochroneMutation = { __typename?: 'Mutation', setInstructorCustomIsochrone: boolean };

export type GQLDeleteInstructorCustomIsochroneMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLDeleteInstructorCustomIsochroneMutation = { __typename?: 'Mutation', deleteInstructorCustomIsochrone: boolean };

export type GQLInstructorAlertFieldsFragment = { __typename?: 'InstructorAlert', id: string, message: string, severity: GQLInstructorAlertSeverity, timestamp: number, readMoreLink?: string | null };

export type GQLInstructorAlertsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLInstructorAlertsForUserQuery = { __typename?: 'Query', instructorAlertsForUser: Array<{ __typename?: 'InstructorAlert', id: string, message: string, severity: GQLInstructorAlertSeverity, timestamp: number, readMoreLink?: string | null }> };

export type GQLDismissInstructorAlertMutationVariables = Exact<{
  alertId: Scalars['ID']['input'];
}>;


export type GQLDismissInstructorAlertMutation = { __typename?: 'Mutation', dismissInstructorAlert: boolean };

export type GQLInstructorBadgeFieldsFragment = { __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon };

export type GQLInstructorBadgesForInstructorQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLInstructorBadgesForInstructorQuery = { __typename?: 'Query', instructorBadges: Array<{ __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon }> };

export type GQLUpdateInstructorBadgesMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  badges?: InputMaybe<Array<GQLInstructorBadgeInput> | GQLInstructorBadgeInput>;
}>;


export type GQLUpdateInstructorBadgesMutation = { __typename?: 'Mutation', updateInstructor: { __typename?: 'Instructor', id: string } };

export type GQLAddInstructorBioMutationVariables = Exact<{
  input: GQLNewInstructorInput;
}>;


export type GQLAddInstructorBioMutation = { __typename?: 'Mutation', addInstructor: { __typename?: 'Instructor', id: string } };

export type GQLUpdateInstructorBioMutationVariables = Exact<{
  query: GQLUpdateInstructorQuery;
  input: GQLUpdateInstructorInput;
}>;


export type GQLUpdateInstructorBioMutation = { __typename?: 'Mutation', updateInstructor: { __typename?: 'Instructor', id: string } };

export type GQLInstructorLessonNotificationRegistrationViewFragment = { __typename?: 'LessonNotificationRegistrationForInstructor', id: string, lessonType: string, milesDistanceFrom?: number | null, durationMinutes: number, meetingPoint?: string | null, isHidden: boolean, timeZone: string, openings: Array<{ __typename?: 'LessonNotificationRegistrationOpening', startDate: number, endDate: number }> };

export type GQLGetInstructorLessonNotificationRegistrationsQueryVariables = Exact<{
  query: GQLInstructorLessonNotificationRegistrationsQuery;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetInstructorLessonNotificationRegistrationsQuery = { __typename?: 'Query', response: { __typename?: 'InstructorLessonNotificationRegistrationsResponse', from: number, to: number, registrations: Array<{ __typename?: 'LessonNotificationRegistrationForInstructor', id: string, lessonType: string, milesDistanceFrom?: number | null, durationMinutes: number, meetingPoint?: string | null, isHidden: boolean, timeZone: string, openings: Array<{ __typename?: 'LessonNotificationRegistrationOpening', startDate: number, endDate: number }> }> } };

export type GQLSetInstructorLessonNotificationVisibilityMutationVariables = Exact<{
  query: GQLSetInstructorLessonNotificationVisibilityInput;
}>;


export type GQLSetInstructorLessonNotificationVisibilityMutation = { __typename?: 'Mutation', result: boolean };

export type GQLTimeOffForCalendarFragment = { __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string };

export type GQLInstructorScheduleFragment = { __typename?: 'InstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength?: number | null, isApproved: boolean, daysPerWeek: number, updatedAt: number, instructorName?: string | null, managerName?: string | null, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null };

export type GQLGetInstructorsSchedulesQueryVariables = Exact<{
  query: GQLInstructorsSchedulesQuery;
}>;


export type GQLGetInstructorsSchedulesQuery = { __typename?: 'Query', instructorsSchedules: Array<{ __typename?: 'InstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength?: number | null, isApproved: boolean, daysPerWeek: number, updatedAt: number, instructorName?: string | null, managerName?: string | null, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null }> };

export type GQLApprovedInstructorScheduleFragment = { __typename?: 'ApprovedInstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength: number, daysPerWeek: number, updatedAt: number, scheduleRequestId: string, instructorName?: string | null, managerName?: string | null, lastAvailabilityDate?: string | null, status: GQLScheduleStatus, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null, mostRecentRequest?: { __typename?: 'InstructorSchedule', id: string, startDate: string, createdAt: number } | null };

export type GQLGetInstructorsApprovedSchedulesQueryVariables = Exact<{
  query: GQLApprovedInstructorsSchedulesQuery;
}>;


export type GQLGetInstructorsApprovedSchedulesQuery = { __typename?: 'Query', approvedInstructorsSchedules: Array<{ __typename?: 'ApprovedInstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength: number, daysPerWeek: number, updatedAt: number, scheduleRequestId: string, instructorName?: string | null, managerName?: string | null, lastAvailabilityDate?: string | null, status: GQLScheduleStatus, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null, mostRecentRequest?: { __typename?: 'InstructorSchedule', id: string, startDate: string, createdAt: number } | null }> };

export type GQLGetInstructorScheduleQueryVariables = Exact<{
  query: GQLInstructorScheduleQuery;
}>;


export type GQLGetInstructorScheduleQuery = { __typename?: 'Query', instructorSchedule: { __typename?: 'InstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength?: number | null, isApproved: boolean, daysPerWeek: number, updatedAt: number, instructorName?: string | null, managerName?: string | null, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null } };

export type GQLGetCurrentApprovedScheduleQueryVariables = Exact<{
  query: GQLApprovedInstructorsSchedulesQuery;
}>;


export type GQLGetCurrentApprovedScheduleQuery = { __typename?: 'Query', approvedInstructorsSchedules: Array<{ __typename?: 'ApprovedInstructorSchedule', id: string, daysPerWeek: number, startDate: string, endDate?: string | null, rollingWeekLength: number, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }> }> };

export type GQLRemoveElevatedAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLRemoveElevatedAccessMutation = { __typename?: 'Mutation', removeElevatedAccess: boolean };

export type GQLSpokenLanguageOptionFragment = { __typename?: 'LanguageOption', code: string, label: string };

export type GQLGetSpokenLanguageOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetSpokenLanguageOptionsQuery = { __typename?: 'Query', languageOptions: Array<{ __typename?: 'LanguageOption', code: string, label: string }> };

export type GQLTeachingZonePreviewQueryVariables = Exact<{
  query: GQLInstructorTeachingZonePreviewQuery;
}>;


export type GQLTeachingZonePreviewQuery = { __typename?: 'Query', instructorTeachingZonePreview: { __typename?: 'InstructorTeachingZonePreview', isStatic: boolean, geoJson: any } };

export type GQLTimeLogFormFragmentFragment = { __typename?: 'InstructorTimeLog', id: string, instructorId: string, description?: string | null, duration: number, startTime: number, endTime: number, rateType: string, logType: GQLInstructorTimeLogType };

export type GQLGetInstructorTimeLogQueryVariables = Exact<{
  query: GQLInstructorTimeLogQuery;
}>;


export type GQLGetInstructorTimeLogQuery = { __typename?: 'Query', instructorTimeLog: { __typename?: 'InstructorTimeLog', id: string, instructorId: string, description?: string | null, duration: number, startTime: number, endTime: number, rateType: string, logType: GQLInstructorTimeLogType } };

export type GQLDeleteInstructorTimeLogMutationVariables = Exact<{
  query: GQLInstructorTimeLogQuery;
}>;


export type GQLDeleteInstructorTimeLogMutation = { __typename?: 'Mutation', deleteInstructorTimeLog: string };

export type GQLCreateInstructorTimeLogMutationVariables = Exact<{
  input: GQLInstructorTimeLogCreateInput;
}>;


export type GQLCreateInstructorTimeLogMutation = { __typename?: 'Mutation', createInstructorTimeLog: { __typename?: 'InstructorTimeLog', id: string, instructorId: string, description?: string | null, duration: number, startTime: number, endTime: number, rateType: string, logType: GQLInstructorTimeLogType } };

export type GQLUpdateInstructorTimeLogMutationVariables = Exact<{
  query: GQLInstructorTimeLogQuery;
  input: GQLInstructorTimeLogUpdateInput;
}>;


export type GQLUpdateInstructorTimeLogMutation = { __typename?: 'Mutation', updateInstructorTimeLog: { __typename?: 'InstructorTimeLog', id: string, instructorId: string, description?: string | null, duration: number, startTime: number, endTime: number, rateType: string, logType: GQLInstructorTimeLogType } };

export type GQLCreateTimeOffMutationVariables = Exact<{
  input: GQLCreateInstructorTimeOffInput;
}>;


export type GQLCreateTimeOffMutation = { __typename?: 'Mutation', createTimeOffAndRemoveAvailability: { __typename?: 'CreateTimeOffResult', timeOffId: string, removedAvailabilityIds: Array<string> } };

export type GQLTimeOffFragment = { __typename?: 'InstructorTimeOff', id: string, instructorId: string, createdAt: number, startDate: string, endDate: string, updatedAt: number };

export type GQLGetInstructorTimeOffQueryVariables = Exact<{
  query: GQLInstructorTimeOffQuery;
}>;


export type GQLGetInstructorTimeOffQuery = { __typename?: 'Query', instructorTimeOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, createdAt: number, startDate: string, endDate: string, updatedAt: number }> | null };

export type GQLDeleteTimeOffMutationVariables = Exact<{
  query: GQLInstructorMutationTimeOffQuery;
}>;


export type GQLDeleteTimeOffMutation = { __typename?: 'Mutation', deleteTimeOff?: string | null };

export type GQLTodayNextVehicleFragment = { __typename?: 'Vehicle', number?: string | null, make?: string | null, model?: string | null, color?: string | null, plate?: string | null };

export type GQLTodayNextInstructorEventFragment = { __typename?: 'InstructorEvent', startTime: number, endTime: number, activity: string, type: GQLInstructorEventType, travelTime?: number | null, travelDistance?: number | null, estTravelTime?: number | null, estTravelDistance?: number | null, teachingTime?: number | null, otherTime?: number | null, lessonId?: string | null, timeLogId?: string | null, breakStartTime?: number | null, breakEndTime?: number | null, teachingRateTime?: number | null, nonTeachingRateTime?: number | null, otherRateTime?: number | null, lessonTypeName?: string | null, lessonTypeDurationMinutes?: number | null, cohortName?: string | null, cohortSessionIds?: Array<string> | null, cohortSessionName?: string | null };

export type GQLTodayNextDayEventsFragment = { __typename?: 'DayEvents', dateStr: string, hasAvail: boolean, locationString?: string | null, hasOverlappingEvents: boolean, isMissingRequiredMealBreak: boolean, vehicle?: { __typename?: 'Vehicle', number?: string | null, make?: string | null, model?: string | null, color?: string | null, plate?: string | null } | null, events: Array<{ __typename?: 'InstructorEvent', startTime: number, endTime: number, activity: string, type: GQLInstructorEventType, travelTime?: number | null, travelDistance?: number | null, estTravelTime?: number | null, estTravelDistance?: number | null, teachingTime?: number | null, otherTime?: number | null, lessonId?: string | null, timeLogId?: string | null, breakStartTime?: number | null, breakEndTime?: number | null, teachingRateTime?: number | null, nonTeachingRateTime?: number | null, otherRateTime?: number | null, lessonTypeName?: string | null, lessonTypeDurationMinutes?: number | null, cohortName?: string | null, cohortSessionIds?: Array<string> | null, cohortSessionName?: string | null }> };

export type GQLGetInstructorEventsQueryVariables = Exact<{
  input: GQLInstructorEventsInput;
}>;


export type GQLGetInstructorEventsQuery = { __typename?: 'Query', instructorEvents: { __typename?: 'InstructorEventsResponse', eventsByDay: Array<{ __typename?: 'DayEvents', dateStr: string, hasAvail: boolean, locationString?: string | null, hasOverlappingEvents: boolean, isMissingRequiredMealBreak: boolean, vehicle?: { __typename?: 'Vehicle', number?: string | null, make?: string | null, model?: string | null, color?: string | null, plate?: string | null } | null, events: Array<{ __typename?: 'InstructorEvent', startTime: number, endTime: number, activity: string, type: GQLInstructorEventType, travelTime?: number | null, travelDistance?: number | null, estTravelTime?: number | null, estTravelDistance?: number | null, teachingTime?: number | null, otherTime?: number | null, lessonId?: string | null, timeLogId?: string | null, breakStartTime?: number | null, breakEndTime?: number | null, teachingRateTime?: number | null, nonTeachingRateTime?: number | null, otherRateTime?: number | null, lessonTypeName?: string | null, lessonTypeDurationMinutes?: number | null, cohortName?: string | null, cohortSessionIds?: Array<string> | null, cohortSessionName?: string | null }> }> } };

export type GQLAdminRecentHistorySectionItemFragment = { __typename?: 'AdminRecentHistoryItem', id: string, name: string, timestamp: number };

export type GQLStudentProfileHistoryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLStudentProfileHistoryQueryQuery = { __typename?: 'Query', adminStudentHistory: Array<{ __typename?: 'AdminRecentHistoryItem', id: string, name: string, timestamp: number }> };

export type GQLInstructorProfileHistoryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLInstructorProfileHistoryQueryQuery = { __typename?: 'Query', adminInstructorHistory: Array<{ __typename?: 'AdminRecentHistoryItem', id: string, name: string, timestamp: number }> };

export type GQLGetAnvilCastQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GQLGetAnvilCastQuery = { __typename?: 'Query', cast: { __typename?: 'Cast', id: string, name: string, title?: string | null, exampleData?: any | null, fieldInfo: Array<{ __typename?: 'FieldInfo', id: string, name: string, type: string, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null, styles?: { __typename?: 'FieldStyles', required?: boolean | null, disabled?: boolean | null, helperText?: string | null } | null }> } };

export type GQLGetStudentForAnvilQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentForAnvilQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, dob?: number | null, controlNumber?: string | null, address: { __typename?: 'Address', address?: string | null, phone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } } | null };

export type GQLUploadAnvilDocumentMutationMutationVariables = Exact<{
  input: GQLUploadUserFileInput;
}>;


export type GQLUploadAnvilDocumentMutationMutation = { __typename?: 'Mutation', uploadUserFile: { __typename?: 'UserFile', id: string } };

export type GQLCalendarHolidayFragmentFragment = { __typename?: 'CalendarHoliday', id: string, date: string, title: string, disallowAvails: boolean };

export type GQLGetCalendarHolidaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetCalendarHolidaysQuery = { __typename?: 'Query', calendarHolidays: Array<{ __typename?: 'CalendarHoliday', id: string, date: string, title: string, disallowAvails: boolean }> };

export type GQLCanceledLogPersonFragment = { __typename?: 'Person', id: string, name: string };

export type GQLCanceledLogInstructorFragment = { __typename?: 'Instructor', id: string, name: string, timeZone: string };

export type GQLCanceledLogEntryFragment = { __typename?: 'CancelLogEntry', id: string, userId: string, changedById?: string | null, timestamp: number, initiatedBy?: GQLInitiatedBy | null, note?: string | null, lessonStartTime: number, user?: { __typename?: 'Person', id: string, name: string } | null, changedBy?: { __typename?: 'Person', id: string, name: string } | null, instructor?: { __typename?: 'Instructor', id: string, name: string, timeZone: string } | null };

export type GQLGetCanceledLogsQueryVariables = Exact<{
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;


export type GQLGetCanceledLogsQuery = { __typename?: 'Query', cancelLogs: Array<{ __typename?: 'CancelLogEntry', id: string, userId: string, changedById?: string | null, timestamp: number, initiatedBy?: GQLInitiatedBy | null, note?: string | null, lessonStartTime: number, user?: { __typename?: 'Person', id: string, name: string } | null, changedBy?: { __typename?: 'Person', id: string, name: string } | null, instructor?: { __typename?: 'Instructor', id: string, name: string, timeZone: string } | null }> };

export type GQLUpdateCancelLogMutationVariables = Exact<{
  input: GQLUpdateCancelLogInput;
}>;


export type GQLUpdateCancelLogMutation = { __typename?: 'Mutation', updateCancelLog: { __typename?: 'CancelLogEntry', id: string } };

export type GQLCohortSessionDetailsFragment = { __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null };

export type GQLCohortDetailsFragment = { __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, allowMakeupRequests: boolean, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null, sessions?: Array<{ __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null }> | null };

export type GQLCohortReportStudentFragment = { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, email: string, billingEmail?: string | null, billingName?: string | null, dob?: number | null, licenseNumber?: string | null, address: { __typename?: 'Address', id: string, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, secondaryPhone?: string | null } };

export type GQLSaveCohortMutationVariables = Exact<{
  input: GQLCohortInput;
}>;


export type GQLSaveCohortMutation = { __typename?: 'Mutation', saveCohort: { __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, allowMakeupRequests: boolean, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null, sessions?: Array<{ __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null }> | null } };

export type GQLFetchCohortQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLFetchCohortQuery = { __typename?: 'Query', cohort: { __typename?: 'Cohort', enrolledUserIds: Array<string>, id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, allowMakeupRequests: boolean, students?: Array<{ __typename?: 'StudentObject', id: string, name: string, email: string, parentEmail?: string | null, parentName?: string | null, licenseNumber?: string | null, accommodation?: { __typename?: 'Accommodation', id: string, accommodationFor: GQLAccommodationFor, request: string, createdAt: number, updatedAt: number, studentId: string } | null }> | null, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null, sessions?: Array<{ __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null }> | null } };

export type GQLCohortEmailSendLogDetailsFragment = { __typename?: 'CohortEmailSendLog', id: string, templateName: string, sentByName?: string | null, recipientCount: number, createdAt: number };

export type GQLGetCohortEmailSendLogsQueryVariables = Exact<{
  cohortId: Scalars['ID']['input'];
}>;


export type GQLGetCohortEmailSendLogsQuery = { __typename?: 'Query', cohortEmailSendLogs: Array<{ __typename?: 'CohortEmailSendLog', id: string, templateName: string, sentByName?: string | null, recipientCount: number, createdAt: number }> };

export type GQLUnenrollStudentFromCohortMutationVariables = Exact<{
  input: GQLUnenrollStudentFromCohortInput;
}>;


export type GQLUnenrollStudentFromCohortMutation = { __typename?: 'Mutation', unenrollStudentFromCohort: boolean };

export type GQLUpdateStudentsSessionAttendanceMutationVariables = Exact<{
  input: GQLUpdateStudentsSessionAttendanceInput;
}>;


export type GQLUpdateStudentsSessionAttendanceMutation = { __typename?: 'Mutation', updateStudentsSessionAttendance: boolean };

export type GQLFetchCohortsForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchCohortsForStudentQuery = { __typename?: 'Query', cohortsForStudent: Array<{ __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null, sessions?: Array<{ __typename?: 'CohortSession', id: string, name: string, startTime: number, endTime: number, attendance: Array<{ __typename?: 'StudentSessionAttendance', attendance: GQLAttendance }> }> | null }> };

export type GQLArchiveCohortSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLArchiveCohortSessionMutation = { __typename?: 'Mutation', archiveCohortSession: boolean };

export type GQLFetchCohortsWithSessionsQueryVariables = Exact<{
  doShowClosed?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchCohortsWithSessionsQuery = { __typename?: 'Query', cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, allowMakeupRequests: boolean, sessions?: Array<{ __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null }> | null, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null }> };

export type GQLGetCohortReportStudentsQueryVariables = Exact<{
  query?: InputMaybe<GQLStudentsQuery>;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetCohortReportStudentsQuery = { __typename?: 'Query', students: { __typename?: 'StudentsPaginatedList', edges: Array<{ __typename?: 'StudentEdge', node: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, email: string, billingEmail?: string | null, billingName?: string | null, dob?: number | null, licenseNumber?: string | null, address: { __typename?: 'Address', id: string, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, secondaryPhone?: string | null } } }> } };

export type GQLFetchCourseIsKnowledgeTestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLFetchCourseIsKnowledgeTestQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', isKnowledgeTest: boolean, id: string } };

export type GQLGetClassroomCoursesForDropdownQueryVariables = Exact<{
  limitToInstructorState?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GQLGetClassroomCoursesForDropdownQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'OnlineCourseContent', id: string, stateShortName: string, title: string, slug: string, locationId?: string | null, maxEnrollees?: number | null, isSingleSessionCohort: boolean }> };

export type GQLFetchCohortsPaginatedQueryVariables = Exact<{
  doShowClosed?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['ID']['input'];
  pageQuery: GQLPageQuery;
}>;


export type GQLFetchCohortsPaginatedQuery = { __typename?: 'Query', cohortsPaginated: { __typename?: 'PaginatedCohortsResponse', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CohortEdge', cursor: string, node: { __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, location: string, maxEnrollees: number, videoConferenceUrl?: string | null, courseId: string, numEnrolled: number, allowMakeupRequests: boolean, sessions?: Array<{ __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number, endTime: number, instructorId?: string | null, instructorName?: string | null, attendance?: Array<{ __typename?: 'StudentSessionAttendance', id: string, studentId: string, attendance: GQLAttendance, cohortSessionId: string, makeUpCohortId?: string | null, makeUpSessionId?: string | null }> | null }> | null, meetingPoint?: { __typename?: 'StateMeetingPoint', id: string, state: string, address: string, label: string } | null } }> } };

export type GQLDeleteCohortMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteCohortMutation = { __typename?: 'Mutation', archiveCohort: boolean };

export type GQLEnrollStudentToCohortMutationVariables = Exact<{
  input: GQLEnrollStudentToCohortInput;
}>;


export type GQLEnrollStudentToCohortMutation = { __typename?: 'Mutation', enrollStudentToCohort: boolean };

export type GQLClassGradesTableCourseFragment = { __typename?: 'OnlineCourseContent', lectureIds: Array<string>, topics: Array<{ __typename?: 'CourseTopic', lectures: Array<{ __typename?: 'CourseLecture', id: string, title: string }> }> };

export type GQLClassGradesTableTestFragment = { __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number };

export type GQLClassGradesTableStudentCourseGradesFragment = { __typename?: 'StudentCourseGrades', studentId: string, tests: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> };

export type GQLFetchCourseForGradesTableQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GQLFetchCourseForGradesTableQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', lectureIds: Array<string>, topics: Array<{ __typename?: 'CourseTopic', lectures: Array<{ __typename?: 'CourseLecture', id: string, title: string }> }> }, studentCourseGrades: Array<{ __typename?: 'StudentCourseGrades', studentId: string, tests: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> }> };

export type GQLMakeUpCohortSessionOptionFragment = { __typename?: 'CohortSession', id: string, name: string };

export type GQLMakeUpCohortOptionFragment = { __typename?: 'Cohort', id: string, name: string, sessions?: Array<{ __typename?: 'CohortSession', id: string, name: string }> | null };

export type GQLMakeUpCohortStateFragment = { __typename?: 'Cohort', id: string, state: GQLUsStateId };

export type GQLAddMakeUpSessionInformationMutationVariables = Exact<{
  input: GQLAddMakeUpSessionInformationInput;
}>;


export type GQLAddMakeUpSessionInformationMutation = { __typename?: 'Mutation', addMakeUpSessionInformation: boolean };

export type GQLFetchCohortsByStateQueryVariables = Exact<{
  state: GQLUsStateId;
  dateRange: GQLDateRange;
}>;


export type GQLFetchCohortsByStateQuery = { __typename?: 'Query', cohortsByState: Array<{ __typename?: 'Cohort', id: string, name: string, sessions?: Array<{ __typename?: 'CohortSession', id: string, name: string }> | null }> };

export type GQLFetchMakeUpCohortStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLFetchMakeUpCohortStateQuery = { __typename?: 'Query', cohort: { __typename?: 'Cohort', id: string, state: GQLUsStateId } };

export type GQLUpdateStudentSessionAttendanceMutationVariables = Exact<{
  input: GQLUpdateStudentSessionAttendanceInput;
}>;


export type GQLUpdateStudentSessionAttendanceMutation = { __typename?: 'Mutation', updateStudentSessionAttendance: boolean };

export type GQLSaveCohortSessionMutationVariables = Exact<{
  input: GQLCohortSessionInput;
}>;


export type GQLSaveCohortSessionMutation = { __typename?: 'Mutation', saveSession: { __typename?: 'CohortSession', id: string } };

export type GQLGetCourseCompletionDateQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseCompletionDateQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', courseCompletionDate?: number | null } | null };

export type GQLGetCourseRequiresNotarizedFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseRequiresNotarizedFormQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, requiresNotarizedForm?: boolean | null } };

export type GQLSetCourseNotaryStatusMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  hasCompletedNotary: Scalars['Boolean']['input'];
}>;


export type GQLSetCourseNotaryStatusMutation = { __typename?: 'Mutation', setCourseNotaryStatus: boolean };

export type GQLGetStudentCourseMetaQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentCourseMetaQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', hasCompletedNotary?: boolean | null } | null };

export type GQLGetCourseTitleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseTitleQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, title: string } };

export type GQLUnenrollStudentFromCourseMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLUnenrollStudentFromCourseMutation = { __typename?: 'Mutation', unenrollStudentFromOnlineCourse: boolean };

export type GQLCreateTraineeMutationVariables = Exact<{
  input: GQLCreateTraineeInput;
}>;


export type GQLCreateTraineeMutation = { __typename?: 'Mutation', createTrainee: { __typename?: 'Instructor', id: string, name: string } };

export type GQLMeetingPointForSchedulerFragment = { __typename?: 'StateMeetingPoint', id: string, address: string, label: string, state: string };

export type GQLGetMeetingPointForSchedulerQueryVariables = Exact<{
  meetingPointId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GQLGetMeetingPointForSchedulerQuery = { __typename?: 'Query', meetingPoint: { __typename?: 'StateMeetingPoint', id: string, address: string, label: string, state: string } };

export type GQLDisableStudentAccountMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLDisableStudentAccountMutation = { __typename?: 'Mutation', disableStudentAccount: boolean };

export type GQLFetchDestinationMakeupStudentsQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  makeupCohortId: Scalars['ID']['input'];
  statuses: Array<GQLMakeupRequestStatus> | GQLMakeupRequestStatus;
  pageQuery: GQLPageQuery;
}>;


export type GQLFetchDestinationMakeupStudentsQuery = { __typename?: 'Query', makeupRequests: { __typename?: 'PaginatedMakeupRequestsResponse', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'MakeupRequestEdge', cursor: string, node: { __typename?: 'MakeupRequest', id: string, studentId: string, studentName: string, createdAt: number, makeupSession: { __typename?: 'CohortSession', id: string, name: string, startTime: number, endTime: number } } }> } };

export type GQLEventLogAuditLogRowFragment = { __typename?: 'AuditLog', id: string, timestamp: number, action: GQLAuditLogActions, updatedBy: { __typename?: 'UpdatedBy', id?: string | null, name: string, role: GQLAuditLogUserRoles }, collection: { __typename?: 'AuditLogCollection', name: string, path: string }, changes: Array<
    | { __typename: 'LogDateTimeChange', path: string, oldDateTime?: number | null, newDateTime?: number | null }
    | { __typename: 'LogFloatChange', path: string, oldFloat?: number | null, newFloat?: number | null }
    | { __typename: 'LogIntChange', path: string, oldInt?: number | null, newInt?: number | null }
    | { __typename: 'LogStringChange', path: string, oldString?: string | null, newString?: string | null }
  > };

export type GQLEventLogAuditLogsQueryVariables = Exact<{
  query: GQLAuditLogsQuery;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLEventLogAuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'AuditLogEdge', cursor: string, node: { __typename?: 'AuditLog', id: string, timestamp: number, action: GQLAuditLogActions, updatedBy: { __typename?: 'UpdatedBy', id?: string | null, name: string, role: GQLAuditLogUserRoles }, collection: { __typename?: 'AuditLogCollection', name: string, path: string }, changes: Array<
          | { __typename: 'LogDateTimeChange', path: string, oldDateTime?: number | null, newDateTime?: number | null }
          | { __typename: 'LogFloatChange', path: string, oldFloat?: number | null, newFloat?: number | null }
          | { __typename: 'LogIntChange', path: string, oldInt?: number | null, newInt?: number | null }
          | { __typename: 'LogStringChange', path: string, oldString?: string | null, newString?: string | null }
        > } }> } | null };

export type GQLParkingHubForSelectFragment = { __typename?: 'ParkingHub', id: string, name: string, timeZone?: string | null };

export type GQLParkingHubsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLParkingHubsQueryQuery = { __typename?: 'Query', parkingHubs: Array<{ __typename?: 'ParkingHub', id: string, name: string, timeZone?: string | null }> };

export type GQLParkingHubDetailsFragment = { __typename?: 'ParkingHub', id: string, name: string, timeZone?: string | null, opsManagerUserId?: string | null, type?: string | null, gateCode?: string | null, opsManager?: { __typename?: 'Person', id: string, name: string } | null, center?: { __typename?: 'LocationCenter', address: string } | null };

export type GQLHubVehicleFragment = { __typename?: 'Vehicle', id: string, number?: string | null, name?: string | null, make?: string | null, model?: string | null, color?: string | null, plate?: string | null, hubParkingSpot?: string | null, samsaraId?: string | null, instructors?: Array<{ __typename?: 'Instructor', id: string, name: string }> | null };

export type GQLHubCalendarEventFieldsFragment = { __typename?: 'HubCalendarEvent', id: string, title: string, start: number, end: number, type: GQLHubCalendarEventType, isAllDay: boolean, vehicleId?: string | null, vehicle?: { __typename?: 'AvailabilityVehicleRef', id: string, name?: string | null } | null, instructor?: { __typename?: 'Instructor', id: string, name: string, timeZone: string } | null };

export type GQLDeleteParkingHubMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteParkingHubMutation = { __typename?: 'Mutation', deletedId: string };

export type GQLHubCalendarQueryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  hubId: Scalars['ID']['input'];
  calendarQuery: GQLHubCalendarQuery;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLHubCalendarQueryQuery = { __typename?: 'Query', hubCalendar: { __typename?: 'HubCalendar', timeZone: string, isVehiclePageTruncated: boolean, hub: { __typename?: 'ParkingHub', id: string, name: string, timeZone?: string | null, opsManagerUserId?: string | null, type?: string | null, gateCode?: string | null, opsManager?: { __typename?: 'Person', id: string, name: string } | null, center?: { __typename?: 'LocationCenter', address: string } | null }, vehicles: { __typename?: 'VehiclesPaginatedList', edges: Array<{ __typename?: 'VehicleEdge', node: { __typename?: 'Vehicle', id: string, number?: string | null, name?: string | null, make?: string | null, model?: string | null, color?: string | null, plate?: string | null, hubParkingSpot?: string | null, samsaraId?: string | null, instructors?: Array<{ __typename?: 'Instructor', id: string, name: string }> | null } }> }, approvedInstructorsSchedules: Array<{ __typename?: 'ApprovedInstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength: number, daysPerWeek: number, updatedAt: number, scheduleRequestId: string, instructorName?: string | null, managerName?: string | null, lastAvailabilityDate?: string | null, status: GQLScheduleStatus, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null, mostRecentRequest?: { __typename?: 'InstructorSchedule', id: string, startDate: string, createdAt: number } | null }>, instructorsSchedules: Array<{ __typename?: 'InstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength?: number | null, isApproved: boolean, daysPerWeek: number, updatedAt: number, instructorName?: string | null, managerName?: string | null, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null }>, calendarEvents: Array<{ __typename?: 'HubCalendarEvent', id: string, title: string, start: number, end: number, type: GQLHubCalendarEventType, isAllDay: boolean, vehicleId?: string | null, vehicle?: { __typename?: 'AvailabilityVehicleRef', id: string, name?: string | null } | null, instructor?: { __typename?: 'Instructor', id: string, name: string, timeZone: string } | null }> }, authRulesForUser: { __typename?: 'AuthRules', parkingHub: { __typename?: 'ParkingHubObjectAuthRules', canEdit: boolean } } };

export type GQLGetStudentCourseTestScoresQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentCourseTestScoresQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', tests?: Array<{ __typename?: 'StudentOnlineCourseTest', numCorrect: number, totalQuestions: number }> | null } | null };

export type GQLGetDrivingSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetDrivingSkillsQuery = { __typename?: 'Query', drivingSkills: Array<{ __typename?: 'DrivingSkill', id: string, label: string, description?: string | null }> };

export type GQLUploadReportCardMutationMutationVariables = Exact<{
  input: GQLUploadUserFileInput;
}>;


export type GQLUploadReportCardMutationMutation = { __typename?: 'Mutation', uploadUserFile: { __typename?: 'UserFile', id: string } };

export type GQLIllinoisStudentReportCardLessonFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, instructor: { __typename?: 'Instructor', name: string }, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number, observationMinutes: number } };

export type GQLIllinoisStudentReportCardLessonsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  observationMinuteProductId: Scalars['ID']['input'];
}>;


export type GQLIllinoisStudentReportCardLessonsQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, instructor: { __typename?: 'Instructor', name: string }, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number, observationMinutes: number } } }> } };

export type GQLInstructorMapInstructorFragment = { __typename?: 'InstructorIsochroneInstructor', id: string, name: string };

export type GQLInstructorMapIsochroneFragment = { __typename?: 'InstructorIsochrone', isCustom: boolean, geoJson: any, instructor: { __typename?: 'InstructorIsochroneInstructor', id: string, name: string } };

export type GQLInstructorMapIsochronesQueryVariables = Exact<{
  state?: InputMaybe<GQLUsStateId>;
}>;


export type GQLInstructorMapIsochronesQuery = { __typename?: 'Query', instructorIsochrones: Array<{ __typename?: 'InstructorIsochrone', isCustom: boolean, geoJson: any, instructor: { __typename?: 'InstructorIsochroneInstructor', id: string, name: string } }> };

export type GQLGetAllInstructorsSchedulesQueryVariables = Exact<{
  query: GQLInstructorsSchedulesQuery;
}>;


export type GQLGetAllInstructorsSchedulesQuery = { __typename?: 'Query', instructorsSchedules: Array<{ __typename?: 'InstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength?: number | null, isApproved: boolean, daysPerWeek: number, updatedAt: number, instructorName?: string | null, managerName?: string | null, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null }> };

export type GQLGetAllApprovedSchedulesQueryVariables = Exact<{
  query: GQLApprovedInstructorsSchedulesQuery;
}>;


export type GQLGetAllApprovedSchedulesQuery = { __typename?: 'Query', approvedInstructorsSchedules: Array<{ __typename?: 'ApprovedInstructorSchedule', id: string, instructorId: string, createdAt: number, startDate: string, endDate?: string | null, rollingWeekLength: number, daysPerWeek: number, updatedAt: number, scheduleRequestId: string, instructorName?: string | null, managerName?: string | null, lastAvailabilityDate?: string | null, status: GQLScheduleStatus, dayTimesAvailable: Array<{ __typename?: 'ScheduleDayTimes', dayOfTheWeek: string, startTime: string, endTime: string, lessonTypes?: Array<string> | null, locationAllowed?: GQLLocationAllowed | null }>, timesOff?: Array<{ __typename?: 'InstructorTimeOff', id: string, instructorId: string, startDate: string, endDate: string }> | null, mostRecentRequest?: { __typename?: 'InstructorSchedule', id: string, startDate: string, createdAt: number } | null }> };

export type GQLInstructorSwitcherFragmentFragment = { __typename?: 'Instructor', id: string, name: string, adminInfo: { __typename?: 'InstructorAdminInfo', isTrainee: boolean } };

export type GQLInstructorSwitcherQueryQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLInstructorSwitcherQueryQuery = { __typename?: 'Query', instructor: { __typename?: 'Instructor', id: string, name: string, adminInfo: { __typename?: 'InstructorAdminInfo', isTrainee: boolean } } };

export type GQLActivateInstructorMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLActivateInstructorMutation = { __typename?: 'Mutation', activateInstructor: { __typename?: 'Instructor', id: string } };

export type GQLDeactivateInstructorMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLDeactivateInstructorMutation = { __typename?: 'Mutation', deactivateInstructor: { __typename?: 'Instructor', id: string } };

export type GQLPromoteTraineeToInstructorMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLPromoteTraineeToInstructorMutation = { __typename?: 'Mutation', promoteTraineeToInstructor: { __typename?: 'Instructor', id: string } };

export type GQLRetireInstructorMutationVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLRetireInstructorMutation = { __typename?: 'Mutation', retireInstructor: { __typename?: 'Instructor', id: string } };

export type GQLInstructorTableInstructorFragment = { __typename?: 'Instructor', id: string, name: string, languages?: string | null, spokenLanguageCodes?: Array<string> | null, summary?: string | null, title?: string | null, portraitImage?: string | null, usStateId: string, locationLandingPageId?: string | null, locationLandingPageName?: string | null, metro?: { __typename?: 'Metro', name: string, slackChannel?: string | null } | null, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string, slackUsername?: string | null, email: string, licenseNumber?: string | null, licenseExpirationDate?: number | null, baseAddress?: string | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, maxBaseTravelMinutesOverride?: number | null, maxBetweenTravelMinutesOverride?: number | null, phoneNumber?: string | null, paylocityId?: string | null }, adminInfo: { __typename?: 'InstructorAdminInfo', regionalManagerId?: string | null, isTrainee: boolean, isRetired?: boolean | null, isInactive?: boolean | null, regionalManager?: { __typename?: 'Person', name: string } | null } };

export type GQLGetInstructorsForAdminTableQueryVariables = Exact<{
  query: GQLAdminInstructorTableQuery;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetInstructorsForAdminTableQuery = { __typename?: 'Query', instructorsForAdminTable: { __typename?: 'InstructorsPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, languages?: string | null, spokenLanguageCodes?: Array<string> | null, summary?: string | null, title?: string | null, portraitImage?: string | null, usStateId: string, locationLandingPageId?: string | null, locationLandingPageName?: string | null, metro?: { __typename?: 'Metro', name: string, slackChannel?: string | null } | null, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string, slackUsername?: string | null, email: string, licenseNumber?: string | null, licenseExpirationDate?: number | null, baseAddress?: string | null, maxBaseTravelMinutes?: number | null, maxBetweenTravelMinutes?: number | null, maxBaseTravelMinutesOverride?: number | null, maxBetweenTravelMinutesOverride?: number | null, phoneNumber?: string | null, paylocityId?: string | null }, adminInfo: { __typename?: 'InstructorAdminInfo', regionalManagerId?: string | null, isTrainee: boolean, isRetired?: boolean | null, isInactive?: boolean | null, regionalManager?: { __typename?: 'Person', name: string } | null } } }> } };

export type GQLMakeupRequestRowFragment = { __typename?: 'MakeupRequest', id: string, studentId: string, studentName: string, createdAt: number, status: GQLMakeupRequestStatus, processedAt?: number | null, originalSession: { __typename?: 'CohortSession', id: string, name: string, startTime: number }, makeupSession: { __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number } };

export type GQLFetchMakeupRequestsQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  cohortId: Scalars['ID']['input'];
  statuses: Array<GQLMakeupRequestStatus> | GQLMakeupRequestStatus;
  pageQuery: GQLPageQuery;
}>;


export type GQLFetchMakeupRequestsQuery = { __typename?: 'Query', makeupRequests: { __typename?: 'PaginatedMakeupRequestsResponse', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'MakeupRequestEdge', cursor: string, node: { __typename?: 'MakeupRequest', id: string, studentId: string, studentName: string, createdAt: number, status: GQLMakeupRequestStatus, processedAt?: number | null, originalSession: { __typename?: 'CohortSession', id: string, name: string, startTime: number }, makeupSession: { __typename?: 'CohortSession', id: string, cohortId: string, name: string, startTime: number } } }> } };

export type GQLUpdateMakeupRequestMutationVariables = Exact<{
  input: GQLUpdateMakeupRequestStatusInput;
}>;


export type GQLUpdateMakeupRequestMutation = { __typename?: 'Mutation', updateMakeupRequestStatus: { __typename?: 'MakeupRequest', id: string, status: GQLMakeupRequestStatus, processedAt?: number | null } };

export type GQLCreateMakeupRequestFromTableMutationVariables = Exact<{
  input: GQLCreateMakeupRequestInput;
}>;


export type GQLCreateMakeupRequestFromTableMutation = { __typename?: 'Mutation', createMakeupRequest: { __typename?: 'MakeupRequest', id: string } };

export type GQLRegionalManagerFragment = { __typename?: 'Person', id: string, name: string };

export type GQLRegionalManagersForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLRegionalManagersForSelectQuery = { __typename?: 'Query', regionalManagers: Array<{ __typename?: 'Person', id: string, name: string }> };

export type GQLGetCourseForMoveQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseForMoveQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, title: string, stateLongName: string } };

export type GQLGetStudentMetaPercentCompleteQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentMetaPercentCompleteQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', percentComplete?: number | null } | null };

export type GQLMigrateCourseMutationVariables = Exact<{
  sourceStudentId: Scalars['ID']['input'];
  destinationStudentId: Scalars['ID']['input'];
  onlineCourseId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type GQLMigrateCourseMutation = { __typename?: 'Mutation', migrateStudentOnlineCourse: { __typename?: 'StudentCourseMigration', onlineCourseId: string } };

export type GQLUpdateParkingHubMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdateParkingHubInput;
}>;


export type GQLUpdateParkingHubMutationMutation = { __typename?: 'Mutation', updateParkingHub: { __typename?: 'ParkingHub', id: string } };

export type GQLCreateParkingHubMutationMutationVariables = Exact<{
  input: GQLCreateParkingHubInput;
}>;


export type GQLCreateParkingHubMutationMutation = { __typename?: 'Mutation', createParkingHub: { __typename?: 'ParkingHub', id: string } };

export type GQLPriceSchemeForBookingFragment = { __typename?: 'PriceScheme', id: string, name: string, products: Array<{ __typename?: 'PriceSchemeProductLink', id: string, name: string, type: GQLProductType, price: number, productLinks: Array<{ __typename?: 'ProductLink', quantity: number, productId: string, product: { __typename?: 'ProductInfo', id: string, name: string, type: GQLProductType } }> }> };

export type GQLFetchPriceSchemeForAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GQLFetchPriceSchemeForAddressQuery = { __typename?: 'Query', priceSchemeForAddress?: { __typename?: 'PriceScheme', id: string, name: string, products: Array<{ __typename?: 'PriceSchemeProductLink', id: string, name: string, type: GQLProductType, price: number, productLinks: Array<{ __typename?: 'ProductLink', quantity: number, productId: string, product: { __typename?: 'ProductInfo', id: string, name: string, type: GQLProductType } }> }> } | null };

export type GQLFetchPurchasePricingPreviewQueryVariables = Exact<{
  input: GQLPurchasePricingPreviewInput;
}>;


export type GQLFetchPurchasePricingPreviewQuery = { __typename?: 'Query', purchasePricingPreview: { __typename?: 'PurchasePricingPreview', totalDollars: number, couponDiscountAmount?: number | null } };

export type GQLCreatePurchaseLogDirectChargeMutationVariables = Exact<{
  input: GQLCreateDirectChargeInput;
}>;


export type GQLCreatePurchaseLogDirectChargeMutation = { __typename?: 'Mutation', createDirectCharge: { __typename?: 'CreateDirectChargePayload', amountCents: number, customerId?: string | null, latestCharge: string, paymentIntentId: string, paymentMethodType?: string | null, status: string } };

export type GQLReactivateStudentAccountMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLReactivateStudentAccountMutation = { __typename?: 'Mutation', reactivateStudentAccount: boolean };

export type GQLReviewFormCreateReviewMutationVariables = Exact<{
  input: GQLPutLessonReviewInput;
}>;


export type GQLReviewFormCreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentName: string, studentId: string, lessonId: string, instructorId: string } };

export type GQLReviewFormUpdateReviewMutationVariables = Exact<{
  query: GQLGetLessonReviewInput;
  input: GQLUpdateLessonReviewInput;
}>;


export type GQLReviewFormUpdateReviewMutation = { __typename?: 'Mutation', updateReview: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentName: string, studentId: string, lessonId: string, instructorId: string } };

export type GQLInstructorLessonFragment = { __typename?: 'Lesson', id: string, instructorId: string, startTime: number, endTime: number, durationMinutes: number, pickupLocation: string, isCancelled: boolean, studentIds: Array<string>, locationId?: string | null, meetingPointId?: string | null, isShareable: boolean, isObserverAllowed: boolean, instructor: { __typename?: 'Instructor', id: string, name: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, student: { __typename?: 'Student', id: string, name: string }, productQuantityList: Array<{ __typename?: 'ProductQuantity', productId: string, quantity: number }> }>, pickupLocationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type GQLInstructorAvailabilityFragment = { __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxLessons?: number | null, maxDurationMinutes?: number | null, note?: string | null, isFixedLocation: boolean, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, center: { __typename?: 'Center', location: string }, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } };

export type GQLSchedulingPageInstructorFragment = { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string, meetingPoints: Array<{ __typename?: 'StateMeetingPoint', id: string, label: string, address: string, description?: string | null, distanceMiles?: number | null }> };

export type GQLGetLessonsByInstructorIdForSchedulingQueryVariables = Exact<{
  instructorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;


export type GQLGetLessonsByInstructorIdForSchedulingQuery = { __typename?: 'Query', lessonsByInstructorIds: Array<{ __typename?: 'Lesson', id: string, instructorId: string, startTime: number, endTime: number, durationMinutes: number, pickupLocation: string, isCancelled: boolean, studentIds: Array<string>, locationId?: string | null, meetingPointId?: string | null, isShareable: boolean, isObserverAllowed: boolean, instructor: { __typename?: 'Instructor', id: string, name: string }, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, isObserverAllowed: boolean, student: { __typename?: 'Student', id: string, name: string }, productQuantityList: Array<{ __typename?: 'ProductQuantity', productId: string, quantity: number }> }>, pickupLocationCoords?: { __typename?: 'LatLng', lat: number, lng: number } | null }> };

export type GQLGetAvailabilitiesForInstructorsQueryVariables = Exact<{
  instructorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
}>;


export type GQLGetAvailabilitiesForInstructorsQuery = { __typename?: 'Query', availabilities: Array<{ __typename?: 'Availability', id: string, date: string, startTime: number, endTime: number, isPrivate: boolean, maxLessons?: number | null, maxDurationMinutes?: number | null, note?: string | null, isFixedLocation: boolean, locationAllowed: GQLLocationAllowed, lessonTypes?: Array<string> | null, center: { __typename?: 'Center', location: string }, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string } }> };

export type GQLGetInstructorForSchedulingQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorForSchedulingQuery = { __typename?: 'Query', instructor: { __typename?: 'Instructor', id: string, name: string, usStateId: string, timeZone: string, meetingPoints: Array<{ __typename?: 'StateMeetingPoint', id: string, label: string, address: string, description?: string | null, distanceMiles?: number | null }> } };

export type GQLCohortEmailTemplateFragment = { __typename?: 'CohortEmailTemplate', id: string, name: string };

export type GQLCohortEmailTemplatePreviewFragment = { __typename?: 'CohortEmailTemplatePreview', id: string, name?: string | null, body: string, subject: string, from: string, autoFilledFields: Array<GQLCohortAutoFillField>, liquidFields: Array<string> };

export type GQLGetCohortEmailTemplatesQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCohortEmailTemplatesQuery = { __typename?: 'Query', cohortEmailTemplates: Array<{ __typename?: 'CohortEmailTemplate', id: string, name: string }> };

export type GQLGetCohortEmailTemplatePreviewQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type GQLGetCohortEmailTemplatePreviewQuery = { __typename?: 'Query', cohortEmailTemplatePreview?: { __typename?: 'CohortEmailTemplatePreview', id: string, name?: string | null, body: string, subject: string, from: string, autoFilledFields: Array<GQLCohortAutoFillField>, liquidFields: Array<string> } | null };

export type GQLSendCohortTemplateEmailMutationVariables = Exact<{
  input: GQLSendCohortTemplateEmailInput;
}>;


export type GQLSendCohortTemplateEmailMutation = { __typename?: 'Mutation', sendCohortTemplateEmail: { __typename?: 'SendCohortEmailResult', success: boolean, queued: number, failed: number, message: string } };

export type GQLCreateSingleSessionCohortMutationVariables = Exact<{
  input: GQLSingleSessionCohortInput;
}>;


export type GQLCreateSingleSessionCohortMutation = { __typename?: 'Mutation', createSingleSessionCohort: { __typename?: 'SingleSessionCohortResult', cohort: { __typename?: 'Cohort', id: string, name: string, stateId: string, startDate: string, endDate: string, maxEnrollees: number, isEnrollmentOpen: boolean, allowMakeupRequests: boolean }, session: { __typename?: 'CohortSession', id: string, name: string, startTime: number, endTime: number } } };

export type GQLTimeSlotWithLectureNameFragment = { __typename?: 'CourseTimerReportTimeSlot', from: number, to: number, courseId: string, lectureId: string, lecture: { __typename?: 'CourseLecture', title: string } };

export type GQLCourseTimerLectureReportFragment = { __typename?: 'LectureReport', id: string, totalTimeSeconds?: number | null, testScore?: number | null };

export type GQLSessionTimePerDayFullFragment = { __typename?: 'SessionTimePerDay', date: string, totalTimeSeconds: number, cappedTimeSeconds: number };

export type GQLGetCourseTimerDebugInfoQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseTimerDebugInfoQuery = { __typename?: 'Query', studentOnlineCourseTimerDebugInfo: { __typename?: 'StudentOnlineCourseTimerDebugInfo', v1TotalTimeSec: number, v2TotalTimeSec: number, v1CappedTimeSec: number, v2CappedTimeSec: number }, studentCourseMeta?: { __typename?: 'StudentOnlineCourse', name: string, featureFlags: Array<
      | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
      | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
      | { __typename: 'FeatureFlagString', key: string, valueString: string }
    > } | null };

export type GQLGetCourseTimerReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLGetCourseTimerReportQuery = { __typename?: 'Query', courseTimerReport: { __typename?: 'CourseTimerReportTimeSlotPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CourseTimerReportTimeSlotEdge', cursor: string, node: { __typename?: 'CourseTimerReportTimeSlot', from: number, to: number, courseId: string, lectureId: string, lecture: { __typename?: 'CourseLecture', title: string } } }> } };

export type GQLGetCourseTimerChapterReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseTimerChapterReportQuery = { __typename?: 'Query', studentOnlineCourseReport: { __typename?: 'StudentOnlineCourseReport', courseTotalTimeSeconds?: number | null, lectureReports?: Array<{ __typename?: 'LectureReport', id: string, totalTimeSeconds?: number | null, testScore?: number | null }> | null }, courseTimerSecondsSpent: { __typename?: 'CourseTimerSecondsSpent', studentId: string, byCourse: Array<{ __typename?: 'CourseTimerSecondsSpentByCourse', courseId: string, secondsSpent: number, secondsSpentCapped: number, byLecture: Array<{ __typename?: 'CourseTimerSecondsSpentByLecture', courseId: string, lectureId: string, secondsSpent: number, secondsSpentCapped: number }> }> } };

export type GQLGetCourseTimerDailyReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseTimerDailyReportQuery = { __typename?: 'Query', studentOnlineCourseReport: { __typename?: 'StudentOnlineCourseReport', sessionTimePerDay: Array<{ __typename?: 'SessionTimePerDay', date: string, totalTimeSeconds: number, cappedTimeSeconds: number }> } };

export type GQLUpdateCourseTimerVersionMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  courseTimerVersion: Scalars['Int']['input'];
}>;


export type GQLUpdateCourseTimerVersionMutation = { __typename?: 'Mutation', updateStudentCourseMeta: boolean };

export type GQLLectureReportFullFragment = { __typename?: 'LectureReport', id: string, totalTimeSeconds?: number | null, testScore?: number | null };

export type GQLFetchStudentOnlineCourseReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchStudentOnlineCourseReportQuery = { __typename?: 'Query', studentOnlineCourseReport: { __typename?: 'StudentOnlineCourseReport', name: string, dob: string, address: string, dmvPreRegNumber?: string | null, startDate?: number | null, completionDate?: number | null, courseTotalTimeSeconds?: number | null, lectureReports?: Array<{ __typename?: 'LectureReport', id: string, totalTimeSeconds?: number | null, testScore?: number | null }> | null } };

export type GQLGenerateStudentDetailedCourseReportPdfMutationVariables = Exact<{
  input: GQLGenerateStudentDetailedCourseReportPdfInput;
}>;


export type GQLGenerateStudentDetailedCourseReportPdfMutation = { __typename?: 'Mutation', generateStudentDetailedCourseReportPdf: { __typename?: 'PrintablePdfDocument', pdfData: string, filename: string } };

export type GQLCourseProgressArchivesQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLCourseProgressArchivesQuery = { __typename?: 'Query', courseProgressArchives: Array<{ __typename?: 'CourseProgressArchive', id: string, createdAt: number }> };

export type GQLGenerateCourseProgressArchivePdfMutationVariables = Exact<{
  archiveId: Scalars['ID']['input'];
}>;


export type GQLGenerateCourseProgressArchivePdfMutation = { __typename?: 'Mutation', generateCourseProgressArchivePdf: { __typename?: 'PrintablePdfDocument', pdfData: string, filename: string } };

export type GQLStudentReservedSlotFieldsFragment = { __typename?: 'TransientSlot', id: string, startTime: number, isBooked?: boolean | null, instructor: { __typename?: 'TransientSlotInstructor', displayName: string, timeZone: string }, reservedFor?: { __typename?: 'Person', id: string } | null };

export type GQLTransientSlotsForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLTransientSlotsForStudentQuery = { __typename?: 'Query', transientSlotsForStudent: Array<{ __typename?: 'TransientSlot', id: string, startTime: number, isBooked?: boolean | null, instructor: { __typename?: 'TransientSlotInstructor', displayName: string, timeZone: string }, reservedFor?: { __typename?: 'Person', id: string } | null }> };

export type GQLVehicleForCalendarFragment = { __typename?: 'Vehicle', id: string, name?: string | null, number?: string | null, usStateId?: GQLUsStateId | null, parkingHub?: string | null, parkingHubId?: string | null, make?: string | null, model?: string | null, instructorIds?: Array<string> | null };

export type GQLAllVehiclesQueryQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  stateFilter?: InputMaybe<GQLUsStateId>;
}>;


export type GQLAllVehiclesQueryQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesPaginatedList', totalCount: number, edges: Array<{ __typename?: 'VehicleEdge', node: { __typename?: 'Vehicle', id: string, name?: string | null, number?: string | null, usStateId?: GQLUsStateId | null, parkingHub?: string | null, parkingHubId?: string | null, make?: string | null, model?: string | null, instructorIds?: Array<string> | null } }> } | null };

export type GQLLocationLandingPagesQueryQueryVariables = Exact<{
  stateFilter: GQLUsStateId;
}>;


export type GQLLocationLandingPagesQueryQuery = { __typename?: 'Query', locationLandingPages: { __typename?: 'LocationLandingPagePaginatedList', edges: Array<{ __typename?: 'LocationLandingPageEdge', node: { __typename?: 'LocationLandingPage', id: string, name: string, state: GQLUsStateId, hubIds?: Array<string> | null } }> } };

export type GQLAvailabilityForVehiclesCalendarFragment = { __typename?: 'Availability', id: string, startTime: number, endTime: number, instructorId: string, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, vehicle?: { __typename?: 'Vehicle', id: string, name?: string | null, usStateId?: GQLUsStateId | null } | null };

export type GQLVehicleAvailabilitiesQueryQueryVariables = Exact<{
  vehicleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GQLVehicleAvailabilitiesQueryQuery = { __typename?: 'Query', availabilitiesForVehicles: Array<{ __typename?: 'Availability', id: string, startTime: number, endTime: number, instructorId: string, instructor: { __typename?: 'Instructor', id: string, name: string, timeZone: string }, vehicle?: { __typename?: 'Vehicle', id: string, name?: string | null, usStateId?: GQLUsStateId | null } | null }> };

export type GQLVoucherViewFragment = { __typename?: 'VoucherV2', id: string, billingAmount: number, name?: string | null, source: string, zipcode: string, productId: string, productName: string, usStateId: GQLUsStateId, courseId?: string | null };

export type GQLCreateVoucherMutationVariables = Exact<{
  voucherInput: GQLCreateVoucherV2Input;
}>;


export type GQLCreateVoucherMutation = { __typename?: 'Mutation', voucher: Array<{ __typename?: 'VoucherV2', id: string, billingAmount: number, name?: string | null, source: string, zipcode: string, productId: string, productName: string, usStateId: GQLUsStateId, courseId?: string | null }> };

export type GQLUpdateVoucherMutationVariables = Exact<{
  voucherInput: GQLUpdateVoucherV2Input;
}>;


export type GQLUpdateVoucherMutation = { __typename?: 'Mutation', voucher: { __typename?: 'VoucherV2', id: string, billingAmount: number, name?: string | null, source: string, zipcode: string, productId: string, productName: string, usStateId: GQLUsStateId, courseId?: string | null } };

export type GQLRedeemVoucherMutationVariables = Exact<{
  voucher: GQLRedeemVoucherV2Input;
}>;


export type GQLRedeemVoucherMutation = { __typename?: 'Mutation', redeemVoucherV2: { __typename?: 'RedeemVoucherV2Result', status: string, voucher?: { __typename?: 'VoucherV2', id: string, billingAmount: number, name?: string | null, source: string, zipcode: string, productId: string, productName: string, usStateId: GQLUsStateId, courseId?: string | null, redemptionCode: string } | null } };

export type GQLVoucherTableFragment = { __typename?: 'VoucherV2', id: string, redemptionCode: string, billingAmount: number, name?: string | null, source: string, sourceName?: string | null, zipcode: string, productId: string, productName: string, isRedeemed: boolean, createdAt?: number | null, usStateId: GQLUsStateId, student?: { __typename?: 'VoucherStudent', id: string, name?: string | null, email?: string | null } | null };

export type GQLGetVouchersV2QueryVariables = Exact<{
  pageQuery: GQLPageQuery;
  filter?: InputMaybe<GQLVoucherV2Filter>;
}>;


export type GQLGetVouchersV2Query = { __typename?: 'Query', vouchersV2: { __typename?: 'PaginatedVouchersV2', totalCount: number, edges: Array<{ __typename?: 'VoucherV2Edge', node: { __typename?: 'VoucherV2', id: string, redemptionCode: string, billingAmount: number, name?: string | null, source: string, sourceName?: string | null, zipcode: string, productId: string, productName: string, isRedeemed: boolean, createdAt?: number | null, usStateId: GQLUsStateId, student?: { __typename?: 'VoucherStudent', id: string, name?: string | null, email?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GQLDeleteVoucherV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteVoucherV2Mutation = { __typename?: 'Mutation', deleteVoucherV2: boolean };

export type GQLGetVoucherSourcesQueryVariables = Exact<{
  pageQuery: GQLPageQuery;
}>;


export type GQLGetVoucherSourcesQuery = { __typename?: 'Query', voucherV2Sources?: { __typename?: 'PaginatedVoucherV2Sources', totalCount: number, edges: Array<{ __typename?: 'VoucherV2SourceEdge', node: { __typename?: 'VoucherV2Source', id: string, sourceId: string, name: string, zipcode: string, usStateId: string, createdAt: number, updatedAt: number, counts?: { __typename?: 'VoucherCounts', total: number, redeemed: number, unredeemed: number } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GQLCreateVoucherV2SourceMutationVariables = Exact<{
  input: GQLCreateVoucherV2SourceInput;
}>;


export type GQLCreateVoucherV2SourceMutation = { __typename?: 'Mutation', createVoucherV2Source: Array<{ __typename?: 'VoucherV2Source', id: string, name: string, zipcode: string, usStateId: string, createdAt: number, updatedAt: number }> };

export type GQLUpdateVoucherV2SourceMutationVariables = Exact<{
  input: GQLUpdateVoucherV2SourceInput;
}>;


export type GQLUpdateVoucherV2SourceMutation = { __typename?: 'Mutation', updateVoucherV2Source: { __typename?: 'VoucherV2Source', id: string, name: string, zipcode: string, usStateId: string, createdAt: number, updatedAt: number } };

export type GQLDeleteVoucherV2SourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteVoucherV2SourceMutation = { __typename?: 'Mutation', deleteVoucherV2Source: boolean };

export type GQLHubFleetAttachmentFieldsFragment = { __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string };

export type GQLHubFleetNoteFieldsFragment = { __typename?: 'FleetNote', id: string, text: string, createdAt: number, createdById: string, updatedAt?: number | null, updatedById?: string | null, attachmentIds: Array<string>, createdBy?: { __typename?: 'Person', id: string, name: string } | null, updatedBy?: { __typename?: 'Person', id: string, name: string } | null, attachments: Array<{ __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string }> };

export type GQLHubFleetNotesQueryVariables = Exact<{
  hubId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GQLHubFleetNotesQuery = { __typename?: 'Query', fleetNotes: { __typename?: 'FleetNotesPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'FleetNoteEdge', node: { __typename?: 'FleetNote', id: string, text: string, createdAt: number, createdById: string, updatedAt?: number | null, updatedById?: string | null, attachmentIds: Array<string>, createdBy?: { __typename?: 'Person', id: string, name: string } | null, updatedBy?: { __typename?: 'Person', id: string, name: string } | null, attachments: Array<{ __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string }> } }> }, fleetAttachments: Array<{ __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string }> };

export type GQLCreateHubFleetNoteMutationVariables = Exact<{
  input: GQLCreateFleetNoteInput;
}>;


export type GQLCreateHubFleetNoteMutation = { __typename?: 'Mutation', createFleetNote: { __typename?: 'FleetNote', id: string, text: string, createdAt: number, createdById: string, updatedAt?: number | null, updatedById?: string | null, attachmentIds: Array<string>, createdBy?: { __typename?: 'Person', id: string, name: string } | null, updatedBy?: { __typename?: 'Person', id: string, name: string } | null, attachments: Array<{ __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string }> } };

export type GQLUpdateHubFleetNoteMutationVariables = Exact<{
  input: GQLUpdateFleetNoteInput;
}>;


export type GQLUpdateHubFleetNoteMutation = { __typename?: 'Mutation', updateFleetNote: { __typename?: 'FleetNote', id: string, text: string, createdAt: number, createdById: string, updatedAt?: number | null, updatedById?: string | null, attachmentIds: Array<string>, createdBy?: { __typename?: 'Person', id: string, name: string } | null, updatedBy?: { __typename?: 'Person', id: string, name: string } | null, attachments: Array<{ __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string }> } };

export type GQLDeleteHubFleetNoteMutationVariables = Exact<{
  input: GQLDeleteFleetNoteInput;
}>;


export type GQLDeleteHubFleetNoteMutation = { __typename?: 'Mutation', deleteFleetNote: string };

export type GQLUploadHubFleetAttachmentMutationVariables = Exact<{
  input: GQLUploadFleetAttachmentInput;
}>;


export type GQLUploadHubFleetAttachmentMutation = { __typename?: 'Mutation', uploadFleetAttachment: { __typename?: 'FleetAttachment', id: string, label: string, url: string, contentType: string } };

export type GQLDeleteHubFleetAttachmentMutationVariables = Exact<{
  input: GQLDeleteFleetAttachmentInput;
}>;


export type GQLDeleteHubFleetAttachmentMutation = { __typename?: 'Mutation', deleteFleetAttachment: boolean };

export type GQLGetLectureForChapterViewQueryVariables = Exact<{
  lectureId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  seed: Scalars['String']['input'];
}>;


export type GQLGetLectureForChapterViewQuery = { __typename?: 'Query', lecture: { __typename?: 'CourseLecture', title: string, content: { __typename?: 'CourseLectureContent', parts: Array<
        | { __typename?: 'LectureContentPart', id: string, type: GQLLecturePartType, structuredText?: any | null, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null, blocks: Array<
            | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
            | { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null }
            | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
            | { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
                | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
                | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
              >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } }
          > }
        | { __typename?: 'LectureQuizPart', id: string, type: GQLLecturePartType, questions: Array<{ __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null }> }
      > } } };

export type GQLUpdateStudentControlNumberMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentControlNumberMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string } };

export type GQLGetStudentControlNumberQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentControlNumberQuery = { __typename?: 'Query', student?: { __typename?: 'Student', controlNumber?: string | null } | null };

export type GQLCourseProviderUserCourseMetaFragment = { __typename?: 'StudentOnlineCourse', enrolled: boolean, currentLecture?: string | null, percentComplete?: number | null, percentTestsPassed?: number | null, isParentGuideOrdered?: boolean | null, isMarketingAssessmentComplete?: boolean | null, isReviewCTAComplete?: boolean | null, isArchived?: boolean | null, lectures?: Array<{ __typename?: 'StudentOnlineCourseLecture', id: string }> | null, tests?: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> | null };

export type GQLGetCourseProviderUserCourseMetaQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseProviderUserCourseMetaQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', enrolled: boolean, currentLecture?: string | null, percentComplete?: number | null, percentTestsPassed?: number | null, isParentGuideOrdered?: boolean | null, isMarketingAssessmentComplete?: boolean | null, isReviewCTAComplete?: boolean | null, isArchived?: boolean | null, lectures?: Array<{ __typename?: 'StudentOnlineCourseLecture', id: string }> | null, tests?: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> | null } | null };

export type GQLGetStudentCourseSecurityAnswersQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentCourseSecurityAnswersQuery = { __typename?: 'Query', studentCourseSecurityAnswers?: any | null };

export type GQLUpdateUserCourseMetaMutationVariables = Exact<{
  input: GQLUpdateStudentCourseMetaInput;
}>;


export type GQLUpdateUserCourseMetaMutation = { __typename?: 'Mutation', updateStudentCourseMeta: boolean };

export type GQLMarkLectureCompletedMutationVariables = Exact<{
  input: GQLStudentCourseLectureInput;
}>;


export type GQLMarkLectureCompletedMutation = { __typename?: 'Mutation', markLectureCompleted: { __typename?: 'StudentOnlineCourse', id: string } };

export type GQLGetCourseReviewPromptQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetCourseReviewPromptQuery = { __typename?: 'Query', studentLocationReviewUrl?: string | null };

export type GQLCompleteCourseReviewPromptMutationVariables = Exact<{
  input: GQLUpdateStudentCourseMetaInput;
}>;


export type GQLCompleteCourseReviewPromptMutation = { __typename?: 'Mutation', updateStudentCourseMeta: boolean };

export type GQLGetCourseForTimerQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetCourseForTimerQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, requiredHours: number }, studentCourse?: { __typename?: 'StudentOnlineCourse', featureFlags: Array<
      | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
      | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
      | { __typename: 'FeatureFlagString', key: string, valueString: string }
    > } | null };

export type GQLGetCourseDmvLinkQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseDmvLinkQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, dmvPreRegistrationLink?: string | null } };

export type GQLGetUserDmvPreRegNumberQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLGetUserDmvPreRegNumberQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, dmvPreRegNumber?: string | null } | null };

export type GQLUpdateStudentDmvPreRegNumberMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  dmvPreRegNumber: Scalars['String']['input'];
}>;


export type GQLUpdateStudentDmvPreRegNumberMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, dmvPreRegNumber?: string | null } };

export type GQLLectureContentImageFullFragment = { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null };

export type GQLLectureContentVideoFullFragment = { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string };

export type GQLLectureSingleImageBlockFullFragment = { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } };

export type GQLLectureSingleVideoBlockFullFragment = { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null };

export type GQLLectureTitleBlockFullFragment = { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string };

export type GQLLectureTwoColumnBlockFullFragment = { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
    | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
    | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
  >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } };

type GQLLectureContentBlockFull_LectureSingleImageBlock_Fragment = { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } };

type GQLLectureContentBlockFull_LectureSingleVideoBlock_Fragment = { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null };

type GQLLectureContentBlockFull_LectureTitleBlock_Fragment = { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string };

type GQLLectureContentBlockFull_LectureTwoColumnBlock_Fragment = { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
    | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
    | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
  >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } };

export type GQLLectureContentBlockFullFragment =
  | GQLLectureContentBlockFull_LectureSingleImageBlock_Fragment
  | GQLLectureContentBlockFull_LectureSingleVideoBlock_Fragment
  | GQLLectureContentBlockFull_LectureTitleBlock_Fragment
  | GQLLectureContentBlockFull_LectureTwoColumnBlock_Fragment
;

export type GQLLectureContentPartFullFragment = { __typename?: 'LectureContentPart', id: string, type: GQLLecturePartType, structuredText?: any | null, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null, blocks: Array<
    | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
    | { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null }
    | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
    | { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
        | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
        | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
      >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } }
  > };

type GQLQuizQuestionBase_CoursePrepQuizQuestion_Fragment = { __typename?: 'CoursePrepQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null };

type GQLQuizQuestionBase_LectureQuizQuestion_Fragment = { __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null };

export type GQLQuizQuestionBaseFragment =
  | GQLQuizQuestionBase_CoursePrepQuizQuestion_Fragment
  | GQLQuizQuestionBase_LectureQuizQuestion_Fragment
;

export type GQLLectureQuizQuestionFullFragment = { __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null };

export type GQLLectureQuizPartFullFragment = { __typename?: 'LectureQuizPart', id: string, type: GQLLecturePartType, questions: Array<{ __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null }> };

type GQLLecturePartFull_LectureContentPart_Fragment = { __typename?: 'LectureContentPart', id: string, type: GQLLecturePartType, structuredText?: any | null, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null, blocks: Array<
    | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
    | { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null }
    | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
    | { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
        | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
        | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
      >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } }
  > };

type GQLLecturePartFull_LectureQuizPart_Fragment = { __typename?: 'LectureQuizPart', id: string, type: GQLLecturePartType, questions: Array<{ __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null }> };

export type GQLLecturePartFullFragment =
  | GQLLecturePartFull_LectureContentPart_Fragment
  | GQLLecturePartFull_LectureQuizPart_Fragment
;

export type GQLGetLectureQueryVariables = Exact<{
  lectureId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  seed: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetLectureQuery = { __typename?: 'Query', lecture: { __typename?: 'CourseLecture', title: string, includesAQuiz: boolean, timeSpentByStudent: number, content: { __typename?: 'CourseLectureContent', minimumDuration: number, parts: Array<
        | { __typename?: 'LectureContentPart', id: string, type: GQLLecturePartType, structuredText?: any | null, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null, blocks: Array<
            | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
            | { __typename: 'LectureSingleVideoBlock', id: string, type: GQLLectureContentBlockType, video?: { __typename?: 'LectureContentVideo', url: string, title: string, thumbnailUrl: string } | null }
            | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
            | { __typename: 'LectureTwoColumnBlock', id: string, type: GQLLectureContentBlockType, column1: Array<
                | { __typename: 'LectureSingleImageBlock', id: string, type: GQLLectureContentBlockType, image: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } }
                | { __typename: 'LectureTitleBlock', id: string, type: GQLLectureContentBlockType, title: string }
              >, column2: { __typename?: 'LectureBlockTextColumn', structuredText: any } }
          > }
        | { __typename?: 'LectureQuizPart', id: string, type: GQLLecturePartType, questions: Array<{ __typename?: 'LectureQuizQuestion', id: string, doShuffle: boolean, question: string, image?: { __typename?: 'LectureContentImage', srcSet?: string | null, webpSrcSet?: string | null, sizes?: string | null, src: string, width: number, height?: number | null, aspectRatio?: number | null, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null, choices?: Array<{ __typename?: 'LectureQuestionChoice', id: string, option: string }> | null }> }
      > } }, studentCourse?: { __typename?: 'StudentOnlineCourse', featureFlags: Array<
      | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
      | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
      | { __typename: 'FeatureFlagString', key: string, valueString: string }
    > } | null };

export type GQLSubmitMarketingAssessmentMutationVariables = Exact<{
  input: GQLMarketingAssessmentInput;
}>;


export type GQLSubmitMarketingAssessmentMutation = { __typename?: 'Mutation', submitMarketingAssessment: boolean };

export type GQLCourseOrderExistsFragment = { __typename?: 'CourseOrder', id: string, courseId: string };

export type GQLTimeProgressFragment = { __typename?: 'StudentOnlineCourseTimeProgress', courseTotalTime: number, totalTimePerDay: Array<{ __typename?: 'LectureTimeDaily', date: string, totalTimeSeconds: number }> };

export type GQLStudentOnlineCourseTimeProgressAndCourseOrdersQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLStudentOnlineCourseTimeProgressAndCourseOrdersQuery = { __typename?: 'Query', studentOnlineCourseTimeProgress: { __typename?: 'StudentOnlineCourseTimeProgress', courseTotalTime: number, totalTimePerDay: Array<{ __typename?: 'LectureTimeDaily', date: string, totalTimeSeconds: number }> }, courseOrder?: { __typename?: 'CourseOrder', id: string, courseId: string } | null };

export type GQLQuizSubmissionFullFragment = { __typename?: 'QuizSubmission', studentId: string, courseId: string, lectureId: string, quizId: string, percentCorrect: number, numCorrect: number, totalQuestions: number, didPass: boolean, quizAnswers: Array<{ __typename?: 'QuizAnswer', questionId: string, correctAnswer: string, studentAnswer: string, isCorrect: boolean }> };

export type GQLScoreQuizMutationVariables = Exact<{
  query: GQLScoreQuizQuery;
  input: GQLScoreQuizInput;
}>;


export type GQLScoreQuizMutation = { __typename?: 'Mutation', scoreQuiz: { __typename?: 'ScoreQuizResult', quizSubmission: { __typename?: 'QuizSubmission', studentId: string, courseId: string, lectureId: string, quizId: string, percentCorrect: number, numCorrect: number, totalQuestions: number, didPass: boolean, quizAnswers: Array<{ __typename?: 'QuizAnswer', questionId: string, correctAnswer: string, studentAnswer: string, isCorrect: boolean }> }, studentOnlineCourse: { __typename?: 'StudentOnlineCourse', id: string, courseId: string, studentId: string, name: string, currentLecture?: string | null, enrolled: boolean, percentComplete?: number | null, percentTestsPassed?: number | null, courseCompletionDate?: number | null, hasCompletedNotary?: boolean | null, isParentGuideOrdered?: boolean | null, isMarketingAssessmentComplete?: boolean | null, isArchived?: boolean | null, lectures?: Array<{ __typename?: 'StudentOnlineCourseLecture', id: string }> | null, tests?: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> | null, featureFlags: Array<
        | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
        | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
        | { __typename: 'FeatureFlagString', key: string, valueString: string }
      > } } };

export type GQLUpdateStudentCourseSecurityAnswersMutationVariables = Exact<{
  input: GQLUpdateStudentCourseSecurityAnswersInput;
}>;


export type GQLUpdateStudentCourseSecurityAnswersMutation = { __typename?: 'Mutation', updateStudentCourseSecurityAnswers: boolean };

export type GQLStudentOnlineCourseFragment = { __typename?: 'StudentOnlineCourse', id: string, courseId: string, studentId: string, name: string, currentLecture?: string | null, enrolled: boolean, percentComplete?: number | null, percentTestsPassed?: number | null, courseCompletionDate?: number | null, hasCompletedNotary?: boolean | null, isParentGuideOrdered?: boolean | null, isMarketingAssessmentComplete?: boolean | null, isArchived?: boolean | null, lectures?: Array<{ __typename?: 'StudentOnlineCourseLecture', id: string }> | null, tests?: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> | null, featureFlags: Array<
    | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
    | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
    | { __typename: 'FeatureFlagString', key: string, valueString: string }
  > };

export type GQLGetCourseOrdersAndUcmForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLGetCourseOrdersAndUcmForStudentQuery = { __typename?: 'Query', courseOrders: Array<{ __typename?: 'CourseOrder', id: string, courseId: string, address?: { __typename?: 'CourseOrderAddress', address: string, city: string, state: string, zipcode: string, phone: string, dob: string, timestamp: number, firstName: string, middleName?: string | null, lastName: string } | null, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', controlNumber?: string | null, firstName: string, middleName?: string | null, middleInit?: string | null, lastName: string, dob: string, timestamp: number, sex: string, branchLicenseNumber?: string | null, roadAndVisionExams?: string | null } | null }>, ucm: { __typename?: 'StudentOnlineCoursesPaginatedList', edges: Array<{ __typename?: 'StudentOnlineCourseEdge', cursor: string, node: { __typename?: 'StudentOnlineCourse', id: string, courseId: string, studentId: string, name: string, currentLecture?: string | null, enrolled: boolean, percentComplete?: number | null, percentTestsPassed?: number | null, courseCompletionDate?: number | null, hasCompletedNotary?: boolean | null, isParentGuideOrdered?: boolean | null, isMarketingAssessmentComplete?: boolean | null, isArchived?: boolean | null, lectures?: Array<{ __typename?: 'StudentOnlineCourseLecture', id: string }> | null, tests?: Array<{ __typename?: 'StudentOnlineCourseTest', id: string, numCorrect: number, totalQuestions: number }> | null, featureFlags: Array<
          | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
          | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
          | { __typename: 'FeatureFlagString', key: string, valueString: string }
        > } }> } };

export type GQLCourseForSummaryFragment = { __typename?: 'OnlineCourseContent', id: string, title: string, slug: string, examSlug?: string | null, courseTypeId?: string | null, courseAgeMinimum?: number | null, isClassroomCourse: boolean, isExternalCourse: boolean, requiresNotarizedForm?: boolean | null, requiresDmvPreRegistration?: boolean | null, hasControlNumber: boolean, hasShipping: boolean, hasTimer: boolean, link?: string | null, completionFlow: Array<string>, stateShortName: string };

export type GQLGetCoursesForSummaryQueryVariables = Exact<{
  courseIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GQLGetCoursesForSummaryQuery = { __typename?: 'Query', coursesWithIds: Array<{ __typename?: 'OnlineCourseContent', id: string, title: string, slug: string, examSlug?: string | null, courseTypeId?: string | null, courseAgeMinimum?: number | null, isClassroomCourse: boolean, isExternalCourse: boolean, requiresNotarizedForm?: boolean | null, requiresDmvPreRegistration?: boolean | null, hasControlNumber: boolean, hasShipping: boolean, hasTimer: boolean, link?: string | null, completionFlow: Array<string>, stateShortName: string }> };

export type GQLStudentExamAttemptItemFragment = { __typename?: 'ExamAttempt', id: string, startTime: number, submittedAt: number, result: { __typename?: 'ExamSessionResult', didPass: boolean } };

export type GQLGetStudentExamAttemptsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  examSlug: Scalars['String']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentExamAttemptsQuery = { __typename?: 'Query', studentExamAttempts: Array<{ __typename?: 'ExamAttempt', id: string, startTime: number, submittedAt: number, result: { __typename?: 'ExamSessionResult', didPass: boolean } }> };

export type GQLStudentOnlineCourseTimeProgressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  onlineCourseId: Scalars['ID']['input'];
}>;


export type GQLStudentOnlineCourseTimeProgressQuery = { __typename?: 'Query', studentOnlineCourseTimeProgress: { __typename?: 'StudentOnlineCourseTimeProgress', courseTotalTime: number, totalTimePerDay: Array<{ __typename?: 'LectureTimeDaily', date: string, totalTimeSeconds: number }> } };

export type GQLGetStudentLicenseNumberQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentLicenseNumberQuery = { __typename?: 'Query', student?: { __typename?: 'Student', licenseNumber?: string | null } | null };

export type GQLUpdateStudentLicenseNumberMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentLicenseNumberMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, licenseNumber?: string | null } };

export type GQLGetCourseTimeLimitsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetCourseTimeLimitsQuery = { __typename?: 'Query', studentCourses: { __typename?: 'StudentOnlineCoursesPaginatedList', edges: Array<{ __typename?: 'StudentOnlineCourseEdge', node: { __typename?: 'StudentOnlineCourse', course: { __typename?: 'OnlineCourseContent', id: string, dailyTimeLimit?: number | null, chapterTimeLimitHours?: number | null, topics: Array<{ __typename?: 'CourseTopic', id: string, lectures: Array<{ __typename?: 'CourseLecture', id: string }> }> } } }> } };

type GQLFeatureFlagFull_FeatureFlagBool_Fragment = { __typename: 'FeatureFlagBool', key: string, valueBool: boolean };

type GQLFeatureFlagFull_FeatureFlagInt_Fragment = { __typename: 'FeatureFlagInt', key: string, valueInt: number };

type GQLFeatureFlagFull_FeatureFlagString_Fragment = { __typename: 'FeatureFlagString', key: string, valueString: string };

export type GQLFeatureFlagFullFragment =
  | GQLFeatureFlagFull_FeatureFlagBool_Fragment
  | GQLFeatureFlagFull_FeatureFlagInt_Fragment
  | GQLFeatureFlagFull_FeatureFlagString_Fragment
;

export type GQLGetIdleTimerDataQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetIdleTimerDataQuery = { __typename?: 'Query', studentCourse?: { __typename?: 'StudentOnlineCourse', featureFlags: Array<
      | { __typename: 'FeatureFlagBool', key: string, valueBool: boolean }
      | { __typename: 'FeatureFlagInt', key: string, valueInt: number }
      | { __typename: 'FeatureFlagString', key: string, valueString: string }
    > } | null, courseById: { __typename?: 'OnlineCourseContent', hasTimer: boolean, inactivityCheck: boolean, idleTimeoutSec: number } };

export type GQLLegacyAdminThemePreferenceUserSettingsFragment = { __typename?: 'UserSettings', themePreference: GQLUserThemePreference };

export type GQLLegacyAdminThemePreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLLegacyAdminThemePreferenceQuery = { __typename?: 'Query', myUserSettings: { __typename?: 'UserSettings', themePreference: GQLUserThemePreference } };

export type GQLCourseCompleteMetaFragment = { __typename?: 'StudentOnlineCourse', percentComplete?: number | null, percentTestsPassed?: number | null };

export type GQLCourseCompleteOrderAddressFragment = { __typename?: 'CourseOrderAddress', firstName: string, middleName?: string | null, lastName: string, address: string, city: string, state: string, zipcode: string, phone: string, dob: string, dlNumber?: string | null };

export type GQLCourseCompleteOrderFragment = { __typename?: 'CourseOrder', id: string, courseId: string, address?: { __typename?: 'CourseOrderAddress', firstName: string, middleName?: string | null, lastName: string, address: string, city: string, state: string, zipcode: string, phone: string, dob: string, dlNumber?: string | null } | null, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', controlNumber?: string | null } | null, shipping?: { __typename?: 'CourseOrderShipping', isComplete: boolean } | null };

export type GQLCourseCompleteSurveyFragment = { __typename?: 'CourseSurvey', courseId: string, timestamp: number };

export type GQLCourseCompleteStudentFragment = { __typename?: 'Student', id: string, dmvPreRegNumber?: string | null };

export type GQLCourseCompleteStatusQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLCourseCompleteStatusQuery = { __typename?: 'Query', studentOnlineCourseIsComplete: boolean, studentCourseMeta?: { __typename?: 'StudentOnlineCourse', percentComplete?: number | null, percentTestsPassed?: number | null } | null, courseOrder?: { __typename?: 'CourseOrder', id: string, courseId: string, address?: { __typename?: 'CourseOrderAddress', firstName: string, middleName?: string | null, lastName: string, address: string, city: string, state: string, zipcode: string, phone: string, dob: string, dlNumber?: string | null } | null, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', controlNumber?: string | null } | null, shipping?: { __typename?: 'CourseOrderShipping', isComplete: boolean } | null } | null, courseSurvey?: { __typename?: 'CourseSurvey', courseId: string, timestamp: number } | null, student?: { __typename?: 'Student', id: string, dmvPreRegNumber?: string | null } | null };

export type GQLInstructorPageInstructorFragment = { __typename?: 'Instructor', id: string, name: string, about?: string | null, portraitImage?: string | null, languages?: string | null };

export type GQLGetInstructorPageQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorPageQuery = { __typename?: 'Query', instructors: { __typename?: 'InstructorsPaginatedList', edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, about?: string | null, portraitImage?: string | null, languages?: string | null } }> } };

export type GQLVerifySessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLVerifySessionQuery = { __typename?: 'Query', me: { __typename?: 'Myself', id: string, roles: Array<string> } };

export type GQLStudentEnrolledCoursesForCourseFragment = { __typename?: 'StudentOnlineCourse', id: string, courseId: string, enrolled: boolean };

export type GQLStudentOnlineCoursesQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLStudentOnlineCoursesQuery = { __typename?: 'Query', studentOnlineCourse: { __typename?: 'StudentOnlineCoursesPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'StudentOnlineCourseEdge', cursor: string, node: { __typename?: 'StudentOnlineCourse', id: string, courseId: string, enrolled: boolean } }> } };

export type GQLRequiredContractPageQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLRequiredContractPageQuery = { __typename?: 'Query', requiredContractPage: { __typename?: 'RequiredContractPageData', pendingContract?: { __typename?: 'RequiredContractPagePendingContract', purchaseId: string, state: GQLUsStateId, purchaseTitle?: string | null, texasPurchaseDetails?: { __typename?: 'TexasRequiredContractPurchaseDetails', hasLessons: boolean, hasCourse: boolean, studentTypeOptions: Array<{ __typename?: 'TexasStudentContractTypeOption', type: string, description: string }> } | null, coloradoPurchaseDetails?: { __typename?: 'ColoradoRequiredContractPurchaseDetails', hasLessons: boolean, hasOnlineCourse: boolean, hasClassroomCourse: boolean } | null } | null } };

type GQLWaContractPurchaseItem_PurchasePackage_Fragment = { __typename?: 'PurchasePackage', productId: string };

type GQLWaContractPurchaseItem_PurchaseProduct_Fragment = { __typename?: 'PurchaseProduct', productId: string };

export type GQLWaContractPurchaseItemFragment =
  | GQLWaContractPurchaseItem_PurchasePackage_Fragment
  | GQLWaContractPurchaseItem_PurchaseProduct_Fragment
;

export type GQLWaContractPurchaseFragment = { __typename?: 'Purchase', id: string, amountDollars: number, isVoid: boolean, usStateId: GQLUsStateId, items: Array<
    | { __typename?: 'PurchasePackage', productId: string }
    | { __typename?: 'PurchaseProduct', productId: string }
  > };

export type GQLWaContractPurchaseOpFragment = { __typename?: 'StudentPurchaseOp', studentContract?: { __typename?: 'StudentContract', dateOfSign?: string | null } | null, purchase: { __typename?: 'Purchase', id: string, amountDollars: number, isVoid: boolean, usStateId: GQLUsStateId, items: Array<
      | { __typename?: 'PurchasePackage', productId: string }
      | { __typename?: 'PurchaseProduct', productId: string }
    > } };

export type GQLWaContractPageQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLWaContractPageQuery = { __typename?: 'Query', studentOperations: { __typename?: 'StudentOperationsPaginatedResult', edges: Array<{ __typename?: 'StudentOperationEdge', node:
        | { __typename?: 'StudentExpirationOp' }
        | { __typename?: 'StudentPurchaseOp', studentContract?: { __typename?: 'StudentContract', dateOfSign?: string | null } | null, purchase: { __typename?: 'Purchase', id: string, amountDollars: number, isVoid: boolean, usStateId: GQLUsStateId, items: Array<
              | { __typename?: 'PurchasePackage', productId: string }
              | { __typename?: 'PurchaseProduct', productId: string }
            > } }
        | { __typename?: 'StudentPurchaseTransferOp' }
        | { __typename?: 'StudentRefundOp' }
       }> } };

export type GQLMeetInstructorFragment = { __typename?: 'Instructor', id: string, name: string, summary?: string | null, portraitImage?: string | null, badges?: Array<{ __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon }> | null };

export type GQLGetMeetInstructorsQueryVariables = Exact<{
  location?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GQLGetMeetInstructorsQuery = { __typename?: 'Query', meetInstructors: { __typename?: 'InstructorsPaginatedList', edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, summary?: string | null, portraitImage?: string | null, badges?: Array<{ __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon }> | null } }> } };

export type GQLAccommodationQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  accommodationFor: GQLAccommodationFor;
}>;


export type GQLAccommodationQuery = { __typename?: 'Query', accommodation?: { __typename?: 'Accommodation', id: string, accommodationFor: GQLAccommodationFor, request: string, updatedAt: number } | null };

export type GQLSaveAccommodationMutationVariables = Exact<{
  input: GQLSaveAccommodationInput;
}>;


export type GQLSaveAccommodationMutation = { __typename?: 'Mutation', saveAccommodation: boolean };

export type GQLAccountTagViewFragment = { __typename?: 'AccountTag', name: string, count: number };

export type GQLSearchAccountTagsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GQLSearchAccountTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'AccountTag', name: string, count: number }> };

export type GQLUpdateStudentTagsMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentTagsMutation = { __typename?: 'Mutation', student: { __typename?: 'Student', id: string } };

export type GQLAddStudentMutationVariables = Exact<{
  student: GQLNewStudentInput;
}>;


export type GQLAddStudentMutation = { __typename?: 'Mutation', addStudent: { __typename?: 'Student', id: string } };

export type GQLUpdateStudentEmailMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  newEmail: Scalars['String']['input'];
}>;


export type GQLUpdateStudentEmailMutation = { __typename?: 'Mutation', updateStudentEmail: boolean };

export type GQLStudentForCohortValidationFragmentFragment = { __typename?: 'Student', id: string, licenseNumber?: string | null, dob?: number | null, completedDriversEd: boolean };

export type GQLStudentForCohortValidationQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLStudentForCohortValidationQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, licenseNumber?: string | null, dob?: number | null, completedDriversEd: boolean } | null };

export type GQLCourseForCohortEnrollmentQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLCourseForCohortEnrollmentQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', id: string, isKnowledgeTest: boolean } };

export type GQLGetCourseForValidationQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseForValidationQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', id: string, isKnowledgeTest: boolean } };

export type GQLCohortDetailsForStudentFragment = { __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, maxEnrollees: number, courseId: string, numEnrolled: number, sessions?: Array<{ __typename?: 'CohortSession', id: string, startTime: number, endTime: number }> | null };

export type GQLFetchCohortsWithSessionsForStudentQueryVariables = Exact<{
  doShowClosed?: InputMaybe<Scalars['Boolean']['input']>;
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchCohortsWithSessionsForStudentQuery = { __typename?: 'Query', cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, stateId: string, description: string, startDate: string, endDate: string, instructorName?: string | null, instructorId?: string | null, isEnrollmentOpen: boolean, state: GQLUsStateId, timeZone: string, maxEnrollees: number, courseId: string, numEnrolled: number, sessions?: Array<{ __typename?: 'CohortSession', id: string, startTime: number, endTime: number }> | null }> };

export type GQLFetchCohortIdsForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchCohortIdsForStudentQuery = { __typename?: 'Query', cohortsForStudent: Array<{ __typename?: 'Cohort', id: string }> };

export type GQLFetchCohortsByStateSelectQueryVariables = Exact<{
  state: GQLUsStateId;
  locationLandingPageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GQLFetchCohortsByStateSelectQuery = { __typename?: 'Query', cohortsByState: Array<{ __typename?: 'Cohort', id: string, name: string, state: GQLUsStateId, stateId: string, location: string }> };

export type GQLUpdateCourseUserMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateCourseUserMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, firstName?: string | null, dob?: number | null, address: { __typename?: 'Address', zipcode?: string | null } } };

export type GQLInstructorSelectorFragment = { __typename?: 'Instructor', id: string, usStateId: string, timeZone: string };

export type GQLGetInstructorForCustomTransientQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorForCustomTransientQuery = { __typename?: 'Query', instructor: { __typename?: 'Instructor', id: string, usStateId: string, timeZone: string } };

export type GQLUpdateStudentEnrollmentFormsCompleteMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentEnrollmentFormsCompleteMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string } };

export type GQLUploadCompletionFormMutationMutationVariables = Exact<{
  input: GQLUploadUserFileInput;
}>;


export type GQLUploadCompletionFormMutationMutation = { __typename?: 'Mutation', uploadUserFile: { __typename?: 'UserFile', id: string } };

export type GQLUpdateIllinoisCompletionFormMutationVariables = Exact<{
  input: GQLUpdateIllinoisCompletionFormInput;
}>;


export type GQLUpdateIllinoisCompletionFormMutation = { __typename?: 'Mutation', updateIllinoisCompletionForm: boolean };

export type GQLIllinoisCompletionFormDataFragment = { __typename?: 'IllinoisCompletionForm', lastName: string, firstName: string, middleInit: string, noMiddleName: boolean, sex: string, isClassroomCreditTransferred: boolean, isLaboratoryCreditTransferred: boolean };

export type GQLIllinoisCompletionFormLessonFragment = { __typename?: 'Lesson', id: string, endTime: number };

export type GQLIllinoisCompletionFormDataQueryQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLIllinoisCompletionFormDataQueryQuery = { __typename?: 'Query', illinoisCompletionForm?: { __typename?: 'IllinoisCompletionForm', lastName: string, firstName: string, middleInit: string, noMiddleName: boolean, sex: string, isClassroomCreditTransferred: boolean, isLaboratoryCreditTransferred: boolean } | null };

export type GQLIllinoisCompletionFormLessonsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLIllinoisCompletionFormLessonsQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, endTime: number } }> } };

export type GQLIndianaBillOfRightsStudentFragment = { __typename?: 'Student', id: string, readBill?: boolean | null };

export type GQLIndianaBillOfRightsStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLIndianaBillOfRightsStudentQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, readBill?: boolean | null } | null };

export type GQLIndianaBillOfRightsUpdateMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  readBill: Scalars['Boolean']['input'];
}>;


export type GQLIndianaBillOfRightsUpdateMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, readBill?: boolean | null } };

export type GQLInstructorForAutocompleteFragment = { __typename?: 'Instructor', id: string, name: string, timeZone: string, usStateId: string, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string }, adminInfo: { __typename?: 'InstructorAdminInfo', isInactive?: boolean | null } };

export type GQLInstructorAutocompleteQueryQueryVariables = Exact<{
  query?: InputMaybe<GQLInstructorsQuery>;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLInstructorAutocompleteQueryQuery = { __typename?: 'Query', instructors: { __typename?: 'InstructorsPaginatedList', edges: Array<{ __typename?: 'InstructorEdge', node: { __typename?: 'Instructor', id: string, name: string, timeZone: string, usStateId: string, privateInfo: { __typename?: 'InstructorPrivateInfo', firstName: string, lastName: string }, adminInfo: { __typename?: 'InstructorAdminInfo', isInactive?: boolean | null } } }> } };

export type GQLUpdateLessonReportRatingMutationVariables = Exact<{
  input: GQLLessonDrivingSkillRatingInput;
}>;


export type GQLUpdateLessonReportRatingMutation = { __typename?: 'Mutation', updateLessonReportForStudent: boolean };

export type GQLLessonReportForViewFragment = { __typename?: 'LessonDrivingSkillsReport', studentId: string, lessonId: string, lessonStartTime: number, timeZone: string, comments?: string | null, createdAt?: number | null, updatedAt?: number | null, createdBy?: string | null, student: { __typename?: 'Student', name: string }, ratings?: Array<{ __typename?: 'LessonCategoryRating', categoryId: string, rating: number }> | null, sends?: Array<{ __typename?: 'LessonReportSend', id: string, sentAt: number }> | null };

export type GQLSharedLessonReportForViewFragment = { __typename?: 'SharedLessonDrivingSkillsReport', lessonId: string, lessonStartTime: number, timeZone: string, comments?: string | null, ratings?: Array<{ __typename?: 'LessonCategoryRating', categoryId: string, rating: number }> | null };

export type GQLGetLessonDrivingSkillsReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
}>;


export type GQLGetLessonDrivingSkillsReportQuery = { __typename?: 'Query', lessonDrivingSkillsReportByStudentAndLesson?: { __typename?: 'LessonDrivingSkillsReport', studentId: string, lessonId: string, lessonStartTime: number, timeZone: string, comments?: string | null, createdAt?: number | null, updatedAt?: number | null, createdBy?: string | null, student: { __typename?: 'Student', name: string }, ratings?: Array<{ __typename?: 'LessonCategoryRating', categoryId: string, rating: number }> | null, sends?: Array<{ __typename?: 'LessonReportSend', id: string, sentAt: number }> | null } | null };

export type GQLGetSharedLessonDrivingSkillsReportQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
}>;


export type GQLGetSharedLessonDrivingSkillsReportQuery = { __typename?: 'Query', sharedLessonDrivingSkillsReport?: { __typename?: 'SharedLessonDrivingSkillsReport', lessonId: string, lessonStartTime: number, timeZone: string, comments?: string | null, ratings?: Array<{ __typename?: 'LessonCategoryRating', categoryId: string, rating: number }> | null } | null };

export type GQLStudentLessonReportsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLStudentLessonReportsQuery = { __typename?: 'Query', lessonsDrivingSkillsReportsByStudent: { __typename?: 'LessonDrivingSkillsReportPaginatedList', edges: Array<{ __typename?: 'LessonDrivingSkillsReportEdge', node: { __typename?: 'LessonDrivingSkillsReport', studentId: string, lessonId: string, lessonStartTime: number, timeZone: string, comments?: string | null, createdAt?: number | null, updatedAt?: number | null, createdBy?: string | null, student: { __typename?: 'Student', name: string }, ratings?: Array<{ __typename?: 'LessonCategoryRating', categoryId: string, rating: number }> | null, sends?: Array<{ __typename?: 'LessonReportSend', id: string, sentAt: number }> | null } }> } };

export type GQLLessonReportDrivingSkillFieldsFragment = { __typename?: 'DrivingSkill', id: string, label: string, description?: string | null };

export type GQLGetLessonReportCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetLessonReportCategoriesQuery = { __typename?: 'Query', drivingSkills: Array<{ __typename?: 'DrivingSkill', id: string, label: string, description?: string | null }> };

export type GQLFetchLocationsByStateQueryVariables = Exact<{
  filter: GQLLocationLandingPagesFilter;
  pageQuery: GQLPageQuery;
}>;


export type GQLFetchLocationsByStateQuery = { __typename?: 'Query', locationLandingPages: { __typename?: 'LocationLandingPagePaginatedList', edges: Array<{ __typename?: 'LocationLandingPageEdge', node: { __typename?: 'LocationLandingPage', id: string, name: string, state: GQLUsStateId } }> } };

export type GQLProductForViewFragment = { __typename?: 'Product', id: string, name: string, description?: string | null, type: GQLProductType, products?: Array<{ __typename?: 'ProductLink', quantity: number, product: { __typename?: 'ProductInfo', id: string, name: string, description?: string | null, type: GQLProductType } }> | null };

export type GQLListProductQueryVariables = Exact<{
  productsQuery?: InputMaybe<GQLProductsQuery>;
  first: Scalars['Int']['input'];
}>;


export type GQLListProductQuery = { __typename?: 'Query', products: { __typename?: 'ProductsPaginatedList', edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'Product', id: string, name: string, description?: string | null, type: GQLProductType, products?: Array<{ __typename?: 'ProductLink', quantity: number, product: { __typename?: 'ProductInfo', id: string, name: string, description?: string | null, type: GQLProductType } }> | null } }> } };

export type GQLReferralPromoFragment = { __typename?: 'RedeemReferralCodeResult', promoTitle: string, promoDescription: string };

export type GQLRedeemReferralCodeMutationVariables = Exact<{
  input: GQLRedeemReferralCodeInput;
}>;


export type GQLRedeemReferralCodeMutation = { __typename?: 'Mutation', redeemReferralCode: { __typename?: 'RedeemReferralCodeResult', codePrefix: string, promoTitle: string, promoDescription: string } };

export type GQLRemoveAutoCreatedAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GQLRemoveAutoCreatedAccountMutation = { __typename?: 'Mutation', removeAutoCreatedAccount: boolean };

export type GQLUpdateSignInUserMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateSignInUserMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string } };

export type GQLCreateStripePaymentFormDirectChargeMutationVariables = Exact<{
  input: GQLCreateDirectChargeInput;
}>;


export type GQLCreateStripePaymentFormDirectChargeMutation = { __typename?: 'Mutation', createDirectCharge: { __typename?: 'CreateDirectChargePayload', amountCents: number, customerId?: string | null, latestCharge: string, paymentIntentId: string, paymentMethodType?: string | null, status: string } };

export type GQLTexasStudentContractDetailsFieldsFragment = { __typename?: 'StudentContractDetails', studentName?: string | null, address?: string | null, dob?: string | null, phoneNumber?: string | null, term1?: boolean | null, term2?: boolean | null, term3?: boolean | null, term4?: boolean | null, privateRefusedInitials?: string | null, studentSignature?: string | null, parentSignature?: string | null, dateOfSign?: string | null, studentType?: string | null };

export type GQLTexasStudentContractDetailsResultFragment = { __typename?: 'Query', studentContractDetails?: { __typename?: 'StudentContractDetails', studentName?: string | null, address?: string | null, dob?: string | null, phoneNumber?: string | null, term1?: boolean | null, term2?: boolean | null, term3?: boolean | null, term4?: boolean | null, privateRefusedInitials?: string | null, studentSignature?: string | null, parentSignature?: string | null, dateOfSign?: string | null, studentType?: string | null } | null };

export type GQLTexasStudentContractDetailsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  purchaseId: Scalars['ID']['input'];
}>;


export type GQLTexasStudentContractDetailsQuery = { __typename?: 'Query', studentContractDetails?: { __typename?: 'StudentContractDetails', studentName?: string | null, address?: string | null, dob?: string | null, phoneNumber?: string | null, term1?: boolean | null, term2?: boolean | null, term3?: boolean | null, term4?: boolean | null, privateRefusedInitials?: string | null, studentSignature?: string | null, parentSignature?: string | null, dateOfSign?: string | null, studentType?: string | null } | null };

export type GQLGetStudentForEditQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentForEditQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } | null };

export type GQLUpdateStudentDetailsMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentDetailsMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } };

export type GQLLegacyUploadRequiredDocumentOptionFragment = { __typename?: 'LicensingRequiredDocument', documentId: string, label: string, isUploaded: boolean };

export type GQLLegacyUploadRequiredDocumentOptionsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLLegacyUploadRequiredDocumentOptionsQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, licensingProgress?: { __typename?: 'LicensingProgress', hasRequirementsConfig: boolean, documents: Array<{ __typename?: 'LicensingRequiredDocument', documentId: string, label: string, isUploaded: boolean }> } | null } | null };

export type GQLUploadUserFileMutationMutationVariables = Exact<{
  input: GQLUploadUserFileInput;
}>;


export type GQLUploadUserFileMutationMutation = { __typename?: 'Mutation', uploadUserFile: { __typename?: 'UserFile', id: string } };

export type GQLUserFileFragmentFragment = { __typename?: 'UserFile', id: string, label: string, url: string, createdAt: number, createdById: string, path: string, isHiddenFromStudent?: boolean | null, documentTypeId?: string | null };

export type GQLUserFilesQueryQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLUserFilesQueryQuery = { __typename?: 'Query', userFiles: Array<{ __typename?: 'UserFile', id: string, label: string, url: string, createdAt: number, createdById: string, path: string, isHiddenFromStudent?: boolean | null, documentTypeId?: string | null }> };

export type GQLDeleteUserFileMutationMutationVariables = Exact<{
  input: GQLDeleteUserFileInput;
}>;


export type GQLDeleteUserFileMutationMutation = { __typename?: 'Mutation', deleteUserFile: boolean };

export type GQLUserNotificationLogFragmentFragment = { __typename?: 'UserNotificationsLog', message: string, notificationType: string, sendStatus: string, timestamp: number, sentTo?: string | null, lessonId?: string | null, errorMessage?: string | null, humanReadableType?: string | null };

export type GQLUserNotificationsLogForTableQueryVariables = Exact<{
  query: GQLUserNotificationsLogQuery;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLUserNotificationsLogForTableQuery = { __typename?: 'Query', userNotificationsLog: { __typename?: 'UserNotificationsPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'UserNotificationsEdge', cursor: string, node: { __typename?: 'UserNotificationsLog', message: string, notificationType: string, sendStatus: string, timestamp: number, sentTo?: string | null, lessonId?: string | null, errorMessage?: string | null, humanReadableType?: string | null } }> } };

export type GQLGetStudentForRegistrationQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentForRegistrationQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } | null };

export type GQLUpdateStudentForRegistrationMutationVariables = Exact<{
  student: GQLStudentInput;
}>;


export type GQLUpdateStudentForRegistrationMutation = { __typename?: 'Mutation', updateStudent: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } };

export type GQLVehicleSelectVehicleFragment = { __typename?: 'Vehicle', id: string, number?: string | null, instructorIds?: Array<string> | null, instructors?: Array<{ __typename?: 'Instructor', id: string, name: string }> | null };

export type GQLVehicleSelectVehiclesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filter?: InputMaybe<GQLVehiclesFilter>;
}>;


export type GQLVehicleSelectVehiclesQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesPaginatedList', edges: Array<{ __typename?: 'VehicleEdge', cursor: string, node: { __typename?: 'Vehicle', id: string, number?: string | null, instructorIds?: Array<string> | null, instructors?: Array<{ __typename?: 'Instructor', id: string, name: string }> | null } }> } | null };

export type GQLContractStudentFragment = { __typename?: 'Student', id: string, name: string, dob?: number | null, address: { __typename?: 'Address', address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null } };

export type GQLStudentForWaContractQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLStudentForWaContractQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, name: string, dob?: number | null, address: { __typename?: 'Address', address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null } } | null };

export type GQLPreviousInstructorFragment = { __typename?: 'Instructor', id: string, name: string };

export type GQLPreviousInstructorSelectQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLPreviousInstructorSelectQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, instructor: { __typename?: 'Instructor', id: string, name: string } } }> } };

export type GQLHasOnlySharedLessonPackagesQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLHasOnlySharedLessonPackagesQuery = { __typename?: 'Query', hasOnlySharedLessonPackages: boolean };

export type GQLGetMeetingPointsQueryVariables = Exact<{
  query: GQLMeetingPointsQuery;
}>;


export type GQLGetMeetingPointsQuery = { __typename?: 'Query', meetingPoints: Array<{ __typename?: 'StateMeetingPoint', id: string, address: string, label: string, distanceMiles?: number | null, coords?: { __typename?: 'LatLng', lat: number, lng: number } | null, restrictedLessonTypes?: Array<{ __typename?: 'LessonTypeForMeetingPoint', nameId: GQLLessonTypeName, name: string }> | null }> };

export type GQLCheckSlotAvailabilityQueryVariables = Exact<{
  input: GQLCheckSlotAvailabilityInput;
}>;


export type GQLCheckSlotAvailabilityQuery = { __typename?: 'Query', checkSlotAvailability: { __typename?: 'SlotAvailabilityResult', isAvailable: boolean, reason?: string | null } };

export type GQLLessonBookingRulesLessonFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number } };

export type GQLGetStudentLessonsForBookingRulesQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  startTimeAfter: Scalars['DateTime']['input'];
  startTimeBefore: Scalars['DateTime']['input'];
}>;


export type GQLGetStudentLessonsForBookingRulesQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, studentDetails: { __typename?: 'LessonStudentDetails', drivingMinutes: number } } }> } };

export type GQLGetStudentRequirementsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentRequirementsQuery = { __typename?: 'Query', student?: { __typename?: 'Student', passedKnowledgeTest: boolean, completedDriversEd: boolean, licensingProgress?: { __typename?: 'LicensingProgress', canBookRoadTest: boolean } | null } | null };

export type GQLGetStudentCourseEnrollmentInfoQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  state: GQLUsStateId;
  datoCourseFilter: GQLDatoCourseFilterInput;
}>;


export type GQLGetStudentCourseEnrollmentInfoQuery = { __typename?: 'Query', studentCourseEnrollmentInfo: { __typename?: 'StudentCourseEnrollmentInfo', hasCourseEnrollment: boolean, firstSessionStartTime?: number | null } };

export type GQLCompleteLessonFragmentFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, searchState?: string | null, locationId?: string | null, pickupLocation: string, lessonType?: { __typename?: 'LessonType', label: string } | null, instructor: { __typename?: 'Instructor', id: string, timeZone: string, displayName: string } };

export type GQLCompleteLessonQueryQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  lessonId: Scalars['ID']['input'];
}>;


export type GQLCompleteLessonQueryQuery = { __typename?: 'Query', lesson: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, searchState?: string | null, locationId?: string | null, pickupLocation: string, lessonType?: { __typename?: 'LessonType', label: string } | null, instructor: { __typename?: 'Instructor', id: string, timeZone: string, displayName: string } } };

export type GQLGetStudentLessonCountForConfirmationQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentLessonCountForConfirmationQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', totalCount: number } };

export type GQLCreateUserReferralMutationVariables = Exact<{
  input: GQLUserReferralInput;
}>;


export type GQLCreateUserReferralMutation = { __typename?: 'Mutation', createUserReferral: boolean };

export type GQLReserveSpotFormTransientSlotFragment = { __typename?: 'TransientSlot', id: string, note?: string | null, expiresAt?: number | null, instructor: { __typename?: 'TransientSlotInstructor', timeZone: string }, reservedFor?: { __typename?: 'Person', id: string, name: string } | null };

export type GQLReserveSpotFormTransientSlotQueryQueryVariables = Exact<{
  slotId: Scalars['ID']['input'];
}>;


export type GQLReserveSpotFormTransientSlotQueryQuery = { __typename?: 'Query', transientSlot: { __typename?: 'TransientSlot', id: string, note?: string | null, expiresAt?: number | null, instructor: { __typename?: 'TransientSlotInstructor', timeZone: string }, reservedFor?: { __typename?: 'Person', id: string, name: string } | null } };

export type GQLCartItemPackageWithPricesFragment = { __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null };

export type GQLCartDetailsFragment = { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
    | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
    | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
    | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
   | null };

export type GQLFetchCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type GQLFetchCartQuery = { __typename?: 'Query', cart: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLCreateCartMutationVariables = Exact<{
  input: GQLCartCreateInput;
}>;


export type GQLCreateCartMutation = { __typename?: 'Mutation', createCart: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLAddToCartMutationVariables = Exact<{
  input: GQLIdLessonPackageInput;
}>;


export type GQLAddToCartMutation = { __typename?: 'Mutation', addToCart: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLClearPackagesMutationVariables = Exact<{
  input: GQLCartInput;
}>;


export type GQLClearPackagesMutation = { __typename?: 'Mutation', clearPackages: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLCompleteOrderWithSlotsMutationVariables = Exact<{
  input: GQLCompleteOrderInput;
}>;


export type GQLCompleteOrderWithSlotsMutation = { __typename?: 'Mutation', completeOrderWithSlots: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLSetStudentIdMutationVariables = Exact<{
  input: GQLSetStudentInput;
}>;


export type GQLSetStudentIdMutation = { __typename?: 'Mutation', setStudentId: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLSetCouponMutationVariables = Exact<{
  input: GQLSetCouponInput;
}>;


export type GQLSetCouponMutation = { __typename?: 'Mutation', setCoupon: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLClearCouponMutationVariables = Exact<{
  input: GQLCartInput;
}>;


export type GQLClearCouponMutation = { __typename?: 'Mutation', clearCoupon: { __typename?: 'Cart', id: string, isOrderComplete: boolean, isFirstPurchase?: boolean | null, createdAt: number, updatedAt: number, bookedSlotIds?: Array<string> | null, paymentStatus?: string | null, purchaseId?: string | null, items: Array<{ __typename?: 'ProductPackageWithPrice', id: string, hasCourse: boolean, hasCertificateShipping?: boolean | null, banner?: string | null, description: string, extras?: string | null, hasLessons: boolean, state: string, title: string, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, courseId?: string | null, courseType?: string | null, roadTestCarType?: GQLRoadTestCarType | null, didApplyCoupon?: boolean | null, doHighlight?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }>, coupon?:
      | { __typename?: 'CourseCoupon', id: string, code: string, discount: number, title: string, courseId?: string | null, state: GQLUsStateId, isDailyCoupon: boolean, type: GQLCouponType, expiration?: number | null }
      | { __typename?: 'LessonCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
      | { __typename?: 'RoadTestCoupon', id: string, code: string, discount: number, type: GQLCouponType, title: string, expiration?: number | null, displayInLandingPages?: boolean | null, onlyFirstPurchase: boolean, locations: Array<{ __typename?: 'LocationLandingPage', id: string }> }
     | null } };

export type GQLCourseForConfirmationFragment = { __typename?: 'OnlineCourseContent', id: string, stateShortName: string, link?: string | null, isExternalCourse: boolean, isClassroomCourse: boolean, courseAgeMinimum?: number | null, slug: string };

export type GQLGetCourseForConfirmationQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseForConfirmationQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, stateShortName: string, link?: string | null, isExternalCourse: boolean, isClassroomCourse: boolean, courseAgeMinimum?: number | null, slug: string } };

export type GQLGetCourseIdByIdQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetCourseIdByIdQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string } };

export type GQLFetchCourseForCheckoutQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GQLFetchCourseForCheckoutQuery = { __typename?: 'Query', courseInfo: { __typename?: 'OnlineCourseContent', id: string, courseAgeMinimum?: number | null, isClassroomCourse: boolean, stateShortName: string, isKnowledgeTest: boolean } };

export type GQLFulfillFreeCheckoutOrderMutationVariables = Exact<{
  input: GQLFulfillFreeCheckoutOrderInput;
}>;


export type GQLFulfillFreeCheckoutOrderMutation = { __typename?: 'Mutation', fulfillFreeCheckoutOrder: { __typename?: 'FulfillFreeCheckoutOrderPayload', purchaseId: string } };

export type GQLCheckoutWarningFieldsFragment = { __typename?: 'CheckoutWarning', code: string, message: string, blocking: boolean };

export type GQLCheckoutMachineViewFieldsFragment = { __typename?: 'CheckoutView', cartId: string, version: number, step: string, warnings: Array<{ __typename?: 'CheckoutWarning', code: string, message: string, blocking: boolean }> };

export type GQLCheckoutMachineViewQueryVariables = Exact<{
  input: GQLCheckoutViewInput;
}>;


export type GQLCheckoutMachineViewQuery = { __typename?: 'Query', checkoutView: { __typename?: 'CheckoutView', cartId: string, version: number, step: string, warnings: Array<{ __typename?: 'CheckoutWarning', code: string, message: string, blocking: boolean }> } };

export type GQLAdvanceCheckoutMachineMutationVariables = Exact<{
  input: GQLCheckoutAdvanceInput;
}>;


export type GQLAdvanceCheckoutMachineMutation = { __typename?: 'Mutation', checkoutAdvance: { __typename?: 'CheckoutAdvancePayload', status: GQLCheckoutAdvanceStatus, view: { __typename?: 'CheckoutView', cartId: string, version: number, step: string, warnings: Array<{ __typename?: 'CheckoutWarning', code: string, message: string, blocking: boolean }> } } };

export type GQLUploadCertificateMutationMutationVariables = Exact<{
  input: GQLUploadUserFileInput;
}>;


export type GQLUploadCertificateMutationMutation = { __typename?: 'Mutation', uploadUserFile: { __typename?: 'UserFile', id: string } };

export type GQLSubmitCourseSurveyMutationVariables = Exact<{
  input: GQLCourseSurveyInput;
}>;


export type GQLSubmitCourseSurveyMutation = { __typename?: 'Mutation', submitCourseSurvey: boolean };

export type GQLCourseOrderDataFragment = { __typename?: 'CourseOrder', id: string, courseId: string, address?: { __typename?: 'CourseOrderAddress', address: string, city: string, state: string, zipcode: string, phone: string, dob: string, timestamp: number, firstName: string, middleName?: string | null, lastName: string } | null, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', controlNumber?: string | null, firstName: string, middleName?: string | null, middleInit?: string | null, lastName: string, dob: string, timestamp: number, sex: string, branchLicenseNumber?: string | null, roadAndVisionExams?: string | null } | null };

export type GQLGetCourseInfoAndOrderQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLGetCourseInfoAndOrderQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, title: string, hasControlNumber: boolean, requiresNotarizedForm?: boolean | null, anvilPdfIds: { __typename?: 'AnvilPdfIds', student?: string | null, admin?: string | null } }, courseOrder?: { __typename?: 'CourseOrder', id: string, courseId: string, address?: { __typename?: 'CourseOrderAddress', address: string, city: string, state: string, zipcode: string, phone: string, dob: string, timestamp: number, firstName: string, middleName?: string | null, lastName: string } | null, confirmInfo?: { __typename?: 'CourseOrderConfirmInfo', controlNumber?: string | null, firstName: string, middleName?: string | null, middleInit?: string | null, lastName: string, dob: string, timestamp: number, sex: string, branchLicenseNumber?: string | null, roadAndVisionExams?: string | null } | null } | null, ucm: { __typename?: 'StudentOnlineCoursesPaginatedList', edges: Array<{ __typename?: 'StudentOnlineCourseEdge', cursor: string, node: { __typename?: 'StudentOnlineCourse', courseId: string, hasCompletedNotary?: boolean | null } }> } };

export type GQLGenerateDigitalCertificateMutationVariables = Exact<{
  input: GQLGenerateDigitalCertificateInput;
}>;


export type GQLGenerateDigitalCertificateMutation = { __typename?: 'Mutation', generateDigitalCertificate: Array<{ __typename?: 'DigitalCertificateResult', pdfData: string, filename: string }> };

export type GQLGetCourseForInstructionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseForInstructionsQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, slug: string, instructionsText?: string | null } };

export type GQLGetStudentCourseMetaForReplacementQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLGetStudentCourseMetaForReplacementQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', courseCompletionDate?: number | null } | null };

export type GQLCheckExistingOrderQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLCheckExistingOrderQuery = { __typename?: 'Query', shippingOrders: { __typename?: 'ShippingOrdersPaginatedList', edges: Array<{ __typename?: 'ShippingOrderEdge', node: { __typename?: 'ShippingOrder', id: string, isReOrder: boolean } }> }, courseOrder?: { __typename?: 'CourseOrder', id: string, courseId: string, shipping?: { __typename?: 'CourseOrderShipping', isComplete: boolean } | null } | null };

export type GQLCreateShippingOrderMutationVariables = Exact<{
  input: GQLCreateShippingOrderInput;
}>;


export type GQLCreateShippingOrderMutation = { __typename?: 'Mutation', createShippingOrder: { __typename?: 'ShippingOrder', id: string } };

export type GQLGetCourseForAddressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseForAddressQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, verifyAddressText?: string | null, requiresSampleCertificateCheck?: boolean | null, anvilPdfIds: { __typename?: 'AnvilPdfIds', student?: string | null } } };

export type GQLGetStudentForAddressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentForAddressQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, email: string, dob?: number | null, address: { __typename?: 'Address', address?: string | null, phone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null } } | null };

export type GQLCreateAddressOrderMutationVariables = Exact<{
  query: GQLCourseOrderQuery;
  input: GQLCourseOrderInput;
}>;


export type GQLCreateAddressOrderMutation = { __typename?: 'Mutation', createCourseOrder: { __typename?: 'CourseOrder', id: string, courseId: string } };

export type GQLUpdateAddressOrderMutationVariables = Exact<{
  query: GQLCourseOrderQuery;
  input: GQLCourseOrderInput;
}>;


export type GQLUpdateAddressOrderMutation = { __typename?: 'Mutation', updateCourseOrder: { __typename?: 'CourseOrder', id: string, courseId: string } };

export type GQLGetCourseForConfirmInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetCourseForConfirmInfoQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string, stateShortName: string, branchLicenseNumber?: string | null, hasControlNumber: boolean, verifyAddressText?: string | null } };

export type GQLGetStudentForConfirmInfoQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GQLGetStudentForConfirmInfoQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, dob?: number | null, controlNumber?: string | null } | null };

export type GQLCreateConfirmInfoOrderMutationVariables = Exact<{
  query: GQLCourseOrderQuery;
  input: GQLCourseOrderInput;
}>;


export type GQLCreateConfirmInfoOrderMutation = { __typename?: 'Mutation', createCourseOrder: { __typename?: 'CourseOrder', id: string, courseId: string } };

export type GQLUpdateConfirmInfoOrderMutationVariables = Exact<{
  query: GQLCourseOrderQuery;
  input: GQLCourseOrderInput;
}>;


export type GQLUpdateConfirmInfoOrderMutation = { __typename?: 'Mutation', updateCourseOrder: { __typename?: 'CourseOrder', id: string, courseId: string } };

export type GQLLessonNotificationRegistrationRangeViewFragment = { __typename?: 'LessonNotificationRegistrationRange', day: GQLWeekDays, startTime: string, endTime: string };

export type GQLLessonNotificationRegistrationViewFragment = { __typename?: 'LessonNotificationRegistration', id: string, notificationInterval: number, address: string, lessonType: string, ranges: Array<{ __typename?: 'LessonNotificationRegistrationRange', day: GQLWeekDays, startTime: string, endTime: string }>, coords: { __typename?: 'LatLng', lat: number, lng: number } };

export type GQLCreateLessonNotificationRegistrationMutationVariables = Exact<{
  studentId: Scalars['ID']['input'];
  input: GQLLessonNotificationRegistrationInput;
  payload: Scalars['JSONObject']['input'];
}>;


export type GQLCreateLessonNotificationRegistrationMutation = { __typename?: 'Mutation', registration: { __typename?: 'LessonNotificationRegistration', id: string, notificationInterval: number, address: string, lessonType: string, ranges: Array<{ __typename?: 'LessonNotificationRegistrationRange', day: GQLWeekDays, startTime: string, endTime: string }>, coords: { __typename?: 'LatLng', lat: number, lng: number } } };

export type GQLGetLessonNotificationRegistrationsQueryVariables = Exact<{
  query?: InputMaybe<GQLLessonNotificationRegistrationsQuery>;
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLGetLessonNotificationRegistrationsQuery = { __typename?: 'Query', registrations: { __typename?: 'LessonNotificationRegistrationPaginatedList', edges: Array<{ __typename?: 'LessonNotificationRegistrationEdge', node: { __typename?: 'LessonNotificationRegistration', id: string, notificationInterval: number, address: string, lessonType: string, ranges: Array<{ __typename?: 'LessonNotificationRegistrationRange', day: GQLWeekDays, startTime: string, endTime: string }>, coords: { __typename?: 'LatLng', lat: number, lng: number } } }> } };

export type GQLInstructorBadgeFragmentFragment = { __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon };

export type GQLGetInstructorBadgesQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLGetInstructorBadgesQuery = { __typename?: 'Query', instructorBadges: Array<{ __typename?: 'InstructorBadge', title: string, icon: GQLInstructorBadgeIcon }> };

export type GQLInstructorReviewFragmentFragment = { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentId: string, studentName: string, lessonId: string, instructorId: string };

export type GQLStudentLessonForReviewsFragmentFragment = { __typename?: 'Lesson', id: string, startTime: number, endTime: number, instructorId: string, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, hasReview: boolean }>, instructor: { __typename?: 'Instructor', name: string, timeZone: string } };

export type GQLStudentLessonsForReviewsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  startTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  startTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GQLStudentLessonsForReviewsQuery = { __typename?: 'Query', lessons: { __typename?: 'LessonsPaginatedList', edges: Array<{ __typename?: 'LessonEdge', node: { __typename?: 'Lesson', id: string, startTime: number, endTime: number, instructorId: string, studentDetailsList: Array<{ __typename?: 'LessonStudentDetails', studentId: string, hasReview: boolean }>, instructor: { __typename?: 'Instructor', name: string, timeZone: string } } }> } };

export type GQLReviewsByInstructorQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  pageQuery?: InputMaybe<GQLPageQuery>;
}>;


export type GQLReviewsByInstructorQuery = { __typename?: 'Query', lessonsReviewsByInstructor: { __typename?: 'LessonsReviewsPaginatedList', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'LessonReviewEdge', cursor: string, node: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentId: string, studentName: string, lessonId: string, instructorId: string } }> } };

export type GQLCreateReviewMutationVariables = Exact<{
  input: GQLPutLessonReviewInput;
}>;


export type GQLCreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentId: string, studentName: string, lessonId: string, instructorId: string } };

export type GQLUpdateReviewMutationVariables = Exact<{
  query: GQLGetLessonReviewInput;
  input: GQLUpdateLessonReviewInput;
}>;


export type GQLUpdateReviewMutation = { __typename?: 'Mutation', updateReview: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentId: string, studentName: string, lessonId: string, instructorId: string } };

export type GQLDeleteReviewMutationVariables = Exact<{
  query: GQLGetLessonReviewInput;
}>;


export type GQLDeleteReviewMutation = { __typename?: 'Mutation', deleteReview: boolean };

export type GQLGetReviewQueryVariables = Exact<{
  query: GQLGetLessonReviewInput;
}>;


export type GQLGetReviewQuery = { __typename?: 'Query', review?: { __typename?: 'LessonReview', id: string, date: number, rating: number, text: string, studentId: string, studentName: string, lessonId: string, instructorId: string } | null };

export type GQLInstructorReviewAggregationsFragment = { __typename?: 'ReviewAggregations', totalCount: number, averageRating: number, ratingCounts: Array<number> };

export type GQLInstructorReviewAggregationsQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
}>;


export type GQLInstructorReviewAggregationsQuery = { __typename?: 'Query', getInstructorReviewAggregations: { __typename?: 'ReviewAggregations', totalCount: number, averageRating: number, ratingCounts: Array<number> } };

export type GQLLegacyUserRolesFragment = { __typename?: 'Myself', id: string, roles: Array<string> };

export type GQLLegacyCurrentUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLLegacyCurrentUserRolesQuery = { __typename?: 'Query', me: { __typename?: 'Myself', id: string, roles: Array<string> } };

export type GQLGetStateMeetingPointQueryVariables = Exact<{
  meetingPointId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GQLGetStateMeetingPointQuery = { __typename?: 'Query', meetingPoint: { __typename?: 'StateMeetingPoint', id: string, label: string, description?: string | null, address: string, state: string, restrictedLessonTypes?: Array<{ __typename?: 'LessonTypeForMeetingPoint', nameId: GQLLessonTypeName, name: string }> | null } };

export type GQLGetCohortSessionsByInstructorIdQueryVariables = Exact<{
  instructorId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GQLGetCohortSessionsByInstructorIdQuery = { __typename?: 'Query', cohortSessionsByInstructorId: Array<{ __typename?: 'CohortSession', id: string, instructorId?: string | null, instructorName?: string | null, name: string, cohortId: string, startTime: number, endTime: number, cohort?: { __typename?: 'Cohort', name: string } | null }> };

export type GQLSchedulingCalendarTransientSlotFragment = { __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, isBooked?: boolean | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string } };

export type GQLGetTransientSlotsForSchedulingQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetTransientSlotsForSchedulingQuery = { __typename?: 'Query', transientSlots: Array<{ __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, isBooked?: boolean | null, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string } }> };

export type GQLProductPackageFieldsFragment = { __typename?: 'ProductPackage', id: string, title: string, banner?: string | null, description: string, roadTestCarType?: GQLRoadTestCarType | null, courseId?: string | null, courseType?: string | null, hasCourse: boolean, hasLessons: boolean, isHomePickup?: boolean | null, state: string, doHighlight?: boolean | null, hasCertificateShipping?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null };

export type GQLProductPackageWithPriceFieldsFragment = { __typename?: 'ProductPackageWithPrice', id: string, title: string, banner?: string | null, description: string, extras?: string | null, moreInfo?: string | null, roadTestCarType?: GQLRoadTestCarType | null, courseId?: string | null, courseType?: string | null, hasCourse: boolean, hasLessons: boolean, isHomePickup?: boolean | null, state: string, doHighlight?: boolean | null, hasCertificateShipping?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, didApplyCoupon?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null };

export type GQLGetPackagesQueryVariables = Exact<{
  state: Scalars['String']['input'];
  courseType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLGetPackagesQuery = { __typename?: 'Query', packages: Array<{ __typename?: 'ProductPackage', id: string, title: string, banner?: string | null, description: string, roadTestCarType?: GQLRoadTestCarType | null, courseId?: string | null, courseType?: string | null, hasCourse: boolean, hasLessons: boolean, isHomePickup?: boolean | null, state: string, doHighlight?: boolean | null, hasCertificateShipping?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null } | null> };

export type GQLGetPackagesForCoordinatesQueryVariables = Exact<{
  state: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type GQLGetPackagesForCoordinatesQuery = { __typename?: 'Query', packagesForCoordinates: Array<{ __typename?: 'ProductPackageWithPrice', id: string, title: string, banner?: string | null, description: string, extras?: string | null, moreInfo?: string | null, roadTestCarType?: GQLRoadTestCarType | null, courseId?: string | null, courseType?: string | null, hasCourse: boolean, hasLessons: boolean, isHomePickup?: boolean | null, state: string, doHighlight?: boolean | null, hasCertificateShipping?: boolean | null, tags?: Array<string | null> | null, isTaxable?: boolean | null, msrp: number, price: number, discountAmount: number, couponDiscountAmount?: number | null, didApplyCoupon?: boolean | null, lessonPackage?: { __typename?: 'LessonPackage', id: string, totalMinutes: number, drivingMinutes: number, observationMinutes: number, numLessons: number, numRoadTests: number, isSharedLessons?: boolean | null } | null }> };

export type GQLGetStateConfigQueryVariables = Exact<{
  state: Scalars['ID']['input'];
}>;


export type GQLGetStateConfigQuery = { __typename?: 'Query', stateConfig?: { __typename?: 'StateConfig', state: string, hasHomePickup: boolean, hasFixedLocations: boolean } | null };

export type GQLCheckCourseExistsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLCheckCourseExistsQuery = { __typename?: 'Query', course: { __typename?: 'OnlineCourseContent', id: string } };

export type GQLCheckIsEnrolledInCourseQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GQLCheckIsEnrolledInCourseQuery = { __typename?: 'Query', studentCourseMeta?: { __typename?: 'StudentOnlineCourse', id: string, enrolled: boolean } | null };

export type GQLUpdateStudentCourseLectureSessionMutationVariables = Exact<{
  input: GQLUpdateCourseSessionInput;
}>;


export type GQLUpdateStudentCourseLectureSessionMutation = { __typename?: 'Mutation', updateStudentCourseLectureSession: boolean };

export type GQLBasicLectureFragment = { __typename?: 'CourseLecture', id: string, title: string, slug: string, includesAQuiz: boolean };

export type GQLFullCourseFragment = { __typename?: 'OnlineCourseContent', id: string, slug: string, title: string, stateShortName: string, stateLongName: string, datoStateId: string, courseTypeId?: string | null, lectureIds: Array<string>, numTests: number, numLectures: number, minPercentCorrect: number, notarizedFormLink?: string | null, requireOrder?: boolean | null, requiredHours: number, requiresDmvPreRegistration?: boolean | null, requiresNotarizedForm?: boolean | null, requiresSampleCertificateCheck?: boolean | null, certificateIncludeMeetsRequirements?: boolean | null, challengeRequired?: boolean | null, completionFlow: Array<string>, courseAgeMinimum?: number | null, dailyTimeLimit?: number | null, chapterTimeLimitHours?: number | null, dmvPreRegistrationLink?: string | null, externalCourseId?: string | null, failTwiceReview: boolean, hasCertificate: boolean, hasControlNumber: boolean, hasDrivingLessons: boolean, hasShipping: boolean, hasTimer: boolean, idleTimeoutSec: number, hasWeakSecurityMeasures: boolean, inactivityCheck: boolean, instructionsText?: string | null, isClassroomCourse: boolean, isEnrollmentOpen: boolean, isExternalCourse: boolean, isGuideRequired: boolean, isKnowledgeTest: boolean, link?: string | null, timerLockedLectureId?: string | null, verifyAddressText?: string | null, topics: Array<{ __typename?: 'CourseTopic', id: string, slug: string, title: string, lectures: Array<{ __typename?: 'CourseLecture', id: string, title: string, slug: string, includesAQuiz: boolean }> }>, testLectures: Array<{ __typename?: 'CourseTestLecture', id: string, title: string }> };

export type GQLFetchCourseByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLFetchCourseByIdQuery = { __typename?: 'Query', courseById: { __typename?: 'OnlineCourseContent', id: string, slug: string, title: string, stateShortName: string, stateLongName: string, datoStateId: string, courseTypeId?: string | null, lectureIds: Array<string>, numTests: number, numLectures: number, minPercentCorrect: number, notarizedFormLink?: string | null, requireOrder?: boolean | null, requiredHours: number, requiresDmvPreRegistration?: boolean | null, requiresNotarizedForm?: boolean | null, requiresSampleCertificateCheck?: boolean | null, certificateIncludeMeetsRequirements?: boolean | null, challengeRequired?: boolean | null, completionFlow: Array<string>, courseAgeMinimum?: number | null, dailyTimeLimit?: number | null, chapterTimeLimitHours?: number | null, dmvPreRegistrationLink?: string | null, externalCourseId?: string | null, failTwiceReview: boolean, hasCertificate: boolean, hasControlNumber: boolean, hasDrivingLessons: boolean, hasShipping: boolean, hasTimer: boolean, idleTimeoutSec: number, hasWeakSecurityMeasures: boolean, inactivityCheck: boolean, instructionsText?: string | null, isClassroomCourse: boolean, isEnrollmentOpen: boolean, isExternalCourse: boolean, isGuideRequired: boolean, isKnowledgeTest: boolean, link?: string | null, timerLockedLectureId?: string | null, verifyAddressText?: string | null, topics: Array<{ __typename?: 'CourseTopic', id: string, slug: string, title: string, lectures: Array<{ __typename?: 'CourseLecture', id: string, title: string, slug: string, includesAQuiz: boolean }> }>, testLectures: Array<{ __typename?: 'CourseTestLecture', id: string, title: string }> } };

export type GQLFetchCourseBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GQLFetchCourseBySlugQuery = { __typename?: 'Query', courseBySlug: { __typename?: 'OnlineCourseContent', id: string, slug: string, title: string, stateShortName: string, stateLongName: string, datoStateId: string, courseTypeId?: string | null, lectureIds: Array<string>, numTests: number, numLectures: number, minPercentCorrect: number, notarizedFormLink?: string | null, requireOrder?: boolean | null, requiredHours: number, requiresDmvPreRegistration?: boolean | null, requiresNotarizedForm?: boolean | null, requiresSampleCertificateCheck?: boolean | null, certificateIncludeMeetsRequirements?: boolean | null, challengeRequired?: boolean | null, completionFlow: Array<string>, courseAgeMinimum?: number | null, dailyTimeLimit?: number | null, chapterTimeLimitHours?: number | null, dmvPreRegistrationLink?: string | null, externalCourseId?: string | null, failTwiceReview: boolean, hasCertificate: boolean, hasControlNumber: boolean, hasDrivingLessons: boolean, hasShipping: boolean, hasTimer: boolean, idleTimeoutSec: number, hasWeakSecurityMeasures: boolean, inactivityCheck: boolean, instructionsText?: string | null, isClassroomCourse: boolean, isEnrollmentOpen: boolean, isExternalCourse: boolean, isGuideRequired: boolean, isKnowledgeTest: boolean, link?: string | null, timerLockedLectureId?: string | null, verifyAddressText?: string | null, topics: Array<{ __typename?: 'CourseTopic', id: string, slug: string, title: string, lectures: Array<{ __typename?: 'CourseLecture', id: string, title: string, slug: string, includesAQuiz: boolean }> }>, testLectures: Array<{ __typename?: 'CourseTestLecture', id: string, title: string }> } };

export type GQLFetchAllCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFetchAllCoursesQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'OnlineCourseContent', id: string, title: string, slug: string, locationId?: string | null, maxEnrollees?: number | null, stateShortName: string, isClassroomCourse: boolean }> };

export type GQLCreateInstructorScheduleMutationVariables = Exact<{
  input: GQLInstructorScheduleInput;
}>;


export type GQLCreateInstructorScheduleMutation = { __typename?: 'Mutation', createInstructorSchedule?: string | null };

export type GQLCreateApprovedInstructorScheduleMutationVariables = Exact<{
  input: GQLApprovedInstructorScheduleInput;
}>;


export type GQLCreateApprovedInstructorScheduleMutation = { __typename?: 'Mutation', createApprovedInstructorSchedule: string };

export type GQLUpdateInstructorScheduleMutationVariables = Exact<{
  input: GQLInstructorScheduleUpdateInput;
  query: GQLScheduleMutateQuery;
}>;


export type GQLUpdateInstructorScheduleMutation = { __typename?: 'Mutation', updateInstructorSchedule?: string | null };

export type GQLDeleteInstructorScheduleMutationVariables = Exact<{
  query: GQLScheduleMutateQuery;
}>;


export type GQLDeleteInstructorScheduleMutation = { __typename?: 'Mutation', deleteInstructorSchedule?: string | null };

export type GQLUpdateApprovedInstructorScheduleMutationVariables = Exact<{
  input: GQLApprovedInstructorScheduleUpdateInput;
  query: GQLScheduleMutateQuery;
}>;


export type GQLUpdateApprovedInstructorScheduleMutation = { __typename?: 'Mutation', updateApprovedInstructorSchedule: string };

export type GQLDeleteApprovedInstructorScheduleMutationVariables = Exact<{
  query: GQLScheduleMutateQuery;
}>;


export type GQLDeleteApprovedInstructorScheduleMutation = { __typename?: 'Mutation', deleteApprovedInstructorSchedule: string };

export type GQLPriceSchemeForLocationUtilsFragment = { __typename?: 'PriceScheme', id: string, name: string, products: Array<{ __typename?: 'PriceSchemeProductLink', id: string, price: number }> };

export type GQLNearbyLocationForLocationUtilsFragment = { __typename?: 'NearbyLocationResult', location: { __typename?: 'LocationPin', id: string, name: string, metro?: { __typename?: 'Metro', name: string } | null } };

export type GQLLocationPinForLocationUtilsFragment = { __typename?: 'LocationPin', id: string, name: string, metro?: { __typename?: 'Metro', name: string } | null };

export type GQLLocationCourseForLocationUtilsFragment = { __typename?: 'LocationCourse', id: string, courseType: string };

export type GQLLocationLandingPageCoursesForLocationUtilsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLLocationLandingPageCoursesForLocationUtilsQuery = { __typename?: 'Query', locationLandingPage?: { __typename?: 'LocationLandingPage', id: string, courses: Array<{ __typename?: 'LocationCourse', id: string, courseType: string }> } | null };

export type GQLNearbyLocationForCoordsForLocationUtilsQueryVariables = Exact<{
  input: GQLNearbyLocationsInput;
}>;


export type GQLNearbyLocationForCoordsForLocationUtilsQuery = { __typename?: 'Query', nearbyLocations: Array<{ __typename?: 'NearbyLocationResult', location: { __typename?: 'LocationPin', id: string, name: string, metro?: { __typename?: 'Metro', name: string } | null } }> };

export type GQLPriceSchemeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLPriceSchemeByIdQuery = { __typename?: 'Query', priceScheme: { __typename?: 'PriceScheme', id: string, name: string, products: Array<{ __typename?: 'PriceSchemeProductLink', id: string, price: number }> } };

export type GQLPriceSchemeForAddressForLocationUtilsQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GQLPriceSchemeForAddressForLocationUtilsQuery = { __typename?: 'Query', priceSchemeForAddress?: { __typename?: 'PriceScheme', id: string, name: string, products: Array<{ __typename?: 'PriceSchemeProductLink', id: string, price: number }> } | null };

export type GQLSaveStudentContractDetailsMutationVariables = Exact<{
  input: GQLSaveStudentContractDetailsInput;
}>;


export type GQLSaveStudentContractDetailsMutation = { __typename?: 'Mutation', saveStudentContractDetails: string };

export type GQLTransientSlotUtilsTransientSlotFragment = { __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, updatedAt?: number | null, expiresAt?: number | null, isBooked?: boolean | null, isConfirmed?: boolean | null, isReserved?: boolean | null, isShareable: boolean, fullSharedReservation?: boolean | null, isShared?: boolean | null, isCustom?: boolean | null, locationId?: string | null, pickupAddress: string, meetingPointId?: string | null, searchAddress?: string | null, searchCity?: string | null, searchState: string, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string }, lessonType: { __typename?: 'TransientSlotLessonType', name: string, label: string, durationMinutes: number }, reservedFor?: { __typename?: 'Person', id: string } | null };

export type GQLGetTransientSlotIfExistsQueryVariables = Exact<{
  transientSlotId: Scalars['ID']['input'];
}>;


export type GQLGetTransientSlotIfExistsQuery = { __typename?: 'Query', transientSlotIfExists?: { __typename?: 'TransientSlot', id: string, startTime: number, endTime: number, updatedAt?: number | null, expiresAt?: number | null, isBooked?: boolean | null, isConfirmed?: boolean | null, isReserved?: boolean | null, isShareable: boolean, fullSharedReservation?: boolean | null, isShared?: boolean | null, isCustom?: boolean | null, locationId?: string | null, pickupAddress: string, meetingPointId?: string | null, searchAddress?: string | null, searchCity?: string | null, searchState: string, note?: string | null, instructor: { __typename?: 'TransientSlotInstructor', id: string, displayName: string, timeZone: string }, lessonType: { __typename?: 'TransientSlotLessonType', name: string, label: string, durationMinutes: number }, reservedFor?: { __typename?: 'Person', id: string } | null } | null };

export type GQLCreateTransientSlotMutationVariables = Exact<{
  input: GQLTransientSlotInput;
}>;


export type GQLCreateTransientSlotMutation = { __typename?: 'Mutation', createTransientSlot: { __typename?: 'TransientSlot', id: string } };

export type GQLBalancedQuantityFullFragment = { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number };

export type GQLStudentBalanceFullFragment = { __typename?: 'StudentBalance', drivingMinutesBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number }, observationMinutesBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number }, homePickupBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number } };

export type GQLStudentBalanceQueryQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  drivingMinuteProductId: Scalars['ID']['input'];
  observationMinuteProductId: Scalars['ID']['input'];
  homePickupProductId: Scalars['ID']['input'];
}>;


export type GQLStudentBalanceQueryQuery = { __typename?: 'Query', studentBalance: { __typename?: 'StudentBalance', drivingMinutesBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number }, observationMinutesBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number }, homePickupBalance: { __typename?: 'BalancedQuantity', purchasedQuantity: number, availableQuantity: number, usedQuantity: number, expiredQuantity: number, refundedQuantity: number, voidedQuantity: number, sentQuantity: number, receivedQuantity: number } } };

export type GQLUserBasicFragment = { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null };

export type GQLGetUserByIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GQLGetUserByIdQuery = { __typename?: 'Query', student?: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } | null };

export type GQLGetCurrentUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetCurrentUserProfileQuery = { __typename?: 'Query', me: { __typename?: 'Myself', id: string, profile?: { __typename?: 'Student', id: string, name: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, hasNoMiddleName?: boolean | null, email: string, signInEmail?: string | null, signupTimestamp?: number | null, referral?: string | null, parentName?: string | null, parentEmail?: string | null, stripeCustomerId?: string | null, smsOptIn?: boolean | null, acceptTOS?: boolean | null, facilityNumber?: string | null, dmvPreRegNumber?: string | null, controlNumber?: string | null, licenseNumber?: string | null, licenseIssueDate?: number | null, licenseExpirationDate?: number | null, licenseEligibilityDate?: number | null, previousHours?: number | null, previousDrivingHours?: number | null, previousObservationHours?: number | null, previousSchoolLessons?: string | null, drivingHistory?: string | null, usStateId?: string | null, timeZone?: string | null, preferredLanguageCode?: string | null, preferredPronoun?: string | null, sex?: string | null, dob?: number | null, age?: number | null, marketingOptIn?: boolean | null, isDeleted?: boolean | null, isInstructor?: boolean | null, instructorId?: string | null, isAdmin?: boolean | null, isRegionalManager?: boolean | null, preferredName?: string | null, billingName?: string | null, billingEmail?: string | null, signupSource?: string | null, lastActive?: number | null, tags?: Array<string> | null, enrollmentFormsComplete?: boolean | null, locationLandingPageIds?: Array<string> | null, address: { __typename?: 'Address', id: string, address?: string | null, phone?: string | null, secondaryPhone?: string | null, city?: string | null, state?: string | null, zipcode?: string | null }, migratedTo?: { __typename?: 'StudentMigrated', email: string } | null } | null } };
